/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "pwNi");
/******/ })
/************************************************************************/
/******/ ({

/***/ "/QC5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "subscribers", function() { return subscribers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentUrl", function() { return getCurrentUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "route", function() { return route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return Router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return Link; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);


var EMPTY$1 = {};

function assign(obj, props) {
	// eslint-disable-next-line guard-for-in
	for (var i in props) {
		obj[i] = props[i];
	}
	return obj;
}

function exec(url, route, opts) {
	var reg = /(?:\?([^#]*))?(#.*)?$/,
	    c = url.match(reg),
	    matches = {},
	    ret;
	if (c && c[1]) {
		var p = c[1].split('&');
		for (var i = 0; i < p.length; i++) {
			var r = p[i].split('=');
			matches[decodeURIComponent(r[0])] = decodeURIComponent(r.slice(1).join('='));
		}
	}
	url = segmentize(url.replace(reg, ''));
	route = segmentize(route || '');
	var max = Math.max(url.length, route.length);
	for (var i$1 = 0; i$1 < max; i$1++) {
		if (route[i$1] && route[i$1].charAt(0) === ':') {
			var param = route[i$1].replace(/(^\:|[+*?]+$)/g, ''),
			    flags = (route[i$1].match(/[+*?]+$/) || EMPTY$1)[0] || '',
			    plus = ~flags.indexOf('+'),
			    star = ~flags.indexOf('*'),
			    val = url[i$1] || '';
			if (!val && !star && (flags.indexOf('?') < 0 || plus)) {
				ret = false;
				break;
			}
			matches[param] = decodeURIComponent(val);
			if (plus || star) {
				matches[param] = url.slice(i$1).map(decodeURIComponent).join('/');
				break;
			}
		} else if (route[i$1] !== url[i$1]) {
			ret = false;
			break;
		}
	}
	if (opts.default !== true && ret === false) {
		return false;
	}
	return matches;
}

function pathRankSort(a, b) {
	return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : a.index - b.index;
}

// filter out VNodes without attributes (which are unrankeable), and add `index`/`rank` properties to be used in sorting.
function prepareVNodeForRanking(vnode, index) {
	vnode.index = index;
	vnode.rank = rankChild(vnode);
	return vnode.attributes;
}

function segmentize(url) {
	return url.replace(/(^\/+|\/+$)/g, '').split('/');
}

function rankSegment(segment) {
	return segment.charAt(0) == ':' ? 1 + '*+?'.indexOf(segment.charAt(segment.length - 1)) || 4 : 5;
}

function rank(path) {
	return segmentize(path).map(rankSegment).join('');
}

function rankChild(vnode) {
	return vnode.attributes.default ? 0 : rank(vnode.attributes.path);
}

var customHistory = null;

var ROUTERS = [];

var subscribers = [];

var EMPTY = {};

function isPreactElement(node) {
	return node.__preactattr_ != null || typeof Symbol !== 'undefined' && node[Symbol.for('preactattr')] != null;
}

function setUrl(url, type) {
	if (type === void 0) type = 'push';

	if (customHistory && customHistory[type]) {
		customHistory[type](url);
	} else if (typeof history !== 'undefined' && history[type + 'State']) {
		history[type + 'State'](null, null, url);
	}
}

function getCurrentUrl() {
	var url;
	if (customHistory && customHistory.location) {
		url = customHistory.location;
	} else if (customHistory && customHistory.getCurrentLocation) {
		url = customHistory.getCurrentLocation();
	} else {
		url = typeof location !== 'undefined' ? location : EMPTY;
	}
	return "" + (url.pathname || '') + (url.search || '');
}

function route(url, replace) {
	if (replace === void 0) replace = false;

	if (typeof url !== 'string' && url.url) {
		replace = url.replace;
		url = url.url;
	}

	// only push URL into history if we can handle it
	if (canRoute(url)) {
		setUrl(url, replace ? 'replace' : 'push');
	}

	return routeTo(url);
}

/** Check if the given URL can be handled by any router instances. */
function canRoute(url) {
	for (var i = ROUTERS.length; i--;) {
		if (ROUTERS[i].canRoute(url)) {
			return true;
		}
	}
	return false;
}

/** Tell all router instances to handle the given URL.  */
function routeTo(url) {
	var didRoute = false;
	for (var i = 0; i < ROUTERS.length; i++) {
		if (ROUTERS[i].routeTo(url) === true) {
			didRoute = true;
		}
	}
	for (var i$1 = subscribers.length; i$1--;) {
		subscribers[i$1](url);
	}
	return didRoute;
}

function routeFromLink(node) {
	// only valid elements
	if (!node || !node.getAttribute) {
		return;
	}

	var href = node.getAttribute('href'),
	    target = node.getAttribute('target');

	// ignore links with targets and non-path URLs
	if (!href || !href.match(/^\//g) || target && !target.match(/^_?self$/i)) {
		return;
	}

	// attempt to route, if no match simply cede control to browser
	return route(href);
}

function handleLinkClick(e) {
	if (e.button == 0) {
		routeFromLink(e.currentTarget || e.target || this);
		return prevent(e);
	}
}

function prevent(e) {
	if (e) {
		if (e.stopImmediatePropagation) {
			e.stopImmediatePropagation();
		}
		if (e.stopPropagation) {
			e.stopPropagation();
		}
		e.preventDefault();
	}
	return false;
}

function delegateLinkHandler(e) {
	// ignore events the browser takes care of already:
	if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || e.button !== 0) {
		return;
	}

	var t = e.target;
	do {
		if (String(t.nodeName).toUpperCase() === 'A' && t.getAttribute('href') && isPreactElement(t)) {
			if (t.hasAttribute('native')) {
				return;
			}
			// if link is handled by the router, prevent browser defaults
			if (routeFromLink(t)) {
				return prevent(e);
			}
		}
	} while (t = t.parentNode);
}

var eventListenersInitialized = false;

function initEventListeners() {
	if (eventListenersInitialized) {
		return;
	}

	if (typeof addEventListener === 'function') {
		if (!customHistory) {
			addEventListener('popstate', function () {
				routeTo(getCurrentUrl());
			});
		}
		addEventListener('click', delegateLinkHandler);
	}
	eventListenersInitialized = true;
}

var Router = function (Component$$1) {
	function Router(props) {
		Component$$1.call(this, props);
		if (props.history) {
			customHistory = props.history;
		}

		this.state = {
			url: props.url || getCurrentUrl()
		};

		initEventListeners();
	}

	if (Component$$1) Router.__proto__ = Component$$1;
	Router.prototype = Object.create(Component$$1 && Component$$1.prototype);
	Router.prototype.constructor = Router;

	Router.prototype.shouldComponentUpdate = function shouldComponentUpdate(props) {
		if (props.static !== true) {
			return true;
		}
		return props.url !== this.props.url || props.onChange !== this.props.onChange;
	};

	/** Check if the given URL can be matched against any children */
	Router.prototype.canRoute = function canRoute(url) {
		return this.getMatchingChildren(this.props.children, url, false).length > 0;
	};

	/** Re-render children with a new URL to match against. */
	Router.prototype.routeTo = function routeTo(url) {
		this._didRoute = false;
		this.setState({ url: url });

		// if we're in the middle of an update, don't synchronously re-route.
		if (this.updating) {
			return this.canRoute(url);
		}

		this.forceUpdate();
		return this._didRoute;
	};

	Router.prototype.componentWillMount = function componentWillMount() {
		ROUTERS.push(this);
		this.updating = true;
	};

	Router.prototype.componentDidMount = function componentDidMount() {
		var this$1 = this;

		if (customHistory) {
			this.unlisten = customHistory.listen(function (location) {
				this$1.routeTo("" + (location.pathname || '') + (location.search || ''));
			});
		}
		this.updating = false;
	};

	Router.prototype.componentWillUnmount = function componentWillUnmount() {
		if (typeof this.unlisten === 'function') {
			this.unlisten();
		}
		ROUTERS.splice(ROUTERS.indexOf(this), 1);
	};

	Router.prototype.componentWillUpdate = function componentWillUpdate() {
		this.updating = true;
	};

	Router.prototype.componentDidUpdate = function componentDidUpdate() {
		this.updating = false;
	};

	Router.prototype.getMatchingChildren = function getMatchingChildren(children, url, invoke) {
		return children.filter(prepareVNodeForRanking).sort(pathRankSort).map(function (vnode) {
			var matches = exec(url, vnode.attributes.path, vnode.attributes);
			if (matches) {
				if (invoke !== false) {
					var newProps = { url: url, matches: matches };
					assign(newProps, matches);
					delete newProps.ref;
					delete newProps.key;
					return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["cloneElement"])(vnode, newProps);
				}
				return vnode;
			}
		}).filter(Boolean);
	};

	Router.prototype.render = function render(ref, ref$1) {
		var children = ref.children;
		var onChange = ref.onChange;
		var url = ref$1.url;

		var active = this.getMatchingChildren(children, url, true);

		var current = active[0] || null;
		this._didRoute = !!current;

		var previous = this.previousUrl;
		if (url !== previous) {
			this.previousUrl = url;
			if (typeof onChange === 'function') {
				onChange({
					router: this,
					url: url,
					previous: previous,
					active: active,
					current: current
				});
			}
		}

		return current;
	};

	return Router;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

var Link = function Link(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('a', assign({ onClick: handleLinkClick }, props));
};

var Route = function Route(props) {
	return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])(props.component, props);
};

Router.subscribers = subscribers;
Router.getCurrentUrl = getCurrentUrl;
Router.route = route;
Router.Router = Router;
Router.Route = Route;
Router.Link = Link;

/* harmony default export */ __webpack_exports__["default"] = (Router);
//# sourceMappingURL=preact-router.es.js.map

/***/ }),

/***/ "4M/d":
/***/ (function(module, exports, __webpack_require__) {

/*jshint -W030 */
var tagRE = /(?:<!--[\S\s]*?-->|<(?:"[^"]*"['"]*|'[^']*'['"]*|[^'">])+>)/g;
var parseTag = __webpack_require__("zsJU");
// re-used obj for quick lookups of components
var empty = Object.create ? Object.create(null) : {};
// common logic for pushing a child node onto a list
function pushTextNode(list, html, level, start, ignoreWhitespace) {
    // calculate correct end of the content slice in case there's
    // no tag after the text node.
    var end = html.indexOf('<', start);
    var content = html.slice(start, end === -1 ? undefined : end);
    // if a node is nothing but whitespace, collapse it as the spec states:
    // https://www.w3.org/TR/html4/struct/text.html#h-9.1
    if (/^\s*$/.test(content)) {
        content = ' ';
    }
    // don't add whitespace-only text nodes if they would be trailing text nodes
    // or if they would be leading whitespace-only text nodes:
    //  * end > -1 indicates this is not a trailing text node
    //  * leading node is when level is -1 and list has length 0
    if (!ignoreWhitespace && end > -1 && level + list.length >= 0 || content !== ' ') {
        list.push({
            type: 'text',
            content: content
        });
    }
}

module.exports = function parse(html, options) {
    options || (options = {});
    options.components || (options.components = empty);
    var result = [];
    var current;
    var level = -1;
    var arr = [];
    var byTag = {};
    var inComponent = false;

    html.replace(tagRE, function (tag, index) {
        if (inComponent) {
            if (tag !== '</' + current.name + '>') {
                return;
            } else {
                inComponent = false;
            }
        }

        var isOpen = tag.charAt(1) !== '/';
        var isComment = tag.indexOf('<!--') === 0;
        var start = index + tag.length;
        var nextChar = html.charAt(start);
        var parent;

        if (isOpen && !isComment) {
            level++;

            current = parseTag(tag);
            if (current.type === 'tag' && options.components[current.name]) {
                current.type = 'component';
                inComponent = true;
            }

            if (!current.voidElement && !inComponent && nextChar && nextChar !== '<') {
                pushTextNode(current.children, html, level, start, options.ignoreWhitespace);
            }

            byTag[current.tagName] = current;

            // if we're at root, push new base node
            if (level === 0) {
                result.push(current);
            }

            parent = arr[level - 1];

            if (parent) {
                parent.children.push(current);
            }

            arr[level] = current;
        }

        if (isComment || !isOpen || current.voidElement) {
            if (!isComment) {
                level--;
            }
            if (!inComponent && nextChar !== '<' && nextChar) {
                // trailing text node
                // if we're at the root, push a base text node. otherwise add as
                // a child to the current node.
                parent = level === -1 ? result : arr[level].children;
                pushTextNode(parent, html, level, start, options.ignoreWhitespace);
            }
        }
    });

    // If the "html" passed isn't actually html, add it as a text node.
    if (!result.length && html.length) {
        pushTextNode(result, html, 0, 0, options.ignoreWhitespace);
    }

    return result;
};

/***/ }),

/***/ "5D9O":
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("wVGV")();
}

/***/ }),

/***/ "89El":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */

var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;

/***/ }),

/***/ "9RYL":
/***/ (function(module, exports) {

module.exports = {"A country must be selected above.":"Выберите страну.","A notification frequency is required to update two factor settings.":"Для обновления настроек двухфакторной аутентификации требуется задать частоту уведомлений.","A notification method is required to update two factor settings.":"Для обновления настроек двухфакторной аутентификации требуется указать способ уведомления.","A phone number is required.":"Требуется номер телефона.","A phone number must be associated with your account to use the phone notification method.":"Для уведомления по телефону номер телефона должен быть связан с вашим аккаунтом.","A username is required to create an account.":"Для создания аккаунта требуется указать имя пользователя.","A valid email address is required.":"Требуется действующий адрес электронной почты.","A verification code is required.":"Требуется код подтверждения.","A verified email address with Facebook is required to create an account. You will use your Facebook login to play.":"Для создания аккаунта требуется подтвержденный в Facebook адрес эл. почты. Для игры вы будете использовать вход в Facebook.","A verified email address with Google is required to create an account. You will use your Google login to play.":"Для создания аккаунта требуется подтвержденный в Google адрес эл. почты. Для игры вы будете использовать вход в Google.","ACTIVE":"АКТИВНО","Account Id:":"ID аккаунта:","Account Info":"Об аккаунте","Account Overview":"Информация об аккаунте","Accounts Created":"Созданные аккаунты","Add Referrer":"Добавить пригласившего","Affiliate Rewards":"Награды за объединение","After verification, you can change your email address and password.":"После подтверждения вы сможете изменить адрес эл. почты и пароль.","Already have a Hi-Rez Studios account? Login.":"У вас уже есть аккаунт Hi-Rez? Вход","An email address is required to send a referral.":"Для отправки реферальной ссылки требуется адрес эл. почты.","An email address is required.":"Требуется адрес эл. почты.","Australia":"Австралия","Authentication Code":"Код подтверждения","Back":"Назад","Belgium":"Бельгия","Both":"И то и другое","Brazil":"Бразилия","CLICK HERE TO REQUEST AN ACCOUNT DELETION OR MAKE AN ACCOUNT DATA REQUEST":"ЩЕЛКНИТЕ ЗДЕСЬ, ЧТОБЫ СДЕЛАТЬ ЗАПРОС НА УДАЛЕНИЕ АККАУНТА ИЛИ ЗАПРОС ПО ПЕРСОНАЛЬНЫМ ДАННЫМ","Can only re-link to the previously linked account.":"Можно заново привязать только к аккаунту, привязанному ранее.","Can't Login?":"Не можете войти?","Canada":"Канада","Cancel":"Отмена","Change":"Изменить","Change Email Address":"Изменить адрес эл. почты","Change Your Password":"Изменить пароль","Chat VIP Support":"Чат VIP-поддержки","Chile":"Чили","Choose Country":"Выберите страну","Choose Method":"Выберите способ","Click here":"Щелкните здесь","Confirm":"Подтвердить","Confirm Email":"Подтвердите адрес","Confirm New Password":"Подтвердите пароль","Contact Customer Support":"Служба поддержки пользователей","Continue":"Продолжить","Copy Link":"Копировать ссылку","Create":"Создать","Create A Free Account":"Создать аккаунт бесплатно","Current Email":"Действующий адрес эл. почты","Current Password":"Действующий пароль","Currently using ${currentEmail} as your recovery e-mail.":"Ваш резервный адрес эл. почты: ${currentEmail}.","Currently using ${currentPhone} as your phone number.":"Ваш номер телефона: ${currentPhone}.","Date":"Дата","Date of Purchase":"Дата покупки","Description":"Описание","Disable":"Отключить","Disable two factor authentication on this account?":"Отключить двухфакторную аутентификацию для этого аккаунта?","Download":"Загрузить","E-Mail Verification Settings":"Настройки проверки адреса эл. почты","E-mail:":"Адрес эл. почты:","Edit":"Изменить","Email":"Адрес эл. почты","Emails do not match. Please try again.":"Адрес эл. почты не совпадает. Пожалуйста, попробуйте снова.","Enable":"Включить","Enter Phone Number:":"Введите номер телефона:","Enter in the email and username associated with your account to reset your password.":"Чтобы сбросить пароль, введите адрес эл. почты и имя пользователя, связанные с вашим аккаунтом.","Enter in the email associated with your account to receive a reminder email.":"Чтобы получить сообщение с напоминанием, введите адрес эл. почты, связанный с вашим аккаунтом.","Enter in the username and one time recovery code (when you setup your two factor authentication) to login.":"Для входа введите имя пользователя и одноразовый код подтверждения (если вы настроили двухфакторную аутентификацию).","Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.":"Для входа введите имя пользователя и пароль. Код подтверждения для двухфакторной аутентификации отправлен на ваш адрес эл. почты.","Everytime":"Всегда","Finland":"Финляндия","Forgot Your Password?":"Забыли пароль?","Forgot Your Username?":"Забыли имя пользователя?","France":"Франция","Frequency:":"Частота:","Game":"Игра","Game Invites":"Приглашения в игру","Games":"Игры","Gdpr":"GDPR","Germany":"Германия","Gift":"Подарить","I agree to receive Hi-Rez marketing communications, including event invitations, special offers, and newsletters.":"Я хочу получать новостную рассылку Hi-Rez, чтобы быть в курсе новых событий, особых предложений и последних новостей.","INACTIVE":"НЕАКТИВНО","If the above options were not able to assist you:":"Если все вышеперечисленное не помогло:","If you would like to relink to this service later to continue sharing data, simply sign in with the email address and click the connect button in the connected accounts section of the account dashboard.":"Если в будущем вы захотите заново привязать учетную запись, просто войдите с помощью вашего адреса эл. почты и нажмите на кнопку \"Привязать\".","In-Game Rewards:":"Награды в игре:","Information about referring a friend can go here.":"Подробнее о реферальной программе можно узнать здесь.","Ireland":"Ирландия","Korea":"Корея","Language":"Язык","Learn More.":"Подробнее","Link A New Account":"Привязать новый аккаунт","Link Account":"Привязать аккаунт","Link An Existing Account":"Привязать существующий аккаунт","Link your Hi-Rez Account to other networks in order to receive in-game rewards! Questions? Check out our FAQ page.":"Свяжите аккаунт Hi-Rez с аккаунтами в других сетях и получите награды в игре! Вопросы? Загляните на страницу FAQ.","Linked & Connected Accounts":"Связанные и объединенные аккаунты","Linked Accounts":"Связанные аккаунты","Logging Into Your Account":"Вход в аккаунт","Login":"Вход","Login With:":"Войти через:","Login to change your two-factor settings":"Войдите для изменения настроек двухфакторной аутентификации","Logout":"Выйти","Method:":"Способ:","Mexico":"Мексика","Netherlands":"Нидерланды","New Email":"Новый адрес эл. почты","New Password":"Новый пароль","Next":"Далее","None":"Нет","Offline":"Не в сети","Online":"В сети","Only select countries can receive our SMS alerts. Normal SMS charges apply.":"СМС-уведомления можно получать не во всех странах. Стоимость СМС соответствует вашему обычному тарифу.","Order Number":"Номер заказа","Other":"Другое","Other Settings":"Другие настройки","Paladins":"Paladins","Password":"Пароль","Password:":"Пароль:","Passwords do not match. Please try again.":"Пароли не совпадают. Пожалуйста, попробуйте снова.","Periodic":"Периодически","Phone":"Телефон","Phone Number Verification Settings":"Настройки подтверждения номера телефона","Phone Number:":"Номер телефона:","Please check your recovery email and try again.":"Проверьте резервный адрес эл. почты и повторите попытку.","Please check your validation code and try again.":"Проверьте код подтверждения и повторите попытку.","Please select how often you want to verify your account. Either every time you log in, every two weeks, or never.":"Выберите частоту проверки аккаунта. При каждом входе, каждые две недели или никогда.","Please select your preferred method of receiving your two-factor security code. Note that not all countries are supported in our text message notification method.":"Выберите способ получения кода двухфакторной аутентификации. Обратите внимание: получение наших кодов по телефону поддерживается не во всех странах.","Please store this recovery code in a safe location.":"Сохраните код подтверждения в надежном месте.","Please try again.":"Пожалуйста, попробуйте снова.","Please verify your email address.":"Подтвердите свой адрес эл. почты.","Please wait while we connect your Hi-Rez Studios Account to ${service}.":"Подождите, мы подключаем ваш аккаунт Hi-Rez Studios к ${service}.","Points Earned":"Заработанные очки","Poland":"Польша","Portugal":"Португалия","Preferred Notification Method":"Способ получения уведомлений","Program":"Программа","Purchases and earned game content will be reset on this account.":"С этой учетной записи исчезнут все покупки и разблокированные предметы.","Recent Rewards":"Недавние награды","Recent Transactions":"Недавние транзакции","Recovery Code":"Код подтверждения","Recovery E-Mail:":"Резервный адрес эл. почты:","Refer A Friend":"Пригласи друга","Refer a Friend":"Пригласи друга","Referral Email:":"Адрес эл. почты для реферальной ссылки:","Referral Link:":"Реферальная ссылка:","Referral sent to ${email}!":"Реферальная ссылка отправлена на адрес ${email}!","Referring Player's Name":"Имя пригласившего игрока","Save":"Сохранить","Security":"Безопасность","Security - Confirm & Recovery Code":"Безопасность − Подтверждение и код подтверждения","Security - Disable Two Factor Authentication":"Безопасность − Отключить двухфакторную аутентификацию","Security - Two Factor Authentication":"Безопасность − Двухфакторная аутентификация","Select A Game":"Выберите игру","Send me Hi-Rez Studios news.":"Я хочу получать новостную рассылку Hi-Rez Studios.","Shared game progression and history will be reset on this account.":"На этой учетной записи сбросятся игровой прогресс и история.","Shared profile data will be reset on this account.":"На этой учетной записи сбросятся данные профиля.","Sign Up Now! Join 25+ Million Players Today":"Регистрация Присоединяйтесь к 25 миллионам игроков уже сегодня","Sign Up With:":"Зарегистрироваться с помощью...","Smite":"SMITE","Something went wrong. Please try again.":"Что-то пошло не так. Пожалуйста, попробуйте снова.","Spain":"Испания","Status":"Статус","Status:":"Статус:","Submit":"Отправить","Submit Support Ticket":"Обратиться в службу поддержки","Sweden":"Швеция","Thank you, an email has been sent to the address on file.":"Спасибо, на указанный адрес эл. почты было отправлено сообщение.","The e-mail used to set up your Hi-Rez Account is automatically used for two-step verification codes.":"Адрес эл. почты, указанный при регистрации аккаунта Hi-Rez, автоматически используется для отправки кодов двухфакторной аутентификации.","There are no rewards to display":"Список наград пуст","There are no transactions to display":"Список транзакций пуст","There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.":"Может быть несколько ситуаций, при которых вы не сможете выполнить вход. Ниже перечислены способы, которые помогут вам восстановить аккаунт.","This player has already been referred or has an existing Hi-Rez Studios account.":"Этот игрок уже получил рекомендацию, или у него уже есть аккаунт Hi-Rez Studios.","Total Revenue":"Общие поступления","Two - Factor Sign In":"Двухфакторный вход","Two-Factor Sign In can be used to help protect your account from unauthorized access by requiring you to enter an additional code when you sign in.":"Двухфакторный вход поможет защитить ваш аккаунт от несанкционированного доступа, так как при каждом входе нужно вводить дополнительный код.","UTM Campaign":"Кампания UTM","UTM Content":"Контент UTM","Unable to link or create Nintendo account. Please log into your Nintendo Switch, create a player, and retry.":"Не удалось создать или привязать учетную запись Nintendo. Войдите в учетную запись Nintendo, создайте игрока и попробуйте заново.","United Kingdom":"Великобритания","United States of America":"США","Unlink":"Отвязать","Unlink Account":"Отвязать аккаунт","Unlink Facebook from this account":"Отвязка учетной записи Facebook от этого аккаунта","Unlink Google from this account":"Отвязка учетной записи Google от этого аккаунта","Unlink Mixer from this account":"Отвязка учетной записи Mixer от этого аккаунта","Unlink Nintendo from this account":"Отвязка учетной записи Nintendo от этого аккаунта","Unlink PSN from this account":"Отвязка учетной записи PSN от этого аккаунта","Unlink Steam from this account":"Отвязка учетной записи Steam от этого аккаунта","Unlink Twitch from this account":"Отвязка учетной записи Twitch от этого аккаунта","Unlink Xbox from this account":"Отвязка учетной записи Xbox от этого аккаунта","Unlink this platform from this account":"Отвязка платформы от этого аккаунта","Unlinking this service will NOT unlock restricted platforms.":"Отвязка учетной записи не разблокирует кроссплатформенный прогресс на платформах, где эта возможность недоступна.","Use Backup Email to Login":"Использовать для входа резервный адрес эл. почты","Use One Time Recovery Code":"Использовать одноразовый код подтверждения","Username":"Имя пользователя","Username:":"Имя пользователя:","VIP Chat":"VIP-чат","VIP Chat Support":"VIP-поддержка","Verification Code:":"Код подтверждения:","Verification Frequency":"Частота подтверждения","Verify":"Подтвердить","View all rewards":"Все награды","View all transactions":"Все транзакции","View more rewards":"Другие награды","View more transactions":"Другие транзакции","Want to change your two factor settings? Click below.":"Хотите изменить настройки двухфакторной аутентификации? Щелкните ниже.","Want to send a link directly? Enter in your referral's email below and we'll send it to them directly!":"Хотите отправить прямую ссылку? Введите адрес эл. почты для отправки рекомендации, и мы отправим прямую ссылку!","Warning: You will no longer be able to use this account to store your progression on Facebook":"Предупреждение: прогресс с этого аккаунта перестанет быть доступен на учетной записи Facebook","Warning: You will no longer be able to use this account to store your progression on Google":"Предупреждение: прогресс с этого аккаунта перестанет быть доступен на учетной записи Google","Warning: You will no longer be able to use this account to store your progression on Mixer":"Предупреждение: прогресс с этого аккаунта перестанет быть доступен на учетной записи Mixer","Warning: You will no longer be able to use this account to store your progression on Nintendo":"Предупреждение: прогресс с этого аккаунта перестанет быть доступен на учетной записи Nintendo","Warning: You will no longer be able to use this account to store your progression on PSN":"Предупреждение: прогресс с этого аккаунта перестанет быть доступен на учетной записи PSN","Warning: You will no longer be able to use this account to store your progression on Steam":"Предупреждение: прогресс с этого аккаунта перестанет быть доступен на учетной записи Steam","Warning: You will no longer be able to use this account to store your progression on Twitch":"Предупреждение: прогресс с этого аккаунта перестанет быть доступен на учетной записи Twitch","Warning: You will no longer be able to use this account to store your progression on Xbox":"Предупреждение: прогресс с этого аккаунта перестанет быть доступен на учетной записи Xbox","Warning: You will no longer be able to use this account to store your progression on this platform.":"Предупреждение: прогресс с этого аккаунта перестанет быть доступен на этой платформе","We have agents available to speak with you! Please click below to enter our chat window in order to receive assistance with any questions you may have!":"Наши сотрудники могут поговорить с вами! Щелкните ниже, чтобы открыть окно чата и получить ответы на ваши вопросы!","We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?":"Мы не можем найти связанный аккаунт Hi-Rez Studios. Хотите привязать этот аккаунт?","We've provided a backup code below to restore access to your account should you lose the ability to verify your Two Factor Authentication.":"Мы предоставляем вам указанный ниже резервный код для восстановления доступа к вашему аккаунту в случае, если вы не можете воспользоваться подтверждением с использованием двухфакторной аутентификации.","Wrong account? <a>Login to a different account.</a>":"Не тот аккаунт? <a>Войдите в другой.</a>","You must confirm your email.":"Подтвердите адрес эл. почты.","You must enter your current password.":"Введите пароль.","You must enter your new email.":"Введите новый адрес эл. почты.","You must verify your email address before changing your password.":"Для смены пароля необходимо подтвердить адрес эл. почты.","You will be logged in as:":"Вы войдете как:","You've successfully changed your email.":"Вы изменили адрес эл. почты.","You've successfully changed your password.":"Вы изменили пароль.","You've successfully updated your Two Factor Authentication settings!":"Вы изменили настройки двухфакторной аутентификации!","You've successfully verified your backup email address.":"Вы подтвердили резервный адрес эл. почты.","You've successfully verified your mobile phone number.":"Вы подтвердили номер телефона.","Your recovery email cannot be the same as your account email.":"Резервный адрес эл. почты не должен совпадать с основным адресом эл. почты вашего аккаунта.","or":"или","to add a backup email address.":"добавить резервный адрес электронной почты.","to add a new phone number.":"добавить новый номер телефона.","I am 13+ years old and I agree to the <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Terms of Service</a>.":"Мне больше 13 лет, и я принимаю <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"blank\\\">Условия обслуживания и Лицензионное соглашение Hi-Rez Studios</a>.","Link your Twitch account to receive content in SMITE with Twitch Prime. After linking, you will be returned to the Twitch Prime landing page for SMITE, or click <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >here</a> to return now.":"Привяжите учетную запись Twitch с подпиской Twitch Prime к аккаунту Hi-Rez, чтобы получить предметы в SMITE. После привязки вы вернетесь на главную страницу Twitch Prime для SMITE. Вы можете перейти на нее сейчас, кликнув <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >здесь</a>.","To unlink your account, please submit a request to Customer Support <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >here</a>.":"Чтобы отвязать учетную запись, пожалуйста, обратитесь в <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >службу поддержки</a>.","You must have a linked Twitch Prime account to receive these rewards in SMITE. You must also claim the offer <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">here</a>, and link your Hi-Rez account to your platform of choice <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >here</a>.":"Чтобы получить эти предметы в SMITE, необходимо привязать учетную запись Twitch с подпиской Twitch Prime. Разблокировать предложение можно <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">здесь</a>. Вы также можете привязать аккаунт Hi-Rez к учетной записи на любой платформе <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >здесь</a>."}

/***/ }),

/***/ "Asjh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "C6iP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    parse: __webpack_require__("4M/d"),
    stringify: __webpack_require__("oJ5z")
};

/***/ }),

/***/ "GC9o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _utils = __webpack_require__("ygIX");

var utils = _interopRequireWildcard(_utils);

var _cookie = __webpack_require__("NruA");

var _cookie2 = _interopRequireDefault(_cookie);

var _querystring = __webpack_require__("x+I3");

var _querystring2 = _interopRequireDefault(_querystring);

var _localStorage = __webpack_require__("UIPi");

var _localStorage2 = _interopRequireDefault(_localStorage);

var _navigator = __webpack_require__("xPfl");

var _navigator2 = _interopRequireDefault(_navigator);

var _htmlTag = __webpack_require__("Mtqa");

var _htmlTag2 = _interopRequireDefault(_htmlTag);

var _path = __webpack_require__("V+3r");

var _path2 = _interopRequireDefault(_path);

var _subdomain = __webpack_require__("qAxq");

var _subdomain2 = _interopRequireDefault(_subdomain);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function getDefaults() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',

    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode']
    //cookieMinutes: 10,
    //cookieDomain: 'myDomain'
  };
}

var Browser = function () {
  function Browser(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Browser);

    this.type = 'languageDetector';
    this.detectors = {};

    this.init(services, options);
  }

  _createClass(Browser, [{
    key: 'init',
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.services = services;
      this.options = utils.defaults(options, this.options || {}, getDefaults());
      this.i18nOptions = i18nOptions;

      this.addDetector(_cookie2.default);
      this.addDetector(_querystring2.default);
      this.addDetector(_localStorage2.default);
      this.addDetector(_navigator2.default);
      this.addDetector(_htmlTag2.default);
      this.addDetector(_path2.default);
      this.addDetector(_subdomain2.default);
    }
  }, {
    key: 'addDetector',
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: 'detect',
    value: function detect(detectionOrder) {
      var _this = this;

      if (!detectionOrder) detectionOrder = this.options.order;

      var detected = [];
      detectionOrder.forEach(function (detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup = _this.detectors[detectorName].lookup(_this.options);
          if (lookup && typeof lookup === 'string') lookup = [lookup];
          if (lookup) detected = detected.concat(lookup);
        }
      });

      var found = void 0;
      detected.forEach(function (lng) {
        if (found) return;
        var cleanedLng = _this.services.languageUtils.formatLanguageCode(lng);
        if (_this.services.languageUtils.isWhitelisted(cleanedLng)) found = cleanedLng;
      });

      if (!found) {
        var fallbacks = this.i18nOptions.fallbackLng;
        if (typeof fallbacks === 'string') fallbacks = [fallbacks];
        if (!fallbacks) fallbacks = [];

        if (Object.prototype.toString.apply(fallbacks) === '[object Array]') {
          found = fallbacks[0];
        } else {
          found = fallbacks[0] || fallbacks.default && fallbacks.default[0];
        }
      };

      return found;
    }
  }, {
    key: 'cacheUserLanguage',
    value: function cacheUserLanguage(lng, caches) {
      var _this2 = this;

      if (!caches) caches = this.options.caches;
      if (!caches) return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
      caches.forEach(function (cacheName) {
        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);

  return Browser;
}();

Browser.type = 'languageDetector';

exports.default = Browser;

/***/ }),

/***/ "JkW7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ./scss/app.scss
var app = __webpack_require__("LNuP");
var app_default = /*#__PURE__*/__webpack_require__.n(app);

// EXTERNAL MODULE: ../node_modules/prop-types/index.js
var prop_types = __webpack_require__("5D9O");
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// CONCATENATED MODULE: ../node_modules/preact-compat/dist/preact-compat.es.js



var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process === 'undefined' || !process.env || "production" !== 'production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(preact_min["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = preact_min["options"].event;
preact_min["options"].event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = preact_min["options"].vnode;
preact_min["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(preact_min["render"])(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(preact_min["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(preact_min["render"])(Object(preact_min["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var preact_compat_es_i = ELEMENTS.length; preact_compat_es_i--;) {
	DOM[ELEMENTS[preact_compat_es_i]] = createFactory(ELEMENTS[preact_compat_es_i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(preact_min["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = Object(preact_min["h"])(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(preact_min["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && component.base || component;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			prop_types_default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	preact_min["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new preact_min["Component"](), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

var preact_compat_es_index = {
	version: version,
	DOM: DOM,
	PropTypes: prop_types_default.a,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	__spread: extend
};

/* harmony default export */ var preact_compat_es = (preact_compat_es_index);
//# sourceMappingURL=preact-compat.es.js.map
// EXTERNAL MODULE: ../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__("89El");
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/shallowEqual.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowEqual
 * @typechecks
 * 
 */

/* eslint-disable no-self-compare */

var shallowEqual_hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }
  // Step 6.a: NaN == NaN
  return x !== x && y !== y;
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!shallowEqual_hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/context.js
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var defaultOptions = {
  wait: false,
  withRef: false,
  bindI18n: 'languageChanged loaded',
  bindStore: 'added removed',
  translateFuncName: 't',
  nsMode: 'default',
  usePureComponent: false,
  omitBoundRerender: true
};

var context_i18n = void 0;

function setDefaults(options) {
  defaultOptions = _extends({}, defaultOptions, options);
}

function getDefaults() {
  return defaultOptions;
}

function setI18n(instance) {
  context_i18n = instance;
}

function getI18n() {
  return context_i18n;
}

var reactI18nextModule = {
  type: '3rdParty',

  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};
// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/I18n.js
var I18n__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}





var removedIsInitialSSR = false;

var I18n_I18n = function (_Component) {
  _inherits(I18n, _Component);

  function I18n(props, context) {
    _classCallCheck(this, I18n);

    var _this = _possibleConstructorReturn(this, (I18n.__proto__ || Object.getPrototypeOf(I18n)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n || getI18n();

    var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
    _this.options = I18n__extends({}, getDefaults(), i18nOptions, props);

    // nextjs SSR: getting data from next.js or other ssr stack
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.options.wait = false; // we got all passed down already
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }

    // provider SSR: data was set in provider and ssr flag was set
    if (_this.i18n.options && _this.i18n.options.isInitialSSR) {
      _this.options.wait = false;
    }

    var language = _this.i18n.languages && _this.i18n.languages[0];
    var ready = !!language && _this.getNamespaces().every(function (ns) {
      return _this.i18n.hasResourceBundle(language, ns);
    });

    _this.state = {
      i18nLoadedAt: null,
      ready: ready
    };

    _this.t = _this.getI18nTranslate();

    _this.onI18nChanged = _this.onI18nChanged.bind(_this);
    _this.getI18nTranslate = _this.getI18nTranslate.bind(_this);
    _this.namespaces = _this.getNamespaces.bind(_this);
    return _this;
  }

  _createClass(I18n, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        t: this.t,
        i18n: this.i18n
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadNamespaces();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Note that dynamically loading additional namespaces after the initial mount will not block rendering – even if the `wait` option is true.
      if (this.props.ns && prevProps.ns !== this.props.ns) this.loadNamespaces();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      this.mounted = false;
      if (this.onI18nChanged) {
        if (this.options.bindI18n) {
          var p = this.options.bindI18n.split(' ');
          p.forEach(function (f) {
            return _this2.i18n.off(f, _this2.onI18nChanged);
          });
        }
        if (this.options.bindStore) {
          var _p = this.options.bindStore.split(' ');
          _p.forEach(function (f) {
            return _this2.i18n.store && _this2.i18n.store.off(f, _this2.onI18nChanged);
          });
        }
      }
    }
  }, {
    key: 'onI18nChanged',
    value: function onI18nChanged() {
      if (!this.mounted) return;
      if (!this.state.ready && this.options.omitBoundRerender) return;

      this.t = this.getI18nTranslate();
      this.setState({ i18nLoadedAt: new Date() }); // rerender
    }
  }, {
    key: 'getI18nTranslate',
    value: function getI18nTranslate() {
      return this.i18n.getFixedT(null, this.options.nsMode === 'fallback' ? this.getNamespaces() : this.getNamespaces()[0]);
    }
  }, {
    key: 'getNamespaces',
    value: function getNamespaces() {
      var ns = this.props.ns || this.i18n.options && this.i18n.options.defaultNS;
      return typeof ns === 'string' ? [ns] : ns;
    }
  }, {
    key: 'loadNamespaces',
    value: function loadNamespaces() {
      var _this3 = this;

      var bind = function bind() {
        if (_this3.options.bindI18n && _this3.i18n) _this3.i18n.on(_this3.options.bindI18n, _this3.onI18nChanged);
        if (_this3.options.bindStore && _this3.i18n.store) _this3.i18n.store.on(_this3.options.bindStore, _this3.onI18nChanged);
      };

      this.mounted = true;
      this.i18n.loadNamespaces(this.getNamespaces(), function () {
        var ready = function ready() {
          if (_this3.mounted && !_this3.state.ready) _this3.setState({ ready: true });
          if (_this3.options.wait && _this3.mounted) bind();
        };

        if (_this3.i18n.isInitialized) {
          ready();
        } else {
          var initialized = function initialized() {
            // due to emitter removing issue in i18next we need to delay remove
            setTimeout(function () {
              _this3.i18n.off('initialized', initialized);
            }, 1000);
            ready();
          };

          _this3.i18n.on('initialized', initialized);
        }
      });

      if (!this.options.wait) bind();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var children = this.props.children;
      var ready = this.state.ready;

      if (!ready && this.options.wait) return null;

      // remove ssr flag set by provider - first render was done from now on wait if set to wait
      if (this.i18n.options && this.i18n.options.isInitialSSR && !removedIsInitialSSR) {
        removedIsInitialSSR = true;
        setTimeout(function () {
          delete _this4.i18n.options.isInitialSSR;
        }, 100);
      }

      return children(this.t, {
        i18n: this.i18n,
        t: this.t,
        lng: this.i18n.language,
        ready: ready
      });
    }
  }]);

  return I18n;
}(Component$1);

/* harmony default export */ var es_I18n = (I18n_I18n);

I18n_I18n.contextTypes = {
  i18n: prop_types_default.a.object
};

I18n_I18n.childContextTypes = {
  t: prop_types_default.a.func.isRequired,
  i18n: prop_types_default.a.object
};
// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/translate.js
var translate__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var translate__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function translate__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function translate__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function translate__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}








function getDisplayName(component) {
  return component.displayName || component.name || 'Component';
}

function translate(namespaceArg) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function Wrapper(WrappedComponent) {
    var Translate = function (_Component) {
      translate__inherits(Translate, _Component);

      function Translate(props, context) {
        translate__classCallCheck(this, Translate);

        var _this = translate__possibleConstructorReturn(this, (Translate.__proto__ || Object.getPrototypeOf(Translate)).call(this, props, context));

        _this.i18n = props.i18n || options.i18n || context.i18n || getI18n();
        _this.namespaces = typeof namespaceArg === 'function' ? namespaceArg(props) : namespaceArg || context.defaultNS || _this.i18n.options && _this.i18n.options.defaultNS;
        if (typeof _this.namespaces === 'string') _this.namespaces = [_this.namespaces];

        var i18nOptions = _this.i18n && _this.i18n.options && _this.i18n.options.react || {};
        _this.options = translate__extends({}, getDefaults(), i18nOptions, options);

        if (context.reportNS) {
          var namespaces = _this.namespaces || [undefined];
          namespaces.forEach(context.reportNS);
        }

        _this.getWrappedInstance = _this.getWrappedInstance.bind(_this);
        return _this;
      }

      translate__createClass(Translate, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
          if (!this.options.usePureComponent) {
            return true;
          }

          return !shallowEqual(this.props, nextProps);
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          if (!this.options.withRef) {
            // eslint-disable-next-line no-console
            console.error('To access the wrapped instance, you need to specify ' + '{ withRef: true } as the second argument of the translate() call.');
          }

          /* eslint react/no-string-refs: 1 */
          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var extraProps = {};

          if (this.options.withRef) {
            extraProps.ref = function (c) {
              _this2.wrappedInstance = c;
            };
          }

          return preact_compat_es.createElement(es_I18n, translate__extends({ ns: this.namespaces }, this.options, this.props, { i18n: this.i18n }), function (t, _ref) {
            var ready = _ref.ready,
                context = _objectWithoutProperties(_ref, ['ready']);

            return preact_compat_es.createElement(WrappedComponent, translate__extends({
              tReady: ready
            }, _this2.props, extraProps, context));
          });
        }
      }]);

      return Translate;
    }(Component$1);

    Translate.WrappedComponent = WrappedComponent;

    Translate.contextTypes = {
      i18n: prop_types_default.a.object,
      defaultNS: prop_types_default.a.string,
      reportNS: prop_types_default.a.func
    };

    Translate.displayName = 'Translate(' + getDisplayName(WrappedComponent) + ')';

    Translate.namespaces = namespaceArg;

    return hoist_non_react_statics_cjs_default()(Translate, WrappedComponent);
  };
}

translate.setDefaults = setDefaults;

translate.setI18n = setI18n;
// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/Interpolate.js
var Interpolate__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var Interpolate__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function Interpolate__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Interpolate__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function Interpolate__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}




var Interpolate_Interpolate = function (_Component) {
  Interpolate__inherits(Interpolate, _Component);

  function Interpolate(props, context) {
    Interpolate__classCallCheck(this, Interpolate);

    var _this = Interpolate__possibleConstructorReturn(this, (Interpolate.__proto__ || Object.getPrototypeOf(Interpolate)).call(this, props, context));

    _this.i18n = props.i18n || context.i18n;
    _this.t = props.t || context.t;
    return _this;
  }

  Interpolate__createClass(Interpolate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var parent = this.props.parent || 'span';
      var REGEXP = this.props.regexp || this.i18n.services.interpolator.regexp;
      var _props = this.props,
          className = _props.className,
          style = _props.style;

      // Set to true if you want to use raw HTML in translation values
      // See https://github.com/i18next/react-i18next/issues/189

      var useDangerouslySetInnerHTML = this.props.useDangerouslySetInnerHTML || false;
      var dangerouslySetInnerHTMLPartElement = this.props.dangerouslySetInnerHTMLPartElement || 'span';

      var tOpts = Interpolate__extends({}, this.props.options, { interpolation: { prefix: '#$?', suffix: '?$#' } });
      var format = this.t(this.props.i18nKey, tOpts);

      if (!format || typeof format !== 'string') return preact_compat_es.createElement('noscript', null);

      var children = [];

      var handleFormat = function handleFormat(key, props) {
        if (key.indexOf(_this2.i18n.options.interpolation.formatSeparator) < 0) {
          if (props[key] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + key + ' for interpolating ' + format);
          return props[key];
        }

        var p = key.split(_this2.i18n.options.interpolation.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this2.i18n.options.interpolation.formatSeparator).trim();

        if (props[k] === undefined) _this2.i18n.services.logger.warn('interpolator: missed to pass in variable ' + k + ' for interpolating ' + format);
        return _this2.i18n.options.interpolation.format(props[k], f, _this2.i18n.language);
      };

      format.split(REGEXP).reduce(function (memo, match, index) {
        var child = void 0;

        if (index % 2 === 0) {
          if (match.length === 0) return memo;
          if (useDangerouslySetInnerHTML) {
            child = preact_compat_es.createElement(dangerouslySetInnerHTMLPartElement, { dangerouslySetInnerHTML: { __html: match } });
          } else {
            child = match;
          }
        } else {
          child = handleFormat(match, _this2.props);
        }

        memo.push(child);
        return memo;
      }, children);

      var additionalProps = {};
      if (this.i18n.options.react && this.i18n.options.react.exposeNamespace) {
        var ns = typeof this.t.ns === 'string' ? this.t.ns : this.t.ns[0];
        if (this.props.i18nKey && this.i18n.options.nsSeparator && this.props.i18nKey.indexOf(this.i18n.options.nsSeparator) > -1) {
          var parts = this.props.i18nKey.split(this.i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (this.t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (className) additionalProps.className = className;
      if (style) additionalProps.style = style;

      return preact_compat_es.createElement.apply(this, [parent, additionalProps].concat(children));
    }
  }]);

  return Interpolate;
}(Component$1);

Interpolate_Interpolate.defaultProps = {
  className: ''
};

Interpolate_Interpolate.contextTypes = {
  i18n: prop_types_default.a.object.isRequired,
  t: prop_types_default.a.func.isRequired
};

/* harmony default export */ var es_Interpolate = (Interpolate_Interpolate);
// EXTERNAL MODULE: ../node_modules/html-parse-stringify2/index.js
var html_parse_stringify2 = __webpack_require__("C6iP");
var html_parse_stringify2_default = /*#__PURE__*/__webpack_require__.n(html_parse_stringify2);

// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/Trans.js
var Trans__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var Trans__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var Trans__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function Trans__objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function Trans__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Trans__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function Trans__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}





function hasChildren(node) {
  return node && (node.children || node.props && node.props.children);
}

function getChildren(node) {
  return node && node.children ? node.children : node.props && node.props.children;
}

function nodesToString(mem, children, index) {
  if (!children) return '';
  if (Object.prototype.toString.call(children) !== '[object Array]') children = [children];

  children.forEach(function (child, i) {
    // const isElement = React.isValidElement(child);
    // const elementKey = `${index !== 0 ? index + '-' : ''}${i}:${typeof child.type === 'function' ? child.type.name : child.type || 'var'}`;
    var elementKey = '' + i;

    if (typeof child === 'string') {
      mem = '' + mem + child;
    } else if (hasChildren(child)) {
      mem = mem + '<' + elementKey + '>' + nodesToString('', getChildren(child), i + 1) + '</' + elementKey + '>';
    } else if (preact_compat_es.isValidElement(child)) {
      mem = mem + '<' + elementKey + '></' + elementKey + '>';
    } else if ((typeof child === 'undefined' ? 'undefined' : Trans__typeof(child)) === 'object') {
      var clone = Trans__extends({}, child);
      var format = clone.format;
      delete clone.format;

      var keys = Object.keys(clone);
      if (format && keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + ', ' + format + '}}</' + elementKey + '>';
      } else if (keys.length === 1) {
        mem = mem + '<' + elementKey + '>{{' + keys[0] + '}}</' + elementKey + '>';
      } else if (console && console.warn) {
        // not a valid interpolation object (can only contain one value plus format)
        console.warn('react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.', child);
      }
    } else if (console && console.warn) {
      console.warn('react-i18next: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.', child);
    }
  });

  return mem;
}

function renderNodes(children, targetString, i18n) {
  if (targetString === "") return [];
  if (!children) return [targetString];

  // parse ast from string with additional wrapper tag
  // -> avoids issues in parser removing prepending text nodes
  var ast = html_parse_stringify2_default.a.parse('<0>' + targetString + '</0>');

  function mapAST(reactNodes, astNodes) {
    if (Object.prototype.toString.call(reactNodes) !== '[object Array]') reactNodes = [reactNodes];
    if (Object.prototype.toString.call(astNodes) !== '[object Array]') astNodes = [astNodes];

    return astNodes.reduce(function (mem, node, i) {
      if (node.type === 'tag') {
        var child = reactNodes[parseInt(node.name, 10)] || {};
        var isElement = preact_compat_es.isValidElement(child);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren(child)) {
          var inner = mapAST(getChildren(child), node.children);
          if (child.dummy) child.children = inner; // needed on preact!
          mem.push(preact_compat_es.cloneElement(child, Trans__extends({}, child.props, { key: i }), inner));
        } else if ((typeof child === 'undefined' ? 'undefined' : Trans__typeof(child)) === 'object' && !isElement) {
          var content = node.children[0] ? node.children[0].content : null;
          if (content) {
            var interpolated = i18n.services.interpolator.interpolate(node.children[0].content, child, i18n.language);
            mem.push(interpolated);
          }
        } else {
          mem.push(child);
        }
      } else if (node.type === 'text') {
        mem.push(node.content);
      }
      return mem;
    }, []);
  }

  // call mapAST with having react nodes nested into additional node like
  // we did for the string ast from translation
  // return the children of that extra node to get expected result
  var result = mapAST([{ dummy: true, children: children }], ast);
  return getChildren(result[0]);
}

var Trans_Trans = function (_React$Component) {
  Trans__inherits(Trans, _React$Component);

  function Trans() {
    Trans__classCallCheck(this, Trans);

    return Trans__possibleConstructorReturn(this, (Trans.__proto__ || Object.getPrototypeOf(Trans)).apply(this, arguments));
  }

  Trans__createClass(Trans, [{
    key: 'render',
    value: function render() {
      var contextAndProps = Trans__extends({ i18n: this.context.i18n, t: this.context.t }, this.props);

      var children = contextAndProps.children,
          count = contextAndProps.count,
          parent = contextAndProps.parent,
          i18nKey = contextAndProps.i18nKey,
          tOptions = contextAndProps.tOptions,
          values = contextAndProps.values,
          defaults = contextAndProps.defaults,
          components = contextAndProps.components,
          namespace = contextAndProps.ns,
          i18n = contextAndProps.i18n,
          tFromContextAndProps = contextAndProps.t,
          additionalProps = Trans__objectWithoutProperties(contextAndProps, ['children', 'count', 'parent', 'i18nKey', 'tOptions', 'values', 'defaults', 'components', 'ns', 'i18n', 't']);

      var t = tFromContextAndProps || i18n.t.bind(i18n);

      var reactI18nextOptions = i18n.options && i18n.options.react || {};
      var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;

      var defaultValue = defaults || nodesToString('', children, 0);
      var hashTransKey = reactI18nextOptions.hashTransKey;
      var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
      var interpolationOverride = values ? {} : { interpolation: { prefix: '#$?', suffix: '?$#' } };
      var translation = key ? t(key, Trans__extends({}, tOptions, values, interpolationOverride, { defaultValue: defaultValue, count: count, ns: namespace })) : defaultValue;

      if (reactI18nextOptions.exposeNamespace) {
        var ns = typeof t.ns === 'string' ? t.ns : t.ns[0];
        if (i18nKey && i18n.options && i18n.options.nsSeparator && i18nKey.indexOf(i18n.options.nsSeparator) > -1) {
          var parts = i18nKey.split(i18n.options.nsSeparator);
          ns = parts[0];
        }
        if (t.ns) additionalProps['data-i18next-options'] = JSON.stringify({ ns: ns });
      }

      if (!useAsParent) return renderNodes(components || children, translation, i18n);

      return preact_compat_es.createElement(useAsParent, additionalProps, renderNodes(components || children, translation, i18n));
    }
  }]);

  return Trans;
}(preact_compat_es.Component);

/* harmony default export */ var es_Trans = (Trans_Trans);

// Trans.defaultProps = {
//   parent: 'div'
// };

Trans_Trans.contextTypes = {
  i18n: prop_types_default.a.object,
  t: prop_types_default.a.func
};
// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/I18nextProvider.js
var I18nextProvider__createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function I18nextProvider__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function I18nextProvider__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function I18nextProvider__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}




var I18nextProvider_I18nextProvider = function (_Component) {
  I18nextProvider__inherits(I18nextProvider, _Component);

  function I18nextProvider(props, context) {
    I18nextProvider__classCallCheck(this, I18nextProvider);

    var _this = I18nextProvider__possibleConstructorReturn(this, (I18nextProvider.__proto__ || Object.getPrototypeOf(I18nextProvider)).call(this, props, context));

    _this.i18n = props.i18n;
    _this.defaultNS = props.defaultNS;
    if (props.initialI18nStore) {
      _this.i18n.services.resourceStore.data = props.initialI18nStore;
      _this.i18n.options.isInitialSSR = true; // if set will be deleted on first render in translate hoc
    }
    if (props.initialLanguage) {
      _this.i18n.changeLanguage(props.initialLanguage);
    }
    _this.reportNS = props.reportNS;
    return _this;
  }

  I18nextProvider__createClass(I18nextProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        i18n: this.i18n,
        defaultNS: this.defaultNS,
        reportNS: this.reportNS
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.i18n !== nextProps.i18n) {
        throw new Error('[react-i18next][I18nextProvider]does not support changing the i18n object.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return Children.only(children);
    }
  }]);

  return I18nextProvider;
}(Component$1);

I18nextProvider_I18nextProvider.propTypes = {
  i18n: prop_types_default.a.object.isRequired,
  children: prop_types_default.a.element.isRequired,
  defaultNS: prop_types_default.a.string,
  reportNS: prop_types_default.a.func
};

I18nextProvider_I18nextProvider.childContextTypes = {
  i18n: prop_types_default.a.object.isRequired,
  defaultNS: prop_types_default.a.string,
  reportNS: prop_types_default.a.func
};

I18nextProvider_I18nextProvider.defaultProps = {
  defaultNS: undefined,
  reportNS: undefined
};

/* harmony default export */ var es_I18nextProvider = (I18nextProvider_I18nextProvider);
// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/loadNamespaces.js
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var loadNamespaces__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var objectEntries = Object.entries || function (obj) {
  var ownProps = Object.keys(obj),
      i = ownProps.length,
      resArray = new Array(i); // preallocate the Array
  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }return resArray;
};

// Borrowed from https://github.com/Rezonans/redux-async-connect/blob/master/modules/ReduxAsyncConnect.js#L16
function eachComponents(components, iterator) {
  for (var i = 0, l = components.length; i < l; i++) {
    // eslint-disable-line id-length
    if (loadNamespaces__typeof(components[i]) === 'object') {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = objectEntries(components[i])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];

          iterator(value, i, key);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else {
      iterator(components[i], i);
    }
  }
}

function filterAndFlattenComponents(components) {
  var flattened = [];
  eachComponents(components, function (Component) {
    if (Component && Component.namespaces) {

      Component.namespaces.forEach(function (namespace) {
        if (flattened.indexOf(namespace) === -1) {
          flattened.push(namespace);
        }
      });
    }
  });
  return flattened;
}

function loadNamespaces(_ref) {
  var components = _ref.components,
      i18n = _ref.i18n;

  var allNamespaces = filterAndFlattenComponents(components);

  return new Promise(function (resolve) {
    i18n.loadNamespaces(allNamespaces, resolve);
  });
}
// CONCATENATED MODULE: ../node_modules/react-i18next/dist/es/index.js







// EXTERNAL MODULE: ../node_modules/preact-router/match.js
var preact_router_match = __webpack_require__("sw5u");
var match_default = /*#__PURE__*/__webpack_require__.n(preact_router_match);

// CONCATENATED MODULE: ./components/Navigation.js


function Navigation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Navigation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Navigation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Navigation__ref = Object(preact_min["h"])(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 125" },
  Object(preact_min["h"])("path", { d: "M45.7,84.7c-1.2,0-2.3-0.4-3.2-1.3c-1.8-1.8-1.8-4.6,0-6.4l27-27l-27-27c-1.8-1.8-1.8-4.6,0-6.4c1.8-1.8,4.6-1.8,6.4,0 l30.2,30.2c1.8,1.8,1.8,4.6,0,6.4L48.9,83.4C48.1,84.2,46.9,84.7,45.7,84.7z" }),
  Object(preact_min["h"])("path", { d: "M24.1,84.7c-1.2,0-2.3-0.4-3.2-1.3c-1.8-1.8-1.8-4.6,0-6.4l27-27l-27-27c-1.8-1.8-1.8-4.6,0-6.4c1.8-1.8,4.6-1.8,6.4,0 l30.2,30.2c1.8,1.8,1.8,4.6,0,6.4L27.3,83.4C26.4,84.2,25.2,84.7,24.1,84.7z" })
);

var _ref2 = Object(preact_min["h"])("i", { className: "icon-account" });

var _ref3 = Object(preact_min["h"])("i", { className: "icon-security" });

var _ref4 = Object(preact_min["h"])("i", { className: "icon-account" });

var _ref5 = Object(preact_min["h"])("i", { className: "icon-vip" });

var _ref6 = Object(preact_min["h"])("i", { className: "icon-settings" });

var _ref7 = Object(preact_min["h"])("i", { className: "icon-logout" });

var _ref8 = Object(preact_min["h"])("i", { className: "icon-account" });

var _ref9 = Object(preact_min["h"])("i", { className: "icon-security" });

var _ref10 = Object(preact_min["h"])("i", { className: "icon-account" });

var _ref11 = Object(preact_min["h"])("i", { className: "icon-vip" });

var _ref12 = Object(preact_min["h"])("i", { className: "icon-settings" });

var _ref13 = Object(preact_min["h"])("i", { className: "icon-logout" });

var _ref14 = Object(preact_min["h"])(
  "svg",
  { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 125" },
  Object(preact_min["h"])("path", { d: "M45.7,84.7c-1.2,0-2.3-0.4-3.2-1.3c-1.8-1.8-1.8-4.6,0-6.4l27-27l-27-27c-1.8-1.8-1.8-4.6,0-6.4c1.8-1.8,4.6-1.8,6.4,0 l30.2,30.2c1.8,1.8,1.8,4.6,0,6.4L48.9,83.4C48.1,84.2,46.9,84.7,45.7,84.7z" }),
  Object(preact_min["h"])("path", { d: "M24.1,84.7c-1.2,0-2.3-0.4-3.2-1.3c-1.8-1.8-1.8-4.6,0-6.4l27-27l-27-27c-1.8-1.8-1.8-4.6,0-6.4c1.8-1.8,4.6-1.8,6.4,0 l30.2,30.2c1.8,1.8,1.8,4.6,0,6.4L27.3,83.4C26.4,84.2,25.2,84.7,24.1,84.7z" })
);

var Navigation_Navigation = function (_Component) {
  Navigation__inherits(Navigation, _Component);

  function Navigation(props) {
    Navigation__classCallCheck(this, Navigation);

    var _this = Navigation__possibleConstructorReturn(this, _Component.call(this, props));

    _this.createCookie = function (name, value, days) {
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        var expires = "; expires=" + date.toGMTString();
        document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
      } else {
        var _expires = "";
        document.cookie = name + "=" + value + _expires + ";domain=.hirezstudios.com;path=/";
      }
    };

    _this.toggleNav = function () {
      _this.state.mobileNavToggled ? _this.setState({ mobileNavToggled: false }) : _this.setState({ mobileNavToggled: true });
    };

    _this.addWindowClickListener = function () {
      window.addEventListener("click", _this.closeMenu);
    };

    _this.closeMenu = function () {
      _this.state.mobileNavToggled ? _this.setState({ mobileNavToggled: false }) : "";
    };

    _this.eraseCookie = function (name) {
      _this.createCookie(name, "", -1);
    };

    _this.logoutUser = function () {
      localStorage.removeItem("linkRedirectUrl");
      _this.eraseCookie("HZAcctTokenExp");
      _this.eraseCookie("HZAcctUsername");
      _this.eraseCookie("HZAcctWebToken");
      _this.eraseCookie("HZRegion");
      _this.eraseCookie("HZAcctID");
      location.reload();
    };

    _this.readCookie = function (name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    };

    _this.state = {
      mobileNavToggled: false
    };
    return _this;
  }

  Navigation.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    console.log(this.state.mobileNavToggled);
  };

  Navigation.prototype.componentDidMount = function componentDidMount() {
    this.addWindowClickListener();
  };

  Navigation.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.props.windowWidth < 1200) {
      //This measures how far to push the main window over when the mobile nav is open.
      this.state.mobileNavToggled ? document.getElementsByClassName("wrapped-content")[0].setAttribute("style", "transform: translateX(" + (document.getElementById("mobile").offsetWidth - (document.body.offsetWidth - document.getElementsByClassName("center-wrapper")[0].offsetWidth) / 2) + "px);") : document.getElementsByClassName("wrapped-content")[0].setAttribute("style", "transform: translateX(0);");
    } else {
      this.state.mobileNavToggled ? this.setState({ mobileNavToggled: false }) : "";
      document.getElementsByClassName("wrapped-content")[0].setAttribute("style", "transform: translateX(0);");
    }
  };

  Navigation.prototype.render = function render() {
    var _this2 = this;

    var userData = this.context.userData;
    var t = this.props.t;

    return Object(preact_min["h"])(
      "div",
      { onClick: function onClick(e) {
          return e.stopPropagation();
        } },
      Object(preact_min["h"])(
        "div",
        { className: "nav-trigger", onClick: this.toggleNav },
        Navigation__ref
      ),
      Object(preact_min["h"])(
        "nav",
        { className: "primary " + (this.state.mobileNavToggled ? "mobile-nav-active" : "") },
        Object(preact_min["h"])(
          preact_router_match["Link"],
          { activeClassName: "active", href: "/" },
          _ref2,
          t("Account Info")
        ),
        Object(preact_min["h"])(
          preact_router_match["Link"],
          { activeClassName: "active", href: "/security" },
          _ref3,
          t("Security")
        ),
        Object(preact_min["h"])(
          preact_router_match["Link"],
          { activeClassName: "active", href: "/linked-accounts" },
          _ref4,
          t("Linked Accounts")
        ),
        this.props.isVIP && Object(preact_min["h"])(
          preact_router_match["Link"],
          {
            activeClassName: "active",
            className: "vip " + (this.props.chatActive ? "chat-active" : ""),
            href: "/vip-chat"
          },
          _ref5,
          t("VIP Chat")
        ),
        Object(preact_min["h"])(
          preact_router_match["Link"],
          { activeClassName: "active", href: "/other-settings" },
          _ref6,
          t("Other Settings")
        ),
        Object(preact_min["h"])(
          preact_router_match["Link"],
          { activeClassName: "active", onClick: this.logoutUser },
          _ref7,
          t("Logout")
        )
      ),
      Object(preact_min["h"])(
        "nav",
        { id: "mobile", "class": "mobile " + (this.state.mobileNavToggled ? "mobile-nav-active" : "") },
        Object(preact_min["h"])(
          "div",
          { className: "user-info" },
          Object(preact_min["h"])(
            "p",
            null,
            this.readCookie("HZAcctUsername")
          )
        ),
        Object(preact_min["h"])(
          preact_router_match["Link"],
          { activeClassName: "active", href: "/", onClick: function onClick() {
              return _this2.handleClick();
            } },
          _ref8,
          t("Account Info")
        ),
        Object(preact_min["h"])(
          preact_router_match["Link"],
          { activeClassName: "active", href: "/security", onClick: function onClick() {
              return _this2.handleClick();
            } },
          _ref9,
          t("Security")
        ),
        Object(preact_min["h"])(
          preact_router_match["Link"],
          { activeClassName: "active", href: "/linked-accounts", onClick: function onClick() {
              return _this2.handleClick();
            } },
          _ref10,
          t("Linked Accounts")
        ),
        this.props.isVIP && Object(preact_min["h"])(
          preact_router_match["Link"],
          {
            activeClassName: "active",
            className: "vip " + (this.props.chatActive ? "chat-active" : ""),
            href: "/vip-chat",
            onClick: function onClick() {
              return _this2.handleClick();
            }
          },
          _ref11,
          t("VIP Chat")
        ),
        Object(preact_min["h"])(
          preact_router_match["Link"],
          { activeClassName: "active", href: "/other-settings", onClick: function onClick() {
              return _this2.handleClick();
            } },
          _ref12,
          t("Other Settings")
        ),
        Object(preact_min["h"])(
          preact_router_match["Link"],
          { activeClassName: "active", onClick: this.logoutUser, href: "/" },
          _ref13,
          t("Logout")
        ),
        Object(preact_min["h"])(
          "div",
          { className: "nav-trigger back", onClick: this.toggleNav },
          _ref14
        )
      )
    );
  };

  return Navigation;
}(preact_min["Component"]);

/* harmony default export */ var components_Navigation = (translate(["common"], { withRef: true })(Navigation_Navigation));
// CONCATENATED MODULE: ./components/AccountOverview.js


function AccountOverview__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AccountOverview__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AccountOverview__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AccountOverview__ref = Object(preact_min["h"])(
	preact_router_match["Link"],
	{ className: 'logo', href: '/' },
	Object(preact_min["h"])('img', { src: 'https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2018/03/Logo_Hi-Rez_White_1c_R.png', alt: 'Hi-Rez Studios Logo' })
);

var AccountOverview__ref2 = Object(preact_min["h"])('img', { src: 'https://webcdn.hirezstudios.com/account-services/mobile-icons.png', alt: '' });

var AccountOverview__ref3 = Object(preact_min["h"])(
	preact_router_match["Link"],
	{ className: 'logo', href: '/' },
	Object(preact_min["h"])('img', { src: 'https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2018/03/Logo_Hi-Rez_White_1c_R.png', alt: 'Hi-Rez Studios Logo' })
);

var AccountOverview_AccountOverview = function (_Component) {
	AccountOverview__inherits(AccountOverview, _Component);

	function AccountOverview(props) {
		AccountOverview__classCallCheck(this, AccountOverview);

		var _this = AccountOverview__possibleConstructorReturn(this, _Component.call(this, props));

		_this.openNav = function () {
			if (_this.state.displayNav === true && _this.props.windowWidth <= 800) {
				_this.setState({ displayNav: false });
				document.body.classList.remove('shift');
				document.getElementById('acct').classList.remove('move');
				document.documentElement.style.overflow = 'auto';
				document.body.scroll = 'yes';
			} else if (_this.state.displayNav === false && _this.props.windowWidth <= 800) {
				_this.setState({ displayNav: true });
				document.body.classList.add('shift');
				document.getElementById('acct').classList.add('move');
				document.documentElement.style.overflow = 'hidden';
				document.body.scroll = 'no';
			} else if (_this.state.displayNav === true && _this.props.windowWidth > 800) {
				_this.setState({ displayNav: false });
				document.body.classList.remove('shift');
				document.getElementById('acct').classList.remove('move');
			} else if (_this.state.displayNav === false && _this.props.windowWidth > 800) {
				_this.setState({ displayNav: true });
				document.body.classList.add('shift');
				document.getElementById('acct').classList.add('move');
			}
		};

		_this.state = {
			displayNav: false
		};
		return _this;
	}

	AccountOverview.prototype.componentDidMount = function componentDidMount() {
		{/* TODO: Check if cookies exist and call account information otherwise display AccountPanel */}
	};

	AccountOverview.prototype.render = function render() {
		var _this2 = this;

		var t = this.props.t;

		if (this.state.windowWidth >= 1200) {
			return Object(preact_min["h"])(
				'header',
				{ className: 'account-overview' },
				AccountOverview__ref,
				Object(preact_min["h"])(
					'div',
					{ className: 'links' },
					Object(preact_min["h"])(
						'div',
						{ className: 'link' },
						t('Games')
					),
					Object(preact_min["h"])(
						'div',
						{ className: 'link' },
						t('Language')
					)
				)
			);
		}
		return Object(preact_min["h"])(
			'header',
			{ className: 'account-overview', id: 'acct' },
			Object(preact_min["h"])(
				'div',
				{ className: 'mobile-nav ' + (this.props.windowWidth < 1200 ? 'active' : ''), onClick: function onClick() {
						return _this2.openNav();
					} },
				AccountOverview__ref2,
				Object(preact_min["h"])(
					'div',
					{ id: 'display-nav', className: '' + (this.state.displayNav ? 'active' : '') },
					Object(preact_min["h"])(components_Navigation, { windowWidth: this.state.windowWidth, chatActive: this.state.chatActive })
				)
			),
			AccountOverview__ref3,
			Object(preact_min["h"])(
				'div',
				{ className: 'links' },
				Object(preact_min["h"])(
					'div',
					{ className: 'link' },
					t('Games')
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'link' },
					t('Language')
				)
			)
		);
	};

	return AccountOverview;
}(preact_min["Component"]);

/* harmony default export */ var components_AccountOverview = (translate(['common'], { withRef: true })(AccountOverview_AccountOverview));
// CONCATENATED MODULE: ./components/NotificationBanner.js


function NotificationBanner__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function NotificationBanner__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function NotificationBanner__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var NotificationBanner_NotificationBanner = function (_Component) {
	NotificationBanner__inherits(NotificationBanner, _Component);

	function NotificationBanner(props) {
		NotificationBanner__classCallCheck(this, NotificationBanner);

		var _this = NotificationBanner__possibleConstructorReturn(this, _Component.call(this, props));

		_this.updateType = function (type) {
			switch (type) {
				case 'success':
					_this.setState({ type: 'success' });
					break;
				case 'warn':
					_this.setState({ type: 'warn' });
					break;
				case 'fail':
					_this.setState({ type: 'fail' });
					break;
				default:
					_this.setState({ type: 'hidden' });
			}
		};

		_this.updateType(_this.props.type);
		return _this;
	}

	NotificationBanner.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		var _this2 = this;

		if (this.props.type !== nextProps.type) {
			this.updateType(nextProps.type);
		}
		if (nextProps.time) {
			setTimeout(function () {
				_this2.updateType('hidden');
			}, nextProps.time);
		}
	};

	NotificationBanner.prototype.render = function render() {
		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'notification ' + this.state.type },
			Object(preact_min["h"])(
				'p',
				null,
				t(this.props.copy)
			)
		);
	};

	return NotificationBanner;
}(preact_min["Component"]);

/* harmony default export */ var components_NotificationBanner = (translate(['common'], { withRef: true })(NotificationBanner_NotificationBanner));
// EXTERNAL MODULE: ../node_modules/preact-router/dist/preact-router.es.js
var preact_router_es = __webpack_require__("/QC5");

// CONCATENATED MODULE: ./components/Button.js



var Button__ref = Object(preact_min["h"])(
	'div',
	{ 'class': 'spinner' },
	Object(preact_min["h"])('div', { 'class': 'bounce1' }),
	Object(preact_min["h"])('div', { 'class': 'bounce2' }),
	Object(preact_min["h"])('div', { 'class': 'bounce3' })
);

var Button_Button = function Button(props) {
	var color = props.color,
	    copy = props.copy,
	    onClick = props.onClick,
	    state = props.state;

	return Object(preact_min["h"])(
		'div',
		{ onClick: onClick, className: 'c-Button ' + color + ' ' + (state === 'loading' ? 'is-loading' : '') },
		state !== 'loading' ? copy : '',
		state === 'loading' && Button__ref
	);
};

/* harmony default export */ var components_Button = (Button_Button);
// CONCATENATED MODULE: ./components/GameOverviewCard.js


function GameOverviewCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function GameOverviewCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function GameOverviewCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var GameOverviewCard_GameOverviewCard = function (_Component) {
	GameOverviewCard__inherits(GameOverviewCard, _Component);

	function GameOverviewCard(props) {
		GameOverviewCard__classCallCheck(this, GameOverviewCard);

		var _this = GameOverviewCard__possibleConstructorReturn(this, _Component.call(this));

		_this.hideInfo = function () {
			if (_this.state.currency !== '0') {
				_this.setState({ currency: true });
			} else if (_this.state.game !== '') {
				_this.setState({ download: true });
				_this.setState({ refer: true });
			}
		};

		_this.checkRefer = function () {
			if (_this.state.game === 'tactics' || _this.state.game === 'realm') {
				_this.setState({ refer: false });
			}
		};

		_this.constructDownloadLink = function (game) {
			switch (game) {
				case 'smite':
					_this.setState({ downloadLink: 'https://www.smitegame.com/download' });
					break;
				case 'paladins':
					_this.setState({ downloadLink: 'https://www.paladins.com/download' });
					break;
				case 'tactics':
					_this.setState({ downloadLink: 'http://cds.q6u4m8x5.hwcdn.net/Installs/InstallSmiteTactics.exe' });
					break;
				case 'realm-royale':
					_this.setState({ downloadLink: 'https://www.realmroyale.com/sign-up' });
					break;
			}
		};

		_this.state = {
			game: props.game || '',
			refer: true,
			downloadLink: undefined
		};
		return _this;
	}

	GameOverviewCard.prototype.componentDidMount = function componentDidMount() {
		this.hideInfo();
		this.checkRefer();
		this.constructDownloadLink(this.props.game);
	};

	GameOverviewCard.prototype.render = function render() {
		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'game-container' },
			Object(preact_min["h"])(
				'div',
				{ className: 'center' },
				Object(preact_min["h"])(
					'div',
					{ className: 'game-logo' },
					Object(preact_min["h"])('img', { src: 'https://webcdn.hirezstudios.com/account-services/logo-' + this.props.game + '.png' })
				),
				Object(preact_min["h"])(
					'p',
					{ className: 'username' },
					this.props.name
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'links-container' },
					Object(preact_min["h"])(
						'a',
						{ href: this.state.downloadLink },
						Object(preact_min["h"])(components_Button, {
							color: 'blue',
							copy: t('Download')
						})
					),
					Object(preact_min["h"])(
						preact_router_match["Link"],
						{ className: this.state.refer === false ? 'is-disabled' : '', href: '/refer/' + this.props.game },
						Object(preact_min["h"])(components_Button, {
							color: 'blue',
							copy: t('Refer a Friend')
						})
					)
				)
			)
		);
	};

	return GameOverviewCard;
}(preact_min["Component"]);

/* harmony default export */ var components_GameOverviewCard = (translate(['common'], { withRef: true })(GameOverviewCard_GameOverviewCard));
// CONCATENATED MODULE: ./components/views/Overview.js


function Overview__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Overview__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Overview__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






//import GameInvites from '../GameInvites';

var Overview_Overview = function (_Component) {
	Overview__inherits(Overview, _Component);

	// setEmailPrefs = (subPref) => {
	// 	console.log(subPref);
	// 	switch (subPref) {
	// 		case true:
	// 			this.setState({
	// 				prefFlag: 'true',
	// 				optOption: 'Unsubscribe from'
	// 			});
	// 			break;
	// 		case false:
	// 			this.setState({
	// 				prefFlag: 'false',
	// 				optOption: 'Subscribe to'
	// 			});
	// 			break;
	// 	}
	// }

	function Overview() {
		Overview__classCallCheck(this, Overview);

		var _this = Overview__possibleConstructorReturn(this, _Component.call(this));

		_this.checkVerificationKey = function () {
			var key = _this.getParameterByName('key');
			var type = _this.getParameterByName('type');
			if (key) {
				var promise = void 0;
				if (type === 'verifyBackup') {
					promise = fetch('https://api.hirezstudios.com/acct/verifyBackupEmail', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: '{"webToken": "' + _this.context.userData.webToken + '", "key": "' + key + '"}'
					});
				} else {
					promise = fetch('https://api.hirezstudios.com/acct/verify', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: '{\n\t\t\t\t\t"key": "' + key + '"\n\t\t\t\t\t}'
					});
				}
				promise.then(function (response) {
					return response.json();
				}).then(function (response) {
					console.log('Verified');
				});
			}
		};

		_this.getParameterByName = function (name, url) {
			if (!url) url = window.location.href;
			name = name.replace(/[\[\]]/g, '\\$&');
			var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
			    results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		};

		_this.sendVerification = function () {
			fetch('https://api.hirezstudios.com/acct/createVerification', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: '{\n\t\t\t"webToken": "' + _this.context.userData.webToken + '"\n\t\t\t}'
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				_this.props.notification('success', 10000, 'Verification email sent.');
			});
		};

		_this.subscribe = function (event) {
			fetch('https://api.hirezstudios.com/acct/subscribe', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: '{\n          "webToken": "' + _this.context.userData.webToken + '",\n          "subscribe": "' + event.target.checked + '"\n        }'
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				if (response.statusCode === 200) {
					console.log('Success');
				} else {
					console.log('Error');
				}
			});
		};

		_this.state = {
			// prefFlag: null,
			// optOption: null
		};
		return _this;
	}

	Overview.prototype.componentDidUpdate = function componentDidUpdate() {
		if (this.context.accountInfo !== null && this.state.prefFlag === null) {
			this.setEmailPrefs(this.context.userData.accountInfo.contactInfo.subscriber);
		}
		this.checkVerificationKey();
	};

	Overview.prototype.render = function render() {
		var _this2 = this;

		var userData = this.context.userData;
		var t = this.props.t;


		return Object(preact_min["h"])(
			'div',
			{ className: 'view-overview' },
			Object(preact_min["h"])(
				'h1',
				null,
				t('Account Overview')
			),
			userData.accountInfo && Object(preact_min["h"])(
				'div',
				{ className: 'account-information' },
				Object(preact_min["h"])(
					'div',
					{ className: 'title' },
					Object(preact_min["h"])(
						'p',
						null,
						t('Username:')
					),
					Object(preact_min["h"])(
						'p',
						null,
						t('E-mail:')
					),
					Object(preact_min["h"])(
						'p',
						null,
						t('Account Id:')
					)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'information' },
					Object(preact_min["h"])(
						'p',
						null,
						userData.accountInfo.name
					),
					Object(preact_min["h"])(
						'div',
						{ className: 'verify-email-container' },
						Object(preact_min["h"])(
							'p',
							{ className: 'email' },
							userData.accountInfo.contactInfo.email
						),
						userData && userData.accountInfo.verified ? Object(preact_min["h"])(
							'div',
							{ className: 'edit-email' },
							Object(preact_min["h"])(
								'a',
								{ href: '/edit-email' },
								Object(preact_min["h"])(
									'p',
									null,
									t('Change')
								)
							)
						) : Object(preact_min["h"])(
							'div',
							{ className: 'verify-email' },
							Object(preact_min["h"])(
								'div',
								null,
								Object(preact_min["h"])(
									'p',
									{ className: 'verify-link', onClick: function onClick() {
											return _this2.sendVerification();
										} },
									t('Please verify your email address.')
								),
								Object(preact_min["h"])(
									'p',
									null,
									t('After verification, you can change your email address and password.')
								)
							)
						)
					),
					Object(preact_min["h"])(
						'p',
						null,
						userData.accountInfo.accountId
					)
				)
			),
			userData.accountInfo && Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ 'class': 'news-opt-in' },
					Object(preact_min["h"])('input', { type: 'checkbox', id: 'subscribeOptIn', name: 'subscribe', checked: userData.accountInfo.contactInfo.subscriber, onChange: this.subscribe }),
					Object(preact_min["h"])(
						'label',
						{ 'for': 'subscribe' },
						Object(preact_min["h"])(
							'p',
							null,
							t('I agree to receive Hi-Rez marketing communications, including event invitations, special offers, and newsletters.')
						)
					)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'games-container' },
					userData.accountInfo.games.map(function (data) {
						return Object(preact_min["h"])(components_GameOverviewCard, {
							name: data.playerName,
							game: data.game.toLowerCase().replace(/[^A-Z0-9]/ig, '-'),
							currencies: data.currency
						});
					})
				)
			)
		);
	};

	return Overview;
}(preact_min["Component"]);

/* harmony default export */ var views_Overview = (translate(['common'], { withRef: true })(Overview_Overview));
// CONCATENATED MODULE: ./components/ChangePassword.js


function ChangePassword__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ChangePassword__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ChangePassword__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var ChangePassword_ChangePassword = function (_Component) {
  ChangePassword__inherits(ChangePassword, _Component);

  function ChangePassword(props) {
    ChangePassword__classCallCheck(this, ChangePassword);

    var _this = ChangePassword__possibleConstructorReturn(this, _Component.call(this, props));

    _this.validateForm = function (currentPass, newPass, confirmPass) {
      _this.setState({
        errorCurrentPassword: undefined,
        errorNewPassword: undefined,
        errorConfirmPassword: undefined
      });
      if (!currentPass) {
        _this.setState({ errorCurrentPassword: 'You must enter your current password.' });
        return false;
      }
      if (!newPass) {
        _this.setState({ errorNewPassword: 'You must enter your current password.' });
        return false;
      }
      if (!confirmPass) {
        _this.setState({ errorConfirmPassword: 'You must enter your current password.' });
        return false;
      }
      if (newPass !== confirmPass) {
        _this.setState({ errorConfirmPassword: 'Passwords do not match. Please try again.' });
        return false;
      }
      return true;
    };

    _this.submitPasswordChange = function (e) {

      _this.setState({ buttonPasswordChange: 'loading' });
      if (_this.validateForm(_this.state.currentPassword, _this.state.newPassword, _this.state.confirmPassword)) {
        fetch('https://api.hirezstudios.com/acct/changePassword', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          body: '{"webToken": "' + _this.props.userData.webToken + '", "oldPassword": "' + _this.state.currentPassword + '", "newPassword": "' + _this.state.newPassword + '", "confirmNewPassword": "' + _this.state.confirmPassword + '"}'
        }).then(function (response) {
          _this.setState({ buttonPasswordChange: 'initial' });
          if (response.status === 500) {
            _this.setState({ errorConfirmPassword: 'Something went wrong. Please try again.' });
          } else {
            _this.props.notification('success', 10000, 'You\'ve successfully changed your password.');
            _this.setState({
              currentPassword: undefined,
              newPassword: undefined,
              confirmPassword: undefined
            });
          }
        });
      } else {
        _this.setState({ buttonPasswordChange: 'initial' });
      }
    };

    _this.state = {
      currentPassword: undefined,
      newPassword: undefined,
      confirmPassword: undefined,
      errorCurrentPassword: undefined,
      errorNewPassword: undefined,
      errorConfirmPassword: undefined,
      buttonPasswordChange: 'initial'
    };
    return _this;
  }

  ChangePassword.prototype.render = function render() {
    var _this2 = this;

    var t = this.props.t;

    return Object(preact_min["h"])(
      'div',
      { className: 'c-ChangePassword' },
      Object(preact_min["h"])(
        'h4',
        null,
        t('Change Your Password')
      ),
      Object(preact_min["h"])(
        'form',
        { className: 'change-password' },
        Object(preact_min["h"])(
          'div',
          { className: 'current-password' },
          Object(preact_min["h"])(
            'label',
            null,
            t('Current Password')
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'input-wrapper' },
            Object(preact_min["h"])('input', {
              id: 'current-password',
              type: 'password',
              onInput: function onInput(e) {
                return _this2.setState({ currentPassword: e.target.value });
              },
              value: this.state.currentPassword
            }),
            Object(preact_min["h"])(
              'div',
              { className: 'error-current-password' },
              t(this.state.errorCurrentPassword)
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'new-password' },
          Object(preact_min["h"])(
            'label',
            null,
            t('New Password')
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'input-wrapper' },
            Object(preact_min["h"])('input', {
              id: 'new-password',
              type: 'password',
              onInput: function onInput(e) {
                return _this2.setState({ newPassword: e.target.value });
              },
              value: this.state.newPassword
            }),
            Object(preact_min["h"])(
              'div',
              { className: 'error-new-password' },
              t(this.state.errorNewPassword)
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'confirm-password' },
          Object(preact_min["h"])(
            'label',
            null,
            t('Confirm New Password')
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'input-wrapper' },
            Object(preact_min["h"])('input', {
              id: 'confirm-password',
              type: 'password',
              onInput: function onInput(e) {
                return _this2.setState({ confirmPassword: e.target.value });
              },
              value: this.state.confirmPassword
            }),
            Object(preact_min["h"])(
              'div',
              { className: 'error-confirm-password' },
              t(this.state.errorConfirmPassword)
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'buttons-wrapper' },
          Object(preact_min["h"])(components_Button, {
            color: 'blue',
            copy: t('Change'),
            state: this.state.buttonPasswordChange,
            onClick: this.submitPasswordChange
          })
        )
      )
    );
  };

  return ChangePassword;
}(preact_min["Component"]);

/* harmony default export */ var components_ChangePassword = (translate(['common'], { withRef: true })(ChangePassword_ChangePassword));
// CONCATENATED MODULE: ./components/TwoFactorStatus.js


function TwoFactorStatus__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TwoFactorStatus__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TwoFactorStatus__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TwoFactorStatus_TwoFactorStatus = function (_Component) {
	TwoFactorStatus__inherits(TwoFactorStatus, _Component);

	function TwoFactorStatus() {
		var _temp, _this, _ret;

		TwoFactorStatus__classCallCheck(this, TwoFactorStatus);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = TwoFactorStatus__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			twoFactorData: null
		}, _this.enableTwoFactor = function () {
			Object(preact_router_es["route"])('/two-factor', true);
		}, _this.disableTwoFactor = function () {
			Object(preact_router_es["route"])('/two-factor-disable', true);
		}, _this.fetchTwoFactorInfo = function (webToken) {
			fetch('https://api.hirezstudios.com/acct/twoFactorInfo', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: '{"webToken": "' + webToken + '"}'
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				_this.setState({ twoFactorData: response });
			});
		}, _temp), TwoFactorStatus__possibleConstructorReturn(_this, _ret);
	}

	TwoFactorStatus.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		if (this.state.twoFactorData === null && nextProps.userData.webToken !== null) {
			this.fetchTwoFactorInfo(nextProps.userData.webToken);
		}
	};

	TwoFactorStatus.prototype.componentDidMount = function componentDidMount() {
		this.fetchTwoFactorInfo(this.props.userData.webToken);
	};

	TwoFactorStatus.prototype.render = function render() {
		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'c-TwoFactorStatus' },
			Object(preact_min["h"])(
				'h4',
				null,
				t('Two - Factor Sign In')
			),
			Object(preact_min["h"])(
				'p',
				null,
				t('Two-Factor Sign In can be used to help protect your account from unauthorized access by requiring you to enter an additional code when you sign in.'),
				' ',
				Object(preact_min["h"])(
					'a',
					{ href: '#learn-more' },
					t('Learn More.')
				)
			),
			this.state.twoFactorData && Object(preact_min["h"])(
				'table',
				{ className: 'current-settings' },
				Object(preact_min["h"])(
					'tr',
					null,
					Object(preact_min["h"])(
						'td',
						null,
						t('Status:')
					),
					Object(preact_min["h"])(
						'td',
						{ className: this.state.twoFactorData.validationPeriod === 'NONE' ? 'is-red' : 'is-green' },
						this.state.twoFactorData.validationPeriod === 'NONE' ? t('INACTIVE') : t('ACTIVE')
					)
				),
				this.state.twoFactorData.validationPeriod !== 'NONE' && Object(preact_min["h"])(
					'tbody',
					null,
					this.state.twoFactorData.phone !== null && Object(preact_min["h"])(
						'tr',
						null,
						Object(preact_min["h"])(
							'td',
							null,
							t('Phone Number:')
						),
						Object(preact_min["h"])(
							'td',
							null,
							this.state.twoFactorData.phone
						)
					),
					this.state.twoFactorData.backupEmail !== null && Object(preact_min["h"])(
						'tr',
						null,
						Object(preact_min["h"])(
							'td',
							null,
							t('Recovery E-Mail:')
						),
						Object(preact_min["h"])(
							'td',
							null,
							this.state.twoFactorData.backupEmail
						)
					),
					this.state.twoFactorData.validationPeriod !== null && Object(preact_min["h"])(
						'tr',
						null,
						Object(preact_min["h"])(
							'td',
							null,
							t('Frequency:')
						),
						Object(preact_min["h"])(
							'td',
							null,
							this.state.twoFactorData.validationPeriod
						)
					),
					this.state.twoFactorData.validationOption !== null && Object(preact_min["h"])(
						'tr',
						null,
						Object(preact_min["h"])(
							'td',
							null,
							t('Method:')
						),
						Object(preact_min["h"])(
							'td',
							null,
							this.state.twoFactorData.validationOption
						)
					)
				)
			),
			Object(preact_min["h"])(
				'p',
				null,
				t('Want to change your two factor settings? Click below.')
			),
			this.state.twoFactorData && this.state.twoFactorData.validationPeriod === 'NONE' && Object(preact_min["h"])(
				'div',
				{ className: 'buttons-wrapper' },
				Object(preact_min["h"])(components_Button, {
					color: 'blue',
					copy: t('Enable'),
					onClick: this.enableTwoFactor
				})
			),
			this.state.twoFactorData && this.state.twoFactorData.validationPeriod !== 'NONE' && Object(preact_min["h"])(
				'div',
				{ className: 'buttons-wrapper' },
				Object(preact_min["h"])(components_Button, {
					color: 'blue',
					copy: t('Edit'),
					onClick: this.enableTwoFactor
				}),
				Object(preact_min["h"])(components_Button, {
					copy: t('Disable'),
					onClick: this.disableTwoFactor
				})
			)
		);
	};

	return TwoFactorStatus;
}(preact_min["Component"]);

/* harmony default export */ var components_TwoFactorStatus = (translate(['common'], { withRef: true })(TwoFactorStatus_TwoFactorStatus));
// CONCATENATED MODULE: ./components/views/Security.js


function Security__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Security__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function Security__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Security_Security = function (_Component) {
	Security__inherits(Security, _Component);

	function Security() {
		Security__classCallCheck(this, Security);

		return Security__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Security.prototype.componentDidMount = function componentDidMount() {
		window.scrollTo(0, 0);
	};

	Security.prototype.render = function render() {
		var userData = this.context.userData;
		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'view-security' },
			Object(preact_min["h"])(
				'h1',
				null,
				t('Security')
			),
			userData.accountInfo && userData.accountInfo.verified ? Object(preact_min["h"])(components_ChangePassword, { userData: this.context.userData, notification: this.props.notification }) : Object(preact_min["h"])(
				'p',
				{ className: 'error-not-verified' },
				t('You must verify your email address before changing your password.')
			),
			Object(preact_min["h"])(components_TwoFactorStatus, { userData: this.context.userData })
		);
	};

	return Security;
}(preact_min["Component"]);

/* harmony default export */ var views_Security = (translate(['common'], { withRef: true })(Security_Security));
// CONCATENATED MODULE: ./components/LinkServiceCard.js


function LinkServiceCard__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LinkServiceCard__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LinkServiceCard__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LinkServiceCard_LinkServiceCard = function (_Component) {
  LinkServiceCard__inherits(LinkServiceCard, _Component);

  function LinkServiceCard() {
    LinkServiceCard__classCallCheck(this, LinkServiceCard);

    return LinkServiceCard__possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  LinkServiceCard.prototype.render = function render() {
    var _this2 = this;

    var t = this.props.t;

    return Object(preact_min["h"])(
      "div",
      { className: "c-LinkServiceCard " + this.props.name },
      Object(preact_min["h"])("img", { src: this.props.image, alt: this.props.name }),
      Object(preact_min["h"])(
        "div",
        { className: "service-name" },
        this.props.name
      ),
      Object(preact_min["h"])(
        "div",
        { className: "service-username" },
        this.props.name !== "Amazon" ? this.props.username : ""
      ),
      Object(preact_min["h"])(
        "div",
        { className: "rewards-wrapper" },
        Object(preact_min["h"])(
          "p",
          null,
          this.props.rewardsString !== false ? t("In-Game Rewards:") : ""
        ),
        Object(preact_min["h"])(
          "div",
          { className: "service-rewards" },
          this.props.rewardsString
        )
      ),
      this.props.linked === true && !["Google", "Facebook", "Steam", "Epic Games"].includes(this.props.name) && Object(preact_min["h"])(
        "div",
        { className: "button unlink", onClick: function onClick() {
            return _this2.props.disconnectCallback(_this2.props.portal);
          } },
        t("Unlink Account")
      ),
      this.props.linked === false && Object(preact_min["h"])(
        "a",
        { className: "button link", href: this.props.url },
        t("Link Account")
      )
    );
  };

  return LinkServiceCard;
}(preact_min["Component"]);

/* harmony default export */ var components_LinkServiceCard = (translate(["common"], { withRef: true })(LinkServiceCard_LinkServiceCard));
// CONCATENATED MODULE: ./components/views/LinkedAccounts.js


function LinkedAccounts__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LinkedAccounts__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LinkedAccounts__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// const baseSettings = {
// 	base: 'http://localhost:3006',
// 	redirect: 'http://localhost:8080/linked-accounts'
// }

var baseSettings = {
	base: 'https://api.hirezstudios.com',
	redirect: 'https://my.hirezstudios.com'
};

function getURLParam(name, url) {
	if (!url) url = location.href;
	name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
	var regexS = '[\\?&]' + name + '=([^&#]*)';
	var regex = new RegExp(regexS);
	var results = regex.exec(url);
	return results == null ? null : results[1];
}

var redirect_uri = getURLParam('redirect_uri');

var LinkedAccounts_services = [{
	portal_name: 'Epic',
	display_name: 'Epic Games',
	oauth_url: baseSettings.base + '/oauth/out/epic?action=link&url=' + baseSettings.redirect + '/linked-accounts',
	rewards: ''
}, {
	portal_name: 'discord',
	display_name: 'Discord',
	oauth_url: baseSettings.base + '/oauth/out/discord?action=link&url=' + baseSettings.redirect + '/linked-accounts',
	rewards: 'Realm Royale'
}, {
	portal_name: 'Nintendo',
	display_name: 'Nintendo',
	oauth_url: baseSettings.base + '/oauth/out/nintendo?action=link&url=' + baseSettings.redirect + '/linked-accounts',
	rewards: 'Smite & Paladins'
}, {
	portal_name: 'Steam',
	display_name: 'Steam',
	oauth_url: baseSettings.base + '/oauth/out/steam?action=link&url=' + baseSettings.redirect + '/linked-accounts',
	rewards: ''
}, {
	portal_name: 'ps4',
	display_name: 'Playstation',
	oauth_url: baseSettings.base + '/oauth/out/playstation?action=link&url=' + baseSettings.redirect + '/linked-accounts',
	rewards: 'Smite & Paladins'
}, {
	portal_name: 'xbox',
	display_name: 'Xbox',
	oauth_url: baseSettings.base + '/oauth/out/xbox?action=link&url=' + baseSettings.redirect + '/linked-accounts',
	rewards: 'Smite & Paladins'
}, {
	portal_name: 'Twitch',
	display_name: 'Twitch',
	oauth_url: !redirect_uri ? baseSettings.base + '/oauth/out/twitch?action=link&url=' + baseSettings.redirect + '/linked-accounts' : baseSettings.base + '/oauth/out/twitch?action=link&redirect_uri=' + redirect_uri + '&url=' + baseSettings.redirect + '/linked-accounts',
	rewards: 'Smite & Paladins'
}, {
	portal_name: 'Amazon',
	display_name: 'Amazon',
	oauth_url: !redirect_uri ? baseSettings.base + '/oauth/out/amazon?action=link&url=' + baseSettings.redirect + '/linked-accounts' : baseSettings.base + '/oauth/out/amazon?action=link&redirect_uri=' + redirect_uri + '&url=' + baseSettings.redirect + '/linked-accounts',
	rewards: '',
	rewardsString: false
}, {
	portal_name: 'Facebook',
	display_name: 'Facebook',
	oauth_url: baseSettings.base + '/oauth/out/facebook?action=link&url=' + baseSettings.redirect + '/linked-accounts',
	rewards: ' '
}, {
	portal_name: 'Google',
	display_name: 'Google',
	oauth_url: baseSettings.base + '/oauth/out/google?action=link&url=' + baseSettings.redirect + '/linked-accounts',
	rewards: ' '
}];

var LinkedAccounts__ref = Object(preact_min["h"])(
	'div',
	null,
	Object(preact_min["h"])('img', { src: 'https://webcdn.hirezstudios.com/account-services/linked-services/twitch-logo.png' })
);

var LinkedAccounts__ref2 = Object(preact_min["h"])('i', { className: 'icon-logout' });

var LinkedAccounts_LinkedAccounts = function (_Component) {
	LinkedAccounts__inherits(LinkedAccounts, _Component);

	function LinkedAccounts(props) {
		LinkedAccounts__classCallCheck(this, LinkedAccounts);

		var _this = LinkedAccounts__possibleConstructorReturn(this, _Component.call(this, props));

		_this.disconnectService = function (portal) {
			_this.setState({ activePortal: portal });
			fetch(baseSettings.base + '/acct/unlink', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: '{"webToken": "' + _this.props.userData.webToken + '", "platform": "' + portal + '"}'
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				// force recheck?
				if (response.statusCode && response.statusCode === 501) {
					_this.setState({ showWarningMessage: true });
				} else if (response.statusCode && response.statusCode === 400) {
					_this.setState({ showWarningMessage: true });
				} else {
					window.location.reload();
				}
			});
		};

		_this.forceDisconnect = function (portal) {
			fetch(baseSettings.base + '/acct/unlink', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: '{"webToken": "' + _this.props.userData.webToken + '", "platform": "' + portal + '", "ignoreMergeChecking": "y"}'
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				window.location.reload();
			});
		};

		_this.populateAccountInfo = function (response) {
			var states = {};
			response.linkedPortalAccounts.concat(response.linkedCredentials).forEach(function (account) {
				states[account.portal] = {
					username: account.portalUsername,
					linked: account.linked
				};
				if (account.portal === 'Amazon' && account.linked === true && _this.getURLParam('redirectUrl')) {
					window.location.href = decodeURIComponent(_this.getURLParam('redirectUrl'));
				}
			});
			_this.setState({ accountLinkStates: states });
		};

		_this.checkErrors = function () {
			if (_this.getURLParam('error')) {
				_this.setState({ error: _this.getURLParam('error').replace(/\+/g, " ") });
			}
		};

		_this.checkRedirectSuccess = function () {
			if (_this.getURLParam('redirect_uri_complete')) {
				location.href = getURLParam('redirect_uri_complete');
			}
		};

		_this.getURLParam = function (name, url) {
			if (!url) url = location.href;
			name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
			var regexS = '[\\?&]' + name + '=([^&#]*)';
			var regex = new RegExp(regexS);
			var results = regex.exec(url);
			return results == null ? null : results[1];
		};

		_this.state = {
			accountLinkStates: null,
			error: null,
			showWarningMessage: false,
			agreedToWarning: false,
			activePortal: undefined,
			showAltView: null,
			amazon: false,
			redirectUrl: null
		};
		return _this;
	}

	LinkedAccounts.prototype.componentDidMount = function componentDidMount() {
		window.scrollTo(0, 0);
		this.checkErrors();
		this.checkRedirectSuccess();

		if (this.getURLParam('redirectUrl')) {
			localStorage.setItem('linkRedirectUrl', this.getURLParam('redirectUrl'));
			this.setState({ redirectUrl: this.getURLParam('redirectUrl') });
		}
		if (this.getURLParam('linked') === 'amazon') {
			window.location.href = decodeURIComponent(localStorage.getItem('linkRedirectUrl'));
		}

		if (redirect_uri) {
			this.setState({ showAltView: 'twitch' });
		}

		if (this.context.userData.accountInfo !== null) {
			this.populateAccountInfo(this.context.userData.accountInfo);
		}

		// if (this.getURLParam('amazon')) {
		// 	this.setState({
		// 		amazon: true
		// 	})
		// }
	};

	LinkedAccounts.prototype.componentDidUpdate = function componentDidUpdate(nextProps) {
		if (this.props !== nextProps && this.context.userData.accountInfo !== null && this.state.accountLinkStates === null) {
			this.populateAccountInfo(this.context.userData.accountInfo);
			if (this.getURLParam('linked') === 'amazon') {
				window.location.href = decodeURIComponent(localStorage.getItem('linkRedirectUrl'));
			}
		}
	};

	LinkedAccounts.prototype.render = function render() {
		var _this2 = this;

		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'v-linked-accounts ' + (this.state.showAltView !== null ? 'show-alt-view ' + this.state.showAltView : '') + (this.state.redirectUrl !== null ? 'amazon-first' : '') },
			Object(preact_min["h"])(
				'h1',
				null,
				t('Linked & Connected Accounts')
			),
			Object(preact_min["h"])(
				'p',
				null,
				t('Link your Hi-Rez Account to other networks in order to receive in-game rewards! Questions? Check out our FAQ page.')
			),
			this.state.error && Object(preact_min["h"])(
				'p',
				{ className: 'account-error' },
				this.state.error
			),
			this.state.showAltView === 'twitch' && Object(preact_min["h"])(
				'div',
				{ className: 'alt-view twitch' },
				LinkedAccounts__ref,
				Object(preact_min["h"])('p', { dangerouslySetInnerHTML: { __html: t('Link your Twitch account to receive content in SMITE with Twitch Prime. After linking, you will be returned to the Twitch Prime landing page for SMITE, or click <a target="_blank" href="https://twitch.amazon.com/prime/loot/smite?ctx=account-link" >here</a> to return now.') } }),
				Object(preact_min["h"])('p', { dangerouslySetInnerHTML: { __html: t('You must have a linked Twitch Prime account to receive these rewards in SMITE. You must also claim the offer <a target="_blank" href="https://twitch.amazon.com/prime/loot/smite?ctx=account-link">here</a>, and link your Hi-Rez account to your platform of choice <a target="_blank" href="https://my.hirezstudios.com/linked-accounts" >here</a>.') } })
			),
			this.state.showWarningMessage && Object(preact_min["h"])(
				'div',
				{ className: 'unlink-error-container' },
				Object(preact_min["h"])(
					'div',
					{ className: 'close', onClick: function onClick() {
							return _this2.setState({ showWarningMessage: false });
						} },
					'X'
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'header' },
					LinkedAccounts__ref2,
					Object(preact_min["h"])('h6', { dangerouslySetInnerHTML: { __html: t('To unlink your account, please submit a request to Customer Support <a href="https://www.hirezstudios.com/submit-support-ticket" target="_blank" >here</a>.') } })
				)
			),
			Object(preact_min["h"])(
				'div',
				{ className: 'links-wrapper' },
				this.state.accountLinkStates != null && LinkedAccounts_services.map(function (service) {
					return Object(preact_min["h"])(components_LinkServiceCard, {
						name: service['display_name'],
						image: 'https://webcdn.hirezstudios.com/account-services/linked-services/' + service['display_name'].toLowerCase().replace(/\s/g, "-") + '-icon.png',
						username: _this2.state.accountLinkStates[service['portal_name']] && _this2.state.accountLinkStates[service['portal_name']].username || '',
						linked: _this2.state.accountLinkStates[service['portal_name']] && _this2.state.accountLinkStates[service['portal_name']].linked || false,
						url: service['oauth_url'],
						portal: service['portal_name'],
						rewardsString: service.rewards,
						disconnectCallback: _this2.disconnectService
					});
				})
			)
		);
	};

	return LinkedAccounts;
}(preact_min["Component"]);

/* harmony default export */ var views_LinkedAccounts = (translate(['common'], { withRef: true })(LinkedAccounts_LinkedAccounts));
// CONCATENATED MODULE: ./components/views/LinkedAccountsHandler.js


function LinkedAccountsHandler__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LinkedAccountsHandler__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LinkedAccountsHandler__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LinkedAccountsHandler__ref = Object(preact_min["h"])(
  'div',
  { 'class': 'spinner' },
  Object(preact_min["h"])('div', { 'class': 'bounce1' }),
  Object(preact_min["h"])('div', { 'class': 'bounce2' }),
  Object(preact_min["h"])('div', { 'class': 'bounce3' })
);

var LinkedAccountsHandler_LinkedAccountsHandler = function (_Component) {
  LinkedAccountsHandler__inherits(LinkedAccountsHandler, _Component);

  function LinkedAccountsHandler() {
    var _temp, _this, _ret;

    LinkedAccountsHandler__classCallCheck(this, LinkedAccountsHandler);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = LinkedAccountsHandler__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getURLParam = function (name, url) {
      if (!url) url = location.href;
      name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
      var regexS = '[\\?&]' + name + '=([^&#]*)';
      var regex = new RegExp(regexS);
      var results = regex.exec(url);
      return results == null ? null : results[1];
    }, _this.processTwitch = function () {
      // fetch code param from url
      if (_this.getURLParam('code', window.location.href)) {
        var code = _this.getURLParam('code', window.location.href);
        fetch('https://api.twitch.tv/kraken/oauth2/token', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json'
          },
          body: '{"client_id": "przn0eyaxn1pm3ujt4qs9dh3tjbgnr", "client_secret": "2ozop6btnez1ttv449klaqkn2zwd8d", "grant_type":"authorization_code","redirect_uri":"https://my.hirezstudios.com/linked-accounts/twitch","code":"' + code + '"}'
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          var access_token = response.access_token;
          // get user data from Twitch
          fetch('https://api.twitch.tv/kraken/user?oauth_token=' + access_token, {
            method: 'get'
          }).then(function (response) {
            return response.json();
          }).then(function (response) {
            var user_id = response._id;
            // put hirez user account on heartbeat service
            fetch('https://api.twitch.tv/kraken/user/vhs?identifier=HR9307314&api_version=5&client_id=vlisrbyc1op7ejvhgg5nhdbtax57iq&oauth_token=' + access_token, {
              method: 'put'
            }).then(function (response) {
              return response.json();
            }).then(function (response) {
              // TODO: fetch api.hirezstudios.com link endpoint for Twitch
              if (true) {
                // TODO: better check here for above PUT
                fetch('https://api.hirezstudios.com/acct/link', {
                  method: 'post',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: '{"webToken": "b31628c240844cafbfbe205b2c2011ce", "platform": "Twitch", "platformUserId": "' + user_id + '", "country": "US", "accessToken": "' + access_token + '"}'
                }).then(function (response) {
                  Object(preact_router_es["route"])('/linked-accounts', true);
                });
              }
            });
          });
        });
      }
    }, _this.processFacebook = function () {
      if (_this.getURLParam('code', window.location.href)) {
        var code = _this.getURLParam('code', window.location.href);
        fetch('https://graph.facebook.com/v2.11/oauth/access_token?client_id=968092606547648&redirect_uri=https://my.hirezstudios.com/linked-accounts/facebook&client_secret=513b8b90e21e5b0b8b8239dc5a8ef5b5&code=' + code, {
          method: 'get'
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          var access_token = response.access_token;
          fetch('https://graph.facebook.com/me?access_token=' + access_token, {
            method: 'get'
          }).then(function (response) {
            return response.json();
          }).then(function (response) {
            var user_id = response.id;
            fetch('https://graph.facebook.com/oauth/access_token?grant_type=fb_exchange_token&client_id=968092606547648&client_secret=513b8b90e21e5b0b8b8239dc5a8ef5b5&fb_exchange_token=' + access_token, {
              method: 'get'
            }).then(function (response) {
              return response.json();
            }).then(function (response) {
              var long_access_token = response.access_token;
              fetch('https://api.hirezstudios.com/acct/link', {
                method: 'post',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: '{"webToken": "b31628c240844cafbfbe205b2c2011ce", "platform": "FacebookPaladins", "platformUserId": "' + user_id + '", "country": "US", "accessToken": "' + long_access_token + '"}'
              }).then(function (response) {
                if (response.status === 200) {
                  Object(preact_router_es["route"])('/linked-accounts', true);
                } else {
                  // TODO: update link?
                }
              });
            });
          });
        });
      }
    }, _this.processPlaystation = function () {
      if (_this.getURLParam('code', window.location.href)) {
        var code = _this.getURLParam('code', window.location.href);
        fetch('https://auth.api.sonyentertainmentnetwork.com/2.0/oauth/token', {
          method: 'POST',
          headers: {
            'Authorization': 'Basic NTZlMDNmZTUtYzliZS00ZWY1LTk3MjItOWI4YmM2YmFlMTkwOjEza2UyU2lkRFZCc3M1ZzM=',
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: '"grant_type=authorization_code&redirect_uri=https://www.hirezstudios.com/link/playstation&code=' + code + '"'
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          if (response.hasOwnProperty('access_token')) {
            fetch('https://auth.api.sonyentertainmentnetwork.com/2.0/oauth/token/' + response.access_token, {
              method: 'GET',
              headers: {
                'Authorization': 'Basic NTZlMDNmZTUtYzliZS00ZWY1LTk3MjItOWI4YmM2YmFlMTkwOjEza2UyU2lkRFZCc3M1ZzM=',
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }).then(function (response) {
              return response.json();
            }).then(function (response) {
              if (response.hasOwnProperty('user_id')) {
                fetch('https://api.hirezstudios.com/acct/link', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: '{"platformAccountId": "' + response.user_id + '", \n\t\t\t\t\t\t\t\t\t"platform": "ps4",\n\t\t\t\t\t\t\t\t\t"country": "' + response.country_code + '",\n\t\t\t\t\t\t\t\t\t"webToken": "' + _this.context.userData.webToken + '"\n\t\t\t\t\t\t\t\t}'
                }).then(function (response) {
                  return response.json();
                }).then(function (response) {
                  if (response.statusCode === 200) {
                    Object(preact_router_es["route"])('/linked-accounts', true);
                  } else {
                    // account link failed at hirez
                  }
                });
              } else {
                // account linked failed at playstation
              }
            });
          } else {
            // account link failed at playstation
          }
        });
      }
    }, _this.processXbox = function () {
      if (window.location.hash.indexOf('access_token') >= 0) {
        var accessToken = window.location.hash.split('&')[0].substring(14);
        fetch('https://user.auth.xboxlive.com/user/authenticate', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-xbl-contract-version': 0
          },
          body: '{"RelyingParty": "http://auth.xboxlive.com", \n\t\t\t\t\t\t\t\t"TokenType": "JWT", \n\t\t\t\t\t\t\t\t"Properties": {\n\t\t\t\t\t\t\t\t\t"AuthMethod": "RPS",\n\t\t\t\t\t\t\t\t\t"SiteName": "user.auth.xboxlive.com",\n\t\t\t\t\t\t\t\t\t"RpsTicket":"d=' + accessToken + '"\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}'
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          fetch('https://xsts.auth.xboxlive.com/xsts/authorize', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-xbl-contract-version': 1
            },
            body: '{"RelyingParty": "http://xboxlive.com", \n\t\t\t\t\t\t\t\t\t"TokenType": "JWT", \n\t\t\t\t\t\t\t\t\t"Properties": {\n\t\t\t\t\t\t\t\t\t\t"UserTokens": ["' + response.Token + '"],\n\t\t\t\t\t\t\t\t\t\t"SandboxId": "RETAIL"\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}'
          }).then(function (response) {
            return response.json();
          }).then(function (response) {
            if (response.hasOwnProperty('xui')) {
              fetch('https://api.hirezstudios.com/acct/link', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: '{"platformAccountId": "' + response.xui.xid + '", \n\t\t\t\t\t\t\t\t"platform": "xbox",\n\t\t\t\t\t\t\t\t"country": "US",\n\t\t\t\t\t\t\t\t"webToken": "' + _this.context.userData.webToken + '"\n\t\t\t\t\t\t\t}'
              }).then(function (response) {
                return response.json();
              }).then(function (response) {
                if (response.statusCode === 200) {
                  Object(preact_router_es["route"])('/linked-accounts', true);
                } else {
                  // account link failed at hirez
                }
              });
            } else {
              // account linked failed at xbox
            }
          });
        });
      }
    }, _this.noService = function () {
      Object(preact_router_es["route"])('/linked-accounts', true);
    }, _temp), LinkedAccountsHandler__possibleConstructorReturn(_this, _ret);
  }

  // TODO: Fix redirect_uri with actual redirect_uri once whitelisted

  // TODO: Fix redirect_uri with actual redirect_uri once whitelisted


  LinkedAccountsHandler.prototype.componentDidMount = function componentDidMount() {
    window.scrollTo(0, 0);
    switch (this.props.service) {
      case 'facebook':
        this.processFacebook();
        break;
      case 'twitch':
        this.processTwitch();
        break;
      case 'playstation':
        this.processPlaystation();
        break;
      case 'xbox':
        this.processXbox();
        break;
      default:
        this.noService();
    }
  };

  LinkedAccountsHandler.prototype.render = function render() {
    var t = this.props.t;

    return Object(preact_min["h"])(
      'div',
      { className: 'v-linked-accounts-handler' },
      Object(preact_min["h"])(
        'h1',
        null,
        t('Please wait while we connect your Hi-Rez Studios Account to ' + this.props.service + '.')
      ),
      LinkedAccountsHandler__ref
    );
  };

  return LinkedAccountsHandler;
}(preact_min["Component"]);

/* harmony default export */ var views_LinkedAccountsHandler = (translate(['common'], { withRef: true })(LinkedAccountsHandler_LinkedAccountsHandler));
// CONCATENATED MODULE: ./components/TwoFactorMethod.js


function TwoFactorMethod__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TwoFactorMethod__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TwoFactorMethod__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TwoFactorMethod_TwoFactorMethod = function (_Component) {
  TwoFactorMethod__inherits(TwoFactorMethod, _Component);

  function TwoFactorMethod(props) {
    TwoFactorMethod__classCallCheck(this, TwoFactorMethod);

    var _this = TwoFactorMethod__possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateMethod = function (e) {
      _this.setState({ select2FAMethod: e.target.value });
      _this.props.update('method', e.target.value);
    };

    _this.updateCountry = function (e) {
      _this.setState({ select2FACountry: e.target.value });
      _this.props.update('country', e.target.value);
      _this.props.update('countryCode', e.target.options[e.target.selectedIndex].dataset.code);
    };

    _this.state = {
      method: 'initial',
      country: 'initial',
      select2FAMethod: 'none',
      select2FACountry: 'none'
    };
    return _this;
  }

  TwoFactorMethod.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (nextProps.twoFactorData !== undefined && this.state.select2FAMethod === 'none') {
      this.setState({ select2FAMethod: nextProps.twoFactorData.validationOption.toLowerCase() });
    }
  };

  TwoFactorMethod.prototype.componentDidMount = function componentDidMount() {
    this.setState({ select2FAMethod: this.props.twoFactorData.validationOption.toLowerCase() });
  };

  TwoFactorMethod.prototype.render = function render() {
    var t = this.props.t;

    return Object(preact_min["h"])(
      'div',
      { className: 'c-TwoFactorMethod' },
      Object(preact_min["h"])(
        'h4',
        null,
        t('Preferred Notification Method')
      ),
      Object(preact_min["h"])(
        'p',
        null,
        t('Please select your preferred method of receiving your two-factor security code. Note that not all countries are supported in our text message notification method.')
      ),
      Object(preact_min["h"])(
        'select',
        {
          key: '2fa-method',
          id: '2fa-method',
          onInput: this.updateMethod,
          value: this.state.select2FAMethod
        },
        Object(preact_min["h"])(
          'option',
          { selected: true, disabled: true, value: 'none' },
          t('None')
        ),
        Object(preact_min["h"])(
          'option',
          { value: 'email' },
          t('Email')
        ),
        Object(preact_min["h"])(
          'option',
          { value: 'phone' },
          t('Phone')
        ),
        Object(preact_min["h"])(
          'option',
          { value: 'both' },
          t('Both')
        )
      ),
      Object(preact_min["h"])(
        'select',
        {
          key: '2fa-country',
          id: '2fa-country',
          onInput: this.updateCountry,
          value: this.state.select2FACountry
        },
        Object(preact_min["h"])(
          'option',
          { selected: true, disabled: true, value: 'none' },
          t('Choose Country')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+61', value: 'AU' },
          t('Australia')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+32', value: 'BE' },
          t('Belgium')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+55', value: 'BR' },
          t('Brazil')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+1', value: 'CA' },
          t('Canada')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+56', value: 'CL' },
          t('Chile')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+358', value: 'FI' },
          t('Finland')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+33', value: 'FR' },
          t('France')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+49', value: 'DE' },
          t('Germany')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+353', value: 'IR' },
          t('Ireland')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+82', value: 'KR' },
          t('Korea')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+52', value: 'MX' },
          t('Mexico')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+31', value: 'NL' },
          t('Netherlands')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+48', value: 'PL' },
          t('Poland')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+351', value: 'PT' },
          t('Portugal')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+34', value: 'ES' },
          t('Spain')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+46', value: 'SE' },
          t('Sweden')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+44', value: 'GB' },
          t('United Kingdom')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '+1', value: 'US' },
          t('United States of America')
        ),
        Object(preact_min["h"])(
          'option',
          { 'data-code': '0', value: 'other' },
          t('Other')
        )
      )
    );
  };

  return TwoFactorMethod;
}(preact_min["Component"]);

/* harmony default export */ var components_TwoFactorMethod = (translate(['common'], { withRef: true })(TwoFactorMethod_TwoFactorMethod));
// CONCATENATED MODULE: ./components/TwoFactorFrequency.js


function TwoFactorFrequency__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TwoFactorFrequency__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TwoFactorFrequency__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TwoFactorFrequency_TwoFactorFrequency = function (_Component) {
  TwoFactorFrequency__inherits(TwoFactorFrequency, _Component);

  TwoFactorFrequency.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (nextProps.twoFactorData !== undefined && this.state.select2FAfrequency === 'initial') {
      this.setState({ select2FAfrequency: nextProps.twoFactorData.validationPeriod.toLowerCase() });
    }
  };

  TwoFactorFrequency.prototype.componentDidMount = function componentDidMount() {
    this.setState({ select2FAfrequency: this.props.twoFactorData.validationPeriod.toLowerCase() });
  };

  function TwoFactorFrequency(props) {
    TwoFactorFrequency__classCallCheck(this, TwoFactorFrequency);

    var _this = TwoFactorFrequency__possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateFrequency = function (e) {
      _this.props.update('frequency', e.target.value);
      _this.setState({ select2FAfrequency: e.target.value });
    };

    _this.state = {
      select2FAfrequency: 'initial'
    };
    return _this;
  }

  TwoFactorFrequency.prototype.render = function render() {
    var t = this.props.t;

    return Object(preact_min["h"])(
      'div',
      { className: 'c-TwoFactorFrequency' },
      Object(preact_min["h"])(
        'h4',
        null,
        t('Verification Frequency')
      ),
      Object(preact_min["h"])(
        'p',
        null,
        t('Please select how often you want to verify your account. Either every time you log in, every two weeks, or never.')
      ),
      Object(preact_min["h"])(
        'select',
        { onChange: this.updateFrequency, id: '2fa-frequency', value: this.state.select2FAfrequency },
        Object(preact_min["h"])(
          'option',
          { selected: true, disabled: true, value: 'none' },
          t('Choose Method')
        ),
        Object(preact_min["h"])(
          'option',
          { value: 'periodic' },
          t('Periodic')
        ),
        Object(preact_min["h"])(
          'option',
          { value: 'everytime' },
          t('Everytime')
        )
      )
    );
  };

  return TwoFactorFrequency;
}(preact_min["Component"]);

/* harmony default export */ var components_TwoFactorFrequency = (translate(['common'], { withRef: true })(TwoFactorFrequency_TwoFactorFrequency));
// CONCATENATED MODULE: ./components/TwoFactorPhone.js


function TwoFactorPhone__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TwoFactorPhone__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TwoFactorPhone__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TwoFactorPhone_TwoFactorPhone = function (_Component) {
	TwoFactorPhone__inherits(TwoFactorPhone, _Component);

	function TwoFactorPhone(props) {
		TwoFactorPhone__classCallCheck(this, TwoFactorPhone);

		var _this = TwoFactorPhone__possibleConstructorReturn(this, _Component.call(this, props));

		_this.addPhone = function () {
			_this.setState({ buttonEnterPhone: 'loading' });
			if (_this.props.country && _this.props.countryCode) {
				if (_this.state.phone) {
					fetch('https://api.hirezstudios.com/acct/addMobileNumber', {
						method: 'post',
						headers: {
							'Content-Type': 'application/json'
						},
						body: '{"webToken": "' + _this.props.userData.webToken + '", "countryCode": "' + _this.props.country + '", "mobileNumber": "' + _this.state.phone + '"}'
					}).then(function (response) {
						return response.json();
					}).then(function (response) {
						_this.setState({ buttonEnterPhone: 'initial' });
						if (response.statusCode === 200) {
							_this.setState({ step: 'verify' });
						} else {
							_this.setState({ errorEnterPhone: 'Something went wrong. Please try again.' });
						}
					});
				} else {
					_this.setState({
						buttonEnterPhone: 'initial',
						errorEnterPhone: 'A phone number is required.'
					});
				}
			} else {
				_this.setState({
					buttonEnterPhone: 'initial',
					errorEnterPhone: 'A country must be selected above.'
				});
			}
		};

		_this.verifyPhone = function () {
			_this.setState({ buttonVerifyPhone: 'loading' });
			if (_this.state.phoneCode) {
				fetch('https://api.hirezstudios.com/acct/validateMobilePhone', {
					method: 'post',
					headers: {
						'Content-Type': 'application/json'
					},
					body: '{"webToken": "' + _this.props.userData.webToken + '", "code": "' + _this.state.phoneCode + '"}'
				}).then(function (response) {
					return response.json();
				}).then(function (response) {
					_this.setState({ buttonVerifyPhone: 'initial' });
					if (response.statusCode === 200) {
						_this.setState({ step: 'confirmed' });
						_this.props.update('newPhone', _this.state.phone);
					} else {
						_this.setState({ errorVerifyPhone: 'Please check your validation code and try again.' });
					}
				});
			} else {
				_this.setState({
					buttonVerifyPhone: 'initial',
					errorVerifyPhone: 'A verification code is required.'
				});
			}
		};

		_this.cancelVerify = function () {
			_this.setState({
				step: 'initial',
				phone: undefined,
				phoneCode: undefined,
				errorVerifyPhone: undefined,
				errorEnterPhone: undefined
			});
		};

		_this.state = {
			step: 'initial',
			buttonEnterPhone: 'initial',
			buttonVerifyPhone: 'initial'
		};
		return _this;
	}

	TwoFactorPhone.prototype.componentDidMount = function componentDidMount() {
		this.setState({ currentPhone: this.props.twoFactorData.phone !== null ? this.props.twoFactorData.phone : '' });
	};

	TwoFactorPhone.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		if (nextProps.twoFactorData !== undefined && this.state.currentPhone === undefined && nextProps.twoFactorData.phonne !== null) {
			this.setState({ currentPhone: nextProps.twoFactorData.phone });
		}
	};

	TwoFactorPhone.prototype.render = function render() {
		var _this2 = this;

		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'c-TwoFactorPhone' },
			Object(preact_min["h"])(
				'h4',
				null,
				t('Phone Number Verification Settings')
			),
			Object(preact_min["h"])(
				'div',
				{ className: 'sms-warning ' + (this.state.step === 'confirmed' ? 'is-hidden' : '') },
				t('Only select countries can receive our SMS alerts. Normal SMS charges apply.')
			),
			this.state.step === 'initial' && this.state.currentPhone !== undefined && Object(preact_min["h"])(
				'div',
				{ className: 'current-phone-notification' },
				t('Currently using ' + this.state.currentPhone + ' as your phone number.')
			),
			this.state.step === 'initial' && Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ className: 'enter-phone' },
					Object(preact_min["h"])(
						'label',
						null,
						t('Enter Phone Number:')
					),
					Object(preact_min["h"])(
						'div',
						{ className: 'input-wrapper' },
						Object(preact_min["h"])(
							'div',
							{ className: 'country-code' },
							this.props.countryCode
						),
						Object(preact_min["h"])('input', {
							key: 'enter-phone',
							id: 'enter-phone',
							type: 'text',
							onInput: function onInput(e) {
								return _this2.setState({ phone: e.target.value });
							},
							value: this.state.phone
						}),
						Object(preact_min["h"])(
							'div',
							{ className: 'error-enter-phone' },
							t(this.state.errorEnterPhone)
						)
					)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'buttons-wrapper' },
					Object(preact_min["h"])(components_Button, {
						color: 'blue',
						copy: t('Next'),
						state: this.state.buttonEnterPhone,
						onClick: this.addPhone
					})
				)
			),
			this.state.step === 'verify' && Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ className: 'verify-phone' },
					Object(preact_min["h"])(
						'label',
						null,
						t('Verification Code:')
					),
					Object(preact_min["h"])(
						'div',
						{ className: 'input-wrapper' },
						Object(preact_min["h"])('input', {
							key: 'verify-phone',
							id: 'verify-phone',
							type: 'text',
							onInput: function onInput(e) {
								return _this2.setState({ phoneCode: e.target.value });
							},
							value: this.state.phoneCode
						}),
						Object(preact_min["h"])(
							'div',
							{ className: 'error-verify-phone' },
							t(this.state.errorVerifyPhone)
						)
					)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'buttons-wrapper' },
					Object(preact_min["h"])(components_Button, {
						color: 'blue',
						copy: t('Verify'),
						state: this.state.buttonVerifyPhone,
						onClick: this.verifyPhone
					}),
					Object(preact_min["h"])(components_Button, {
						copy: t('Cancel'),
						onClick: this.cancelVerify
					})
				)
			),
			this.state.step === 'confirmed' && Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ className: 'confirmed-phone' },
					Object(preact_min["h"])(
						'div',
						{ className: 'confirm-message' },
						t('You\'ve successfully verified your mobile phone number.'),
						' ',
						Object(preact_min["h"])(
							'a',
							{ onClick: this.cancelVerify },
							t('Click here')
						),
						' ',
						t('to add a new phone number.')
					)
				)
			)
		);
	};

	return TwoFactorPhone;
}(preact_min["Component"]);

/* harmony default export */ var components_TwoFactorPhone = (translate(['common'], { withRef: true })(TwoFactorPhone_TwoFactorPhone));
// CONCATENATED MODULE: ./components/TwoFactorBackupEmail.js


function TwoFactorBackupEmail__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TwoFactorBackupEmail__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TwoFactorBackupEmail__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TwoFactorBackupEmail_TwoFactorBackupEmail = function (_Component) {
	TwoFactorBackupEmail__inherits(TwoFactorBackupEmail, _Component);

	function TwoFactorBackupEmail(props) {
		TwoFactorBackupEmail__classCallCheck(this, TwoFactorBackupEmail);

		var _this = TwoFactorBackupEmail__possibleConstructorReturn(this, _Component.call(this, props));

		_this.addEmail = function () {
			_this.setState({ buttonEnterEmail: 'loading' });
			if (_this.state.email) {
				if (_this.state.email !== _this.props.accountEmail) {
					fetch('https://api.hirezstudios.com/acct/setBackupEmail', {
						method: 'post',
						headers: {
							'Content-Type': 'application/json'
						},
						body: '{"webToken": "' + _this.props.userData.webToken + '", "email": "' + _this.state.email + '"}'
					}).then(function (response) {
						return response.json();
					}).then(function (response) {
						_this.setState({
							buttonEnterEmail: 'initial',
							errorEnterEmail: undefined
						});
						if (response.statusCode === 200) {
							_this.setState({ step: 'verify' });
						} else {
							_this.setState({ errorEnterEmail: 'Please check your recovery email and try again.' });
						}
					});
				} else {
					_this.setState({
						buttonEnterEmail: 'initial',
						errorEnterEmail: 'Your recovery email cannot be the same as your account email.'
					});
				}
			} else {
				_this.setState({
					buttonEnterEmail: 'initial',
					errorEnterEmail: 'An email address is required.'
				});
			}
		};

		_this.verifyEmail = function () {
			_this.setState({ buttonVerifyEmail: 'loading' });
			if (_this.state.emailCode) {
				fetch('https://api.hirezstudios.com/acct/verifyBackupEmail', {
					method: 'post',
					headers: {
						'Content-Type': 'application/json'
					},
					body: '{"webToken": "' + _this.props.userData.webToken + '", "key": "' + _this.state.emailCode + '"}'
				}).then(function (response) {
					return response.json();
				}).then(function (response) {
					_this.setState({ buttonVerifyEmail: 'initial' });
					if (response.statusCode === 200) {
						_this.setState({ step: 'confirmed' });
						_this.props.update('newEmail', _this.state.email);
					} else {
						_this.setState({ errorVerifyEmail: 'Please check your validation code and try again.' });
					}
				});
				// fetch api endpoint on success
				_this.setState({
					buttonVerifyEmail: 'initial',
					step: 'initial',
					errorVerifyEmail: undefined,
					emailCode: undefined
				});
			} else {
				_this.setState({
					buttonVerifyEmail: 'initial',
					errorVerifyEmail: 'A verification code is required.'
				});
			}
		};

		_this.cancelVerify = function () {
			_this.setState({
				step: 'initial',
				email: undefined,
				emailCode: undefined,
				errorVerifyEmail: undefined
			});
		};

		_this.state = {
			step: 'initial',
			buttonEnterEmail: 'initial',
			buttonVerifyEmail: 'initial'
		};
		return _this;
	}

	TwoFactorBackupEmail.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		if (nextProps.twoFactorData !== undefined && this.state.currentEmail === undefined) {
			this.setState({ currentEmail: nextProps.twoFactorData.backupEmail !== null ? nextProps.twoFactorData.backupEmail.toLowerCase() : '' });
		}
	};

	TwoFactorBackupEmail.prototype.componentDidMount = function componentDidMount() {
		this.setState({ currentEmail: this.props.twoFactorData.backupEmail !== null ? this.props.twoFactorData.backupEmail.toLowerCase() : '' });
	};

	TwoFactorBackupEmail.prototype.render = function render() {
		var _this2 = this;

		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'c-TwoFactorBackupEmail' },
			Object(preact_min["h"])(
				'h4',
				null,
				t('E-Mail Verification Settings')
			),
			Object(preact_min["h"])(
				'p',
				null,
				t('The e-mail used to set up your Hi-Rez Account is automatically used for two-step verification codes.')
			),
			this.state.step === 'initial' && this.state.currentEmail !== undefined && Object(preact_min["h"])(
				'div',
				{ className: 'current-email-notification' },
				t('Currently using ' + this.state.currentEmail + ' as your recovery e-mail.')
			),
			this.state.step === 'initial' && Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ className: 'enter-email' },
					Object(preact_min["h"])(
						'label',
						null,
						t('Recovery E-Mail:')
					),
					Object(preact_min["h"])(
						'div',
						{ className: 'input-wrapper' },
						Object(preact_min["h"])('input', {
							id: 'enter-email',
							type: 'text',
							onInput: function onInput(e) {
								return _this2.setState({ email: e.target.value });
							},
							value: this.state.email
						}),
						Object(preact_min["h"])(
							'div',
							{ className: 'error-enter-email' },
							t(this.state.errorEnterEmail)
						)
					)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'buttons-wrapper' },
					Object(preact_min["h"])(components_Button, {
						color: 'blue',
						copy: t('Next'),
						state: this.state.buttonEnterEmail,
						onClick: this.addEmail
					})
				)
			),
			this.state.step === 'verify' && Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ className: 'verify-email' },
					Object(preact_min["h"])(
						'label',
						null,
						t('Verification Code:')
					),
					Object(preact_min["h"])(
						'div',
						{ className: 'input-wrapper' },
						Object(preact_min["h"])('input', {
							id: 'verify-email',
							type: 'text',
							onInput: function onInput(e) {
								return _this2.setState({ emailCode: e.target.value });
							},
							value: this.state.emailCode
						}),
						Object(preact_min["h"])(
							'div',
							{ className: 'error-verify-email' },
							t(this.state.errorVerifyEmail)
						)
					)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'buttons-wrapper' },
					Object(preact_min["h"])(components_Button, {
						color: 'blue',
						copy: t('Verify'),
						state: this.state.buttonVerifyEmail,
						onClick: this.verifyEmail
					}),
					Object(preact_min["h"])(components_Button, {
						copy: t('Cancel'),
						onClick: this.cancelVerify
					})
				)
			),
			this.state.step === 'confirmed' && Object(preact_min["h"])(
				'div',
				null,
				Object(preact_min["h"])(
					'div',
					{ className: 'confirmed-email' },
					Object(preact_min["h"])(
						'div',
						{ className: 'confirm-message' },
						t('You\'ve successfully verified your backup email address.'),
						' ',
						Object(preact_min["h"])(
							'a',
							{ onClick: this.cancelVerify },
							t('Click here')
						),
						' ',
						t('to add a backup email address.')
					)
				)
			)
		);
	};

	return TwoFactorBackupEmail;
}(preact_min["Component"]);

/* harmony default export */ var components_TwoFactorBackupEmail = (translate(['common'], { withRef: true })(TwoFactorBackupEmail_TwoFactorBackupEmail));
// CONCATENATED MODULE: ./components/TwoFactorLogin.js


function TwoFactorLogin__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TwoFactorLogin__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TwoFactorLogin__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TwoFactorLogin_TwoFactorLogin = function (_Component) {
  TwoFactorLogin__inherits(TwoFactorLogin, _Component);

  function TwoFactorLogin(props) {
    TwoFactorLogin__classCallCheck(this, TwoFactorLogin);

    var _this = TwoFactorLogin__possibleConstructorReturn(this, _Component.call(this, props));

    _this.cancelVerify = function () {
      _this.setState({
        step: "initial",
        buttonVerifyAccount: "initial",
        errorEnterPassword: undefined,
        errorEnterCode: undefined,
        password: undefined,
        code: undefined
      });
      Object(preact_router_es["route"])("/security", true);
    };

    _this.validateForm = function (password, username) {
      _this.setState({
        errorEnterPassword: undefined,
        errorEnterCode: undefined
      });
      if (!password) {
        _this.setState({ errorEnterPassword: "You must enter your current password." });
        return false;
      }
      if (!username) {
        _this.setState({ errorEnterPassword: "Please try again." });
        return false;
      }
      return true;
    };

    _this.verifyAccount = function (e) {
      _this.setState({ buttonVerifyAccount: "loading" });
      var username = _this.props.userData.accountInfo.name;

      if (_this.validateForm(_this.state.password, username)) {
        var bodyValue = void 0;
        if (_this.state.code === undefined) {
          bodyValue = "{\"username\": \"" + username + "\", \"password\": \"" + _this.state.password + "\"}";
        } else {
          bodyValue = "{\"username\": \"" + username + "\", \"password\": \"" + _this.state.password + "\", \"code\": \"" + _this.state.code + "\"}";
        }
        fetch("https://api.hirezstudios.com/acct/loginTwoFactor", {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          },
          body: bodyValue
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          _this.setState({ buttonVerifyAccount: "initial" });
          if (response.hasOwnProperty("errors")) {
            _this.setState({ errorEnterCode: response.errors[0] });
          } else if (response.hasOwnProperty("webToken")) {
            _this.props.callback();
          } else if (response.statusCode === 403) {
            _this.setState({ step: "code" });
          } else {
            _this.setState({ errorEnterCode: "Something went wrong. Please try again." });
          }
        });
      } else {
        _this.setState({ buttonVerifyAccount: "initial" });
      }
    };

    _this.handleKeySubmit = function (e) {
      if (e.key === "Enter") {
        _this.verifyAccount();
      }
    };

    _this.state = {
      step: "initial",
      buttonVerifyAccount: "initial",
      errorEnterPassword: undefined,
      errorEnterCode: undefined,
      password: undefined,
      code: undefined
    };
    return _this;
  }

  TwoFactorLogin.prototype.render = function render() {
    var _this2 = this;

    var t = this.props.t;

    return Object(preact_min["h"])(
      "div",
      { className: "c-TwoFactorLogin" },
      Object(preact_min["h"])(
        "h4",
        null,
        t("Login to change your two-factor settings")
      ),
      this.state.step === "initial" && Object(preact_min["h"])(
        "div",
        { className: "enter-password" },
        Object(preact_min["h"])(
          "label",
          null,
          t("Password:")
        ),
        Object(preact_min["h"])(
          "div",
          { className: "input-wrapper" },
          Object(preact_min["h"])("input", {
            key: "enter-password",
            id: "enter-password",
            type: "password",
            onKeyPress: this.handleKeySubmit,
            onInput: function onInput(e) {
              return _this2.setState({ password: e.target.value });
            },
            value: this.state.password
          }),
          Object(preact_min["h"])(
            "div",
            { className: "error-enter-password" },
            t(this.state.errorEnterPassword)
          )
        )
      ),
      this.state.step === "code" && Object(preact_min["h"])(
        "div",
        { className: "enter-code" },
        Object(preact_min["h"])(
          "label",
          null,
          t("Verification Code:")
        ),
        Object(preact_min["h"])(
          "div",
          { className: "input-wrapper" },
          Object(preact_min["h"])("input", {
            key: "enter-code",
            id: "enter-code",
            type: "text",
            onKeyPress: this.handleKeySubmit,
            onInput: function onInput(e) {
              return _this2.setState({ code: e.target.value });
            },
            value: this.state.code
          }),
          Object(preact_min["h"])(
            "div",
            { className: "error-enter-code" },
            t(this.state.errorEnterCode)
          )
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: "buttons-wrapper" },
        Object(preact_min["h"])(components_Button, { color: "blue", copy: t("Login"), state: this.state.buttonVerifyAccount, onClick: this.verifyAccount }),
        Object(preact_min["h"])(components_Button, { copy: t("Cancel"), onClick: this.cancelVerify })
      )
    );
  };

  return TwoFactorLogin;
}(preact_min["Component"]);

/* harmony default export */ var components_TwoFactorLogin = (translate(["common"], { withRef: true })(TwoFactorLogin_TwoFactorLogin));
// CONCATENATED MODULE: ./components/views/TwoFactorSettings.js


function TwoFactorSettings__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TwoFactorSettings__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TwoFactorSettings__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// import FetchAccountInfo from '../FetchAccountInfo.js';


var TwoFactorSettings_TwoFactorSettings = function (_Component) {
	TwoFactorSettings__inherits(TwoFactorSettings, _Component);

	function TwoFactorSettings() {
		var _temp, _this, _ret;

		TwoFactorSettings__classCallCheck(this, TwoFactorSettings);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = TwoFactorSettings__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			verified: false,
			showCode: false
		}, _this.updateState = function (key, value) {
			switch (key) {
				case 'method':
					_this.setState({ method: value });
					break;
				case 'country':
					_this.setState({ country: value });
					break;
				case 'countryCode':
					_this.setState({ countryCode: value });
					break;
				case 'frequency':
					_this.setState({ frequency: value });
					break;
				case 'newPhone':
					_this.setState({ newPhone: value });
					break;
				case 'newEmail':
					_this.setState({ newEmail: value });
					break;
			}
		}, _this.cancel2FAUpdate = function () {
			Object(preact_router_es["route"])('/security', true);
		}, _this.fetchTwoFactorInfo = function (webToken) {
			fetch('https://api.hirezstudios.com/acct/twoFactorInfo', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: '{"webToken": "' + webToken + '"}'
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				_this.setState({
					twoFactorData: response,
					method: response.validationOption.toLowerCase(),
					frequency: response.validationPeriod.toLowerCase(),
					oldPhone: response.phone === null ? '' : response.phone
				});
			});
		}, _this.prepareData = function () {
			_this.setState({
				notifyBySms: undefined,
				notifyByEmail: undefined
			});
			switch (_this.state.method) {
				case 'phone':
					_this.setState({ notifyBySms: true });
					break;
				case 'email':
					_this.setState({ notifyByEmail: true });
					break;
				case 'both':
					_this.setState({ notifyBySms: true, notifyByEmail: true });
					break;
				default:
					return false;
			}
			switch (_this.state.frequency) {
				case 'none':
					_this.setState({ validationPeriod: 0 });
					break;
				case 'periodic':
					_this.setState({ validationPeriod: 1 });
					break;
				case 'everytime':
					_this.setState({ validationPeriod: 2 });
					break;
				default:
					return false;
			}
			return true;
		}, _this.validateUpdate = function () {
			_this.setState({ errorMessage: undefined });
			if (!_this.state.method) {
				_this.setState({ errorMessage: 'A notification method is required to update two factor settings.' });
				return false;
			}
			if (!_this.state.frequency) {
				_this.setState({ errorMessage: 'A notification frequency is required to update two factor settings.' });
				return false;
			}
			if (_this.state.method === 'phone') {
				if (!_this.state.newPhone) {
					if (!_this.state.oldPhone) {
						_this.setState({ errorMessage: 'A phone number must be associated with your account to use the phone notification method.' });
						return false;
					}
				}
			}
			return true;
		}, _this.update2FASettings = function () {
			_this.setState({ buttonUpdate2FA: 'loading' });
			if (_this.validateUpdate()) {
				if (_this.prepareData()) {
					fetch('https://api.hirezstudios.com/acct/twoFactorOptIn', {
						method: 'post',
						headers: {
							'Content-Type': 'application/json'
						},
						body: '{"webToken": "' + _this.props.userData.webToken + '", "notifyBySms": "' + _this.props.notifyBySms + '", "notifyByEmail": "' + _this.state.notifyByEmail + '", "validationPeriod": "' + _this.state.validationPeriod + '"}'
					}).then(function (response) {
						return response.json();
					}).then(function (response) {
						_this.setState({ buttonUpdate2FA: 'initial' });
						if (response.statusCode === 200) {
							Object(preact_router_es["route"])('/two-factor-confirm', true);
						} else {
							_this.setState({ errorMessage: 'Something went wrong. Please try again.' });
						}
					});
				} else {
					_this.setState({ buttonUpdate2FA: 'initial' });
				}
			} else {
				_this.setState({ buttonUpdate2FA: 'initial' });
			}
		}, _temp), TwoFactorSettings__possibleConstructorReturn(_this, _ret);
	}

	TwoFactorSettings.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
		if (this.state.twoFactorData === undefined && nextProps.userData.webToken !== null) {
			this.fetchTwoFactorInfo(nextProps.userData.webToken);
		}
	};

	TwoFactorSettings.prototype.componentDidMount = function componentDidMount() {
		window.scrollTo(0, 0);
		this.fetchTwoFactorInfo(this.props.userData.webToken);
	};

	TwoFactorSettings.prototype.componentWillUnmount = function componentWillUnmount() {
		this.setState({ verified: false });
	};

	// TODO: expose webToken to TwoFactorPhone as webToken prop via Context from AccountInfo
	// TODO: expose accountEmail and webToken to TwoFactorBackupEmail via Context from AccountInfo

	TwoFactorSettings.prototype.render = function render() {
		var _this2 = this;

		var t = this.props.t;

		if (this.state.verified === false) {
			return Object(preact_min["h"])(
				'div',
				{ className: 'view-two-factor' },
				Object(preact_min["h"])(
					'h1',
					null,
					t('Security')
				),
				Object(preact_min["h"])(components_TwoFactorLogin, { userData: this.props.userData, callback: function callback() {
						return _this2.setState({ verified: true });
					} })
			);
		}
		return Object(preact_min["h"])(
			'div',
			{ className: 'view-two-factor' },
			Object(preact_min["h"])(
				'h1',
				null,
				t('Security - Two Factor Authentication')
			),
			Object(preact_min["h"])(components_TwoFactorMethod, { update: this.updateState, twoFactorData: this.state.twoFactorData }),
			Object(preact_min["h"])(components_TwoFactorFrequency, { update: this.updateState, twoFactorData: this.state.twoFactorData }),
			(this.state.method === 'phone' || this.state.method === 'both') && this.state.country !== 'other' && Object(preact_min["h"])(components_TwoFactorPhone, { userData: this.props.userData, country: this.state.country, countryCode: this.state.countryCode, update: this.updateState, twoFactorData: this.state.twoFactorData }),
			(this.state.method === 'email' || this.state.method === 'both') && Object(preact_min["h"])(components_TwoFactorBackupEmail, { userData: this.props.userData, update: this.updateState, twoFactorData: this.state.twoFactorData }),
			Object(preact_min["h"])(
				'div',
				{ className: 'buttons-wrapper save-settings' },
				Object(preact_min["h"])(components_Button, {
					color: 'blue',
					copy: t('Save'),
					state: this.state.buttonUpdate2FA,
					onClick: this.update2FASettings
				}),
				Object(preact_min["h"])(components_Button, {
					copy: t('Cancel'),
					onClick: this.cancel2FAUpdate
				})
			)
		);
	};

	return TwoFactorSettings;
}(preact_min["Component"]);

/* harmony default export */ var views_TwoFactorSettings = (translate(['common'], { withRef: true })(TwoFactorSettings_TwoFactorSettings));
// CONCATENATED MODULE: ./components/views/TwoFactorDisable.js


function TwoFactorDisable__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TwoFactorDisable__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TwoFactorDisable__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var TwoFactorDisable_TwoFactorDisable = function (_Component) {
	TwoFactorDisable__inherits(TwoFactorDisable, _Component);

	function TwoFactorDisable() {
		var _temp, _this, _ret;

		TwoFactorDisable__classCallCheck(this, TwoFactorDisable);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = TwoFactorDisable__possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
			verified: false,
			showCode: false,
			buttonDisable2FA: 'initial'
		}, _this.cancel2FADisable = function () {
			Object(preact_router_es["route"])('/security', true);
		}, _this.disable2FAForReal = function () {
			_this.setState({ buttonDisable2FA: 'loading' });
			fetch('https://api.hirezstudios.com/acct/twoFactorOptIn', {
				method: 'post',
				headers: {
					'Content-Type': 'application/json'
				},
				body: '{"webToken": "' + _this.props.userData.webToken + '", "notifyBySms": "false", "notifyByEmail": "false", "validationPeriod": "0"}'
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				_this.setState({ buttonDisable2FA: 'initial' });
				if (response.statusCode === 200) {
					Object(preact_router_es["route"])('/security', true);
				} else {
					// TODO: error message to user
				}
			});
		}, _temp), TwoFactorDisable__possibleConstructorReturn(_this, _ret);
	}

	TwoFactorDisable.prototype.componentDidMount = function componentDidMount() {
		{/* TODO: Load account data after initial load with ShouldComponentUpdate() to ensure username population for TwoFactorLogin bug */}
	};

	TwoFactorDisable.prototype.render = function render() {
		var _this2 = this;

		var t = this.props.t;

		if (this.state.verified === false) {
			return Object(preact_min["h"])(
				'div',
				{ className: 'view-two-factor' },
				Object(preact_min["h"])(
					'h1',
					null,
					t('Security')
				),
				Object(preact_min["h"])(components_TwoFactorLogin, { userData: this.props.userData, callback: function callback() {
						return _this2.setState({ verified: true });
					} })
			);
		}
		return Object(preact_min["h"])(
			'div',
			{ className: 'view-two-factor' },
			Object(preact_min["h"])(
				'h1',
				null,
				t('Security - Disable Two Factor Authentication')
			),
			Object(preact_min["h"])(
				'p',
				null,
				t('Disable two factor authentication on this account?')
			),
			Object(preact_min["h"])(
				'div',
				{ className: 'buttons-wrapper save-settings' },
				Object(preact_min["h"])(components_Button, {
					color: 'blue',
					copy: t('Disable'),
					state: this.state.buttonDisable2FA,
					onClick: this.disable2FAForReal
				}),
				Object(preact_min["h"])(components_Button, {
					copy: t('Cancel'),
					onClick: this.cancel2FADisable
				})
			)
		);
	};

	return TwoFactorDisable;
}(preact_min["Component"]);

/* harmony default export */ var views_TwoFactorDisable = (translate(['common'], { withRef: true })(TwoFactorDisable_TwoFactorDisable));
// CONCATENATED MODULE: ./components/views/TwoFactorConfirm.js


function TwoFactorConfirm__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function TwoFactorConfirm__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function TwoFactorConfirm__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var TwoFactorConfirm_TwoFactorConfirm = function (_Component) {
  TwoFactorConfirm__inherits(TwoFactorConfirm, _Component);

  function TwoFactorConfirm(props) {
    TwoFactorConfirm__classCallCheck(this, TwoFactorConfirm);

    var _this = TwoFactorConfirm__possibleConstructorReturn(this, _Component.call(this, props));

    _this.routeToSecurity = function () {
      Object(preact_router_es["route"])('/security', true);
    };

    _this.fetchRecoveryCode = function (webToken) {
      fetch('https://api.hirezstudios.com/acct/createSingleUseCode', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: '{"webToken": "' + webToken + '"}'
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        if (response.code) {
          _this.setState({
            buttonEnd2FA: 'initial',
            recoveryCode: response.code
          });
        } else {
          // something went wrong
        }
      });
    };

    _this.state = {
      recoveryCode: undefined,
      buttonEnd2FA: 'loading',
      validRender: false
    };
    return _this;
  }

  TwoFactorConfirm.prototype.componentDidMount = function componentDidMount() {
    if (this.props.userData.webToken) {
      this.fetchRecoveryCode(this.props.userData.webToken);
    }
    if (this.props.previousRoute === '/two-factor') {
      this.setState({
        validRender: true
      });
    }
  };

  TwoFactorConfirm.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    if (this.state.recoveryCode === undefined) {
      this.fetchRecoveryCode(nextProps.userData.webToken);
    }
    if (nextProps.previousRoute !== this.props.previousRoute && nextProps.previousRoute === '/two-factor') {
      this.setState({
        validRender: true
      });
    }
  };

  TwoFactorConfirm.prototype.render = function render() {
    var t = this.props.t;

    return Object(preact_min["h"])(
      'div',
      null,
      this.state.validRender === true && Object(preact_min["h"])(
        'div',
        { className: 'c-TwoFactorConfirm' },
        Object(preact_min["h"])(
          'h1',
          null,
          t('Security - Confirm & Recovery Code')
        ),
        Object(preact_min["h"])(
          'p',
          null,
          t('You\'ve successfully updated your Two Factor Authentication settings!')
        ),
        Object(preact_min["h"])(
          'p',
          null,
          t('We\'ve provided a backup code below to restore access to your account should you lose the ability to verify your Two Factor Authentication.')
        ),
        Object(preact_min["h"])(
          'p',
          null,
          Object(preact_min["h"])(
            'strong',
            null,
            t('Please store this recovery code in a safe location.')
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'recovery-code' },
          this.state.recoveryCode
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'buttons-wrapper save-settings' },
          Object(preact_min["h"])(components_Button, {
            color: 'blue',
            copy: t('Continue'),
            state: this.state.buttonEnd2FA,
            onClick: this.routeToSecurity
          })
        )
      )
    );
  };

  return TwoFactorConfirm;
}(preact_min["Component"]);

/* harmony default export */ var views_TwoFactorConfirm = (translate(['common'], { withRef: true })(TwoFactorConfirm_TwoFactorConfirm));
// CONCATENATED MODULE: ./components/views/VIP.js


function VIP__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function VIP__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function VIP__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var VIP_VIP = function (_Component) {
	VIP__inherits(VIP, _Component);

	function VIP() {
		VIP__classCallCheck(this, VIP);

		return VIP__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	VIP.prototype.render = function render() {
		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'view-VIP' },
			Object(preact_min["h"])(
				'h1',
				null,
				t('VIP Chat Support')
			),
			Object(preact_min["h"])(
				'div',
				{ className: 'status-container' },
				Object(preact_min["h"])(
					'h4',
					null,
					t('Status:')
				),
				Object(preact_min["h"])(
					'h4',
					{ className: this.props.chatActive ? 'green' : 'red' },
					this.props.chatActive ? t('Online') : t('Offline')
				)
			),
			Object(preact_min["h"])(
				'p',
				null,
				t('We have agents available to speak with you! Please click below to enter our chat window in order to receive assistance with any questions you may have!')
			),
			this.props.chatActive ? Object(preact_min["h"])(components_Button, {
				color: 'blue true',
				copy: t('Chat VIP Support'),
				onClick: function onClick() {
					return liveagent.startChat('573410000008luG');
				} }) : Object(preact_min["h"])(components_Button, {
				color: 'blue false',
				copy: t('Chat VIP Support') })
		);
	};

	return VIP;
}(preact_min["Component"]);

/* harmony default export */ var views_VIP = (translate(['common'], { withRef: true })(VIP_VIP));
// CONCATENATED MODULE: ./components/views/EditEmail.js


function EditEmail__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function EditEmail__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function EditEmail__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var EditEmail_Email = function (_Component) {
	EditEmail__inherits(Email, _Component);

	function Email(props) {
		EditEmail__classCallCheck(this, Email);

		var _this = EditEmail__possibleConstructorReturn(this, _Component.call(this, props));

		_this.cancelEmailChange = function () {
			Object(preact_router_es["route"])('/', true);
		};

		_this.validateForm = function (newEmail, confirmEmail) {
			_this.setState({
				errorNewEmail: undefined,
				errorConfirmEmail: undefined
			});
			if (!newEmail) {
				_this.setState({ errorNewEmail: 'You must enter your new email.' });
				return false;
			}
			if (!confirmEmail) {
				_this.setState({ errorConfirmEmail: 'You must confirm your email.' });
				return false;
			}
			if (newEmail !== confirmEmail) {
				_this.setState({ errorConfirmEmail: 'Emails do not match. Please try again.' });
				return false;
			}
			return true;
		};

		_this.createCookie = function (name, value, days) {
			var expires = void 0;
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				expires = '; expires=' + date.toGMTString();
			} else {
				expires = '';
			}
			document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
		};

		_this.eraseCookie = function (name) {
			_this.createCookie(name, '', -1);
		};

		_this.logoutUser = function () {
			_this.eraseCookie('HZAcctTokenExp');
			_this.eraseCookie('HZAcctUsername');
			_this.eraseCookie('HZAcctWebToken');
			_this.eraseCookie('HZRegion');
			_this.eraseCookie('HZAcctID');
			location.reload();
		};

		_this.submitEmailChange = function (e) {
			_this.setState({ buttonEmailChange: 'loading' });
			if (_this.validateForm(_this.state.newEmail, _this.state.confirmEmail)) {
				fetch('https://api.hirezstudios.com/acct/changeEmail', {
					method: 'post',
					headers: {
						'Content-Type': 'application/json'
					},
					body: '{"webToken": "' + _this.props.webToken + '", "newEmail": "' + _this.state.newEmail + '", "password": "' + _this.state.pass + '"}'
				}).then(function (response) {
					return response.json();
				}).then(function (response) {
					_this.setState({ buttonEmailChange: 'initial' });
					if (response.statusCode === 200) {
						_this.props.notification('success', 10000, 'You\'ve successfully changed your email. Logging out momentarily');
						_this.setState({
							newEmail: undefined,
							confirmEmail: undefined
						});
						window.setTimeout(function () {
							this.logoutUser();
						}.bind(_this), 3000);
					} else if (response.statusCode === 400) {
						_this.props.notification('fail', 10000, 'There is already a record with this email address or your password may be incorrect. Please verify and submit again.');
					} else if (response.statusCode === 401) {
						_this.props.notification('warn', 10000, 'Please log out of the account dashboard and try again.');
						window.setTimeout(function () {
							this.logoutUser();
						}.bind(_this), 3000);
					} else {
						_this.props.notification('fail', 10000, 'Something went wrong. Please try again.');
					}
				});
			} else {
				_this.setState({ buttonEmailChange: 'initial' });
			}
		};

		_this.state = {
			newEmail: undefined,
			confirmEmail: undefined,
			errorNewEmail: undefined,
			errorConfirmEmail: undefined,
			buttonEmailChange: 'initial',
			pass: undefined
		};
		return _this;
	}

	Email.prototype.render = function render() {
		var _this2 = this;

		var _context = this.context,
		    userData = _context.userData,
		    t = _context.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'edit-email' },
			Object(preact_min["h"])(
				'h1',
				null,
				t('Change Email Address')
			),
			Object(preact_min["h"])(
				'form',
				null,
				Object(preact_min["h"])(
					'label',
					{ 'for': 'current-email' },
					t('Current Email')
				),
				Object(preact_min["h"])(
					'p',
					null,
					userData.accountInfo && userData.accountInfo.contactInfo.email
				),
				Object(preact_min["h"])(
					'label',
					{ 'for': 'new-email' },
					t('New Email')
				),
				Object(preact_min["h"])('input', {
					id: 'new-email',
					type: 'email',
					onInput: function onInput(e) {
						return _this2.setState({ newEmail: e.target.value });
					},
					value: t(this.state.newEmail)
				}),
				Object(preact_min["h"])(
					'div',
					{ className: 'error-new-email' },
					t(this.state.errorNewEmail)
				),
				Object(preact_min["h"])(
					'label',
					{ 'for': 'confirm-email' },
					t('Confirm Email')
				),
				Object(preact_min["h"])('input', {
					id: 'confirm-email',
					type: 'email',
					onInput: function onInput(e) {
						return _this2.setState({ confirmEmail: e.target.value });
					},
					value: t(this.state.confirmEmail)
				}),
				Object(preact_min["h"])(
					'label',
					{ 'for': 'password' },
					t('Password')
				),
				Object(preact_min["h"])('input', {
					id: 'password',
					type: 'password',
					onInput: function onInput(e) {
						return _this2.setState({ pass: e.target.value });
					},
					value: t(this.state.pass)
				}),
				Object(preact_min["h"])(
					'div',
					{ className: 'error-confirm-email' },
					t(this.state.errorConfirmEmail)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'buttons' },
					Object(preact_min["h"])(components_Button, {
						color: 'blue',
						copy: t('Change'),
						state: this.state.buttonEmailwordChange,
						onClick: this.submitEmailChange
					}),
					Object(preact_min["h"])(components_Button, {
						color: 'white',
						copy: t('Cancel'),
						onClick: this.cancelEmailChange
					})
				)
			)
		);
	};

	return Email;
}(preact_min["Component"]);

/* harmony default export */ var EditEmail = (translate(['common'], { withRef: true })(EditEmail_Email));
// CONCATENATED MODULE: ./components/OtherSettingsGrids.js


function OtherSettingsGrids__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OtherSettingsGrids__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function OtherSettingsGrids__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OtherSettingsGrids_OtherSettingsGrids = function (_Component) {
	OtherSettingsGrids__inherits(OtherSettingsGrids, _Component);

	function OtherSettingsGrids(props) {
		OtherSettingsGrids__classCallCheck(this, OtherSettingsGrids);

		var _this = OtherSettingsGrids__possibleConstructorReturn(this, _Component.call(this, props));

		_this.addMore = function () {
			_this.setState({ btnLoadMore: 'loading' });
			var n = _this.state.number;
			_this.setState({ number: n + 3 });
			_this.setState({ btnLoadMore: 'initial' });
			if (n === 6) {
				if (_this.props.type === 'transactions') {
					_this.setState({ buttonText: 'View all transactions' });
				} else {
					_this.setState({ buttonText: 'View all rewards' });
				}
			}
			if (n >= 9) {
				_this.setState({
					number: 1000,
					button: false
				});
			}
		};

		_this.state = {
			transactionsData: null,
			rewardsData: null,
			affiliatesData: null,
			number: 3,
			button: true,
			buttonText: 'View more transactions',
			show: true,
			btnLoadMore: 'initial'
		};
		return _this;
	}

	OtherSettingsGrids.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		fetch('https://api.hirezstudios.com/acct/transactions', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: '{"webToken": "' + this.props.webToken + '"}'
		}).then(function (response) {
			return response.json();
		}).then(function (response) {
			_this2.setState({ transactionsData: response });
		});
	};

	OtherSettingsGrids.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
		var _this3 = this;

		if (this.props.type !== prevProps.type) {
			this.setState({ number: 3 });
			this.setState({ button: true });
			if (this.props.type === 'transactions') {
				this.setState({ buttonText: 'View more transactions' });
			} else {
				this.setState({ buttonText: 'View more rewards' });
			}
			if (this.props.type && this.state[this.props.type + 'Data'] === null) {
				fetch('https://api.hirezstudios.com/acct/' + this.props.type, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: '{"webToken": "' + this.props.webToken + '"}'
				}).then(function (response) {
					return response.json();
				}).then(function (response) {
					var _this3$setState;

					response.length === 0 ? _this3.setState({ show: _this3.props.type }) : _this3.setState((_this3$setState = {}, _this3$setState[_this3.props.type + 'Data'] = response, _this3$setState));
				});
			}
		}
	};

	OtherSettingsGrids.prototype.render = function render() {
		var _this4 = this;

		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'grid-container' },
			Object(preact_min["h"])(
				'div',
				{ className: 'grids' },
				Object(preact_min["h"])(
					'div',
					{ className: 'no-data ' + (this.state.show === this.props.type ? 'true' : 'false') },
					this.props.type === 'transactions' ? t('There are no transactions to display') : t('There are no rewards to display')
				),
				this.state.show !== this.props.type && Object(preact_min["h"])(
					'div',
					{ className: 'transactions ' + (this.props.type === 'transactions' ? ' active' : '') },
					Object(preact_min["h"])(
						'div',
						{ className: 'info' },
						Object(preact_min["h"])(
							'table',
							{ key: 'transactions' },
							Object(preact_min["h"])(
								'thead',
								null,
								Object(preact_min["h"])(
									'th',
									null,
									t('Date of Purchase')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('Description')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('Order Number')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('Gift')
								)
							),
							Object(preact_min["h"])(
								'tbody',
								null,
								this.state.transactionsData && this.state.transactionsData.slice(0, this.state.number).map(function (data) {
									return Object(preact_min["h"])(
										'tr',
										{ className: 'info', key: data.creation_dt },
										Object(preact_min["h"])(
											'td',
											null,
											data.creation_dt.split('T')[0]
										),
										Object(preact_min["h"])(
											'td',
											null,
											data.item_name
										),
										Object(preact_min["h"])(
											'td',
											null,
											data.order_no
										),
										Object(preact_min["h"])(
											'td',
											null,
											'' + (data.gift_recipient_player !== null ? data.gift_recipient_player : 'N/A')
										)
									);
								})
							)
						),
						this.state.button === true && Object(preact_min["h"])(
							'div',
							{ className: 'buttons-wrapper' },
							Object(preact_min["h"])(components_Button, {
								color: 'blue',
								copy: t(this.state.buttonText),
								state: t(this.state.btnLoadMore),
								onClick: this.addMore
							})
						)
					)
				),
				this.state.show !== this.props.type && Object(preact_min["h"])(
					'div',
					{ className: 'rewards ' + (this.props.type === 'rewards' ? ' active' : '') },
					Object(preact_min["h"])(
						'div',
						{ className: 'info' },
						Object(preact_min["h"])(
							'table',
							{ key: 'rewards' },
							Object(preact_min["h"])(
								'thead',
								null,
								Object(preact_min["h"])(
									'th',
									null,
									t('Date')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('Program')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('Order Number')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('Points Earned')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('Game')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('Status')
								)
							),
							Object(preact_min["h"])(
								'tbody',
								null,
								this.state.rewardsData && this.state.rewardsData.slice(0, this.state.number).map(function (data) {
									return Object(preact_min["h"])(
										'tr',
										{ className: 'info', key: data.creation_dt },
										Object(preact_min["h"])(
											'td',
											null,
											data.creation_dt
										),
										Object(preact_min["h"])(
											'td',
											null,
											data.provider
										),
										Object(preact_min["h"])(
											'td',
											null,
											data.transaction_id
										),
										Object(preact_min["h"])(
											'td',
											null,
											data.award
										),
										Object(preact_min["h"])(
											'td',
											null,
											data.game
										),
										Object(preact_min["h"])(
											'td',
											null,
											data.status
										)
									);
								})
							)
						),
						this.state.button === true && Object(preact_min["h"])(
							'div',
							{ className: 'buttons-wrapper' },
							Object(preact_min["h"])(components_Button, {
								color: 'blue',
								copy: t(this.state.buttonText + this.props.type),
								state: this.state.btnLoadMore,
								onClick: this.addMore
							})
						)
					)
				),
				this.state.show !== this.props.type && Object(preact_min["h"])(
					'div',
					{ className: 'affiliates ' + (this.props.type === 'affiliates' ? ' active' : '') },
					Object(preact_min["h"])(
						'div',
						{ className: 'info' },
						Object(preact_min["h"])(
							'table',
							{ key: 'affiliates' },
							Object(preact_min["h"])(
								'thead',
								null,
								Object(preact_min["h"])(
									'th',
									null,
									t('Date')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('UTM Campaign')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('Total Revenue')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('UTM Content')
								),
								Object(preact_min["h"])(
									'th',
									null,
									t('Accounts Created')
								)
							),
							Object(preact_min["h"])(
								'tbody',
								null,
								this.state.affiliatesData && this.state.affiliatesData.slice(0, 1000).map(function (data) {
									return Object(preact_min["h"])(
										'tr',
										{ className: 'info', key: data.time_period },
										Object(preact_min["h"])(
											'td',
											null,
											data.time_period
										),
										Object(preact_min["h"])(
											'td',
											null,
											data.utm_campaign
										),
										Object(preact_min["h"])(
											'td',
											null,
											data['total_revenue_' + _this4.props.currency]
										),
										Object(preact_min["h"])(
											'td',
											null,
											data.utm_content
										),
										Object(preact_min["h"])(
											'td',
											null,
											data.new_and_paying_accounts_created
										)
									);
								})
							)
						)
					)
				)
			)
		);
	};

	return OtherSettingsGrids;
}(preact_min["Component"]);

/* harmony default export */ var components_OtherSettingsGrids = (translate(['common'], { withRef: true })(OtherSettingsGrids_OtherSettingsGrids));
// CONCATENATED MODULE: ./components/views/OtherSettings.js


function OtherSettings__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function OtherSettings__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function OtherSettings__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var OtherSettings_Other = function (_Component) {
  OtherSettings__inherits(Other, _Component);

  function Other(props) {
    OtherSettings__classCallCheck(this, Other);

    var _this = OtherSettings__possibleConstructorReturn(this, _Component.call(this, props));

    _this.clickyclickyboomboom = function (type) {
      switch (type) {
        case 'transactions':
          _this.setState({ type: 'transactions' });
          break;
        case 'rewards':
          _this.setState({ type: 'rewards' });
          break;
        case 'affiliates':
          _this.setState({ type: 'affiliates' });
          break;
        default:
          _this.setState({ type: 'transactions' });
      }
    };

    _this.state = {
      type: 'transactions',
      data: null,
      affiliates: false,
      currency: null
    };
    return _this;
  }

  Other.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    fetch('https://api.hirezstudios.com/acct/info', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: '{"webToken": "' + this.props.webToken + '"}'
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      _this2.setState({ data: response });
      _this2.setState({ affiliates: _this2.state.data.isAffiliate });
      _this2.setState({ currency: _this2.state.data.contactInfo.currency });
    });
  };

  Other.prototype.render = function render() {
    var _this3 = this;

    var t = this.props.t;

    return Object(preact_min["h"])(
      'div',
      { className: 'other-settings' },
      Object(preact_min["h"])(
        'div',
        { className: 'nav' },
        Object(preact_min["h"])(
          'div',
          { className: 'rewards-container', onClick: function onClick() {
              return _this3.clickyclickyboomboom('transactions');
            } },
          Object(preact_min["h"])(
            'div',
            { className: 'transaction rewards ' + (this.state.type === 'transactions' ? ' active' : '') },
            t('Recent Transactions')
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'rewards-container', onClick: function onClick() {
              return _this3.clickyclickyboomboom('rewards');
            } },
          Object(preact_min["h"])(
            'div',
            { className: 'recent rewards ' + (this.state.type === 'rewards' ? ' active' : '') },
            t('Recent Rewards')
          )
        ),
        this.state.affiliates && Object(preact_min["h"])(
          'div',
          { className: 'rewards-container', onClick: function onClick() {
              return _this3.clickyclickyboomboom('affiliates');
            } },
          Object(preact_min["h"])(
            'div',
            { className: 'affiliates rewards  ' + (this.state.type === 'affiliates' ? ' active' : '') },
            t('Affiliate Rewards')
          )
        )
      ),
      Object(preact_min["h"])(components_OtherSettingsGrids, { type: this.state.type, webToken: this.props.webToken, affiliates: this.state.affiliates, currency: this.state.currency })
    );
  };

  return Other;
}(preact_min["Component"]);

/* harmony default export */ var OtherSettings = (translate(['common'], { withRef: true })(OtherSettings_Other));
// CONCATENATED MODULE: ./components/views/ReferAFriend.js
var _class, ReferAFriend__temp, ReferAFriend__initialiseProps;



function ReferAFriend__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ReferAFriend__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ReferAFriend__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ReferAFriend_ReferAFriend = (ReferAFriend__temp = _class = function (_Component) {
  ReferAFriend__inherits(ReferAFriend, _Component);

  ReferAFriend.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    if (this.props !== nextProps && nextProps.userData !== null && this.state.gameNames === null) {
      this.getPlayerName(nextProps);
    }
  };

  ReferAFriend.prototype.componentDidMount = function componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.userData.accountInfo !== null) {
      this.getPlayerName(this.props);
    }
  };

  function ReferAFriend(props, context) {
    ReferAFriend__classCallCheck(this, ReferAFriend);

    var _this = ReferAFriend__possibleConstructorReturn(this, _Component.call(this, props, context));

    ReferAFriend__initialiseProps.call(_this);

    _this.state = {
      game: null,
      url: null,
      player: null,
      buttonSendReferral: 'initial',
      errorReferralEmail: '',
      gameNames: null
    };
    _this.setGameSpecificData(_this.props.matches.game.toLowerCase());
    return _this;
  }

  ReferAFriend.prototype.render = function render() {
    var _this2 = this;

    var t = this.props.t;

    return Object(preact_min["h"])(
      'div',
      { className: 'view-refer' },
      Object(preact_min["h"])(
        'h1',
        null,
        t('Refer A Friend') + ' - ' + this.state.game
      ),
      this.state.gameNames && this.state.game && Object(preact_min["h"])(
        'div',
        { className: 'refer-wrapper' },
        Object(preact_min["h"])(
          'p',
          null,
          t('Information about referring a friend can go here.')
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'link-container' },
          Object(preact_min["h"])(
            'strong',
            null,
            t('Referral Link:')
          ),
          Object(preact_min["h"])(
            'div',
            null,
            this.state.url + this.state.gameNames[this.state.game].player
          ),
          Object(preact_min["h"])(components_Button, {
            copy: t('Copy Link'),
            onClick: function onClick() {
              return _this2.copyStringToClipboard(_this2.state.url + _this2.state.gameNames[_this2.state.game].player);
            }
          })
        ),
        Object(preact_min["h"])(
          'p',
          null,
          t('Want to send a link directly? Enter in your referral\'s email below and we\'ll send it to them directly!')
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'referral-email' },
          Object(preact_min["h"])(
            'label',
            null,
            t('Referral Email:')
          ),
          Object(preact_min["h"])(
            'div',
            { className: 'input-wrapper' },
            Object(preact_min["h"])('input', {
              key: 'referral-email',
              id: 'referral-email',
              type: 'email',
              onBlur: this.checkEmail,
              onInput: function onInput(e) {
                return _this2.setState({ email: e.target.value });
              },
              value: this.state.email
            }),
            Object(preact_min["h"])(
              'div',
              { className: 'error-referral-email' },
              t(this.state.errorReferralEmail)
            )
          )
        ),
        Object(preact_min["h"])(
          'div',
          { className: 'buttons-wrapper' },
          Object(preact_min["h"])(components_Button, {
            color: 'blue',
            copy: t('Submit'),
            state: this.state.buttonSendReferral,
            onClick: this.sendReferral
          }),
          Object(preact_min["h"])(components_Button, {
            copy: t('Cancel'),
            onClick: this.cancelReferral
          })
        )
      )
    );
  };

  return ReferAFriend;
}(preact_min["Component"]), ReferAFriend__initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setGameSpecificData = function (game) {
    switch (game) {
      case 'smite':
        _this3.setState({
          game: 'Smite',
          url: 'smitegame.com/play-for-free?ref='
        });
        break;
      case 'paladins':
        _this3.setState({
          game: 'Paladins',
          url: 'paladins.com/play-for-free?ref='
        });
        break;
      default:
        Object(preact_router_es["route"])('/', true);
    }
  };

  this.copyStringToClipboard = function (str) {
    var el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style = { position: 'absolute', left: '-9999px' };
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  };

  this.copyLink = function () {
    _this3.copyStringToClipboard(_this3.state.url + _this3.state.player);
  };

  this.cancelReferral = function () {
    Object(preact_router_es["route"])('/', true);
  };

  this.sendReferral = function () {
    _this3.setState({ buttonSendReferral: 'loading' });
    if (_this3.state.email) {
      fetch('https://api.hirezstudios.com/acct/sendReferral', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: '{"webToken": "' + _this3.props.userData.webToken + '", "game": "' + _this3.state.game + '", "email": "' + _this3.state.email + '", "message": ""}'
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        _this3.setState({ buttonSendReferral: 'initial' });
        if (response.statusCode === 200) {
          _this3.props.notification('success', 10000, 'Referral sent to ' + _this3.state.email + '!');
          _this3.setState({
            errorReferralEmail: undefined,
            email: undefined
          });
        } else if (response.statusCode === 400) {
          _this3.setState({ errorReferralEmail: 'This player has already been referred or has an existing Hi-Rez Studios account.' });
        } else {
          _this3.setState({ errorReferralEmail: 'Something went wrong. Please try again.' });
        }
      });
    } else {
      _this3.setState({
        buttonSendReferral: 'initial',
        errorReferralEmail: 'An email address is required to send a referral.'
      });
    }
  };

  this.checkEmail = function (e) {
    var email = e.target.value;
    var isValid = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
    if (email.length > 0) {
      if (isValid === false) {
        _this3.setState({
          errorReferralEmail: 'A valid email address is required.'
        });
      } else {
        _this3.setState({
          errorReferralEmail: undefined
        });
      }
    } else {
      _this3.setState({
        errorReferralEmail: undefined
      });
    }
  };

  this.getPlayerName = function (props) {
    var names = {};
    props.userData.accountInfo.games.forEach(function (game) {
      names[game.game] = {
        player: game.playerName
      };
    });
    _this3.setState({ gameNames: names });
  };
}, ReferAFriend__temp);


/* harmony default export */ var views_ReferAFriend = (translate(['common'], { withRef: true })(ReferAFriend_ReferAFriend));
// CONCATENATED MODULE: ./components/views/AddReferrer.js


function AddReferrer__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AddReferrer__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AddReferrer__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var AddReferrer_AddReferrer = function (_Component) {
	AddReferrer__inherits(AddReferrer, _Component);

	function AddReferrer(props) {
		AddReferrer__classCallCheck(this, AddReferrer);

		var _this = AddReferrer__possibleConstructorReturn(this, _Component.call(this, props));

		_this.cancelEmailChange = function () {
			Object(preact_router_es["route"])('/', true);
		};

		_this.validateForm = function (refer, game) {
			_this.setState({
				errorReferralAdd: undefined
			});
			if (!refer) {
				_this.setState({ errorReferralAdd: 'A referring player is required.' });
				return false;
			}
			if (game === 'None') {
				_this.setState({ errorReferralAdd: 'You must select a game.' });
				return false;
			}
			return true;
		};

		_this.submitAddReferrer = function (e) {
			_this.setState({ buttonEmailChange: 'loading' });
			if (_this.validateForm(_this.state.refer, _this.state.game)) {
				fetch('https://api.hirezstudios.com/acct/addReferrer', {
					method: 'post',
					headers: {
						'Content-Type': 'application/json'
					},
					body: '{"webToken": "' + _this.props.userData.webToken + '", "playerName": "' + _this.state.refer + '", "game": "' + _this.state.game + '"}'
				}).then(function (response) {
					return response.json();
				}).then(function (response) {
					_this.setState({ buttonEmailChange: 'initial' });
					if (response.statusCode !== 200) {
						_this.setState({ errorReferralAdd: 'Referrer cannot be added for accounts greater than 10 days old or account does not exist.' });
					} else {
						_this.props.notification('success', 10000, 'You\'ve successfully added ' + response.body.playerName + ' as a referring player!');
						_this.setState({
							refer: undefined,
							game: 'None'
						});
					}
				});
			} else {
				_this.setState({ buttonEmailChange: 'initial' });
			}
		};

		_this.state = {
			refer: undefined,
			game: 'None',
			errorReferralAdd: undefined,
			buttonEmailChange: 'initial'
		};
		return _this;
	}

	AddReferrer.prototype.render = function render() {
		var _this2 = this;

		var _context = this.context,
		    userData = _context.userData,
		    t = _context.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'add-referrer' },
			Object(preact_min["h"])(
				'h1',
				null,
				t('Add Referrer')
			),
			Object(preact_min["h"])(
				'div',
				{ className: 'error-new-email' },
				t(this.state.errorReferralAdd)
			),
			Object(preact_min["h"])(
				'form',
				null,
				Object(preact_min["h"])(
					'label',
					{ 'for': 'player-name' },
					t('Referring Player\'s Name')
				),
				Object(preact_min["h"])('input', {
					id: 'player-name',
					type: 'text',
					onInput: function onInput(e) {
						return _this2.setState({ refer: e.target.value });
					},
					value: t(this.state.refer)
				}),
				Object(preact_min["h"])(
					'label',
					{ 'for': 'player-name' },
					t('Game')
				),
				Object(preact_min["h"])(
					'select',
					{ onChange: function onChange(e) {
							return _this2.setState({ game: e.target.value });
						}, id: '2fa-frequency', value: this.state.game },
					Object(preact_min["h"])(
						'option',
						{ 'default': true, disabled: true, value: 'None' },
						t('Select A Game')
					),
					Object(preact_min["h"])(
						'option',
						{ value: 'Smite' },
						t('Smite')
					),
					Object(preact_min["h"])(
						'option',
						{ value: 'Paladins' },
						t('Paladins')
					)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'buttons' },
					Object(preact_min["h"])(components_Button, {
						color: 'blue',
						copy: t('Submit'),
						state: this.state.buttonEmailChange,
						onClick: this.submitAddReferrer
					}),
					Object(preact_min["h"])(components_Button, {
						color: 'white',
						copy: t('Cancel'),
						onClick: this.cancelEmailChange
					})
				)
			)
		);
	};

	return AddReferrer;
}(preact_min["Component"]);

/* harmony default export */ var views_AddReferrer = (translate(['common'], { withRef: true })(AddReferrer_AddReferrer));
// CONCATENATED MODULE: ./components/ViewsWrapper.js


function ViewsWrapper__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ViewsWrapper__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function ViewsWrapper__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var ViewsWrapper__ref = Object(preact_min["h"])('i', { className: 'ion-android-arrow-dropdown' });

var ViewsWrapper_ViewsWrapper = function (_Component) {
  ViewsWrapper__inherits(ViewsWrapper, _Component);

  function ViewsWrapper(props) {
    ViewsWrapper__classCallCheck(this, ViewsWrapper);

    var _this = ViewsWrapper__possibleConstructorReturn(this, _Component.call(this, props));

    _this.storePreviousRoute = function (route) {
      _this.setState({
        previousRoute: _this.state.currentRoute,
        currentRoute: route
      });
    };

    _this.createCookie = function (name, value, days) {
      var expires = void 0;
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
      } else {
        expires = '';
      }
      document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
    };

    _this.readCookie = function (name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    };

    _this.getURLParam = function (name, url) {
      if (!url) url = location.href;
      name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
      var regexS = '[\\?&]' + name + '=([^&#]*)';
      var regex = new RegExp(regexS);
      var results = regex.exec(url);
      return results == null ? null : results[1];
    };

    _this.getLanguageCookie = function () {
      var langCookie = _this.readCookie('language_pref');
      _this.setState({ langCode: langCookie == undefined ? 'en_US' : langCookie });
      _this.setLanguagePref(langCookie);
    };

    _this.setLanguagePref = function (lang) {
      switch (lang) {
        case 'en_uS':
          _this.setState({ language: 'English' });
          break;
        case 'fr_FR':
          _this.setState({ language: 'Français' });
          break;
        case 'es_LA':
          _this.setState({ language: 'Español' });
          break;
        case 'de_DE':
          _this.setState({ language: 'Deutsch' });
          break;
        case 'pl_PL':
          _this.setState({ language: 'Polski' });
          break;
        case 'ru_RU':
          _this.setState({ language: 'Русский' });
          break;
        case 'tr_TR':
          _this.setState({ language: 'Turkish' });
          break;
        case 'pt_BR':
          _this.setState({ language: 'Português do Brasil' });
          break;
        case 'zh_CN':
          _this.setState({ language: '中国' });
          break;
        default:
          _this.setState({ language: 'English' });
      }
    };

    _this.changeLanguage = function (lang) {
      _this.createCookie('language_pref', lang, 365);
      // i18n.changeLanguage(lang);
      window.location = window.location.href.split('?')[0] + '?lng=' + lang;
    };

    _this.mobileLanguageTap = function () {
      if (_this.props.windowWidth < 1200) {
        _this.state.langNavToggled ? _this.setState({ langNavToggled: false }) : _this.setState({ langNavToggled: true });
      }
    };

    _this.state = {
      previousRoute: undefined,
      currentRoute: undefined,
      language: null,
      langCode: null
    };
    return _this;
  }

  ViewsWrapper.prototype.componentDidMount = function componentDidMount() {
    window.scrollTo(0, 0);

    var lngFromURL = this.getURLParam('lng');
    var lang = void 0;

    if (lngFromURL != null) {
      this.createCookie('language_pref', lngFromURL);
      lang = lngFromURL;
    } else {
      this.readCookie('language_pref') == undefined ? this.createCookie('language_pref', 'en_US', 365) : '';
      lang = this.readCookie('language_pref') != null ? this.readCookie('language_pref') : 'en_US';
    }
    if (window.location.hash === '#addreferrer') {
      Object(preact_router_es["route"])('/add-referrer', true);
    }
  };

  ViewsWrapper.prototype.componentWillMount = function componentWillMount() {
    this.getLanguageCookie();
  };

  // read cookie


  ViewsWrapper.prototype.render = function render() {
    var _this2 = this;

    return Object(preact_min["h"])(
      'main',
      { className: 'views-wrapper ' + (this.state.chatActive ? 'vip-chat-active' : '') },
      Object(preact_min["h"])(
        'div',
        { className: 'language-wrapper ' + (this.state.langNavToggled ? 'mobile-expanded' : ''), onClick: this.mobileLanguageTap },
        Object(preact_min["h"])(
          'div',
          { className: 'lang-select' },
          this.state.language && this.state.language,
          ViewsWrapper__ref,
          Object(preact_min["h"])(
            'div',
            { className: 'languages' },
            Object(preact_min["h"])(
              'a',
              { onClick: function onClick() {
                  return _this2.changeLanguage('en_US');
                } },
              'English'
            ),
            Object(preact_min["h"])(
              'a',
              { onClick: function onClick() {
                  return _this2.changeLanguage('fr_FR');
                } },
              'Fran\xE7ais'
            ),
            Object(preact_min["h"])(
              'a',
              { onClick: function onClick() {
                  return _this2.changeLanguage('de_DE');
                } },
              'Deutsch'
            ),
            Object(preact_min["h"])(
              'a',
              { onClick: function onClick() {
                  return _this2.changeLanguage('es_LA');
                } },
              'Espa\xF1ol'
            ),
            Object(preact_min["h"])(
              'a',
              { onClick: function onClick() {
                  return _this2.changeLanguage('pl_PL');
                } },
              'Polski'
            ),
            Object(preact_min["h"])(
              'a',
              { onClick: function onClick() {
                  return _this2.changeLanguage('ru_RU');
                } },
              '\u0420\u0443\u0441\u0441\u043A\u0438\u0439'
            ),
            Object(preact_min["h"])(
              'a',
              { onClick: function onClick() {
                  return _this2.changeLanguage('pt_BR');
                } },
              'Portugu\xEAs do Brasil'
            ),
            Object(preact_min["h"])(
              'a',
              { onClick: function onClick() {
                  return _this2.changeLanguage('tr_TR');
                } },
              'Turkish'
            ),
            Object(preact_min["h"])(
              'a',
              { onClick: function onClick() {
                  return _this2.changeLanguage('zh_CN');
                } },
              '\u4E2D\u56FD'
            )
          )
        )
      ),
      Object(preact_min["h"])(
        preact_router_es["Router"],
        { onChange: function onChange() {
            return _this2.storePreviousRoute(window.location.pathname);
          } },
        Object(preact_min["h"])(views_Overview, { 'default': true, path: '/', notification: this.props.notification }),
        Object(preact_min["h"])(views_Security, { path: '/security', notification: this.props.notification }),
        Object(preact_min["h"])(views_LinkedAccounts, {
          path: '/linked-accounts',
          userData: this.context.userData
        }),
        Object(preact_min["h"])(views_LinkedAccountsHandler, { path: '/linked-accounts/:service', webToken: this.props.webToken }),
        Object(preact_min["h"])(views_TwoFactorSettings, { path: '/two-factor', userData: this.context.userData, notification: this.props.notification }),
        Object(preact_min["h"])(views_TwoFactorDisable, { path: '/two-factor-disable', userData: this.context.userData, notification: this.props.notification }),
        Object(preact_min["h"])(views_TwoFactorConfirm, { path: '/two-factor-confirm', userData: this.context.userData, previousRoute: this.state.previousRoute }),
        Object(preact_min["h"])(views_VIP, { path: '/vip-chat', chatActive: this.props.chatActive }),
        Object(preact_min["h"])(EditEmail, { path: '/edit-email', webToken: this.props.webToken, notification: this.props.notification }),
        Object(preact_min["h"])(OtherSettings, { path: '/other-settings', webToken: this.props.webToken }),
        Object(preact_min["h"])(views_ReferAFriend, { path: '/refer/:game', userData: this.context.userData, notification: this.props.notification }),
        Object(preact_min["h"])(views_AddReferrer, { path: '/add-referrer', userData: this.context.userData, notification: this.props.notification })
      )
    );
  };

  return ViewsWrapper;
}(preact_min["Component"]);

/* harmony default export */ var components_ViewsWrapper = (ViewsWrapper_ViewsWrapper);
// CONCATENATED MODULE: ./components/AccountInfoProvider.js
var AccountInfoProvider__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var AccountInfoProvider__class, AccountInfoProvider__temp;

function AccountInfoProvider__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function AccountInfoProvider__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function AccountInfoProvider__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AccountInfoProvider = (AccountInfoProvider__temp = AccountInfoProvider__class = function (_Component) {
  AccountInfoProvider__inherits(AccountInfoProvider, _Component);

  AccountInfoProvider.prototype.getChildContext = function getChildContext() {
    return {
      userData: {
        accountInfo: this.state.accountData,
        webToken: this.state.webToken
      }
    };
  };

  function AccountInfoProvider(props) {
    AccountInfoProvider__classCallCheck(this, AccountInfoProvider);

    var _this = AccountInfoProvider__possibleConstructorReturn(this, _Component.call(this, props));

    _this.readCookie = function (name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    };

    _this.state = {
      accountData: null,
      webToken: null
    };
    return _this;
  }

  AccountInfoProvider.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var token = this.readCookie('HZAcctWebToken');

    if (token && !this.state.accountData) {
      fetch('https://api.hirezstudios.com/acct/info', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: '{"webToken": "' + token + '"}'
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        _this2.setState({ accountData: response, webToken: token });
      });
    }
  };

  AccountInfoProvider.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this3 = this;

    var token = this.readCookie('HZAcctWebToken');

    if (token && !this.state.accountData) {
      fetch('https://api.hirezstudios.com/acct/info', {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: '{"webToken": "' + token + '"}'
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        _this3.setState({ accountData: response, webToken: token });
      });
    }
  };

  AccountInfoProvider.prototype.render = function render() {
    return AccountInfoProvider__extends({}, this.props);
  };

  return AccountInfoProvider;
}(preact_min["Component"]), AccountInfoProvider__class.childContextTypes = {
  accountData: prop_types_default.a.object,
  webToken: prop_types_default.a.string
}, AccountInfoProvider__temp);


/* harmony default export */ var components_AccountInfoProvider = (AccountInfoProvider);
// CONCATENATED MODULE: ./components/error-handling/trustedErrors.js
var TrustedErrors = ["Something went wrong. Please try again.", "Your third party account is already linked to an existing Hi-Rez Studios account.", "Your steam account is already linked to an existing Hi-Rez Studios account.", "We were unable to retrieve your Steam details. Please try again.", "We were unable to retrieve your Facebook details. Please try again.", "We were unable to retrieve your Google details. Please try again.", "We were unable to retrieve your Playstation details. Please try again.", "We were unable to retrieve your Xbox details. Please try again.", "We were unable to retrieve your Nintendo details. Please try again.", "Unsupported action type for service Twitch. Please try again with a supported action type.", "Unable to retrieve your Twitch details. Please try again.", "Unsupported action type for service Mixer. Please try again with a supported action type.", "Unable to retrieve your Mixer details. Please try again.", "Unable to retrieve your Discord details. Please try again.", "Unable to retrieve your Epic details. Please try again.", "Unsupported action type for service Amazon. Please try again with a supported action type.", "Unable to retrieve your Amazon details. Please try again."];
// CONCATENATED MODULE: ./components/LoginPanelBranding.js


function LoginPanelBranding__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginPanelBranding__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LoginPanelBranding__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LoginPanelBranding__ref = Object(preact_min["h"])(
	'div',
	{ className: 'image' },
	Object(preact_min["h"])('img', { src: 'https://webcdn.hirezstudios.com/account-services/logo-hirez.png', alt: 'Branding' })
);

var LoginPanelBranding_Branding = function (_Component) {
	LoginPanelBranding__inherits(Branding, _Component);

	function Branding() {
		LoginPanelBranding__classCallCheck(this, Branding);

		return LoginPanelBranding__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Branding.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			{ className: 'branding-wrapper' },
			LoginPanelBranding__ref,
			Object(preact_min["h"])('div', { className: 'copy' })
		);
	};

	return Branding;
}(preact_min["Component"]);

/* harmony default export */ var LoginPanelBranding = (translate(['common'], { withRef: true })(LoginPanelBranding_Branding));
// CONCATENATED MODULE: ./components/LoginPanelInputs.js


function LoginPanelInputs__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginPanelInputs__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LoginPanelInputs__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var locale = {
  labelUsername: "Username",
  labelPassword: "Password",
  labelConfirm: "Confirm",
  labelEmail: "Email",
  labelRecovery: "Recovery Code",
  labelTwoFactor: "Two Factor Code",
  labelAuth: "Authentication Code",
  labelAge: 'I am 13+ years old and I agree to the <a href="https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf" rel="noopener noreferrer" target="_blank">Terms of Service</a>.',
  labelSubscribe: "Send me Hi-Rez Studios news.",
  copyCantLogin: "Can't Login?",
  copyDivider: "or",
  copyServicesSignup: "Sign Up With:",
  copyServicesLogin: "Login With:",
  copyContactSupport: "If the above options were not able to assist you:",
  btnLogin: "Login",
  btnCreate: "Create",
  btnCreateFree: "Create A Free Account",
  btnSubmit: "Submit",
  btnGoogle: "Google",
  btnFacebook: "Facebook",
  btnBack: "Back",
  btnRecoverUsername: "Forgot Your Username?",
  btnRecoverPassword: "Forgot Your Password?",
  btnRecoverCode: "Use One Time Recovery Code",
  btnBackupEmail: "Use Backup Email to Login",
  btnContactSupport: "Contact Customer Support",
  smiteCopy: "Sign Up Now! Join 25+ Million Players Today",
  errorUsernameMissing: "A username is required to create an account.",
  panelCopyCantLogin: "There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.",
  panelCopyForgotUsername: "Enter in the email associated with your account to receive a reminder email.",
  panelCopyForgotPassword: "Enter in the email and username associated with your account to reset your password.",
  panelCopyRecoveryCode: "Enter in the username and one time recovery code (when you setup your two factor authentication) to login.",
  panelCopyBackupEmail: "Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.",
  panelCopyCreateGoogle: "A verified email address with Google is required to create an account. You will use your Google login to play.",
  panelCopyCreateFacebook: "A verified email address with Facebook is required to create an account. You will use your Facebook login to play.",
  panelCopyLoginThirdParty: "You will be logged in as:",
  forgotResponse: "Thank you, an email has been sent to the address on file.",
  noMasterAccount: "We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?"
};

// Input Component
// TODO: better response handling for 200/40* responses
// TODO: form validation, different method
// TODO: show password action?
// TODO: live username checking
// TODO: realtime error display under input fields
// TODO: cleanup inputs section and actions section

var LoginPanelInputs__ref = Object(preact_min["h"])("div", { className: "h-captcha", "data-sitekey": "a19bf4f8-9fcb-43d6-be97-ff5623f9621c", "data-size": "invisible" });

var LoginPanelInputs__ref2 = Object(preact_min["h"])("div", { className: "loading" });

var LoginPanelInputs_Inputs = function (_Component) {
  LoginPanelInputs__inherits(Inputs, _Component);

  // read cookie
  function Inputs(props) {
    LoginPanelInputs__classCallCheck(this, Inputs);

    var _this = LoginPanelInputs__possibleConstructorReturn(this, _Component.call(this, props));

    _this.constructInputs = function (panel) {
      switch (panel) {
        case "login":
          _this.setState({ btnCopy: locale.btnLogin });
          _this.setState({ panelCopy: null });
          break;
        case "create":
          _this.setState({ btnCopy: locale.btnCreate });
          _this.setState({ panelCopy: null });
          break;
        case "forgot-username":
          _this.setState({ btnCopy: locale.btnSubmit });
          _this.setState({ panelCopy: locale.panelCopyForgotUsername });
          break;
        case "forgot-password":
          _this.setState({ btnCopy: locale.btnSubmit });
          _this.setState({ panelCopy: locale.panelCopyForgotPassword });
          break;
        case "recovery-code":
          _this.setState({ btnCopy: locale.btnSubmit });
          _this.setState({ panelCopy: locale.panelCopyRecoveryCode });
          break;
        case "backup-email":
          _this.setState({ btnCopy: locale.btnSubmit });
          _this.setState({ panelCopy: locale.panelCopyBackupEmail });
          break;
        case "create-google":
          _this.setState({ btnCopy: locale.btnCreate });
          _this.setState({ panelCopy: locale.panelCopyCreateGoogle });
          break;
        case "create-facebook":
          _this.setState({ btnCopy: locale.btnCreate });
          _this.setState({ panelCopy: locale.panelCopyCreateFacebook });
          break;
        case "login-google":
          _this.setState({ btnCopy: locale.labelConfirm });
          _this.setState({ panelCopy: locale.panelCopyLoginThirdParty });
          break;
        case "login-facebook":
          _this.setState({ btnCopy: locale.labelConfirm });
          _this.setState({ panelCopy: locale.panelCopyLoginThirdParty });
          break;
        case "cant-login":
          _this.setState({ panelCopy: locale.panelCopyCantLogin });
          break;
        default:
          _this.setState({ btnCopy: locale.btnCreate });
          _this.setState({ panelCopy: null });
      }
    };

    _this.storeInputs = function (e) {
      switch (e.target.id) {
        case "username":
          _this.setState({ username: e.target.value });
          break;
        case "password":
          _this.setState({ password: e.target.value });
          break;
        case "confirm":
          _this.setState({ confirm: e.target.value });
          break;
        case "email":
          _this.setState({ email: e.target.value });
          break;
        case "recovery":
          _this.setState({ recovery: e.target.value });
          break;
        case "authentication":
          _this.setState({ authentication: e.target.value });
          break;
        case "age":
          _this.setState({ age: e.target.checked });
          break;
        case "subscribe":
          _this.setState({ subscribe: e.target.checked });
          break;
        case "twofactor":
          _this.setState({ twofactor: e.target.value });
          break;
      }
    };

    _this.createCookie = function (name, value, days) {
      var expires = void 0;
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
      } else {
        expires = "";
      }
      document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
      //document.cookie = name+"="+value+expires+";path=/";
    };

    _this.readCookie = function (name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    };

    _this.eraseCookie = function (name) {
      _this.createCookie(name, "", -1);
    };

    _this.validateEmail = function (response, email) {
      var emailValidation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailValidation.test(String(email).toLowerCase()) === true) {
        _this.submitForm(response);
      } else {
        _this.setState({ resMessage: "Please enter a valid email address." });
      }
    };

    _this.submitForm = function (recaptcha) {
      // TOOD: validate form before this process continues
      var method = void 0;
      var endpoint = void 0;
      var payload = void 0;
      var source = 13;
      var recapResponse = hcaptcha.getResponse();
      switch (_this.state.panel) {
        case "login":
          method = "POST";
          endpoint = "loginDashboard";
          if (_this.state.twofactor !== undefined) {
            payload = "{\"username\":\"" + _this.state.username + "\",\"password\":\"" + _this.state.password + "\",\"code\":\"" + _this.state.twofactor + "\",\"recaptcha\": \"" + recapResponse + "\"}";
          } else {
            payload = "{\"username\":\"" + _this.state.username + "\",\"password\":\"" + _this.state.password + "\",\"recaptcha\": \"" + recapResponse + "\"}";
          }
          break;
        case "create":
          method = "POST";
          endpoint = "create";
          payload = "{\"username\":\"" + _this.state.username + "\",\"password\":\"" + _this.state.password + "\",\"confirmPassword\":\"" + _this.state.confirm + "\",\"email\":\"" + _this.state.email + "\",\"over13\":\"" + _this.state.age + "\",\"subscribe\":\"" + _this.state.subscribe + "\",\"recaptcha\": \"" + recapResponse + "\"}";
          break;
        case "forgot-username":
          method = "POST";
          endpoint = "sendUsername";
          payload = "{\"email\":\"" + _this.state.email + "\"}";
          break;
        case "forgot-password":
          method = "POST";
          endpoint = "resetPassword";
          payload = "{\"username\":\"" + _this.state.username + "\",\"email\":\"" + _this.state.email + "\"}";
          break;
        case "recovery-code":
          method = "POST";
          endpoint = "auth/singleUseCodeLogin";
          payload = "username=" + _this.state.username + "&singleUseCode=" + _this.state.recovery;
          break;
        case "backup-email":
          method = "POST";
          endpoint = "auth/login";
          payload = "username=" + _this.state.username + "&password=" + _this.state.password + "&source=" + source + "&useBackupEmail=true";
          break;
        case "login-google":
          method = "POST";
          endpoint = "loginGoogleUser";
          payload = "{\"token\":\"" + _this.props.thirdPartyToken + "\",\"clientType\":\"0\"}";
          break;
        case "login-facebook":
          method = "POST";
          endpoint = "loginFacebookUser";
          payload = "{\"token\":\"" + _this.props.thirdPartyToken + "\",\"clientType\":\"0\"}";
          break;
      }
      if (_this.state.passwordConfirm === undefined) {
        _this.setState({ disableSubmit: true });
        fetch("https://api.hirezstudios.com/acct/" + endpoint, {
          method: "" + method,
          headers: {
            "Content-Type": "application/json"
          },
          body: "" + payload
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          hcaptcha.reset();
          _this.setState({ disableSubmit: false });
          if (response.errors) {
            _this.setState({ resMessage: response.errors[0] });
          } else if (response.webToken) {
            // set cookie for web token
            _this.createCookie("HZAcctWebToken", response.webToken, 30);
            _this.createCookie("HZAcctTokenExp", response.expiration, 30);
            _this.createCookie("HZAcctUsername", response.user, 30);
            _this.createCookie("HZRegion", response.region, 30);
            _this.createCookie("HZAccountId", response.accountId, 30);
            window.location.reload();
          } else if (_this.state.panel === "forgot-password" || _this.state.panel === "forgot-username" && response.statusCode === 200) {
            _this.setState({
              resMessage: undefined,
              panelCopy: locale.forgotResponse,
              panel: "login"
            });
            _this.navController(_this.state.panel);
          } else if (response.statusCode === 400) {
            _this.setState({ resMessage: "Please check your information and try again." });
          } else if (response.statusCode === 401) {
            hcaptcha.reset();
            _this.setState({ resMessage: "Validation failed. Please try again." });
          } else if (response.statusCode === 403) {
            _this.setState({ showTwoFactor: true });
          } else {
            _this.setState({ resMessage: undefined });
          }
        });
      }
    };

    _this.getRecaptchaToken = function () {
      var token = hcaptcha.getResponse();
      if (!token) {
        setTimeout(_this.getRecaptchaToken, 100);
        return;
      }
      if (_this.state.email !== undefined) {
        _this.validateEmail(token, _this.state.email);
      } else {
        _this.submitForm(token);
      }
    };

    _this.recaptchaVerify = function (e) {
      e.preventDefault();
      hcaptcha.execute();
      _this.getRecaptchaToken();
    };

    _this.state = {
      panel: _this.props.panel,
      showLoading: false,
      btnCopy: null,
      referral: _this.props.referral,
      showTwoFactor: false,
      disableSubmit: false
    };
    return _this;
  }

  // erase cookie


  // create cookie

  // TODO: trim this section down if cases are not needed


  Inputs.prototype.componentWillMount = function componentWillMount() {
    this.constructInputs(this.state.panel);
  };

  Inputs.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({ panel: nextProps.panel });
    this.constructInputs(this.state.panel);
    this.setState({ username: undefined });
    this.setState({ password: undefined });
    this.setState({ confirm: undefined });
    this.setState({ email: undefined });
    this.setState({ recovery: undefined });
    this.setState({ twofactor: undefined });
    this.setState({ authentication: undefined });
    this.setState({ age: undefined });
    this.setState({ subscribe: undefined });
    this.setState({ resMessage: undefined });
  };

  Inputs.prototype.render = function render() {
    var _this2 = this;

    var t = this.props.t;

    return Object(preact_min["h"])(
      "div",
      { className: "inputs-wrapper " + this.state.panel },
      this.state.panelCopy && Object(preact_min["h"])(
        "div",
        { className: "panel-copy" },
        t(this.state.panelCopy)
      ),
      this.props.thirdPartyEmail !== null && (this.state.panel === "login-google" || "login-facebook") && Object(preact_min["h"])(
        "div",
        { className: "third-party-email" },
        this.props.thirdPartyEmail
      ),
      this.state.resMessage && Object(preact_min["h"])(
        "div",
        { className: "response-message" },
        t(this.state.resMessage)
      ),
      Object(preact_min["h"])(
        "div",
        { className: "username-wrapper" },
        Object(preact_min["h"])(
          "label",
          { htmlFor: "username" },
          t(locale.labelUsername)
        ),
        Object(preact_min["h"])("input", { type: "text", id: "username", onInput: this.storeInputs, value: this.state.username })
      ),
      Object(preact_min["h"])(
        "div",
        { className: "password-wrapper" },
        Object(preact_min["h"])(
          "label",
          { htmlFor: "username" },
          t(locale.labelPassword)
        ),
        Object(preact_min["h"])("input", { type: "password", id: "password", onInput: this.storeInputs, value: this.state.password })
      ),
      Object(preact_min["h"])(
        "div",
        { className: "confirm-wrapper" },
        Object(preact_min["h"])(
          "label",
          { htmlFor: "confirm" },
          t(locale.labelConfirm)
        ),
        Object(preact_min["h"])("input", { type: "password", id: "confirm", onInput: this.storeInputs, value: this.state.confirm })
      ),
      Object(preact_min["h"])(
        "div",
        { className: "password-wrapper" },
        Object(preact_min["h"])("input", { type: "hidden", id: "passwordConfirm", onInput: this.storeInputs, value: this.state.passwordConfirm })
      ),
      Object(preact_min["h"])(
        "div",
        { className: "email-wrapper" },
        Object(preact_min["h"])(
          "label",
          { htmlFor: "email" },
          t(locale.labelEmail)
        ),
        Object(preact_min["h"])("input", { type: "text", id: "email", onInput: this.storeInputs, value: this.state.email })
      ),
      Object(preact_min["h"])(
        "div",
        { className: "recovery-wrapper" },
        Object(preact_min["h"])(
          "label",
          { htmlFor: "recovery" },
          t(locale.labelRecovery)
        ),
        Object(preact_min["h"])("input", { type: "text", id: "recovery", onInput: this.storeInputs, value: this.state.recovery })
      ),
      this.state.showTwoFactor === true && Object(preact_min["h"])(
        "div",
        { className: "twofactor-wrapper" },
        Object(preact_min["h"])(
          "label",
          { htmlFor: "twofactor" },
          t(locale.labelTwoFactor)
        ),
        Object(preact_min["h"])("input", { type: "text", id: "twofactor", onInput: this.storeInputs, value: this.state.twofactor })
      ),
      Object(preact_min["h"])(
        "div",
        { className: "authentication-wrapper" },
        Object(preact_min["h"])(
          "label",
          { htmlFor: "authentication" },
          t(locale.labelAuth)
        ),
        Object(preact_min["h"])("input", { type: "text", id: "authentication", onInput: this.storeInputs, value: this.state.authentication })
      ),
      Object(preact_min["h"])(
        "div",
        { className: "age-wrapper" },
        Object(preact_min["h"])("input", { type: "checkbox", id: "age", onInput: this.storeInputs, value: this.state.age }),
        Object(preact_min["h"])("label", { htmlFor: "age", dangerouslySetInnerHTML: { __html: t(locale.labelAge) } })
      ),
      Object(preact_min["h"])(
        "div",
        { className: "subscribe-wrapper" },
        Object(preact_min["h"])("input", { type: "checkbox", id: "subscribe", onInput: this.storeInputs, value: this.state.subscribe }),
        Object(preact_min["h"])(
          "label",
          { htmlFor: "subscribe" },
          t(locale.labelSubscribe)
        )
      ),
      Object(preact_min["h"])("input", { type: "hidden", id: "referral", value: this.state.referral }),
      LoginPanelInputs__ref,
      Object(preact_min["h"])(
        "div",
        { className: "actions-wrapper" },
        Object(preact_min["h"])(
          "div",
          { className: "submit" },
          Object(preact_min["h"])("input", {
            type: "submit",
            onClick: this.recaptchaVerify,
            value: t(this.state.btnCopy),
            className: "login-btn " + (this.state.disableSubmit ? "disable-submit" : "")
          }),
          this.state.panel === "login" && Object(preact_min["h"])(
            "div",
            { className: "create-acct-assist" },
            Object(preact_min["h"])(
              "a",
              { "class": "cant-login", onClick: function onClick() {
                  return _this2.props.callback("cant-login", _this2.state.panel);
                } },
              this.state.panel === "login" ? t(locale.copyCantLogin) : ""
            ),
            Object(preact_min["h"])(
              "a",
              { "class": "create-free", onClick: function onClick() {
                  return _this2.props.callback("create", _this2.state.panel);
                } },
              t(locale.btnCreateFree)
            )
          )
        ),
        LoginPanelInputs__ref2
      ),
      Object(preact_min["h"])(
        "div",
        { className: "cant-login-wrapper" },
        Object(preact_min["h"])(
          "a",
          { onClick: function onClick() {
              return _this2.props.callback("forgot-username");
            } },
          t(locale.btnRecoverUsername)
        ),
        Object(preact_min["h"])(
          "a",
          { onClick: function onClick() {
              return _this2.props.callback("forgot-password");
            } },
          t(locale.btnRecoverPassword)
        ),
        Object(preact_min["h"])(
          "div",
          { className: "divider" },
          t(locale.copyDivider)
        ),
        Object(preact_min["h"])(
          "a",
          { href: "https://support.hirezstudios.com/", target: "_blank" },
          t(locale.btnContactSupport)
        )
      )
    );
  };

  return Inputs;
}(preact_min["Component"]);

/* harmony default export */ var LoginPanelInputs = (translate(["common"], { withRef: true })(LoginPanelInputs_Inputs));
// CONCATENATED MODULE: ./components/LoginPanelLoading.js


function LoginPanelLoading__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginPanelLoading__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LoginPanelLoading__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LoginPanelLoading__ref = Object(preact_min["h"])('div', { className: 'loading' });

var LoginPanelLoading_Loading = function (_Component) {
	LoginPanelLoading__inherits(Loading, _Component);

	function Loading() {
		LoginPanelLoading__classCallCheck(this, Loading);

		return LoginPanelLoading__possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Loading.prototype.render = function render() {
		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'loading-wrapper' },
			LoginPanelLoading__ref,
			Object(preact_min["h"])(
				'div',
				{ className: 'loading-copy' },
				t('Logging Into Your Account')
			)
		);
	};

	return Loading;
}(preact_min["Component"]);

/* harmony default export */ var LoginPanelLoading = (translate(['common'], { withRef: true })(LoginPanelLoading_Loading));
// CONCATENATED MODULE: ./components/LoginPanelNavigation.js


function LoginPanelNavigation__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginPanelNavigation__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LoginPanelNavigation__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var redirectURL = void 0;

var LoginPanelNavigation_locale = {
  labelUsername: "Username",
  labelPassword: "Password",
  labelConfirm: "Confirm",
  labelEmail: "Email",
  labelRecovery: "Recovery Code",
  labelTwoFactor: "Two Factor Code",
  labelAuth: "Authentication Code",
  labelAge: 'I am 13+ years old and I agree to the <a href="https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf" rel="noopener noreferrer" target="_blank">Terms of Service</a>.',
  labelSubscribe: "Send me Hi-Rez Studios news.",
  copyCantLogin: "Can't Login?",
  copyDivider: "or",
  copyServicesSignup: "Sign Up With:",
  copyServicesLogin: "Login With:",
  copyContactSupport: "If the above options were not able to assist you:",
  btnLogin: "Login",
  btnCreate: "Create",
  btnCreateFree: "Create A Free Account",
  btnSubmit: "Submit",
  btnGoogle: "Google",
  btnFacebook: "Facebook",
  btnBack: "Back",
  btnRecoverUsername: "Forgot Your Username?",
  btnRecoverPassword: "Forgot Your Password?",
  btnRecoverCode: "Use One Time Recovery Code",
  btnBackupEmail: "Use Backup Email to Login",
  btnContactSupport: "Contact Customer Support",
  smiteCopy: "Sign Up Now! Join 25+ Million Players Today",
  errorUsernameMissing: "A username is required to create an account.",
  panelCopyCantLogin: "There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.",
  panelCopyForgotUsername: "Enter in the email associated with your account to receive a reminder email.",
  panelCopyForgotPassword: "Enter in the email and username associated with your account to reset your password.",
  panelCopyRecoveryCode: "Enter in the username and one time recovery code (when you setup your two factor authentication) to login.",
  panelCopyBackupEmail: "Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.",
  panelCopyCreateGoogle: "A verified email address with Google is required to create an account. You will use your Google login to play.",
  panelCopyCreateFacebook: "A verified email address with Facebook is required to create an account. You will use your Facebook login to play.",
  panelCopyLoginThirdParty: "You will be logged in as:",
  forgotResponse: "Thank you, an email has been sent to the address on file.",
  noMasterAccount: "We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?"
};

// Navigation Component
// TODO: cleanup state, switch, and general display of nav elements
// TODO: split nav elements off into containers and display with css based upon panel
// TODO: login with facebook, login with google, create with google, create with facebook views and routes

var LoginPanelNavigation__ref = Object(preact_min["h"])("i", { className: "icon-facebook" });

var LoginPanelNavigation__ref2 = Object(preact_min["h"])("i", { className: "icon-google" });

var LoginPanelNavigation__ref3 = Object(preact_min["h"])("i", { className: "icon-discord" });

var LoginPanelNavigation__ref4 = Object(preact_min["h"])("i", { className: "icon-nintendo" });

var LoginPanelNavigation__ref5 = Object(preact_min["h"])("i", { className: "icon-playstation" });

var LoginPanelNavigation__ref6 = Object(preact_min["h"])("i", { className: "icon-steam" });

var LoginPanelNavigation__ref7 = Object(preact_min["h"])("i", { className: "icon-xbox" });

var LoginPanelNavigation_Navigation = function (_Component) {
  LoginPanelNavigation__inherits(Navigation, _Component);

  function Navigation(props) {
    LoginPanelNavigation__classCallCheck(this, Navigation);

    var _this = LoginPanelNavigation__possibleConstructorReturn(this, _Component.call(this, props));

    _this.navController = function (panel) {
      switch (panel) {
        case "login":
          _this.setState({ serviceHeaderCopy: LoginPanelNavigation_locale.copyServicesLogin });
          _this.setState({ showBackBtn: false });
          _this.setState({ lastPanel: null });
          break;
        case "create":
          _this.setState({ serviceHeaderCopy: LoginPanelNavigation_locale.copyServicesSignup });
          _this.setState({ showBackBtn: false });
          _this.setState({ lastPanel: null });
          break;
        case "cant-login":
          _this.setState({ showBackBtn: true });
          _this.setState({ lastPanel: "login" });
          break;
        case "forgot-username":
          _this.setState({ showBackBtn: true });
          _this.setState({ lastPanel: "cant-login" });
          break;
        case "forgot-password":
          _this.setState({ showBackBtn: true });
          _this.setState({ lastPanel: "cant-login" });
          break;
        case "recovery-code":
          _this.setState({ showBackBtn: true });
          _this.setState({ lastPanel: "cant-login" });
          break;
        case "backup-email":
          _this.setState({ showBackBtn: true });
          _this.setState({ lastPanel: "cant-login" });
          break;
        case "create-google":
          _this.setState({ showBackBtn: true });
          _this.setState({ lastPanel: "create" });
          break;
        case "create-facebook":
          _this.setState({ showBackBtn: true });
          _this.setState({ lastPanel: "create" });
          break;
        case "login-google":
          _this.setState({ showBackBtn: true });
          _this.setState({ lastPanel: "login" });
          break;
        case "login-facebook":
          _this.setState({ showBackBtn: true });
          _this.setState({ lastPanel: "login" });
          break;
        default:
      }
    };

    _this.loginWithGoogle = function (response) {
      if (response) {
        if (response.hasOwnProperty("error")) {
          // error handling
        } else {
          _this.props.thirdParty("Google", response.accessToken, response.w3.U3, response.w3.Eea);
          _this.props.callback("login-google");
          //token, email, id
        }
      }
    };

    _this.createWithGoogle = function (response) {
      if (response.hasOwnProperty("error")) {
        // error handling
      } else {
        _this.props.thirdParty("Google", response.accessToken, response.w3.U3, response.w3.Eea);
        _this.props.callback("create-google");
        //token, email, id
      }
    };

    _this.failedWithGoogle = function (response) {
      console.log(response);
    };

    _this.loginWithFacebook = function (response) {
      if (response.hasOwnProperty("error")) {
        // error handling
      } else {
        _this.props.thirdParty("Facebook", response.accessToken, response.email, response.id);
        _this.props.callback("login-facebook");
        //token, email, id
      }
    };

    _this.createWithFacebook = function (response) {
      if (response.hasOwnProperty("error")) {
        // error handling
      } else {
        _this.props.thirdParty("Facebook", response.accessToken, response.email, response.id);
        _this.props.callback("create-facebook");
        //token, email, id
      }
    };

    _this.failedWithFacebook = function (response) {
      console.log(response);
    };

    _this.state = {
      panel: _this.props.panel,
      lastPanel: null,
      showBackBtn: false,
      serviceHeaderCopy: null
    };
    return _this;
  }

  Navigation.prototype.componentWillMount = function componentWillMount() {
    this.navController(this.state.panel);
    // redirectURL = window.location.origin + window.location.pathname;
    redirectURL = "https://my.hirezstudios.com/";
  };

  Navigation.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({ panel: nextProps.panel });
    this.setState({ lastPanel: nextProps.lastPanel });
    this.navController(this.state.panel);
  };

  Navigation.prototype.render = function render() {
    var _this2 = this;

    var t = this.props.t;

    return Object(preact_min["h"])(
      "div",
      { className: "nav-wrapper" },
      this.state.panel === "login" && Object(preact_min["h"])(
        "div",
        { className: "nav-header" },
        Object(preact_min["h"])(
          "div",
          { className: "divider" },
          t(LoginPanelNavigation_locale.copyDivider)
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: "services-container login " + (this.state.panel === "login" ? "" : "is-disabled") },
        Object(preact_min["h"])(
          "div",
          { className: "third-party-services" },
          Object(preact_min["h"])(
            "a",
            { href: "https://api.hirezstudios.com/oauth/out/facebook?url=" + redirectURL },
            LoginPanelNavigation__ref
          ),
          Object(preact_min["h"])(
            "a",
            { href: "https://api.hirezstudios.com/oauth/out/google?url=" + redirectURL },
            LoginPanelNavigation__ref2
          ),
          Object(preact_min["h"])(
            "a",
            { href: "https://api.hirezstudios.com/oauth/out/discord?url=" + redirectURL },
            LoginPanelNavigation__ref3
          ),
          Object(preact_min["h"])(
            "a",
            { href: "https://api.hirezstudios.com/oauth/out/nintendo?url=" + redirectURL },
            LoginPanelNavigation__ref4
          ),
          Object(preact_min["h"])(
            "a",
            { href: "https://api.hirezstudios.com/oauth/out/playstation?url=" + redirectURL },
            LoginPanelNavigation__ref5
          ),
          Object(preact_min["h"])(
            "a",
            { href: "https://api.hirezstudios.com/oauth/out/steam?url=" + redirectURL },
            LoginPanelNavigation__ref6
          ),
          Object(preact_min["h"])(
            "a",
            { href: "https://api.hirezstudios.com/oauth/out/xbox?url=" + redirectURL },
            LoginPanelNavigation__ref7
          )
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: "services-container create " + (this.state.panel === "create" ? "" : "is-disabled") },
        Object(preact_min["h"])(
          "a",
          { className: "back-to-login", onClick: function onClick() {
              return _this2.props.callback("login", _this2.state.panel);
            } },
          t("Already have a Hi-Rez Studios account? Login.")
        )
      ),
      Object(preact_min["h"])(
        "div",
        { className: "back-wrapper " + (this.state.showBackBtn === true ? "" : "is-disabled") },
        Object(preact_min["h"])(
          "a",
          { className: "back-btn", onClick: function onClick() {
              return _this2.props.callback(_this2.state.lastPanel);
            } },
          t(LoginPanelNavigation_locale.btnBack)
        )
      )
    );
  };

  return Navigation;
}(preact_min["Component"]);

/* harmony default export */ var LoginPanelNavigation = (translate(["common"], { withRef: true })(LoginPanelNavigation_Navigation));
// CONCATENATED MODULE: ./components/LoginPanelNoMaster.js


function LoginPanelNoMaster__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginPanelNoMaster__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LoginPanelNoMaster__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LoginPanelNoMaster_locale = {
	labelUsername: 'Username',
	labelPassword: 'Password',
	labelConfirm: 'Confirm',
	labelEmail: 'Email',
	labelRecovery: 'Recovery Code',
	labelTwoFactor: 'Two Factor Code',
	labelAuth: 'Authentication Code',
	labelAge: 'I am 13+ years old and I agree to the <a href="https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf" rel="noopener noreferrer" target="_blank">Terms of Service</a>.',
	labelSubscribe: 'Send me Hi-Rez Studios news.',
	copyCantLogin: 'Can\'t Login?',
	copyDivider: 'or',
	copyServicesSignup: 'Sign Up With:',
	copyServicesLogin: 'Login With:',
	copyContactSupport: 'If the above options were not able to assist you:',
	btnLogin: 'Login',
	btnCreate: 'Create',
	btnCreateFree: 'Create A Free Account',
	btnSubmit: 'Submit',
	btnGoogle: 'Google',
	btnFacebook: 'Facebook',
	btnBack: 'Back',
	btnRecoverUsername: 'Forgot Your Username?',
	btnRecoverPassword: 'Forgot Your Password?',
	btnRecoverCode: 'Use One Time Recovery Code',
	btnBackupEmail: 'Use Backup Email to Login',
	btnContactSupport: 'Contact Customer Support',
	smiteCopy: 'Sign Up Now! Join 25+ Million Players Today',
	errorUsernameMissing: 'A username is required to create an account.',
	panelCopyCantLogin: 'There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.',
	panelCopyForgotUsername: 'Enter in the email associated with your account to receive a reminder email.',
	panelCopyForgotPassword: 'Enter in the email and username associated with your account to reset your password.',
	panelCopyRecoveryCode: 'Enter in the username and one time recovery code (when you setup your two factor authentication) to login.',
	panelCopyBackupEmail: 'Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.',
	panelCopyCreateGoogle: 'A verified email address with Google is required to create an account. You will use your Google login to play.',
	panelCopyCreateFacebook: 'A verified email address with Facebook is required to create an account. You will use your Facebook login to play.',
	panelCopyLoginThirdParty: 'You will be logged in as:',
	forgotResponse: 'Thank you, an email has been sent to the address on file.',
	noMasterAccount: 'We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?'
};

var LoginPanelNoMaster__ref = Object(preact_min["h"])('div', { className: 'loading' });

var LoginPanelNoMaster__ref2 = Object(preact_min["h"])('div', { className: 'loading' });

var LoginPanelNoMaster_NoMasterAcct = function (_Component) {
	LoginPanelNoMaster__inherits(NoMasterAcct, _Component);

	function NoMasterAcct(props) {
		LoginPanelNoMaster__classCallCheck(this, NoMasterAcct);

		var _this = LoginPanelNoMaster__possibleConstructorReturn(this, _Component.call(this, props));

		_this.changeView = function (view) {
			_this.setState({
				error: undefined,
				username: undefined,
				password: undefined,
				email: undefined,
				age: undefined,
				subscribe: undefined
			});
			_this.setState({ linkView: view });
		};

		_this.getURLParam = function (name, url) {
			if (!url) url = location.href;
			name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
			var regexS = '[\\?&]' + name + '=([^&#]*)';
			var regex = new RegExp(regexS);
			var results = regex.exec(url);
			return results == null ? null : results[1];
		};

		_this.createCookie = function (name, value, days) {
			var expires = void 0;
			if (days) {
				var date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				expires = '; expires=' + date.toGMTString();
			} else {
				expires = '';
			}
			document.cookie = name + "=" + value + expires + ";path=/";
		};

		_this.linkThirdPartyAccount = function (platform, accessToken, webToken) {
			fetch('https://api.hirezstudios.com/acct/decryptToken', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: '{"token": "' + accessToken + '"}'
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				if (response.decryptedToken) {
					var decryptedToken = response.decryptedToken;
					fetch('https://api.hirezstudios.com/acct/linkNew', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: '{"token":"' + decryptedToken + '", "platform":"' + platform + '", "webToken":"' + webToken + '"}'
					}).then(function (response) {
						return response.json();
					}).then(function (response) {
						if (response.statusCode === 200) {
							_this.createCookie('HZAcctWebToken', webToken, 30);
							location.reload();
						} else if (response.statusCode === 400) {
							_this.setState({ error: 'Your third party account is already linked to an existing Hi-Rez Studios account.' });
						} else {
							_this.setState({ error: 'Something went wrong. Please try again.' });
						}
					});
				} else {
					_this.setState({ error: 'Something went wrong. Please try again.' });
				}
			});
		};

		_this.linkSteamAccount = function (accessToken, webToken) {
			fetch('https://api.hirezstudios.com/acct/decryptToken', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: '{"token": "' + accessToken + '"}'
			}).then(function (response) {
				return response.json();
			}).then(function (response) {
				if (response.decryptedToken) {
					var decryptedToken = response.decryptedToken;
					fetch('https://api.hirezstudios.com/acct/linkSteam', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json'
						},
						body: '{"token":"' + decryptedToken + '", "platform":"steam", "webToken":"' + webToken + '"}'
					}).then(function (response) {
						return response.json();
					}).then(function (response) {
						if (response.statusCode === 200) {
							_this.createCookie('HZAcctWebToken', webToken, 30);
							location.reload();
						} else if (response.statusCode === 400) {
							_this.setState({ error: 'Your third party account is already linked to an existing Hi-Rez Studios account.' });
						} else {
							_this.setState({ error: 'Something went wrong. Please try again.' });
						}
					});
				} else {
					_this.setState({ error: 'Something went wrong. Please try again.' });
				}
			});
		};

		_this.validateLoginData = function (username, password) {
			if (!username || username === undefined || username === null) {
				_this.setState({ error: 'Username is a required field.' });
				return false;
			}
			if (!password || password === undefined || password === null) {
				_this.setState({ error: 'Password is a required field.' });
				return false;
			}
			return true;
		};

		_this.validateCreateData = function (username, password, email, age) {
			var emailValidation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if (!username || username === undefined || username === null) {
				_this.setState({ error: 'Username is a required field.' });
				return false;
			}
			if (!password || password === undefined || password === null) {
				_this.setState({ error: 'Password is a required field.' });
				return false;
			}
			if (!email || password === undefined || password === null) {
				_this.setState({ error: 'Email is a required field.' });
				return false;
			}
			if (emailValidation.test(String(email).toLowerCase()) !== true) {
				_this.setState({ error: 'Please enter a valid email address.' });
				return false;
			}
			if (!age || age === undefined || age === null) {
				_this.setState({ error: 'You must be at least 13 years old and agree to the Terms of Service to create an account.' });
				return false;
			}
			return true;
		};

		_this.attemptLogin = function (e) {
			e.preventDefault();
			var username = _this.state.username;
			var password = _this.state.password;
			if (_this.validateLoginData(username, password)) {
				fetch('https://api.hirezstudios.com/acct/login', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: '{"username":"' + username + '","password":"' + password + '"}'
				}).then(function (response) {
					return response.json();
				}).then(function (response) {
					if (response.hasOwnProperty('webToken')) {
						var platform = _this.getURLParam('platform');
						if (platform == 'playstation') {
							platform = 'ps4';
						}
						var accessToken = _this.getURLParam('accessToken');
						if (platform === 'steam') {
							_this.linkSteamAccount(accessToken, response.webToken);
						} else {
							_this.linkThirdPartyAccount(platform, accessToken, response.webToken);
						}
					} else if (response.hasOwnProperty('errors')) {
						_this.setState({ error: response.errors[0] });
					} else {
						_this.setState({ error: 'Something went wrong. Please try again.' });
					}
				});
			}
		};

		_this.attemptCreate = function (e) {
			e.preventDefault();
			var username = _this.state.username;
			var password = _this.state.password;
			var email = _this.state.email;
			var age = _this.state.age;
			var subscribe = _this.state.subscribe;
			if (_this.validateCreateData(username, password, email, age)) {
				fetch('https://api.hirezstudios.com/acct/create', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: '{"username":"' + username + '","password":"' + password + '","confirmPassword":"' + password + '","email":"' + email + '","over13":"true","subscribe":"' + subscribe + '"}'
				}).then(function (response) {
					return response.json();
				}).then(function (response) {
					if (response.hasOwnProperty('webToken')) {
						var platform = _this.getURLParam('platform');
						if (platform == 'playstation') {
							platform = 'ps4';
						}
						var accessToken = _this.getURLParam('accessToken');
						if (platform === 'steam') {
							_this.linkSteamAccount(accessToken, response.webToken);
						} else {
							_this.linkThirdPartyAccount(platform, accessToken, response.webToken);
						}
					} else if (response.hasOwnProperty('errors')) {
						_this.setState({ error: response.errors[0] });
					} else {
						_this.setState({ error: 'Something went wrong. Please try again.' });
					}
				});
			}
		};

		_this.state = {
			buttonSupportState: 'initial',
			linkView: 'login'
		};
		return _this;
	}

	// create cookie


	NoMasterAcct.prototype.render = function render() {
		var _this2 = this;

		var t = this.props.t;

		return Object(preact_min["h"])(
			'div',
			{ className: 'v-NoMasterAcct' },
			Object(preact_min["h"])(
				'div',
				{ className: 'inputs-wrapper' },
				Object(preact_min["h"])(
					'p',
					null,
					t(LoginPanelNoMaster_locale.noMasterAccount)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'error-message' },
					this.state.error
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'view-selectors' },
					Object(preact_min["h"])(
						'div',
						{ onClick: function onClick() {
								return _this2.changeView('login');
							}, className: 'view ' + (this.state.linkView === 'login' ? 'active' : '') },
						t('Link An Existing Account')
					),
					Object(preact_min["h"])(
						'div',
						{ onClick: function onClick() {
								return _this2.changeView('create');
							}, className: 'view ' + (this.state.linkView === 'create' ? 'active' : '') },
						t('Link A New Account')
					)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'form-wrappers' },
					this.state.linkView === 'login' && Object(preact_min["h"])(
						'div',
						{ className: 'form link-login' },
						Object(preact_min["h"])(
							'div',
							{ className: 'username-wrapper' },
							Object(preact_min["h"])(
								'label',
								{ htmlFor: 'username' },
								t(LoginPanelNoMaster_locale.labelUsername)
							),
							Object(preact_min["h"])('input', {
								type: 'text',
								id: 'username',
								onInput: function onInput(e) {
									return _this2.setState({ username: e.target.value });
								},
								value: this.state.username
							})
						),
						Object(preact_min["h"])(
							'div',
							{ className: 'password-wrapper' },
							Object(preact_min["h"])(
								'label',
								{ htmlFor: 'username' },
								t(LoginPanelNoMaster_locale.labelPassword)
							),
							Object(preact_min["h"])('input', {
								type: 'password',
								id: 'password',
								onInput: function onInput(e) {
									return _this2.setState({ password: e.target.value });
								},
								value: this.state.password
							})
						),
						Object(preact_min["h"])(
							'div',
							{ className: 'actions-wrapper' },
							Object(preact_min["h"])(
								'div',
								{ className: 'submit' },
								Object(preact_min["h"])('input', { type: 'submit', value: t(LoginPanelNoMaster_locale.btnLogin), onClick: this.attemptLogin, className: 'login-btn' })
							),
							LoginPanelNoMaster__ref
						)
					),
					this.state.linkView === 'create' && Object(preact_min["h"])(
						'div',
						{ className: 'form link-create' },
						Object(preact_min["h"])(
							'div',
							{ className: 'username-wrapper' },
							Object(preact_min["h"])(
								'label',
								{ htmlFor: 'username' },
								t(LoginPanelNoMaster_locale.labelUsername)
							),
							Object(preact_min["h"])('input', {
								type: 'text',
								id: 'username',
								onInput: function onInput(e) {
									return _this2.setState({ username: e.target.value });
								},
								value: this.state.username
							})
						),
						Object(preact_min["h"])(
							'div',
							{ className: 'password-wrapper' },
							Object(preact_min["h"])(
								'label',
								{ htmlFor: 'username' },
								t(LoginPanelNoMaster_locale.labelPassword)
							),
							Object(preact_min["h"])('input', {
								type: 'password',
								id: 'password',
								onInput: function onInput(e) {
									return _this2.setState({ password: e.target.value });
								},
								value: this.state.password
							})
						),
						Object(preact_min["h"])(
							'div',
							{ className: 'email-wrapper' },
							Object(preact_min["h"])(
								'label',
								{ htmlFor: 'email' },
								t(LoginPanelNoMaster_locale.labelEmail)
							),
							Object(preact_min["h"])('input', {
								type: 'text',
								id: 'email',
								onInput: function onInput(e) {
									return _this2.setState({ email: e.target.value });
								},
								value: this.state.email
							})
						),
						Object(preact_min["h"])(
							'div',
							{ className: 'age-wrapper' },
							Object(preact_min["h"])('input', {
								type: 'checkbox',
								id: 'age',
								onInput: function onInput(e) {
									return _this2.setState({ age: e.target.value });
								},
								value: this.state.age
							}),
							Object(preact_min["h"])('label', { htmlFor: 'age', dangerouslySetInnerHTML: { __html: t(LoginPanelNoMaster_locale.labelAge) } })
						),
						Object(preact_min["h"])(
							'div',
							{ className: 'subscribe-wrapper' },
							Object(preact_min["h"])('input', {
								type: 'checkbox',
								id: 'subscribe',
								onInput: function onInput(e) {
									return _this2.setState({ subscribe: e.target.value });
								},
								value: this.state.subscribe
							}),
							Object(preact_min["h"])(
								'label',
								{ htmlFor: 'subscribe' },
								t(LoginPanelNoMaster_locale.labelSubscribe)
							)
						),
						Object(preact_min["h"])(
							'div',
							{ className: 'actions-wrapper' },
							Object(preact_min["h"])(
								'div',
								{ className: 'submit' },
								Object(preact_min["h"])('input', { type: 'submit', value: t(LoginPanelNoMaster_locale.btnCreate), onClick: this.attemptCreate, className: 'login-btn' })
							),
							LoginPanelNoMaster__ref2
						)
					)
				),
				Object(preact_min["h"])(
					'div',
					{ className: 'cancel-link' },
					Object(preact_min["h"])('div', { onClick: function onClick() {
							return _this2.props.callback('login', _this2.state.panel);
						}, className: 'warning', dangerouslySetInnerHTML: { __html: t('Wrong account? <a>Login to a different account.</a>') } })
				)
			)
		);
	};

	return NoMasterAcct;
}(preact_min["Component"]);

/* harmony default export */ var LoginPanelNoMaster = (translate(['common'], { withRef: true })(LoginPanelNoMaster_NoMasterAcct));
// CONCATENATED MODULE: ./components/LoginPanel.js


function LoginPanel__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LoginPanel__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function LoginPanel__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// TODO: attribute for successLoginRedirect and successCreateRedirect
// TODO: split off locale, logic based upon attribute lang

var LoginPanel_redirectURL = void 0;

var LoginPanel_locale = {
  labelUsername: "Username",
  labelPassword: "Password",
  labelConfirm: "Confirm",
  labelEmail: "Email",
  labelRecovery: "Recovery Code",
  labelTwoFactor: "Two Factor Code",
  labelAuth: "Authentication Code",
  labelAge: 'I am 13+ years old and I agree to the <a href="https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf" rel="noopener noreferrer" target="_blank">Terms of Service</a>.',
  labelSubscribe: "Send me Hi-Rez Studios news.",
  copyCantLogin: "Can't Login?",
  copyDivider: "or",
  copyServicesSignup: "Sign Up With:",
  copyServicesLogin: "Login With:",
  copyContactSupport: "If the above options were not able to assist you:",
  btnLogin: "Login",
  btnCreate: "Create",
  btnCreateFree: "Create A Free Account",
  btnSubmit: "Submit",
  btnGoogle: "Google",
  btnFacebook: "Facebook",
  btnBack: "Back",
  btnRecoverUsername: "Forgot Your Username?",
  btnRecoverPassword: "Forgot Your Password?",
  btnRecoverCode: "Use One Time Recovery Code",
  btnBackupEmail: "Use Backup Email to Login",
  btnContactSupport: "Contact Customer Support",
  smiteCopy: "Sign Up Now! Join 25+ Million Players Today",
  errorUsernameMissing: "A username is required to create an account.",
  panelCopyCantLogin: "There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.",
  panelCopyForgotUsername: "Enter in the email associated with your account to receive a reminder email.",
  panelCopyForgotPassword: "Enter in the email and username associated with your account to reset your password.",
  panelCopyRecoveryCode: "Enter in the username and one time recovery code (when you setup your two factor authentication) to login.",
  panelCopyBackupEmail: "Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.",
  panelCopyCreateGoogle: "A verified email address with Google is required to create an account. You will use your Google login to play.",
  panelCopyCreateFacebook: "A verified email address with Facebook is required to create an account. You will use your Facebook login to play.",
  panelCopyLoginThirdParty: "You will be logged in as:",
  forgotResponse: "Thank you, an email has been sent to the address on file.",
  noMasterAccount: "We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?"
};

// TODO: load data-* attributes into App state
// TODO: cleanup App state







var LoginPanel__ref = Object(preact_min["h"])("i", { className: "ion-android-arrow-dropdown" });

var LoginPanel__ref2 = Object(preact_min["h"])(LoginPanelBranding, null);

var LoginPanel_LoginPanel = function (_Component) {
  LoginPanel__inherits(LoginPanel, _Component);

  function LoginPanel(props) {
    LoginPanel__classCallCheck(this, LoginPanel);

    var _this = LoginPanel__possibleConstructorReturn(this, _Component.call(this, props));

    _this.tokenToCookie = function () {
      if (_this.readCookie("HZAcctWebToken") !== _this.getURLParam("webToken")) {
        var encrytpedToken = _this.getURLParam("webToken");
        fetch("https://api.hirezstudios.com/acct/decryptToken", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: "{\"token\":\"" + encrytpedToken + "\"}"
        }).then(function (response) {
          return response.json();
        }).then(function (response) {
          if (response.hasOwnProperty("decryptedToken")) {
            _this.createCookie("HZAcctWebToken", response.decryptedToken, 30);
            window.location.href = window.location.href.split("?")[0];
          } else {
            _this.setState({ resMessage: "Unable to process token. Please try again." });
            window.location.href = window.location.href.split("?")[0];
          }
        });
      }
    };

    _this.createCookie = function (name, value, days) {
      var expires = void 0;
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
      } else {
        expires = "";
      }
      document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
    };

    _this.readCookie = function (name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    };

    _this.getURLParam = function (name, url) {
      if (!url) url = location.href;
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(url);
      return results == null ? null : results[1];
    };

    _this.updateActivePanel = function (nextPanel) {
      _this.setState({
        activePanel: nextPanel,
        errorMsg: undefined
      });
      if (nextPanel === "login" || nextPanel === "create") {
        _this.setState({ thirdPartyEmail: undefined });
      }
    };

    _this.updateErrorMessage = function (error) {
      var formattedMessage = error.split("+").join(" ");
      // this.setState({ errorMsg: formattedMessage });
      // console.log(TrustedErrors.includes(formattedMessage));
      if (TrustedErrors.includes(formattedMessage)) {
        _this.setState({ errorMsg: formattedMessage });
      }
    };

    _this.thirdPartyAction = function (portal, token, email, id) {
      _this.setState({ thirdPartyPortal: portal });
      _this.setState({ thirdPartyToken: token });
      _this.setState({ thirdPartyEmail: email });
      _this.setState({ thirdPartyId: id });
    };

    _this.getLanguageCookie = function () {
      var langCookie = _this.readCookie("language_pref");
      _this.setState({ langCode: langCookie == undefined ? "en_US" : langCookie });
      _this.setLanguagePref(langCookie);
    };

    _this.setLanguagePref = function (lang) {
      switch (lang) {
        case "en_uS":
          _this.setState({ language: "English" });
          break;
        case "fr_FR":
          _this.setState({ language: "Français" });
          break;
        case "es_LA":
          _this.setState({ language: "Español" });
          break;
        case "de_DE":
          _this.setState({ language: "Deutsch" });
          break;
        case "pl_PL":
          _this.setState({ language: "Polski" });
          break;
        case "ru_RU":
          _this.setState({ language: "Русский" });
          break;
        case "tr_TR":
          _this.setState({ language: "Turkish" });
          break;
        case "pt_BR":
          _this.setState({ language: "Português do Brasil" });
          break;
        case "zh_CN":
          _this.setState({ language: "中国" });
          break;
        default:
          _this.setState({ language: "English" });
      }
    };

    _this.changeLanguage = function (lang) {
      _this.createCookie("language_pref", lang, 365);
      // i18n.changeLanguage(lang);
      window.location = window.location.href.split("?")[0] + "?lng=" + lang;
    };

    _this.qrReaderRedirect = function () {
      if (window.location.href.indexOf("platform") > -1) {
        var platformloc = window.location.href.split("?platform=");
        var platformName = platformloc[1];
        var _redirectURL = window.location.origin + window.location.pathname;
        switch (platformName) {
          case "switch":
            window.location.href = "https://api.hirezstudios.com/oauth/out/nintendo?url=" + _redirectURL;
            break;
          // Remove this comment when they fix the game client
          // case 'xbox':
          // 	window.location.href = ('https://api.hirezstudios.com/oauth/out/xbox?url=' + redirectURL);
          // 	break;
          case "xbox1":
            window.location.href = "https://api.hirezstudios.com/oauth/out/xbox?url=" + _redirectURL;
            break;
          case "xbox":
            window.location.href = "http://www.hirezstudios.com/console-link-redirect/?1";
            break;
          case "playstation":
            window.location.href = "https://api.hirezstudios.com/oauth/out/playstation?url=" + _redirectURL;
            break;
          default:
            "";
        }
      }
    };

    _this.mobileLanguageTap = function () {
      if (_this.props.windowWidth < 1200) {
        _this.state.langNavToggled ? _this.setState({ langNavToggled: false }) : _this.setState({ langNavToggled: true });
      }
    };

    _this.state = {
      startPanel: null,
      activePanel: "login",
      brandTheme: null,
      brandImage: null,
      brandCopy: null,
      panelCopy: null,
      resMessage: null,
      referral: null,
      thirdPartyPortal: null,
      thirdPartyToken: null,
      thirdPartyEmail: null,
      thirdPartyId: null,
      language: null,
      langCode: null,
      langNavToggled: false
    };
    return _this;
  }

  // read cookie


  LoginPanel.prototype.componentDidMount = function componentDidMount() {
    document.body.classList.add("blue");
    if (this.getURLParam("webToken")) {
      this.updateActivePanel("loading");
      this.tokenToCookie();
    }
    if (this.getURLParam("accessToken")) {
      this.updateActivePanel("no-master");
    }
    if (window.location.hash === "#forgot-password") {
      this.updateActivePanel("forgot-password");
    }
    if (window.location.hash === "#forgot-username") {
      this.updateActivePanel("forgot-username");
    }
    if (this.getURLParam("error")) {
      this.updateErrorMessage(this.getURLParam("error"));
    }
    this.qrReaderRedirect();

    //lang switcher
    var lngFromURL = this.getURLParam("lng");
    var lang = void 0;

    if (lngFromURL != null) {
      this.createCookie("language_pref", lngFromURL);
      lang = lngFromURL;
    } else {
      this.readCookie("language_pref") == undefined ? this.createCookie("language_pref", "en_US", 365) : "";
      lang = this.readCookie("language_pref") != null ? this.readCookie("language_pref") : "en_US";
    }
  };

  LoginPanel.prototype.componentWillMount = function componentWillMount() {
    this.getLanguageCookie();
  };

  LoginPanel.prototype.render = function render() {
    var _this2 = this;

    return Object(preact_min["h"])(
      "form",
      { id: "hirez-acct-form" },
      Object(preact_min["h"])(
        "div",
        {
          className: "language-wrapper " + (this.state.langNavToggled ? "mobile-expanded" : ""),
          onClick: this.mobileLanguageTap
        },
        Object(preact_min["h"])(
          "div",
          { className: "lang-select" },
          this.state.language && this.state.language,
          LoginPanel__ref,
          Object(preact_min["h"])(
            "div",
            { className: "languages" },
            Object(preact_min["h"])(
              "a",
              { onClick: function onClick() {
                  return _this2.changeLanguage("en_US");
                } },
              "English"
            ),
            Object(preact_min["h"])(
              "a",
              { onClick: function onClick() {
                  return _this2.changeLanguage("fr_FR");
                } },
              "Fran\xE7ais"
            ),
            Object(preact_min["h"])(
              "a",
              { onClick: function onClick() {
                  return _this2.changeLanguage("de_DE");
                } },
              "Deutsch"
            ),
            Object(preact_min["h"])(
              "a",
              { onClick: function onClick() {
                  return _this2.changeLanguage("es_LA");
                } },
              "Espa\xF1ol"
            ),
            Object(preact_min["h"])(
              "a",
              { onClick: function onClick() {
                  return _this2.changeLanguage("pl_PL");
                } },
              "Polski"
            ),
            Object(preact_min["h"])(
              "a",
              { onClick: function onClick() {
                  return _this2.changeLanguage("ru_RU");
                } },
              "\u0420\u0443\u0441\u0441\u043A\u0438\u0439"
            ),
            Object(preact_min["h"])(
              "a",
              { onClick: function onClick() {
                  return _this2.changeLanguage("pt_BR");
                } },
              "Portugu\xEAs do Brasil"
            ),
            Object(preact_min["h"])(
              "a",
              { onClick: function onClick() {
                  return _this2.changeLanguage("tr_TR");
                } },
              "Turkish"
            ),
            Object(preact_min["h"])(
              "a",
              { onClick: function onClick() {
                  return _this2.changeLanguage("zh_CN");
                } },
              "\u4E2D\u56FD"
            )
          )
        )
      ),
      LoginPanel__ref2,
      Object(preact_min["h"])(
        "div",
        { className: "error-message" },
        this.state.errorMsg
      ),
      this.state.activePanel === "loading" && Object(preact_min["h"])(LoginPanelLoading, { panel: this.state.activePanel, callback: this.updateActivePanel }),
      this.state.activePanel === "no-master" && Object(preact_min["h"])(LoginPanelNoMaster, { panel: this.state.activePanel, callback: this.updateActivePanel }),
      this.state.activePanel !== "no-master" && this.state.activePanel !== "loading" && Object(preact_min["h"])(LoginPanelInputs, {
        panel: this.state.activePanel,
        callback: this.updateActivePanel,
        thirdPartyPortal: this.state.thirdPartyPortal,
        thirdPartyToken: this.state.thirdPartyToken,
        thirdPartyEmail: this.state.thirdPartyEmail,
        thirdPartyId: this.state.thirdPartyId
      }),
      Object(preact_min["h"])(LoginPanelNavigation, {
        panel: this.state.activePanel,
        callback: this.updateActivePanel,
        lastPanel: this.state.lastPanel,
        thirdParty: this.thirdPartyAction
      })
    );
  };

  return LoginPanel;
}(preact_min["Component"]);

/* harmony default export */ var components_LoginPanel = (translate(["common"], { withRef: true })(LoginPanel_LoginPanel));
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/logger.js
var logger__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function logger__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }return arr2;
  } else {
    return Array.from(arr);
  }
}

var consoleLogger = {
  type: 'logger',

  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    var _console;

    /* eslint no-console: 0 */
    if (console && console[type]) (_console = console)[type].apply(_console, _toConsumableArray(args));
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    logger__classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  Logger.prototype.init = function init(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    this.prefix = options.prefix || 'i18next:';
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  };

  Logger.prototype.setDebug = function setDebug(bool) {
    this.debug = bool;
  };

  Logger.prototype.log = function log() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return this.forward(args, 'log', '', true);
  };

  Logger.prototype.warn = function warn() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return this.forward(args, 'warn', '', true);
  };

  Logger.prototype.error = function error() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return this.forward(args, 'error', '');
  };

  Logger.prototype.deprecate = function deprecate() {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
  };

  Logger.prototype.forward = function forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (typeof args[0] === 'string') args[0] = '' + prefix + this.prefix + ' ' + args[0];
    return this.logger[lvl](args);
  };

  Logger.prototype.create = function create(moduleName) {
    return new Logger(this.logger, logger__extends({ prefix: this.prefix + ':' + moduleName + ':' }, this.options));
  };

  return Logger;
}();

/* harmony default export */ var logger = (new Logger());
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/EventEmitter.js
function EventEmitter__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var EventEmitter = function () {
  function EventEmitter() {
    EventEmitter__classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  EventEmitter.prototype.on = function on(events, listener) {
    var _this = this;

    events.split(' ').forEach(function (event) {
      _this.observers[event] = _this.observers[event] || [];
      _this.observers[event].push(listener);
    });
    return this;
  };

  EventEmitter.prototype.off = function off(event, listener) {
    var _this2 = this;

    if (!this.observers[event]) {
      return;
    }

    this.observers[event].forEach(function () {
      if (!listener) {
        delete _this2.observers[event];
      } else {
        var index = _this2.observers[event].indexOf(listener);
        if (index > -1) {
          _this2.observers[event].splice(index, 1);
        }
      }
    });
  };

  EventEmitter.prototype.emit = function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (this.observers[event]) {
      var cloned = [].concat(this.observers[event]);
      cloned.forEach(function (observer) {
        observer.apply(undefined, args);
      });
    }

    if (this.observers['*']) {
      var _cloned = [].concat(this.observers['*']);
      _cloned.forEach(function (observer) {
        observer.apply(observer, [event].concat(args));
      });
    }
  };

  return EventEmitter;
}();

/* harmony default export */ var es_EventEmitter = (EventEmitter);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/utils.js
function makeString(object) {
  if (object == null) return '';
  /* eslint prefer-template: 0 */
  return '' + object;
}

function utils_copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};

    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    object = object[key];
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}

function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}

function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}

function deepExtend(target, source, overwrite) {
  /* eslint no-restricted-syntax: 0 */
  for (var prop in source) {
    if (prop in target) {
      // If we reached a leaf string in target or source then replace with source or skip depending on the 'overwrite' switch
      if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
        if (overwrite) target[prop] = source[prop];
      } else {
        deepExtend(target[prop], source[prop], overwrite);
      }
    } else {
      target[prop] = source[prop];
    }
  }
  return target;
}

function regexEscape(str) {
  /* eslint no-useless-escape: 0 */
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

/* eslint-disable */
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': '&quot;',
  "'": '&#39;',
  "/": '&#x2F;'
};
/* eslint-enable */

function utils_escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/ResourceStore.js
var ResourceStore__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _defaults(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);for (var i = 0; i < keys.length; i++) {
    var key = keys[i];var value = Object.getOwnPropertyDescriptor(defaults, key);if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }return obj;
}

function ResourceStore__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function ResourceStore__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function ResourceStore__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass);
}




var ResourceStore_ResourceStore = function (_EventEmitter) {
  ResourceStore__inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { ns: ['translation'], defaultNS: 'translation' };

    ResourceStore__classCallCheck(this, ResourceStore);

    var _this = ResourceStore__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    return _this;
  }

  ResourceStore.prototype.addNamespaces = function addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  };

  ResourceStore.prototype.removeNamespaces = function removeNamespaces(ns) {
    var index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  };

  ResourceStore.prototype.getResource = function getResource(lng, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    var path = [lng, ns];
    if (key && typeof key !== 'string') path = path.concat(key);
    if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
    }

    return getPath(this.data, path);
  };

  ResourceStore.prototype.addResource = function addResource(lng, ns, key, value) {
    var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : { silent: false };

    var keySeparator = this.options.keySeparator;
    if (keySeparator === undefined) keySeparator = '.';

    var path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      value = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    setPath(this.data, path, value);

    if (!options.silent) this.emit('added', lng, ns, key, value);
  };

  ResourceStore.prototype.addResources = function addResources(lng, ns, resources) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { silent: false };

    /* eslint no-restricted-syntax: 0 */
    for (var m in resources) {
      if (typeof resources[m] === 'string') this.addResource(lng, ns, m, resources[m], { silent: true });
    }
    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.addResourceBundle = function addResourceBundle(lng, ns, resources, deep, overwrite) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : { silent: false };

    var path = [lng, ns];
    if (lng.indexOf('.') > -1) {
      path = lng.split('.');
      deep = resources;
      resources = ns;
      ns = path[1];
    }

    this.addNamespaces(ns);

    var pack = getPath(this.data, path) || {};

    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = ResourceStore__extends({}, pack, resources);
    }

    setPath(this.data, path, pack);

    if (!options.silent) this.emit('added', lng, ns, resources);
  };

  ResourceStore.prototype.removeResourceBundle = function removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);

    this.emit('removed', lng, ns);
  };

  ResourceStore.prototype.hasResourceBundle = function hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== undefined;
  };

  ResourceStore.prototype.getResourceBundle = function getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;

    // COMPATIBILITY: remove extend in v2.1.0
    if (this.options.compatibilityAPI === 'v1') return ResourceStore__extends({}, this.getResource(lng, ns));

    return this.getResource(lng, ns);
  };

  ResourceStore.prototype.getDataByLanguage = function getDataByLanguage(lng) {
    return this.data[lng];
  };

  ResourceStore.prototype.toJSON = function toJSON() {
    return this.data;
  };

  return ResourceStore;
}(es_EventEmitter);

/* harmony default export */ var es_ResourceStore = (ResourceStore_ResourceStore);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/postProcessor.js
/* harmony default export */ var postProcessor = ({

  processors: {},

  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });

    return value;
  }
});
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/Translator.js
var Translator__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var Translator__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function Translator__defaults(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);for (var i = 0; i < keys.length; i++) {
    var key = keys[i];var value = Object.getOwnPropertyDescriptor(defaults, key);if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }return obj;
}

function Translator__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function Translator__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function Translator__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : Translator__defaults(subClass, superClass);
}






var Translator_Translator = function (_EventEmitter) {
  Translator__inherits(Translator, _EventEmitter);

  function Translator(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    Translator__classCallCheck(this, Translator);

    var _this = Translator__possibleConstructorReturn(this, _EventEmitter.call(this));

    utils_copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat'], services, _this);

    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = logger.create('translator');
    return _this;
  }

  Translator.prototype.changeLanguage = function changeLanguage(lng) {
    if (lng) this.language = lng;
  };

  Translator.prototype.exists = function exists(key) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { interpolation: {} };

    var resolved = this.resolve(key, options);
    return resolved && resolved.res !== undefined;
  };

  Translator.prototype.extractFromKey = function extractFromKey(key, options) {
    var nsSeparator = options.nsSeparator || this.options.nsSeparator;
    if (nsSeparator === undefined) nsSeparator = ':';

    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    var namespaces = options.ns || this.options.defaultNS;
    if (nsSeparator && key.indexOf(nsSeparator) > -1) {
      var parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    if (typeof namespaces === 'string') namespaces = [namespaces];

    return {
      key: key,
      namespaces: namespaces
    };
  };

  Translator.prototype.translate = function translate(keys, options) {
    var _this2 = this;

    if ((typeof options === 'undefined' ? 'undefined' : Translator__typeof(options)) !== 'object' && this.options.overloadTranslationOptionHandler) {
      /* eslint prefer-rest-params: 0 */
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (!options) options = {};

    // non valid keys handling
    if (keys === undefined || keys === null || keys === '') return '';
    if (typeof keys === 'number') keys = String(keys);
    if (typeof keys === 'string') keys = [keys];

    // separators
    var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

    // get namespace(s)

    var _extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _extractFromKey.key,
        namespaces = _extractFromKey.namespaces;

    var namespace = namespaces[namespaces.length - 1];

    // return key on CIMode
    var lng = options.lng || this.language;
    var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === 'cimode') {
      if (appendNamespaceToCIMode) {
        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
        return namespace + nsSeparator + key;
      }

      return key;
    }

    // resolve from store
    var resolved = this.resolve(keys, options);
    var res = resolved && resolved.res;
    var resUsedKey = resolved && resolved.usedKey || key;

    var resType = Object.prototype.toString.apply(res);
    var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
    var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;

    // object
    var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(joinArrays && resType === '[object Array]')) {
      if (!options.returnObjects && !this.options.returnObjects) {
        this.logger.warn('accessing an object - but returnObjects options is not enabled!');
        return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : 'key \'' + key + ' (' + this.language + ')\' returned an object instead of string.';
      }

      // if we got a separator we loop over children - else we just return object as is
      // as having it set to false means no hierarchy so no lookup for nested values
      if (keySeparator) {
        var copy = resType === '[object Array]' ? [] : {}; // apply child translation on a copy

        /* eslint no-restricted-syntax: 0 */
        for (var m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            var deepKey = '' + resUsedKey + keySeparator + m;
            copy[m] = this.translate(deepKey, Translator__extends({}, options, { joinArrays: false, ns: namespaces }));
            if (copy[m] === deepKey) copy[m] = res[m]; // if nothing found use orginal value as fallback
          }
        }
        res = copy;
      }
    } else if (handleAsObjectInI18nFormat && joinArrays && resType === '[object Array]') {
      // array special treatment
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options);
    } else {
      // string, empty or null
      var usedDefault = false;
      var usedKey = false;

      // fallback value
      if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
        usedDefault = true;

        if (options.count !== undefined) {
          var suffix = this.pluralResolver.getSuffix(lng, options.count);
          res = options['defaultValue' + suffix];
        }
        if (!res) res = options.defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }

      // save missing
      var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

        var lngs = [];
        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
          for (var i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === 'all') {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }

        var send = function send(l, k) {
          if (_this2.options.missingKeyHandler) {
            _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
            _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
          }
          _this2.emit('missingKey', l, namespace, k, res);
        };

        if (this.options.saveMissing) {
          var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach(function (l) {
              var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

              plurals.forEach(function (p) {
                return send([l], p);
              });
            });
          } else {
            send(lngs, key);
          }
        }
      }

      // extend
      res = this.extendTranslation(res, keys, options, resolved);

      // append namespace if still key
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = namespace + ':' + key;

      // parseMissingKeyHandler
      if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
    }

    // return
    return res;
  };

  Translator.prototype.extendTranslation = function extendTranslation(res, key, options, resolved) {
    var _this3 = this;

    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, { resolved: resolved });
    } else if (!options.skipInterpolation) {
      // i18next.parsing
      if (options.interpolation) this.interpolator.init(Translator__extends({}, options, { interpolation: Translator__extends({}, this.options.interpolation, options.interpolation) }));

      // interpolate
      var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = Translator__extends({}, this.options.interpolation.defaultVariables, data);
      res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

      // nesting
      if (options.nest !== false) res = this.interpolator.nest(res, function () {
        return _this3.translate.apply(_this3, arguments);
      }, options);

      if (options.interpolation) this.interpolator.reset();
    }

    // post process
    var postProcess = options.postProcess || this.options.postProcess;
    var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

    if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, options, this);
    }

    return res;
  };

  Translator.prototype.resolve = function resolve(keys) {
    var _this4 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var found = void 0;
    var usedKey = void 0;
    var usedLng = void 0;
    var usedNS = void 0;

    if (typeof keys === 'string') keys = [keys];

    // forEach possible key
    keys.forEach(function (k) {
      if (_this4.isValidLookup(found)) return;
      var extracted = _this4.extractFromKey(k, options);
      var key = extracted.key;
      usedKey = key;
      var namespaces = extracted.namespaces;
      if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);

      var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
      var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';

      var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);

      namespaces.forEach(function (ns) {
        if (_this4.isValidLookup(found)) return;
        usedNS = ns;

        codes.forEach(function (code) {
          if (_this4.isValidLookup(found)) return;
          usedLng = code;

          var finalKey = key;
          var finalKeys = [finalKey];

          if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
            _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            var pluralSuffix = void 0;
            if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);

            // fallback for plural if context not found
            if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);

            // get key for context if needed
            if (needsContextHandling) finalKeys.push(finalKey += '' + _this4.options.contextSeparator + options.context);

            // get key for plural if needed
            if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
          }

          // iterate over finalKeys starting with most specific pluralkey (-> contextkey only) -> singularkey only
          var possibleKey = void 0;
          /* eslint no-cond-assign: 0 */
          while (possibleKey = finalKeys.pop()) {
            if (!_this4.isValidLookup(found)) {
              found = _this4.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });

    return { res: found, usedKey: usedKey, usedLng: usedLng, usedNS: usedNS };
  };

  Translator.prototype.isValidLookup = function isValidLookup(res) {
    return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
  };

  Translator.prototype.getResource = function getResource(code, ns, key) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  };

  return Translator;
}(es_EventEmitter);

/* harmony default export */ var es_Translator = (Translator_Translator);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/LanguageUtils.js
function LanguageUtils__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}



function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtils_LanguageUtil = function () {
  function LanguageUtil(options) {
    LanguageUtils__classCallCheck(this, LanguageUtil);

    this.options = options;

    this.whitelist = this.options.whitelist || false;
    this.logger = logger.create('languageUtils');
  }

  LanguageUtil.prototype.getScriptPartFromCode = function getScriptPartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return null;

    var p = code.split('-');
    if (p.length === 2) return null;
    p.pop();
    return this.formatLanguageCode(p.join('-'));
  };

  LanguageUtil.prototype.getLanguagePartFromCode = function getLanguagePartFromCode(code) {
    if (!code || code.indexOf('-') < 0) return code;

    var p = code.split('-');
    return this.formatLanguageCode(p[0]);
  };

  LanguageUtil.prototype.formatLanguageCode = function formatLanguageCode(code) {
    // http://www.iana.org/assignments/language-tags/language-tags.xhtml
    if (typeof code === 'string' && code.indexOf('-') > -1) {
      var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
      var p = code.split('-');

      if (this.options.lowerCaseLng) {
        p = p.map(function (part) {
          return part.toLowerCase();
        });
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();

        // if lenght 2 guess it's a country
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();

        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }

      return p.join('-');
    }

    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  };

  LanguageUtil.prototype.isWhitelisted = function isWhitelisted(code) {
    if (this.options.load === 'languageOnly' || this.options.nonExplicitWhitelist) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.whitelist || !this.whitelist.length || this.whitelist.indexOf(code) > -1;
  };

  LanguageUtil.prototype.getFallbackCodes = function getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === 'string') fallbacks = [fallbacks];
    if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;

    if (!code) return fallbacks.default || [];

    // asume we have an object defining fallbacks
    var found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks.default;

    return found || [];
  };

  LanguageUtil.prototype.toResolveHierarchy = function toResolveHierarchy(code, fallbackCode) {
    var _this = this;

    var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);

    var codes = [];
    var addCode = function addCode(c) {
      if (!c) return;
      if (_this.isWhitelisted(c)) {
        codes.push(c);
      } else {
        _this.logger.warn('rejecting non-whitelisted language code: ' + c);
      }
    };

    if (typeof code === 'string' && code.indexOf('-') > -1) {
      if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
      if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
    } else if (typeof code === 'string') {
      addCode(this.formatLanguageCode(code));
    }

    fallbackCodes.forEach(function (fc) {
      if (codes.indexOf(fc) < 0) addCode(_this.formatLanguageCode(fc));
    });

    return codes;
  };

  return LanguageUtil;
}();

/* harmony default export */ var LanguageUtils = (LanguageUtils_LanguageUtil);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/PluralResolver.js
function PluralResolver__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}



// definition http://translate.sourceforge.net/wiki/l10n/pluralforms
/* eslint-disable */
var sets = [{ lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'], nr: [1, 2], fc: 1 }, { lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'he', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'], nr: [1, 2], fc: 2 }, { lngs: ['ay', 'bo', 'cgg', 'fa', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'], nr: [1], fc: 3 }, { lngs: ['be', 'bs', 'dz', 'hr', 'ru', 'sr', 'uk'], nr: [1, 2, 5], fc: 4 }, { lngs: ['ar'], nr: [0, 1, 2, 3, 11, 100], fc: 5 }, { lngs: ['cs', 'sk'], nr: [1, 2, 5], fc: 6 }, { lngs: ['csb', 'pl'], nr: [1, 2, 5], fc: 7 }, { lngs: ['cy'], nr: [1, 2, 3, 8], fc: 8 }, { lngs: ['fr'], nr: [1, 2], fc: 9 }, { lngs: ['ga'], nr: [1, 2, 3, 7, 11], fc: 10 }, { lngs: ['gd'], nr: [1, 2, 3, 20], fc: 11 }, { lngs: ['is'], nr: [1, 2], fc: 12 }, { lngs: ['jv'], nr: [0, 1], fc: 13 }, { lngs: ['kw'], nr: [1, 2, 3, 4], fc: 14 }, { lngs: ['lt'], nr: [1, 2, 10], fc: 15 }, { lngs: ['lv'], nr: [1, 2, 0], fc: 16 }, { lngs: ['mk'], nr: [1, 2], fc: 17 }, { lngs: ['mnk'], nr: [0, 1, 2], fc: 18 }, { lngs: ['mt'], nr: [1, 2, 11, 20], fc: 19 }, { lngs: ['or'], nr: [2, 1], fc: 2 }, { lngs: ['ro'], nr: [1, 2, 20], fc: 20 }, { lngs: ['sl'], nr: [5, 1, 2, 3], fc: 21 }];

var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n === 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n === 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n === 1 ? 0 : n === 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
/* eslint-enable */

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver_PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    PluralResolver__classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;

    this.logger = logger.create('pluralResolver');

    this.rules = createRules();
  }

  PluralResolver.prototype.addRule = function addRule(lng, obj) {
    this.rules[lng] = obj;
  };

  PluralResolver.prototype.getRule = function getRule(code) {
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  };

  PluralResolver.prototype.needsPlural = function needsPlural(code) {
    var rule = this.getRule(code);

    return rule && rule.numbers.length > 1;
  };

  PluralResolver.prototype.getPluralFormsOfKey = function getPluralFormsOfKey(code, key) {
    var _this = this;

    var ret = [];

    var rule = this.getRule(code);

    if (!rule) return ret;

    rule.numbers.forEach(function (n) {
      var suffix = _this.getSuffix(code, n);
      ret.push('' + key + suffix);
    });

    return ret;
  };

  PluralResolver.prototype.getSuffix = function getSuffix(code, count) {
    var _this2 = this;

    var rule = this.getRule(code);

    if (rule) {
      // if (rule.numbers.length === 1) return ''; // only singular

      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];

      // special treatment for lngs only having singular and plural
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }

      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };

      // COMPATIBILITY JSON
      // v1
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return '_plural_' + suffix.toString();
        return returnSuffix();
      } else if ( /* v2 */this.options.compatibilityJSON === 'v2' && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      } else if ( /* v3 - gettext index */this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }

    this.logger.warn('no plural rule found for: ' + code);
    return '';
  };

  return PluralResolver;
}();

/* harmony default export */ var es_PluralResolver = (PluralResolver_PluralResolver);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/Interpolator.js
var Interpolator__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function Interpolator__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}




var Interpolator_Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Interpolator__classCallCheck(this, Interpolator);

    this.logger = logger.create('interpolator');

    this.init(options, true);
  }

  /* eslint no-param-reassign: 0 */

  Interpolator.prototype.init = function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var reset = arguments[1];

    if (reset) {
      this.options = options;
      this.format = options.interpolation && options.interpolation.format || function (value) {
        return value;
      };
    }
    if (!options.interpolation) options.interpolation = { escapeValue: true };

    var iOpts = options.interpolation;

    this.escape = iOpts.escape !== undefined ? iOpts.escape : utils_escape;
    this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
    this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;

    this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
    this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';

    this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';

    this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
    this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';

    this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
    this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');

    this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;

    // the regexp
    this.resetRegExp();
  };

  Interpolator.prototype.reset = function reset() {
    if (this.options) this.init(this.options);
  };

  Interpolator.prototype.resetRegExp = function resetRegExp() {
    // the regexp
    var regexpStr = this.prefix + '(.+?)' + this.suffix;
    this.regexp = new RegExp(regexpStr, 'g');

    var regexpUnescapeStr = '' + this.prefix + this.unescapePrefix + '(.+?)' + this.unescapeSuffix + this.suffix;
    this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');

    var nestingRegexpStr = this.nestingPrefix + '(.+?)' + this.nestingSuffix;
    this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
  };

  Interpolator.prototype.interpolate = function interpolate(str, data, lng, options) {
    var _this = this;

    var match = void 0;
    var value = void 0;
    var replaces = void 0;

    function regexSafe(val) {
      return val.replace(/\$/g, '$$$$');
    }

    var handleFormat = function handleFormat(key) {
      if (key.indexOf(_this.formatSeparator) < 0) return getPath(data, key);

      var p = key.split(_this.formatSeparator);
      var k = p.shift().trim();
      var f = p.join(_this.formatSeparator).trim();

      return _this.format(getPath(data, k), f, lng);
    };

    this.resetRegExp();

    var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;

    replaces = 0;
    // unescape if has unescapePrefix/Suffix
    /* eslint no-cond-assign: 0 */
    while (match = this.regexpUnescape.exec(str)) {
      value = handleFormat(match[1].trim());
      str = str.replace(match[0], value);
      this.regexpUnescape.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }

    replaces = 0;
    // regular escape on demand
    while (match = this.regexp.exec(str)) {
      value = handleFormat(match[1].trim());
      if (value === undefined) {
        if (typeof missingInterpolationHandler === 'function') {
          var temp = missingInterpolationHandler(str, match);
          value = typeof temp === 'string' ? temp : '';
        } else {
          this.logger.warn('missed to pass in variable ' + match[1] + ' for interpolating ' + str);
          value = '';
        }
      } else if (typeof value !== 'string' && !this.useRawValueToEscape) {
        value = makeString(value);
      }
      value = this.escapeValue ? regexSafe(this.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
      replaces++;
      if (replaces >= this.maxReplaces) {
        break;
      }
    }
    return str;
  };

  Interpolator.prototype.nest = function nest(str, fc) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var match = void 0;
    var value = void 0;

    var clonedOptions = Interpolator__extends({}, options);
    clonedOptions.applyPostProcessor = false; // avoid post processing on nested lookup

    // if value is something like "myKey": "lorem $(anotherKey, { "count": {{aValueInOptions}} })"
    function handleHasOptions(key, inheritedOptions) {
      if (key.indexOf(',') < 0) return key;

      var p = key.split(',');
      key = p.shift();
      var optionsString = p.join(',');
      optionsString = this.interpolate(optionsString, clonedOptions);
      optionsString = optionsString.replace(/'/g, '"');

      try {
        clonedOptions = JSON.parse(optionsString);

        if (inheritedOptions) clonedOptions = Interpolator__extends({}, inheritedOptions, clonedOptions);
      } catch (e) {
        this.logger.error('failed parsing options string in nesting for key ' + key, e);
      }

      return key;
    }

    // regular escape on demand
    while (match = this.nestingRegexp.exec(str)) {
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);

      // is only the nesting key (key1 = '$(key2)') return the value without stringify
      if (value && match[0] === str && typeof value !== 'string') return value;

      // no string to include or empty
      if (typeof value !== 'string') value = makeString(value);
      if (!value) {
        this.logger.warn('missed to resolve ' + match[1] + ' for nesting ' + str);
        value = '';
      }
      // Nested keys should not be escaped by default #854
      // value = this.escapeValue ? regexSafe(utils.escape(value)) : regexSafe(value);
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  };

  return Interpolator;
}();

/* harmony default export */ var es_Interpolator = (Interpolator_Interpolator);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/BackendConnector.js
var BackendConnector__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var BackendConnector__slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

function BackendConnector__defaults(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);for (var i = 0; i < keys.length; i++) {
    var key = keys[i];var value = Object.getOwnPropertyDescriptor(defaults, key);if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }return obj;
}

function BackendConnector__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function BackendConnector__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function BackendConnector__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : BackendConnector__defaults(subClass, superClass);
}





function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var BackendConnector_Connector = function (_EventEmitter) {
  BackendConnector__inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    BackendConnector__classCallCheck(this, Connector);

    var _this = BackendConnector__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.backend = backend;
    _this.store = store;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = logger.create('backendConnector');

    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }

  Connector.prototype.queueLoad = function queueLoad(languages, namespaces, options, callback) {
    var _this2 = this;

    // find what needs to be loaded
    var toLoad = [];
    var pending = [];
    var toLoadLanguages = [];
    var toLoadNamespaces = [];

    languages.forEach(function (lng) {
      var hasAllNamespaces = true;

      namespaces.forEach(function (ns) {
        var name = lng + '|' + ns;

        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
          _this2.state[name] = 2; // loaded
        } else if (_this2.state[name] < 0) {
          // nothing to do for err
        } else if (_this2.state[name] === 1) {
          if (pending.indexOf(name) < 0) pending.push(name);
        } else {
          _this2.state[name] = 1; // pending

          hasAllNamespaces = false;

          if (pending.indexOf(name) < 0) pending.push(name);
          if (toLoad.indexOf(name) < 0) toLoad.push(name);
          if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
        }
      });

      if (!hasAllNamespaces) toLoadLanguages.push(lng);
    });

    if (toLoad.length || pending.length) {
      this.queue.push({
        pending: pending,
        loaded: {},
        errors: [],
        callback: callback
      });
    }

    return {
      toLoad: toLoad,
      pending: pending,
      toLoadLanguages: toLoadLanguages,
      toLoadNamespaces: toLoadNamespaces
    };
  };

  Connector.prototype.loaded = function loaded(name, err, data) {
    var _name$split = name.split('|'),
        _name$split2 = BackendConnector__slicedToArray(_name$split, 2),
        lng = _name$split2[0],
        ns = _name$split2[1];

    if (err) this.emit('failedLoading', lng, ns, err);

    if (data) {
      this.store.addResourceBundle(lng, ns, data);
    }

    // set loaded
    this.state[name] = err ? -1 : 2;

    // consolidated loading done in this run - only emit once for a loaded namespace
    var loaded = {};

    // callback if ready
    this.queue.forEach(function (q) {
      pushPath(q.loaded, [lng], ns);
      remove(q.pending, name);

      if (err) q.errors.push(err);

      if (q.pending.length === 0 && !q.done) {
        // only do once per loaded -> this.emit('loaded', q.loaded);
        Object.keys(q.loaded).forEach(function (l) {
          if (!loaded[l]) loaded[l] = [];
          if (q.loaded[l].length) {
            q.loaded[l].forEach(function (ns) {
              if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
            });
          }
        });

        /* eslint no-param-reassign: 0 */
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });

    // emit consolidated loaded event
    this.emit('loaded', loaded);

    // remove done load requests
    this.queue = this.queue.filter(function (q) {
      return !q.done;
    });
  };

  Connector.prototype.read = function read(lng, ns, fcName) {
    var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    var _this3 = this;

    var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 250;
    var callback = arguments[5];

    if (!lng.length) return callback(null, {}); // noting to load

    return this.backend[fcName](lng, ns, function (err, data) {
      if (err && data /* = retryFlag */ && tried < 5) {
        setTimeout(function () {
          _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    });
  };

  /* eslint consistent-return: 0 */

  Connector.prototype.prepareLoading = function prepareLoading(languages, namespaces) {
    var _this4 = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var callback = arguments[3];

    if (!this.backend) {
      this.logger.warn('No backend was added via i18next.use. Will not load resources.');
      return callback && callback();
    }

    if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
    if (typeof namespaces === 'string') namespaces = [namespaces];

    var toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback(); // nothing to load and no pendings...callback now
      return null; // pendings will trigger callback
    }

    toLoad.toLoad.forEach(function (name) {
      _this4.loadOne(name);
    });
  };

  Connector.prototype.load = function load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  };

  Connector.prototype.reload = function reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, { reload: true }, callback);
  };

  Connector.prototype.loadOne = function loadOne(name) {
    var _this5 = this;

    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var _name$split3 = name.split('|'),
        _name$split4 = BackendConnector__slicedToArray(_name$split3, 2),
        lng = _name$split4[0],
        ns = _name$split4[1];

    this.read(lng, ns, 'read', null, null, function (err, data) {
      if (err) _this5.logger.warn(prefix + 'loading namespace ' + ns + ' for language ' + lng + ' failed', err);
      if (!err && data) _this5.logger.log(prefix + 'loaded namespace ' + ns + ' for language ' + lng, data);

      _this5.loaded(name, err, data);
    });
  };

  Connector.prototype.saveMissing = function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

    if (this.backend && this.backend.create) {
      this.backend.create(languages, namespace, key, fallbackValue, null /* unused callback */, BackendConnector__extends({}, options, { isUpdate: isUpdate }));
    }

    // write to store to avoid resending
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  };

  return Connector;
}(es_EventEmitter);

/* harmony default export */ var BackendConnector = (BackendConnector_Connector);
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/defaults.js

function get() {
  return {
    debug: false,
    initImmediate: true,

    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false, // string or array of namespaces

    whitelist: false, // array with whitelisted languages
    nonExplicitWhitelist: false,
    load: 'all', // | currentOnly | languageOnly
    preload: false, // array with preload languages

    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',

    saveMissing: false, // enable to send missing values
    updateMissing: false, // enable to update default values if different from translated value (only useful on initial development, or when keeping code as source of truth)
    saveMissingTo: 'fallback', // 'current' || 'all'
    saveMissingPlurals: true, // will save all forms not only singular key
    missingKeyHandler: false, // function(lng, ns, key, fallbackValue) -> override if prefer on handling
    missingInterpolationHandler: false, // function(str, match)

    postProcess: false, // string or array of postProcessor names
    returnNull: true, // allows null value as valid translation
    returnEmptyString: true, // allows empty string value as valid translation
    returnObjects: false,
    joinArrays: false, // or string to join array
    returnedObjectHandler: function returnedObjectHandler() {}, // function(key, value, options) triggered if key returns object but returnObjects is set to false
    parseMissingKeyHandler: false, // function(key) parsed a key that was not found in t() before returning
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (args[1]) ret.defaultValue = args[1];
      if (args[2]) ret.tDescription = args[2];
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      // prefixEscaped: '{{',
      // suffixEscaped: '}}',
      // unescapeSuffix: '',
      unescapePrefix: '-',

      nestingPrefix: '$t(',
      nestingSuffix: ')',
      // nestingPrefixEscaped: '$t(',
      // nestingSuffixEscaped: ')',
      // defaultVariables: undefined // object that can have values to interpolate on - extends passed in interpolation data
      maxReplaces: 1000 // max replaces to prevent endless loop
    }
  };
}

/* eslint no-param-reassign: 0 */
function transformOptions(options) {
  // create namespace object if namespace is passed in as string
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  // extend whitelist with cimode
  if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
    options.whitelist = options.whitelist.concat(['cimode']);
  }

  return options;
}
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/i18next.js
var i18next__typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var i18next__extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function i18next__defaults(obj, defaults) {
  var keys = Object.getOwnPropertyNames(defaults);for (var i = 0; i < keys.length; i++) {
    var key = keys[i];var value = Object.getOwnPropertyDescriptor(defaults, key);if (value && value.configurable && obj[key] === undefined) {
      Object.defineProperty(obj, key, value);
    }
  }return obj;
}

function i18next__classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function i18next__possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function i18next__inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : i18next__defaults(subClass, superClass);
}












function noop() {}

var i18next_I18n = function (_EventEmitter) {
  i18next__inherits(I18n, _EventEmitter);

  function I18n() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    i18next__classCallCheck(this, I18n);

    var _this = i18next__possibleConstructorReturn(this, _EventEmitter.call(this));

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = logger;
    _this.modules = { external: [] };

    if (callback && !_this.isInitialized && !options.isClone) {
      var _ret;

      // https://github.com/i18next/i18next/issues/879
      if (!_this.options.initImmediate) return _ret = _this.init(options, callback), i18next__possibleConstructorReturn(_this, _ret);
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }

  I18n.prototype.init = function init() {
    var _this2 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    this.options = i18next__extends({}, get(), this.options, transformOptions(options));

    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;

    function createClassOnDemand(ClassOrObject) {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === 'function') return new ClassOrObject();
      return ClassOrObject;
    }

    // init services
    if (!this.options.isClone) {
      if (this.modules.logger) {
        logger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        logger.init(null, this.options);
      }

      var lu = new LanguageUtils(this.options);
      this.store = new es_ResourceStore(this.options.resources, this.options);

      var s = this.services;
      s.logger = logger;
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new es_PluralResolver(lu, { prepend: this.options.pluralSeparator, compatibilityJSON: this.options.compatibilityJSON, simplifyPluralSuffix: this.options.simplifyPluralSuffix });
      s.interpolator = new es_Interpolator(this.options);

      s.backendConnector = new BackendConnector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      // pipe events from backendConnector
      s.backendConnector.on('*', function (event) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        s.languageDetector.init(s, this.options.detection, this.options);
      }

      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }

      this.translator = new es_Translator(this.services, this.options);
      // pipe events from translator
      this.translator.on('*', function (event) {
        for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        _this2.emit.apply(_this2, [event].concat(args));
      });

      this.modules.external.forEach(function (m) {
        if (m.init) m.init(_this2);
      });
    }

    // append api
    var storeApi = ['getResource', 'addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
    storeApi.forEach(function (fcName) {
      _this2[fcName] = function () {
        var _store;

        return (_store = _this2.store)[fcName].apply(_store, arguments);
      };
    });

    var load = function load() {
      _this2.changeLanguage(_this2.options.lng, function (err, t) {
        _this2.isInitialized = true;
        _this2.logger.log('initialized', _this2.options);
        _this2.emit('initialized', _this2.options);

        callback(err, t);
      });
    };

    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }

    return this;
  };

  /* eslint consistent-return: 0 */

  I18n.prototype.loadResources = function loadResources() {
    var _this3 = this;

    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;

    if (!this.options.resources) {
      if (this.language && this.language.toLowerCase() === 'cimode') return callback(); // avoid loading resources for cimode

      var toLoad = [];

      var append = function append(lng) {
        if (!lng) return;
        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };

      if (!this.language) {
        // at least load fallbacks in this case
        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach(function (l) {
          return append(l);
        });
      } else {
        append(this.language);
      }

      if (this.options.preload) {
        this.options.preload.forEach(function (l) {
          return append(l);
        });
      }

      this.services.backendConnector.load(toLoad, this.options.ns, callback);
    } else {
      callback(null);
    }
  };

  I18n.prototype.reloadResources = function reloadResources(lngs, ns, callback) {
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = function callback() {};
    this.services.backendConnector.reload(lngs, ns, callback);
  };

  I18n.prototype.use = function use(module) {
    if (module.type === 'backend') {
      this.modules.backend = module;
    }

    if (module.type === 'logger' || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }

    if (module.type === 'languageDetector') {
      this.modules.languageDetector = module;
    }

    if (module.type === 'i18nFormat') {
      this.modules.i18nFormat = module;
    }

    if (module.type === 'postProcessor') {
      postProcessor.addPostProcessor(module);
    }

    if (module.type === '3rdParty') {
      this.modules.external.push(module);
    }

    return this;
  };

  I18n.prototype.changeLanguage = function changeLanguage(lng, callback) {
    var _this4 = this;

    var done = function done(err, l) {
      _this4.translator.changeLanguage(l);

      if (l) {
        _this4.emit('languageChanged', l);
        _this4.logger.log('languageChanged', l);
      }

      if (callback) callback(err, function () {
        return _this4.t.apply(_this4, arguments);
      });
    };

    var setLng = function setLng(l) {
      if (l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        if (!_this4.translator.language) _this4.translator.changeLanguage(l);

        if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
      }

      _this4.loadResources(function (err) {
        done(err, l);
      });
    };

    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      this.services.languageDetector.detect(setLng);
    } else {
      setLng(lng);
    }
  };

  I18n.prototype.getFixedT = function getFixedT(lng, ns) {
    var _this5 = this;

    var fixedT = function fixedT(key, opts) {
      for (var _len3 = arguments.length, rest = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        rest[_key3 - 2] = arguments[_key3];
      }

      var options = i18next__extends({}, opts);
      if ((typeof opts === 'undefined' ? 'undefined' : i18next__typeof(opts)) !== 'object') {
        options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      }

      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      return _this5.t(key, options);
    };
    if (typeof lng === 'string') {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    return fixedT;
  };

  I18n.prototype.t = function t() {
    var _translator;

    return this.translator && (_translator = this.translator).translate.apply(_translator, arguments);
  };

  I18n.prototype.exists = function exists() {
    var _translator2;

    return this.translator && (_translator2 = this.translator).exists.apply(_translator2, arguments);
  };

  I18n.prototype.setDefaultNamespace = function setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  };

  I18n.prototype.loadNamespaces = function loadNamespaces(ns, callback) {
    var _this6 = this;

    if (!this.options.ns) return callback && callback();
    if (typeof ns === 'string') ns = [ns];

    ns.forEach(function (n) {
      if (_this6.options.ns.indexOf(n) < 0) _this6.options.ns.push(n);
    });

    this.loadResources(callback);
  };

  I18n.prototype.loadLanguages = function loadLanguages(lngs, callback) {
    if (typeof lngs === 'string') lngs = [lngs];
    var preloaded = this.options.preload || [];

    var newLngs = lngs.filter(function (lng) {
      return preloaded.indexOf(lng) < 0;
    });
    // Exit early if all given languages are already preloaded
    if (!newLngs.length) return callback();

    this.options.preload = preloaded.concat(newLngs);
    this.loadResources(callback);
  };

  I18n.prototype.dir = function dir(lng) {
    if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
    if (!lng) return 'rtl';

    var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];

    return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
  };

  /* eslint class-methods-use-this: 0 */

  I18n.prototype.createInstance = function createInstance() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments[1];

    return new I18n(options, callback);
  };

  I18n.prototype.cloneInstance = function cloneInstance() {
    var _this7 = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    var mergedOptions = i18next__extends({}, this.options, options, { isClone: true });
    var clone = new I18n(mergedOptions);
    var membersToCopy = ['store', 'services', 'language'];
    membersToCopy.forEach(function (m) {
      clone[m] = _this7[m];
    });
    clone.translator = new es_Translator(clone.services, clone.options);
    clone.translator.on('*', function (event) {
      for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      clone.emit.apply(clone, [event].concat(args));
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = clone.options; // sync options

    return clone;
  };

  return I18n;
}(es_EventEmitter);

/* harmony default export */ var i18next = (new i18next_I18n());
// CONCATENATED MODULE: ../node_modules/i18next/dist/es/index.js


/* harmony default export */ var es = (i18next);

var changeLanguage = i18next.changeLanguage.bind(i18next);
var es_cloneInstance = i18next.cloneInstance.bind(i18next);
var createInstance = i18next.createInstance.bind(i18next);
var dir = i18next.dir.bind(i18next);
var exists = i18next.exists.bind(i18next);
var getFixedT = i18next.getFixedT.bind(i18next);
var es_init = i18next.init.bind(i18next);
var loadLanguages = i18next.loadLanguages.bind(i18next);
var es_loadNamespaces = i18next.loadNamespaces.bind(i18next);
var loadResources = i18next.loadResources.bind(i18next);
var off = i18next.off.bind(i18next);
var on = i18next.on.bind(i18next);
var setDefaultNamespace = i18next.setDefaultNamespace.bind(i18next);
var es_t = i18next.t.bind(i18next);
var es_use = i18next.use.bind(i18next);
// EXTERNAL MODULE: ../node_modules/i18next-browser-languagedetector/index.js
var i18next_browser_languagedetector = __webpack_require__("iEou");
var i18next_browser_languagedetector_default = /*#__PURE__*/__webpack_require__.n(i18next_browser_languagedetector);

// EXTERNAL MODULE: ./locales/pl_PL/common.json
var common = __webpack_require__("miSq");
var common_default = /*#__PURE__*/__webpack_require__.n(common);

// EXTERNAL MODULE: ./locales/en_US/common.json
var en_US_common = __webpack_require__("Koob");
var en_US_common_default = /*#__PURE__*/__webpack_require__.n(en_US_common);

// EXTERNAL MODULE: ./locales/pt_BR/common.json
var pt_BR_common = __webpack_require__("PDuM");
var pt_BR_common_default = /*#__PURE__*/__webpack_require__.n(pt_BR_common);

// EXTERNAL MODULE: ./locales/de_DE/common.json
var de_DE_common = __webpack_require__("pc+c");
var de_DE_common_default = /*#__PURE__*/__webpack_require__.n(de_DE_common);

// EXTERNAL MODULE: ./locales/tr_TR/common.json
var tr_TR_common = __webpack_require__("QlQx");
var tr_TR_common_default = /*#__PURE__*/__webpack_require__.n(tr_TR_common);

// EXTERNAL MODULE: ./locales/ru_RU/common.json
var ru_RU_common = __webpack_require__("9RYL");
var ru_RU_common_default = /*#__PURE__*/__webpack_require__.n(ru_RU_common);

// EXTERNAL MODULE: ./locales/es_LA/common.json
var es_LA_common = __webpack_require__("qBBm");
var es_LA_common_default = /*#__PURE__*/__webpack_require__.n(es_LA_common);

// EXTERNAL MODULE: ./locales/fr_FR/common.json
var fr_FR_common = __webpack_require__("WGa/");
var fr_FR_common_default = /*#__PURE__*/__webpack_require__.n(fr_FR_common);

// EXTERNAL MODULE: ./locales/zh_CN/common.json
var zh_CN_common = __webpack_require__("ohx6");
var zh_CN_common_default = /*#__PURE__*/__webpack_require__.n(zh_CN_common);

// CONCATENATED MODULE: ./i18n.client.js

// import XHR from 'i18next-xhr-backend';
// import Cache from 'i18next-localstorage-cache';












es
// .use(XHR)
// .use(Cache)
.use(i18next_browser_languagedetector_default.a).init({
  fallbackLng: 'en_US',
  // have a common namespace used around the full app
  ns: ['common'],
  defaultNS: 'common',
  // initImmediate: false,
  nsSeparator: false,
  keySeparator: false,
  resources: {
    "pl_PL": {
      common: common_default.a
    },
    "en_US": {
      common: en_US_common_default.a
    },
    "pt_BR": {
      common: pt_BR_common_default.a
    },
    "de_DE": {
      common: de_DE_common_default.a
    },
    "tr_TR": {
      common: tr_TR_common_default.a
    },
    "ru_RU": {
      common: ru_RU_common_default.a
    },
    "es_LA": {
      common: es_LA_common_default.a
    },
    "fr_FR": {
      common: fr_FR_common_default.a
    },
    "zh_CN": {
      common: zh_CN_common_default.a
    }
  },
  debug: false,
  // cache: {
  //   enabled: true
  // },
  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ',',
    format: function format(value, _format, lng) {
      if (_format === 'uppercase') return value.toUpperCase();
      return value;
    }
  }
});

/* harmony default export */ var i18n_client = (es);
// CONCATENATED MODULE: ./index.js


function index__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function index__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function index__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var index__ref2 = Object(preact_min["h"])("div", { id: "liveagent_button_online_573410000008luG", style: "display: none; width: 0; height: 0" });

var index__ref3 = Object(preact_min["h"])(
  "p",
  null,
  "Please log into your Hi-Rez Studios Account."
);

var index__ref4 = Object(preact_min["h"])("script", { src: "https://js.hcaptcha.com/1/api.js", async: true, defer: true });

var index_Dashboard = function (_Component) {
  index__inherits(Dashboard, _Component);

  function Dashboard(props) {
    index__classCallCheck(this, Dashboard);

    var _this = index__possibleConstructorReturn(this, _Component.call(this, props));

    _this.runVIPcheck = function () {
      liveagent.init("https://d.la3-c2-ia2.salesforceliveagent.com/chat", "572410000008jas", "00D41000000fmlp");
      if (!window._laq) {
        window._laq = [];
      }
      window._laq.push(function () {
        liveagent.showWhenOnline("573410000008luG", document.getElementById("liveagent_button_online_573410000008luG"));
        // liveagent.showWhenOffline('573410000008luG', document.getElementById('liveagent_button_offline_573410000008luG'));
        liveagent.addCustomDetail("First Name", "");
        liveagent.addCustomDetail("Last Name", this.context.userData.accountInfo.name);
        liveagent.addCustomDetail("Contact E-mail", this.context.userData.accountInfo.contactInfo.email);
        liveagent.findOrCreate("Contact").map("Email", "Contact E-mail", true, true, true).map("FirstName", "First Name", false, false, true).map("LastName", "Last Name", false, false, true).map("Phone", "Phone Number", false, false, true);
      }.bind(_this));
    };

    _this.verifyEmailAddress = function (key) {
      fetch("https://api.hirezstudios.com/acct/verify", {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: "{\"key\": \"" + key + "\"}"
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        if (response.statusCode === 200) {
          _this.setState({
            notificationType: "success",
            notificationTime: 10000,
            notificationCopy: "Your email address has been verified."
          });
        } else {
          _this.setState({
            notificationType: "fail",
            notificationTime: 10000,
            notificationCopy: "Unable to verify your email address. Please try again."
          });
        }
      });
    };

    _this.readCookie = function (name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return c.substring(nameEQ.length, c.length);
        }
      }
      return null;
    };

    _this.eraseCookie = function (name) {
      _this.createCookie(name, "", -1);
    };

    _this.createCookie = function (name, value, days) {
      var expires = void 0;
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
      } else {
        expires = "";
      }
      document.cookie = name + "=" + value + expires + ";domain=.hirezstudios.com;path=/";
    };

    _this.injectScript = function (src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.async = true;
        script.src = src;
        script.addEventListener("load", resolve);
        script.addEventListener("error", function () {
          return reject("Error loading script.");
        });
        script.addEventListener("abort", function () {
          return reject("Script loading aborted.");
        });
        document.head.appendChild(script);
      });
    };

    _this.parseJwt = function (token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(atob(base64).split("").map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));

      return JSON.parse(jsonPayload);
    };

    _this.getURLParam = function (name, url) {
      if (!url) url = location.href;
      name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(url);
      return results == null ? null : results[1];
    };

    _this.deployNotification = function (type, time, copy) {
      if (type) {
        _this.setState({ notificationType: type });
        _this.setState({ notificationTime: time });
        _this.setState({ notificationCopy: copy });
      }
    };

    _this.windowChange = function () {
      _this.setState({ windowWidth: window.innerWidth });
    };

    _this.componentDidUpdate = function () {
      if (_this.state.loggedIn && !_this.state.logInToggled) {
        window.addEventListener("resize", _this.windowChange);
        _this.setState({ logInToggled: true });
      }
      if (_this.state.loggedIn && _this.context.userData.accountInfo) {
        //Mutation observer for the  liveagent element
        var targetNode = document.getElementById("liveagent_button_online_573410000008luG");
        var config = { attributes: true, childList: true };

        var callback = function (mutationsList) {
          for (var _iterator = mutationsList, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var mutation = _ref;

            if (mutation.type === "attributes") {
              if (targetNode.style.display === "") {
                this.setState({ chatActive: true });
              } else {
                this.setState({ chatActive: false });
              }
            }
          }
        }.bind(_this);

        var observer = new MutationObserver(callback);
        observer.observe(targetNode, config);

        _this.injectScript("https://c.la3-c2-ia2.salesforceliveagent.com/content/g/js/49.0/deployment.js").then(function () {
          if (document.readyState === "complete") {
            this.runVIPcheck();
          }
          document.onreadystatechange = function () {
            this.runVIPcheck();
          }.bind(this);
        }.bind(_this));
      }
    };

    _this.state = {
      loggedIn: false,
      logInToggled: false,
      acctUsername: undefined,
      chatActive: false,
      windowWidth: undefined,
      hash: null,
      dev: false
    };
    return _this;
  }

  Dashboard.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    //dev state
    if (this.getURLParam("dev")) {
      document.body.classList.add("oauth");
      this.setState({
        dev: true,
        origin: window.location.origin
      });
    }

    //Google Analytics
    this.injectScript("https://www.googletagmanager.com/gtag/js?id=UA-128185289-1");
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "UA-128185289-1");

    // Google Tag Manager
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "GTM-TLR4LFV");
    //End Google Tag Manager

    if (window.location.hash === "#forgot-username" || window.location.hash === "#forgot-password") {
      this.setState({ hash: window.location.hash.substr(1) });
    }
    if (this.getURLParam("key")) {
      this.verifyEmailAddress(this.getURLParam("key"));
    }
    if (this.readCookie("HZAcctWebToken") || this.getURLParam("jwt")) {
      document.body.classList.remove("blue");
      this.setState({ loggedIn: true });
      var token = void 0,
          jwtWebToken = void 0;
      if (this.getURLParam("jwt")) {
        token = this.getURLParam("jwt");
        jwtWebToken = this.parseJwt(token);
        history.pushState({}, document.title, "/");
        this.createCookie("HZAcctWebToken", jwtWebToken.jti, 30);
        this.createCookie("JWT", token, 30);
      } else {
        token = this.readCookie("HZAcctWebToken");
      }
      fetch("https://api.hirezstudios.com/acct/info", {
        method: "post",
        headers: {
          "Content-Type": "application/json"
        },
        body: "{\"webToken\": \"" + token + "\"}"
      }).then(function (response) {
        return response.json();
      }).then(function (response) {
        if (response.name) {
          _this2.setState({ acctUsername: response.name });
        }
        if (!_this2.readCookie("HZAccountId")) {
          _this2.createCookie("HZAccountId", response.accountId, 30);
        }
      });
    }

    this.windowChange();
    window.scrollTo(0, 0);
  };

  Dashboard.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("resize", this.windowChange);
    localStorage.removeItem("linkRedirectUrl");
  };

  Dashboard.prototype.render = function render() {
    var userData = this.context.userData;

    if (!this.state.dev && this.state.loggedIn && this.state.hash !== "forgot-password" && this.state.hash !== "forgot-username") {
      return Object(preact_min["h"])(
        "div",
        { className: "hirez-acct-dashboard" },
        index__ref2,
        Object(preact_min["h"])(
          "div",
          { className: "master-username" },
          this.state.acctUsername ? this.state.acctUsername : ""
        ),
        Object(preact_min["h"])(
          "div",
          { className: "center-wrapper" },
          Object(preact_min["h"])(components_Navigation, {
            windowWidth: this.state.windowWidth,
            chatActive: this.state.chatActive,
            isVIP: userData.accountInfo && userData.accountInfo.vip,
            isLoggedIn: this.state.loggedIn
          }),
          Object(preact_min["h"])(
            "div",
            { className: "wrapped-content" },
            Object(preact_min["h"])(components_NotificationBanner, {
              type: this.state.notificationType,
              time: this.state.notificationTime,
              copy: this.state.notificationCopy
            }),
            Object(preact_min["h"])(components_ViewsWrapper, {
              chatActive: this.state.chatActive,
              isVIP: userData.accountInfo && userData.accountInfo.vip,
              webToken: this.readCookie("HZAcctWebToken"),
              notification: this.deployNotification,
              windowWidth: this.state.windowWidth
            })
          )
        )
      );
    } else if (this.state.dev) {
      return Object(preact_min["h"])(
        "div",
        { className: "oauth-panel" },
        index__ref3,
        Object(preact_min["h"])(
          "a",
          {
            href: "https://ben.mechanicalghosts.com/?grant_type=jwt&client_id=1&redirect_uri=" + this.state.origin + "&scope=user&state=XyZ"
          },
          "Log In"
        )
      );
    }
    return Object(preact_min["h"])(
      "div",
      { className: "hirez-acct-dashboard panel" },
      index__ref4,
      Object(preact_min["h"])(components_LoginPanel, { hash: this.state.hash, windowWidth: this.state.windowWidth })
    );
  };

  return Dashboard;
}(preact_min["Component"]);

if (typeof window !== "undefined") {
  Object(preact_min["render"])(Object(preact_min["h"])(
    es_I18nextProvider,
    { i18n: i18n_client },
    Object(preact_min["h"])(
      components_AccountInfoProvider,
      null,
      Object(preact_min["h"])(index_Dashboard, null)
    )
  ), document.body);
}

/***/ }),

/***/ "KM04":
/***/ (function(module, exports, __webpack_require__) {

!function () {
  "use strict";
  function e() {}function t(t, n) {
    var o,
        r,
        i,
        l,
        a = E;for (l = arguments.length; l-- > 2;) {
      W.push(arguments[l]);
    }n && null != n.children && (W.length || W.push(n.children), delete n.children);while (W.length) {
      if ((r = W.pop()) && void 0 !== r.pop) for (l = r.length; l--;) {
        W.push(r[l]);
      } else "boolean" == typeof r && (r = null), (i = "function" != typeof t) && (null == r ? r = "" : "number" == typeof r ? r += "" : "string" != typeof r && (i = !1)), i && o ? a[a.length - 1] += r : a === E ? a = [r] : a.push(r), o = i;
    }var u = new e();return u.nodeName = t, u.children = a, u.attributes = null == n ? void 0 : n, u.key = null == n ? void 0 : n.key, void 0 !== S.vnode && S.vnode(u), u;
  }function n(e, t) {
    for (var n in t) {
      e[n] = t[n];
    }return e;
  }function o(e, o) {
    return t(e.nodeName, n(n({}, e.attributes), o), arguments.length > 2 ? [].slice.call(arguments, 2) : e.children);
  }function r(e) {
    !e.__d && (e.__d = !0) && 1 == A.push(e) && (S.debounceRendering || P)(i);
  }function i() {
    var e,
        t = A;A = [];while (e = t.pop()) {
      e.__d && k(e);
    }
  }function l(e, t, n) {
    return "string" == typeof t || "number" == typeof t ? void 0 !== e.splitText : "string" == typeof t.nodeName ? !e._componentConstructor && a(e, t.nodeName) : n || e._componentConstructor === t.nodeName;
  }function a(e, t) {
    return e.__n === t || e.nodeName.toLowerCase() === t.toLowerCase();
  }function u(e) {
    var t = n({}, e.attributes);t.children = e.children;var o = e.nodeName.defaultProps;if (void 0 !== o) for (var r in o) {
      void 0 === t[r] && (t[r] = o[r]);
    }return t;
  }function _(e, t) {
    var n = t ? document.createElementNS("http://www.w3.org/2000/svg", e) : document.createElement(e);return n.__n = e, n;
  }function p(e) {
    var t = e.parentNode;t && t.removeChild(e);
  }function c(e, t, n, o, r) {
    if ("className" === t && (t = "class"), "key" === t) ;else if ("ref" === t) n && n(null), o && o(e);else if ("class" !== t || r) {
      if ("style" === t) {
        if (o && "string" != typeof o && "string" != typeof n || (e.style.cssText = o || ""), o && "object" == typeof o) {
          if ("string" != typeof n) for (var i in n) {
            i in o || (e.style[i] = "");
          }for (var i in o) {
            e.style[i] = "number" == typeof o[i] && !1 === V.test(i) ? o[i] + "px" : o[i];
          }
        }
      } else if ("dangerouslySetInnerHTML" === t) o && (e.innerHTML = o.__html || "");else if ("o" == t[0] && "n" == t[1]) {
        var l = t !== (t = t.replace(/Capture$/, ""));t = t.toLowerCase().substring(2), o ? n || e.addEventListener(t, f, l) : e.removeEventListener(t, f, l), (e.__l || (e.__l = {}))[t] = o;
      } else if ("list" !== t && "type" !== t && !r && t in e) s(e, t, null == o ? "" : o), null != o && !1 !== o || e.removeAttribute(t);else {
        var a = r && t !== (t = t.replace(/^xlink\:?/, ""));null == o || !1 === o ? a ? e.removeAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase()) : e.removeAttribute(t) : "function" != typeof o && (a ? e.setAttributeNS("http://www.w3.org/1999/xlink", t.toLowerCase(), o) : e.setAttribute(t, o));
      }
    } else e.className = o || "";
  }function s(e, t, n) {
    try {
      e[t] = n;
    } catch (e) {}
  }function f(e) {
    return this.__l[e.type](S.event && S.event(e) || e);
  }function d() {
    var e;while (e = D.pop()) {
      S.afterMount && S.afterMount(e), e.componentDidMount && e.componentDidMount();
    }
  }function h(e, t, n, o, r, i) {
    H++ || (R = null != r && void 0 !== r.ownerSVGElement, j = null != e && !("__preactattr_" in e));var l = m(e, t, n, o, i);return r && l.parentNode !== r && r.appendChild(l), --H || (j = !1, i || d()), l;
  }function m(e, t, n, o, r) {
    var i = e,
        l = R;if (null != t && "boolean" != typeof t || (t = ""), "string" == typeof t || "number" == typeof t) return e && void 0 !== e.splitText && e.parentNode && (!e._component || r) ? e.nodeValue != t && (e.nodeValue = t) : (i = document.createTextNode(t), e && (e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0))), i.__preactattr_ = !0, i;var u = t.nodeName;if ("function" == typeof u) return U(e, t, n, o);if (R = "svg" === u || "foreignObject" !== u && R, u += "", (!e || !a(e, u)) && (i = _(u, R), e)) {
      while (e.firstChild) {
        i.appendChild(e.firstChild);
      }e.parentNode && e.parentNode.replaceChild(i, e), b(e, !0);
    }var p = i.firstChild,
        c = i.__preactattr_,
        s = t.children;if (null == c) {
      c = i.__preactattr_ = {};for (var f = i.attributes, d = f.length; d--;) {
        c[f[d].name] = f[d].value;
      }
    }return !j && s && 1 === s.length && "string" == typeof s[0] && null != p && void 0 !== p.splitText && null == p.nextSibling ? p.nodeValue != s[0] && (p.nodeValue = s[0]) : (s && s.length || null != p) && v(i, s, n, o, j || null != c.dangerouslySetInnerHTML), g(i, t.attributes, c), R = l, i;
  }function v(e, t, n, o, r) {
    var i,
        a,
        u,
        _,
        c,
        s = e.childNodes,
        f = [],
        d = {},
        h = 0,
        v = 0,
        y = s.length,
        g = 0,
        w = t ? t.length : 0;if (0 !== y) for (var C = 0; C < y; C++) {
      var x = s[C],
          N = x.__preactattr_,
          k = w && N ? x._component ? x._component.__k : N.key : null;null != k ? (h++, d[k] = x) : (N || (void 0 !== x.splitText ? !r || x.nodeValue.trim() : r)) && (f[g++] = x);
    }if (0 !== w) for (var C = 0; C < w; C++) {
      _ = t[C], c = null;var k = _.key;if (null != k) h && void 0 !== d[k] && (c = d[k], d[k] = void 0, h--);else if (!c && v < g) for (i = v; i < g; i++) {
        if (void 0 !== f[i] && l(a = f[i], _, r)) {
          c = a, f[i] = void 0, i === g - 1 && g--, i === v && v++;break;
        }
      }c = m(c, _, n, o), u = s[C], c && c !== e && c !== u && (null == u ? e.appendChild(c) : c === u.nextSibling ? p(u) : e.insertBefore(c, u));
    }if (h) for (var C in d) {
      void 0 !== d[C] && b(d[C], !1);
    }while (v <= g) {
      void 0 !== (c = f[g--]) && b(c, !1);
    }
  }function b(e, t) {
    var n = e._component;n ? L(n) : (null != e.__preactattr_ && e.__preactattr_.ref && e.__preactattr_.ref(null), !1 !== t && null != e.__preactattr_ || p(e), y(e));
  }function y(e) {
    e = e.lastChild;while (e) {
      var t = e.previousSibling;b(e, !0), e = t;
    }
  }function g(e, t, n) {
    var o;for (o in n) {
      t && null != t[o] || null == n[o] || c(e, o, n[o], n[o] = void 0, R);
    }for (o in t) {
      "children" === o || "innerHTML" === o || o in n && t[o] === ("value" === o || "checked" === o ? e[o] : n[o]) || c(e, o, n[o], n[o] = t[o], R);
    }
  }function w(e) {
    var t = e.constructor.name;(I[t] || (I[t] = [])).push(e);
  }function C(e, t, n) {
    var o,
        r = I[e.name];if (e.prototype && e.prototype.render ? (o = new e(t, n), T.call(o, t, n)) : (o = new T(t, n), o.constructor = e, o.render = x), r) for (var i = r.length; i--;) {
      if (r[i].constructor === e) {
        o.__b = r[i].__b, r.splice(i, 1);break;
      }
    }return o;
  }function x(e, t, n) {
    return this.constructor(e, n);
  }function N(e, t, n, o, i) {
    e.__x || (e.__x = !0, (e.__r = t.ref) && delete t.ref, (e.__k = t.key) && delete t.key, !e.base || i ? e.componentWillMount && e.componentWillMount() : e.componentWillReceiveProps && e.componentWillReceiveProps(t, o), o && o !== e.context && (e.__c || (e.__c = e.context), e.context = o), e.__p || (e.__p = e.props), e.props = t, e.__x = !1, 0 !== n && (1 !== n && !1 === S.syncComponentUpdates && e.base ? r(e) : k(e, 1, i)), e.__r && e.__r(e));
  }function k(e, t, o, r) {
    if (!e.__x) {
      var i,
          l,
          a,
          _ = e.props,
          p = e.state,
          c = e.context,
          s = e.__p || _,
          f = e.__s || p,
          m = e.__c || c,
          v = e.base,
          y = e.__b,
          g = v || y,
          w = e._component,
          x = !1;if (v && (e.props = s, e.state = f, e.context = m, 2 !== t && e.shouldComponentUpdate && !1 === e.shouldComponentUpdate(_, p, c) ? x = !0 : e.componentWillUpdate && e.componentWillUpdate(_, p, c), e.props = _, e.state = p, e.context = c), e.__p = e.__s = e.__c = e.__b = null, e.__d = !1, !x) {
        i = e.render(_, p, c), e.getChildContext && (c = n(n({}, c), e.getChildContext()));var U,
            T,
            M = i && i.nodeName;if ("function" == typeof M) {
          var W = u(i);l = w, l && l.constructor === M && W.key == l.__k ? N(l, W, 1, c, !1) : (U = l, e._component = l = C(M, W, c), l.__b = l.__b || y, l.__u = e, N(l, W, 0, c, !1), k(l, 1, o, !0)), T = l.base;
        } else a = g, U = w, U && (a = e._component = null), (g || 1 === t) && (a && (a._component = null), T = h(a, i, c, o || !v, g && g.parentNode, !0));if (g && T !== g && l !== w) {
          var E = g.parentNode;E && T !== E && (E.replaceChild(T, g), U || (g._component = null, b(g, !1)));
        }if (U && L(U), e.base = T, T && !r) {
          var P = e,
              V = e;while (V = V.__u) {
            (P = V).base = T;
          }T._component = P, T._componentConstructor = P.constructor;
        }
      }if (!v || o ? D.unshift(e) : x || (e.componentDidUpdate && e.componentDidUpdate(s, f, m), S.afterUpdate && S.afterUpdate(e)), null != e.__h) while (e.__h.length) {
        e.__h.pop().call(e);
      }H || r || d();
    }
  }function U(e, t, n, o) {
    var r = e && e._component,
        i = r,
        l = e,
        a = r && e._componentConstructor === t.nodeName,
        _ = a,
        p = u(t);while (r && !_ && (r = r.__u)) {
      _ = r.constructor === t.nodeName;
    }return r && _ && (!o || r._component) ? (N(r, p, 3, n, o), e = r.base) : (i && !a && (L(i), e = l = null), r = C(t.nodeName, p, n), e && !r.__b && (r.__b = e, l = null), N(r, p, 1, n, o), e = r.base, l && e !== l && (l._component = null, b(l, !1))), e;
  }function L(e) {
    S.beforeUnmount && S.beforeUnmount(e);var t = e.base;e.__x = !0, e.componentWillUnmount && e.componentWillUnmount(), e.base = null;var n = e._component;n ? L(n) : t && (t.__preactattr_ && t.__preactattr_.ref && t.__preactattr_.ref(null), e.__b = t, p(t), w(e), y(t)), e.__r && e.__r(null);
  }function T(e, t) {
    this.__d = !0, this.context = t, this.props = e, this.state = this.state || {};
  }function M(e, t, n) {
    return h(n, e, {}, !1, t, !1);
  }var S = {},
      W = [],
      E = [],
      P = "function" == typeof Promise ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout,
      V = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i,
      A = [],
      D = [],
      H = 0,
      R = !1,
      j = !1,
      I = {};n(T.prototype, { setState: function setState(e, t) {
      var o = this.state;this.__s || (this.__s = n({}, o)), n(o, "function" == typeof e ? e(o, this.props) : e), t && (this.__h = this.__h || []).push(t), r(this);
    }, forceUpdate: function forceUpdate(e) {
      e && (this.__h = this.__h || []).push(e), k(this, 2);
    }, render: function render() {} });var $ = { h: t, createElement: t, cloneElement: o, Component: T, render: M, rerender: i, options: S }; true ? module.exports = $ : self.preact = $;
}();
//# sourceMappingURL=preact.min.js.map

/***/ }),

/***/ "Koob":
/***/ (function(module, exports) {

module.exports = {}

/***/ }),

/***/ "LNuP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Mtqa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'htmlTag',

  lookup: function lookup(options) {
    var found = void 0;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);

    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }

    return found;
  }
};

/***/ }),

/***/ "NruA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cookie = {
  create: function create(name, value, minutes, domain) {
    var expires = void 0;
    if (minutes) {
      var date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    } else expires = '';
    domain = domain ? 'domain=' + domain + ';' : '';
    document.cookie = name + '=' + value + expires + ';' + domain + 'path=/';
  },

  read: function read(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  remove: function remove(name) {
    this.create(name, '', -1);
  }
};

exports.default = {
  name: 'cookie',

  lookup: function lookup(options) {
    var found = void 0;

    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain);
    }
  }
};

/***/ }),

/***/ "PDuM":
/***/ (function(module, exports) {

module.exports = {"A country must be selected above.":"Você precisa escolher um dos países acima.","A notification frequency is required to update two factor settings.":"A frequência das notificações é necessária para atualizar as configurações dos duas etapas.","A notification method is required to update two factor settings.":"O método das notificações é necessária para atualizar as configurações dos duas etapas.","A phone number is required.":"É necessário um número de telefone.","A phone number must be associated with your account to use the phone notification method.":"Um número de telefone deve ser associado à sua conta para usar o método de notificação por telefone.","A username is required to create an account.":"É preciso um nome de usuário para criar uma conta.","A valid email address is required.":"É necessário um e-mail válido.","A verification code is required.":"Um código de verificação é necessário.","A verified email address with Facebook is required to create an account. You will use your Facebook login to play.":"Um e-mail verificado com o Facebook é necessário para criar uma conta. Você usará o seu login no Facebook para jogar.","A verified email address with Google is required to create an account. You will use your Google login to play.":"Um e-mail verificado com o Google é necessário para criar uma conta. Você usará o seu login no Google para jogar.","ACTIVE":"ATIVA","Account Id:":"ID da conta:","Account Info":"Informações da conta","Account Overview":"Visão geral da conta","Accounts Created":"Contas criadas","Add Referrer":"Adicionar indicante","Affiliate Rewards":"Recompensas associadas","After verification, you can change your email address and password.":"Depois da verificação, você pode alterar seu endereço de e-mail e senha.","Already have a Hi-Rez Studios account? Login.":"Já tem uma conta da Hi-Rez Studios? Faça o login","An email address is required to send a referral.":"É necessário um e-mail para enviar uma indicação.","An email address is required.":"É necessário um e-mail.","Australia":"Austrália","Authentication Code":"Código de autenticação","Back":"Voltar","Belgium":"Bélgica","Both":"Ambos","Brazil":"Brasil","CLICK HERE TO REQUEST AN ACCOUNT DELETION OR MAKE AN ACCOUNT DATA REQUEST":"CLIQUE AQUI PARA SOLICITAR A REMOÇÃO DE UMA CONTA OU UM PEDIDO DE DADOS DA CONTA","Can only re-link to the previously linked account.":"Só é possível reassociar a uma conta já previamente associada.","Can't Login?":"Não consegue fazer o login?","Canada":"Canadá","Cancel":"Cancelar","Change":"Trocar","Change Email Address":"Trocar e-mail","Change Your Password":"Trocar sua senha","Chat VIP Support":"Suporte de chat vip","Chile":"Chile","Choose Country":"Escolher país","Choose Method":"Escolher método","Click here":"Clique aqui","Confirm":"Confirmar","Confirm Email":"Confirmar e-mail","Confirm New Password":"Confirmar nova senha","Contact Customer Support":"Falar com o suporte ao cliente","Continue":"Continuar","Copy Link":"Copiar link","Create":"Criar","Create A Free Account":"Criar uma conta grátis","Current Email":"E-mail atual","Current Password":"Senha atual","Currently using ${currentEmail} as your recovery e-mail.":"Atualmente usando ${currentEmail} como seu e-mail de recuperação","Currently using ${currentPhone} as your phone number.":"Atualmente usando ${currentPhone} como seu número de telefone","Date":"Data","Date of Purchase":"Data da compra","Description":"Descrição","Disable":"Desativar","Disable two factor authentication on this account?":"Desativar a autenticação de duas etapas nessa conta?","Download":"Baixar","E-Mail Verification Settings":"Configurações de verificação de e-mail","E-mail:":"E-mail:","Edit":"Editar","Email":"E-mail","Emails do not match. Please try again.":"Os e-mails não batem. Por favor, tente novamente.","Enable":"Ativar","Enter Phone Number:":"Informe o número de telefone:","Enter in the email and username associated with your account to reset your password.":"Informe o e-mail e o nome de usuários associados com a sua conta para redefinir sua senha.","Enter in the email associated with your account to receive a reminder email.":"Informe o e-mail associado com a sua conta para receber um e-mail de lembrete.","Enter in the username and one time recovery code (when you setup your two factor authentication) to login.":"Informe o seu nome de usuário e o código de recuperação único (quando você configurou a autenticação de duas etapas) para fazer o login.","Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.":"Informe seu nome de usuário e senha para fazer o login. Seu código de autorização de duas etapas será enviado para o seu e-mail de backup.","Everytime":"Toda vez","Finland":"Finlândia","Forgot Your Password?":"Esqueceu sua senha?","Forgot Your Username?":"Esqueceu o nome de usuário?","France":"França","Frequency:":"Frequência:","Game":"Jogo","Game Invites":"Convites de jogo","Games":"Jogos","Gdpr":"GDPR","Germany":"Alemanha","Gift":"Presente","I agree to receive Hi-Rez marketing communications, including event invitations, special offers, and newsletters.":"Eu concordo em receber mensagens de marketing da Hi-Rez, incluindo convites para eventos, ofertas especiais e newsletters.","INACTIVE":"INATIVO","If the above options were not able to assist you:":"Se as opções acima não forem suficientes para te ajudar:","If you would like to relink to this service later to continue sharing data, simply sign in with the email address and click the connect button in the connected accounts section of the account dashboard.":"Se você quiser reassociar a esse serviço depois para continuar compartilhando dados, é só entrar com o e-mail e clicar no botão Associar na aba das contas associadas.","In-Game Rewards:":"Recompensas no jogo:","Information about referring a friend can go here.":"Informações sobre a indicação de um amigo vão aqui.","Ireland":"Irlanda","Korea":"Coreia","Language":"Idioma","Learn More.":"Saiba mais.","Link A New Account":"Associe uma nova conta","Link Account":"Associar conta","Link An Existing Account":"Associar uma conta existente","Link your Hi-Rez Account to other networks in order to receive in-game rewards! Questions? Check out our FAQ page.":"Associe sua conta Hi-Rez com outras redes para receber recompensas no jogo. Perguntas? Dê uma olhada na página de dúvidas frequentes (FAQ)","Linked & Connected Accounts":"Contas associadas e conectadas","Linked Accounts":"Contas associadas","Logging Into Your Account":"Fazendo o login na sua conta","Login":"Entrar","Login With:":"Fazer login com:","Login to change your two-factor settings":"Faça o login para alterar as configurações da sua autenticação de duas etapas","Logout":"Desconectar","Method:":"Método:","Mexico":"México","Netherlands":"Holanda","New Email":"Novo e-mail","New Password":"Nova senha","Next":"Próximo","None":"Nenhum","Offline":"Offline","Online":"Online","Only select countries can receive our SMS alerts. Normal SMS charges apply.":"Apenas alguns países podem receber nossos avisos por SMS. Taxas normais de SMS serão cobradas.","Order Number":"Número da ordem","Other":"Outro","Other Settings":"Outras configurações","Paladins":"Paladins","Password":"Senha","Password:":"Senha:","Passwords do not match. Please try again.":"As senhas não batem. Por favor, tente novamente.","Periodic":"Periodicamente","Phone":"Telefone","Phone Number Verification Settings":"Configurações do número de telefone de verificação","Phone Number:":"Número do telefone:","Please check your recovery email and try again.":"Por favor, confira seu e-mail de recuperação e tente de novo.","Please check your validation code and try again.":"Por favor, confira seu código de validação e tente de novo.","Please select how often you want to verify your account. Either every time you log in, every two weeks, or never.":"Por favor, escolha a frequência que você quer que sua conta seja verificada. Pode ser a cada vez que você fizer login, a cada duas semanas, ou nunca.","Please select your preferred method of receiving your two-factor security code. Note that not all countries are supported in our text message notification method.":"Por favor, escolha o seu método preferido para receber o seu código de segurança de duas etapas. Importante notar que nem todos os países recebem o nosso método de notificação via mensagem de texto.","Please store this recovery code in a safe location.":"Por favor guarde esse código de verificação em um lugar seguro.","Please try again.":"Por favor, tente novamente.","Please verify your email address.":"Por favor, verifique seu e-mail","Please wait while we connect your Hi-Rez Studios Account to ${service}.":"Por favor, aguarde enquanto conectamos a sua conta da Hi-Rez Studios com o ${service}.","Points Earned":"pontos recebidos","Poland":"Polônia","Portugal":"Portugal","Preferred Notification Method":"Método de notificação preferido","Program":"Programa","Purchases and earned game content will be reset on this account.":"Os conteúdos do jogo adquiridos ou ganhos serão reiniciados nessa conta.","Recent Rewards":"Recompensas recentes","Recent Transactions":"Transações recentes","Recovery Code":"Código de recuperação","Recovery E-Mail:":"E-mail de recuperação","Refer A Friend":"Convide um amigo","Refer a Friend":"Indique a um amigo","Referral Email:":"E-mail de indicação:","Referral Link:":"Link de indicação:","Referral sent to ${email}!":"Indicação enviada para ${email}!","Referring Player's Name":"Nome do jogador indicado","Save":"Salvar","Security":"Segurança","Security - Confirm & Recovery Code":"Segurança - Confirmação e código de recuperação","Security - Disable Two Factor Authentication":"Segurança - Desabilitar a autenticação de duas etapas","Security - Two Factor Authentication":"Segurança - Autenticação de duas etapas","Select A Game":"Escolha um jogo","Send me Hi-Rez Studios news.":"Envie-me notícias da Hi-Rez Studios","Shared game progression and history will be reset on this account.":"A progressão a o histórico do jogo compartilhados serão reiniciados nessa conta.","Shared profile data will be reset on this account.":"Os dados de perfil compartilhados serão reiniciados nessa conta.","Sign Up Now! Join 25+ Million Players Today":"Inscreva-se já! Junte-se hoje mesmo a mais de 25 milhões de jogadores","Sign Up With:":"Inscrever com:","Smite":"Smite","Something went wrong. Please try again.":"Aconteceu alguma coisa errada. Por favor, tente novamente.","Spain":"Espanha","Status":"Status","Status:":"Status:","Submit":"Enviar","Submit Support Ticket":"Enviar ticket de suporte","Sweden":"Suécia","Thank you, an email has been sent to the address on file.":"Obrigado, um e-mail foi enviado ao endereço que consta no arquivo.","The e-mail used to set up your Hi-Rez Account is automatically used for two-step verification codes.":"O e-mail usado para configurar a sua conta Hi-Rez é automaticamente usado para os códigos da verificação em duas etapas.","There are no rewards to display":"Não há recompensas a serem exibidas","There are no transactions to display":"Não há transações a serem exibidas","There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.":"Há várias razões pelas quais você pode não estar conseguindo fazer o login. As opções abaixo podem te ajudar a conseguir recuperar a sua conta.","This player has already been referred or has an existing Hi-Rez Studios account.":"Esse jogador já foi indicado ou já tem uma conta da Hi-Rez Studios.","Total Revenue":"Faturamento total","Two - Factor Sign In":"Acesso em duas etapas","Two-Factor Sign In can be used to help protect your account from unauthorized access by requiring you to enter an additional code when you sign in.":"O acesso em duas etapas pode ser usado para ajudar a proteger a sua conta de acessos não autorizados, pois pede que você informe um código adicional ao fazer o login.","UTM Campaign":"Campanha UTM","UTM Content":"Conteúdo UTM","Unable to link or create Nintendo account. Please log into your Nintendo Switch, create a player, and retry.":"Não é possível associar ou criar uma conta Nintendo. Por favor, faça o login com sua conta Nintendo Switch, crie um jogador e tente de novo.","United Kingdom":"Reino Unido","United States of America":"Estados Unidos","Unlink":"Desassociar","Unlink Account":"Desassociar conta","Unlink Facebook from this account":"Desassociar o Facebook dessa conta","Unlink Google from this account":"Desassociar o Google dessa conta","Unlink Mixer from this account":"Desassociar o Mixer dessa conta","Unlink Nintendo from this account":"Desassociar o Nintendo dessa conta","Unlink PSN from this account":"Desassociar o PSN dessa conta","Unlink Steam from this account":"Desassociar o Steam dessa conta","Unlink Twitch from this account":"Desassociar o Twitch dessa conta","Unlink Xbox from this account":"Desassociar o Xbox dessa conta","Unlink this platform from this account":"Desassociar essa plataforma dessa conta","Unlinking this service will NOT unlock restricted platforms.":"O fato de desassociar esse serviço NÃO vai fazer com que outras plataformas sejam liberadas.","Use Backup Email to Login":"Usar o e-mail de backup para fazer login","Use One Time Recovery Code":"Usar o código único de recuperação de conta","Username":"Nome de usuário","Username:":"Nome de usuário:","VIP Chat":"Chat vip","VIP Chat Support":"Chat de suporte vip","Verification Code:":"Código de verificação","Verification Frequency":"Frequência de verificação","Verify":"Verificar","View all rewards":"Ver todas as recompensas","View all transactions":"Ver todas as transações","View more rewards":"Ver mais recompensas","View more transactions":"Ver mais transações","Want to change your two factor settings? Click below.":"Quer alterar as configurações da sua autenticação de duas etapas? Clique no botão abaixo.","Want to send a link directly? Enter in your referral's email below and we'll send it to them directly!":"Quer enviar um link diretamente? Informe abaixo o e-mail do seu amigo e nós enviamos para ele!","Warning: You will no longer be able to use this account to store your progression on Facebook":"Aviso: você não vai poder mais usar essa conta para guardar sua progressão no Facebook","Warning: You will no longer be able to use this account to store your progression on Google":"Aviso: você não vai poder mais usar essa conta para guardar sua progressão no Google","Warning: You will no longer be able to use this account to store your progression on Mixer":"Aviso: você não vai poder mais usar essa conta para guardar sua progressão no Mixer","Warning: You will no longer be able to use this account to store your progression on Nintendo":"Aviso: você não vai poder mais usar essa conta para guardar sua progressão no Nintendo","Warning: You will no longer be able to use this account to store your progression on PSN":"Aviso: você não vai poder mais usar essa conta para guardar sua progressão no PSN","Warning: You will no longer be able to use this account to store your progression on Steam":"Aviso: você não vai poder mais usar essa conta para guardar sua progressão no Steam","Warning: You will no longer be able to use this account to store your progression on Twitch":"Aviso: você não vai poder mais usar essa conta para guardar sua progressão no Twitch","Warning: You will no longer be able to use this account to store your progression on Xbox":"Aviso: você não vai poder mais usar essa conta para guardar sua progressão no Xbox","Warning: You will no longer be able to use this account to store your progression on this platform.":"Aviso: você não vai poder mais usar essa conta para guardar sua progressão nessa plataforma","We have agents available to speak with you! Please click below to enter our chat window in order to receive assistance with any questions you may have!":"Nós temos pessoas disponíveis para falar com você! Por favor, clique abaixo para entrar na nossa janela de chat para receber assistência nas perguntas que você tem.","We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?":"Não foi possível encontrar uma conta Hi-Rez Studios associada. Você gostaria de associar essa conta?","We've provided a backup code below to restore access to your account should you lose the ability to verify your Two Factor Authentication.":"Abaixo está o código de backup para que você possa acessar sua conta caso você por algum motivo não consiga verificar a sua autenticação de duas etapas.","Wrong account? <a>Login to a different account.</a>":"Conta errada? <a>Faça o login usando uma conta diferente.</a>","You must confirm your email.":"Você precisa confirmar o seu e-mail.","You must enter your current password.":"Você precisa digitar sua senha atual.","You must enter your new email.":"Você precisa informar o seu novo e-mail.","You must verify your email address before changing your password.":"É necessário verificar seu endereço de e-mail antes de mudar sua senha.","You will be logged in as:":"Você fará o login como:","You've successfully changed your email.":"Você alterou o seu e-mail com sucesso.","You've successfully changed your password.":"Você alterou sua senha com sucesso.","You've successfully updated your Two Factor Authentication settings!":"Você atualizou as suas configurações da autenticação de com sucesso!","You've successfully verified your backup email address.":"O seu e-mail de backup foi verificado com sucesso.","You've successfully verified your mobile phone number.":"Seu número de telefone foi verificado com sucesso.","Your recovery email cannot be the same as your account email.":"Seu e-mail de recuperação não pode ser o mesmo e-mail da conta.","or":"ou","to add a backup email address.":"para adicionar um e-mail de backup.","to add a new phone number.":"para adicionar um novo número de telefone.","I am 13+ years old and I agree to the <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Terms of Service</a>.":"Tenho 13 anos de idade ou mais e estou de acordo com os <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" target=\"_blank\">Termos de Serviço & Licença de Uso da Hi-Rez Studios</a>. (requerido)","Link your Twitch account to receive content in SMITE with Twitch Prime. After linking, you will be returned to the Twitch Prime landing page for SMITE, or click <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >here</a> to return now.":"Asspocie sua conta Twitch para ganhar conteúdo em SMITE com o Twitch Prime. Após associar, você será levado de volta à página inicial de SMITE no Twitch Prime, ou clique <a target=\"blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >aqui</a> para ir agora.","To unlink your account, please submit a request to Customer Support <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >here</a>.":"Para desassociar sua conta, por favor envie um pedido para o Suporte ao Cliente <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >aqui</a>.","You must have a linked Twitch Prime account to receive these rewards in SMITE. You must also claim the offer <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">here</a>, and link your Hi-Rez account to your platform of choice <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >here</a>.":"Você precisa ter uma conta Twitch Prime associada para receber essas recompensas em SMITE. Você também deve reivindicar essa promoção <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">aqui</a>, e associar sua conta Hi-Rez com a plataforma de sua preferência <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >aqui</a>."}

/***/ }),

/***/ "QlQx":
/***/ (function(module, exports) {

module.exports = {"A country must be selected above.":"Yukarıdan bir ülke seçilmelidir.","A notification frequency is required to update two factor settings.":"İki faktörlü ayarlarını güncellemek için bir bildirim sıklığı belirlenmelidir.","A notification method is required to update two factor settings.":"İki faktörlü ayarlarını güncellemek için bir bildirim yöntemi belirlenmelidir.","A phone number is required.":"Bir telefon numarası gerekli.","A phone number must be associated with your account to use the phone notification method.":"Telefon ile bildirim yöntemini kullanmak için hesabına bağlı bir telefon numarası gerekli.","A username is required to create an account.":"Bir hesap oluşturmak için kullanıcı adı gereklidir.","A valid email address is required.":"Geçerli bir e-posta adresi gereklidir.","A verification code is required.":"Doğrulama kodu gereklidir.","A verified email address with Facebook is required to create an account. You will use your Facebook login to play.":"Bir hesap oluşturmak için Facebook doğrulama e-posta adresi gereklidir. Oynamak için Facebook kullanıcı adını ve şifreni kullanacaksın.","A verified email address with Google is required to create an account. You will use your Google login to play.":"Bir hesap oluşturmak için Google doğrulama e-posta adresi gereklidir. Oynamak için Google kullanıcı adını ve şifreni kullanacaksın.","ACTIVE":"AKTİF","Account Id:":"Hesap Kimliği:","Account Info":"Hesap Bilgisi","Account Overview":"Hesaba Genel Bakış","Accounts Created":"Oluşturulan Hesaplar","Add Referrer":"Öneren Ekle","Affiliate Rewards":"İştirakçi Ödülleri","After verification, you can change your email address and password.":"Doğrulama sonrası e-posta adresini ve parolanı değiştirebilirsin.","Already have a Hi-Rez Studios account? Login.":"Zaten bir Hi-Rez hesabın var mı? Oturum Aç","An email address is required to send a referral.":"Referans göndermek için bir e-posta adresi gereklidir.","An email address is required.":"Bir e-posta adresi gereklidir.","Australia":"Avustralya","Authentication Code":"Doğrulama Kodu","Back":"Geri","Belgium":"Belçika","Both":"Her İkisi","Brazil":"Brezilya","CLICK HERE TO REQUEST AN ACCOUNT DELETION OR MAKE AN ACCOUNT DATA REQUEST":"BİR HESAP SİLME TALEBİ VEYA BİR HESAP VERİSİ TALEBİ YAPMAK İÇİN BURAYA TIKLA","Can only re-link to the previously linked account.":"Sadece daha önce bağlanmış hesabı yeniden bağlayabilirsin.","Can't Login?":"Oturum Açamıyor Musun?","Canada":"Kanada","Cancel":"İptal","Change":"Değiştir","Change Email Address":"E-posta Adresini Değiştir","Change Your Password":"Parolanı Değiştir","Chat VIP Support":"Canlı VIP Destek","Chile":"Şili","Choose Country":"Ülke Seç","Choose Method":"Yöntem Seç","Click here":"Buraya tıkla","Confirm":"Onayla","Confirm Email":"E-postayı Onayla","Confirm New Password":"Yeni Parolayı Onayla","Contact Customer Support":"Müşteri Desteği ile İletişim","Continue":"Devam Et","Copy Link":"Bağlantıyı Kopyala","Create":"Oluştur","Create A Free Account":"Ücretsiz Hesap Oluştur","Current Email":"Mevcut E-posta","Current Password":"Mevcut Parola","Currently using ${currentEmail} as your recovery e-mail.":"Şu an yedek e-posta olarak ${currentEmail} adresini kullanmaktasın.","Currently using ${currentPhone} as your phone number.":"Şu anda ${currentPhone} numarasını kullanmaktasın.","Date":"Tarih","Date of Purchase":"Satın Alma Tarihi","Description":"Açıklama","Disable":"Devre Dışı Bırak","Disable two factor authentication on this account?":"Bu hesaptaki iki faktörlü doğrulama devre dışı bırakılsın mı? ","Download":"İndir","E-Mail Verification Settings":"E-posta Doğrulama Ayarları","E-mail:":"E-posta:","Edit":"Düzenle","Email":"E-posta","Emails do not match. Please try again.":"E-postalar uyuşmuyor Lütfen tekrar dene.","Enable":"Etkinleştir","Enter Phone Number:":"Telefon Numarası Gir:","Enter in the email and username associated with your account to reset your password.":"Parolanı sıfırlamak için hesap e-postanı ve kullanıcı adını gir.","Enter in the email associated with your account to receive a reminder email.":"Hatırlatma e-postası almak için hesap e-postanı gir.","Enter in the username and one time recovery code (when you setup your two factor authentication) to login.":"Oturum açmak için kullanıcı adını gir ve tek kullanımlık kurtarma kodunu al (iki faktörlü doğrulama ayarları yapıldıysa).","Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.":"Oturum açmak için kullanıcı adını ve parolanı gir. İki faktörlü doğrulama kodun yedek e-postana gönderilecek.","Everytime":"Her zaman","Finland":"Finlandiya","Forgot Your Password?":"Şifreni mi unuttun?","Forgot Your Username?":"Kullanıcı adını mı unuttun?","France":"Fransa","Frequency:":"Sıklık:","Game":"Oyun","Game Invites":"Oyun Davetleri","Games":"Oyunlar","Gdpr":"Gdpr","Germany":"Almanya","Gift":"Hediye","I agree to receive Hi-Rez marketing communications, including event invitations, special offers, and newsletters.":"Etkinlik davetiyeleri, özel teklifler ve haber bültenleri gibi şeylerin yer aldığı Hi-Rez pazarlama mesajlarını almayı kabul ediyorum.","INACTIVE":"ETKİN DEĞİL","If the above options were not able to assist you:":"Yukarıdaki seçenekler sana yardımcı olmadıysa:","If you would like to relink to this service later to continue sharing data, simply sign in with the email address and click the connect button in the connected accounts section of the account dashboard.":"Verileri paylaşmak için daha sonra bu hizmete tekrar bağlanmak istersen e-posta adresi ile tekrar oturum açarak hesap tablosundaki bağlı hesaplar bölümündeki bağla butonuna basman yeterlidir.","In-Game Rewards:":"Oyun İçi Ödüller:","Information about referring a friend can go here.":"Bir arkadaş önerme ile ilgili bilgiler buraya girilebilir.","Ireland":"İrlanda","Korea":"Kore","Language":"Dil","Learn More.":"Daha Fazlasını Öğren.","Link A New Account":"Yeni Bir Hesap Bağla","Link Account":"Hesap Bağlama","Link An Existing Account":"Var Olan Bir Hesabı Bağla","Link your Hi-Rez Account to other networks in order to receive in-game rewards! Questions? Check out our FAQ page.":"Hi-Rez Hesabını diğer ağlara bağlayarak oyun içi ödüller kazan! Soru mu soracaksın? SSS sayfamızı ziyaret et.","Linked & Connected Accounts":"Bağlı & İlişkili Hesaplar","Linked Accounts":"Bağlı Hesaplar","Logging Into Your Account":"Hesabında Oturum Açılıyor","Login":"Oturum Aç","Login With:":"Şunla Oturum Aç:","Login to change your two-factor settings":"İki faktörlü ayarlarını değiştirmek için oturum aç","Logout":"Çıkış Yap","Method:":"Yöntem:","Mexico":"Meksika","Netherlands":"Hollanda","New Email":"Yeni E-posta","New Password":"Yeni Parola","Next":"Sonraki","None":"Hiçbiri","Offline":"Çevrimdışı","Online":"Çevrimiçi","Only select countries can receive our SMS alerts. Normal SMS charges apply.":"Sadece seçili ülkelerde SMS uyarıları kullanılabilir. Normal SMS ücretleri geçerlidir.","Order Number":"Sipariş Numarası","Other":"Diğer","Other Settings":"Diğer Ayarlar","Paladins":"Paladins","Password":"Parola","Password:":"Parola:","Passwords do not match. Please try again.":"Parolalar uyuşmuyor. Lütfen tekrar dene.","Periodic":"Periyodik","Phone":"Telefon","Phone Number Verification Settings":"Telefon Numarası Doğrulama Ayarları","Phone Number:":"Telefon Numarası:","Please check your recovery email and try again.":"Yedek e-postanı kontrol et ve tekrar dene.","Please check your validation code and try again.":"Doğrulama kodunu kontrol et ve tekrar dene.","Please select how often you want to verify your account. Either every time you log in, every two weeks, or never.":"Lütfen hangi sıklıkla hesabını doğrulamak istediğini seç. Ya her oturum açtığında ya iki haftada bir ya da hiç.","Please select your preferred method of receiving your two-factor security code. Note that not all countries are supported in our text message notification method.":"Lütfen iki faktörlü güvenlik kodunu alma yöntemini seç. SMS bildirim yöntemi her ülkede desteklenmemektedir.","Please store this recovery code in a safe location.":"Lütfen bu kurtarma kodunu güvenli bir yerde sakla.","Please try again.":"Lütfen tekrar dene.","Please verify your email address.":"Lütfen e-posta adresini doğrula.","Please wait while we connect your Hi-Rez Studios Account to ${service}.":"Hi-Rez Studios Hesabın ile ${service} hesabını bağlarken lütfen biraz bekle.","Points Earned":"Kazanılan Puanlar","Poland":"Polonya","Portugal":"Portekiz","Preferred Notification Method":"Bildirim Yöntemi","Program":"Program","Purchases and earned game content will be reset on this account.":"Satın alınan ve kazanılan oyun içerikleri bu hesapta sıfırlanacaktır.","Recent Rewards":"Son Ödüller","Recent Transactions":"Son İşlemler","Recovery Code":"Kurtarma Kodu","Recovery E-Mail:":"Yedek E-posta:","Refer A Friend":"Bir Arkadaşa Öner","Refer a Friend":"Arkadaşına Tavsiye Et","Referral Email:":"Tavsiye E-postası:","Referral Link:":"Tavsiye Bağlantısı:","Referral sent to ${email}!":"Tavsiye, ${email} adresine gönderildi!","Referring Player's Name":"Tavsiye Eden Oyuncu","Save":"Kaydet","Security":"Güvenlik","Security - Confirm & Recovery Code":"Güvenlik - Doğrulama & Kurtarma Kodu","Security - Disable Two Factor Authentication":"Güvenlik - İki Faktörlü Doğrulamayı Devre Dışı Bırak","Security - Two Factor Authentication":"Güvenlik - İki Faktörlü Doğrulama","Select A Game":"Bir Oyun Seç","Send me Hi-Rez Studios news.":"Hi-Rez Studios haberlerini bana gönder.","Shared game progression and history will be reset on this account.":"Paylaşılan oyun ilerlemesi ve geçmişi bu hesapta sıfırlanacaktır.","Shared profile data will be reset on this account.":"Paylaşılan profil verileri bu hesapta sıfırlanacaktır.","Sign Up Now! Join 25+ Million Players Today":"Şimdi Kayıt Ol! 25 Milyondan Fazla Oyuncuya Şimdi Katıl","Sign Up With:":"Şununla Kaydol:","Smite":"Smite","Something went wrong. Please try again.":"Bir şeyler yanlış gitti. Lütfen tekrar dene.","Spain":"İspanya","Status":"Durum","Status:":"Durum:","Submit":"Gönder","Submit Support Ticket":"Destek Çağrısı Gönder","Sweden":"İsveç","Thank you, an email has been sent to the address on file.":"Teşekkürler, adrese konu hakkında bir e-posta gönderildi.","The e-mail used to set up your Hi-Rez Account is automatically used for two-step verification codes.":"Hi-Rez Hesabında kullandığın e-posta adresi otomatik olarak iki adımlı doğrulama kodları için kullanılacak.","There are no rewards to display":"Gösterilecek hiç ödül yok","There are no transactions to display":"Gösterilecek hiç işlem yok","There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.":"Oturum açamamanın birden çok sebebi var. Hesabını kurtarmak için aşağıdaki seçenekler yardımcı olabilir.","This player has already been referred or has an existing Hi-Rez Studios account.":"Bu oyuncuya zaten tavsiye gönderilmiş ya da Hi-Rez Studios hesabı var.","Total Revenue":"Toplam Gelir","Two - Factor Sign In":"İki Faktörlü Oturum Açma","Two-Factor Sign In can be used to help protect your account from unauthorized access by requiring you to enter an additional code when you sign in.":"İki Faktörlü Oturum Açma, oturum açtığın anda bir kod girmek gerektirir ve hesabını yetkisiz erişimden korumanı sağlar.","UTM Campaign":"UTM Kampanyası","UTM Content":"UTM İçeriği","Unable to link or create Nintendo account. Please log into your Nintendo Switch, create a player, and retry.":"Nintendo hesabı bağlanamıyor ya da oluşturulamıyor. Nintendo Switch'te oturum açarak bir oyuncu oluştur ve tekrar dene.","United Kingdom":"Birleşik Krallık","United States of America":"ABD","Unlink":"Bağlantıyı Kaldır","Unlink Account":"Hesap Bağlantısını Kaldır","Unlink Facebook from this account":"Bu hesaptan Facebook bağlantısını kaldır","Unlink Google from this account":"Bu hesaptan Google bağlantısını kaldır","Unlink Mixer from this account":"Bu hesaptan Mixer bağlantısını kaldır","Unlink Nintendo from this account":"Bu hesaptan Nintendo bağlantısını kaldır","Unlink PSN from this account":"Bu hesaptan PSN bağlantısını kaldır","Unlink Steam from this account":"Bu hesaptan Steam bağlantısını kaldır","Unlink Twitch from this account":"Bu hesaptan Twitch bağlantısını kaldır","Unlink Xbox from this account":"Bu hesaptan Xbox bağlantısını kaldır","Unlink this platform from this account":"Bu hesaptan bu platformun bağlantısını kaldır","Unlinking this service will NOT unlock restricted platforms.":"Bu hizmetin bağlantısını kaldırmak kısıtlanmış platformları AÇMAYACAKTIR.","Use Backup Email to Login":"Oturum Açmak için Yedek E-posta Kullan","Use One Time Recovery Code":"Tek Kullanımlık Kurtarma Kodu Kullan","Username":"Kullanıcı Adı","Username:":"Kullanıcı Adı:","VIP Chat":"VIP Destek","VIP Chat Support":"VIP Canlı Destek","Verification Code:":"Doğrulama Kodu:","Verification Frequency":"Doğrulama Sıklığı","Verify":"Doğrula","View all rewards":"Tüm ödülleri göster","View all transactions":"Tüm işlemleri göster","View more rewards":"Daha fazla ödül göster","View more transactions":"Daha fazla işlem göster","Want to change your two factor settings? Click below.":"İki faktörlü ayarlarını değiştirmek istiyor musun? Aşağıya tıkla.","Want to send a link directly? Enter in your referral's email below and we'll send it to them directly!":"Doğrudan bağlantıyı göndermek istiyor musun? Referans e-postanı aşağıya girersen hemen göndeririz!","Warning: You will no longer be able to use this account to store your progression on Facebook":"Uyarı: Facebook üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Google":"Uyarı: Google üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Mixer":"Uyarı: Mixer üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Nintendo":"Uyarı: Nintendo üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on PSN":"Uyarı: PSN üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Steam":"Uyarı: Steam üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Twitch":"Uyarı: Twitch üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Xbox":"Uyarı: Xbox üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on this platform.":"Uyarı: Bu platform üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","We have agents available to speak with you! Please click below to enter our chat window in order to receive assistance with any questions you may have!":"Seninle konuşmaya uygun temsilcilerimiz var! Aşağıya tıklayarak canlı destek penceresini açabilir ve sormak istediklerinin cevabını öğrenebilirsin!","We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?":"Bağlı bir Hi-Rez Studios hesabı bulamadık. Bu hesabı bağlamak ister misin?","We've provided a backup code below to restore access to your account should you lose the ability to verify your Two Factor Authentication.":"İki Faktörlü Doğrulama yapamıyorsan aşağıda hesabına erişmen için bir kurtarma kodu veriyoruz.","Wrong account? <a>Login to a different account.</a>":"Hesap yanlış mı? <a>Farklı bir hesapta oturum aç.</a>","You must confirm your email.":"E-postanı onaylamalısın.","You must enter your current password.":"Mevcut şifreni girmelisin.","You must enter your new email.":"Yeni e-postanı girmelisin.","You must verify your email address before changing your password.":"Parolanı değiştirmeden önce e-posta adresini doğrulamalısın.","You will be logged in as:":"Şu olarak oturum açacaksın:","You've successfully changed your email.":"E-postanı başarıyla değiştirdin.","You've successfully changed your password.":"Parolanı başarıyla değiştirdin.","You've successfully updated your Two Factor Authentication settings!":"İki Faktörlü Doğrulama ayarlarını başarıyla güncelledin!","You've successfully verified your backup email address.":"Yedek e-posta adresini başarıyla doğruladın.","You've successfully verified your mobile phone number.":"Cep telefonu numaranı başarıyla doğruladın.","Your recovery email cannot be the same as your account email.":"Yedek e-postan, hesap e-postan ile aynı olamaz.","or":"ya da","to add a backup email address.":"yedek e-posta eklemek için","to add a new phone number.":"yeni telefon numarası eklemek için","I am 13+ years old and I agree to the <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Terms of Service</a>.":"13 yaş ve üzerindeyim, şunu kabul ediyorum: <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"","Link your Twitch account to receive content in SMITE with Twitch Prime. After linking, you will be returned to the Twitch Prime landing page for SMITE, or click <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >here</a> to return now.":"Twitch Prime ile SMITE içerikleri kazanmak için Twitch hesabını bağla. Bağlama işlemi sonrası SMITE için Twitch Prime sayfasına yönledirileceksin ya da <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >buraya</a> tıklayarak şimdi ilgili sayfaya gidebilirsin.","To unlink your account, please submit a request to Customer Support <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >here</a>.":"Hesap bağlantısını kaldırmak istiyorsan lütfen <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >buradan</a> Müşteri Desteği'ne bir talep gönder.","You must have a linked Twitch Prime account to receive these rewards in SMITE. You must also claim the offer <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">here</a>, and link your Hi-Rez account to your platform of choice <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >here</a>.":"SMITE'ta bu ödülleri alabilmek için Twitch Prime'a bağlanmış bir hesaba sahip olman gerekiyor. Ayrıca <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">buradan</a> teklifi alma talebinde bulunmalı ve <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >buradan</a> tercih ettiğin platformu Hi-Rez hesabına bağlamalısın."}

/***/ }),

/***/ "UIPi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var hasLocalStorageSupport = void 0;
try {
  hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
  var testKey = 'i18next.translate.boo';
  window.localStorage.setItem(testKey, 'foo');
  window.localStorage.removeItem(testKey);
} catch (e) {
  hasLocalStorageSupport = false;
}

exports.default = {
  name: 'localStorage',

  lookup: function lookup(options) {
    var found = void 0;

    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }

    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && hasLocalStorageSupport) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

/***/ }),

/***/ "UQex":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "V+3r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'path',

  lookup: function lookup(options) {
    var found = void 0;
    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (language instanceof Array) {
        if (typeof options.lookupFromUrlIndex === 'number') {
          found = language[options.lookupFromPathIndex].replace('/', '');
        } else {
          found = language[0].replace('/', '');
        }
      }
    }
    return found;
  }
};

/***/ }),

/***/ "WGa/":
/***/ (function(module, exports) {

module.exports = {"A country must be selected above.":"Sélectionnez un pays ci-dessus.","A notification frequency is required to update two factor settings.":"Saisissez une fréquence de notification pour mettre à jour l'authentification à deux facteurs.","A notification method is required to update two factor settings.":"Saisissez une méthode de notification pour mettre à jour l'authentification à deux facteurs.","A phone number is required.":"Saisissez un numéro de téléphone.","A phone number must be associated with your account to use the phone notification method.":"Un numéro de téléphone doit être associé à votre compte pour utiliser la méthode de notification téléphonique.","A username is required to create an account.":"Saisissez un nom d'utilisateur pour créer un compte.","A valid email address is required.":"Saisissez une adresse e-mail valide.","A verification code is required.":"Saisissez le code de vérification.","A verified email address with Facebook is required to create an account. You will use your Facebook login to play.":"Une adresse e-mail vérifiée avec Facebook est requise pour créer un compte. Vous utiliserez vos identifiants Facebook pour jouer.","A verified email address with Google is required to create an account. You will use your Google login to play.":"Une adresse e-mail vérifiée avec Google est requise pour créer un compte. Vous utiliserez vos identifiants Google pour jouer.","ACTIVE":"ACTIF","Account Id:":"Nom de compte :","Account Info":"Infos de compte","Account Overview":"Aperçu du compte","Accounts Created":"Comptes créés","Add Referrer":"Ajout. parrain","Affiliate Rewards":"Récompenses affiliées","After verification, you can change your email address and password.":"Après vérification, vous pourrez changer votre adresse e-mail et votre mot de passe.","Already have a Hi-Rez Studios account? Login.":"Vous avez déjà un compte Hi-Rez Studios ? Connexion","An email address is required to send a referral.":"Une adresse e-mail est requise pour parrainer un ami.","An email address is required.":"Saisissez une adresse e-mail.","Australia":"Australie","Authentication Code":"Code d'authentification","Back":"Retour","Belgium":"Belgique","Both":"Les deux","Brazil":"Brésil","CLICK HERE TO REQUEST AN ACCOUNT DELETION OR MAKE AN ACCOUNT DATA REQUEST":"CLIQUEZ ICI POUR DEMANDER LA SUPPRESSION DU COMPTE OU L'ENVOI DES DONNÉES PERSONNELLES CONFORMÉMENT AU RGPD","Can only re-link to the previously linked account.":"La nouvelle liaison n'est possible qu'avec le compte lié au préalable.","Can't Login?":"Connexion impossible ?","Canada":"Canada","Cancel":"Annuler","Change":"Changer","Change Email Address":"Changer d'adresse e-mail","Change Your Password":"Changer de mot de passe","Chat VIP Support":"Discussion d'assistance VIP","Chile":"Chili","Choose Country":"Choisir un pays","Choose Method":"Choisir une méthode","Click here":"Cliquez ici","Confirm":"Confirmer","Confirm Email":"Confirmer l'e-mail","Confirm New Password":"Confirmer le mot de passe","Contact Customer Support":"Contact de l'assistance","Continue":"Continuer","Copy Link":"Copier le lien","Create":"Créer","Create A Free Account":"Créer un compte gratuitement","Current Email":"e-mail actuel","Current Password":"Mot de passe actuel","Currently using ${currentEmail} as your recovery e-mail.":"Actuellement, ${currente-mail} est votre adresse e-mail de récupération de compte.","Currently using ${currentPhone} as your phone number.":"Actuellement, ${currentPhone} est votre numéro de téléphone.","Date":"Date","Date of Purchase":"Date d'achat","Description":"Description","Disable":"Désactiver","Disable two factor authentication on this account?":"Voulez-vous désactiver l'authentification à deux facteurs pour ce compte ?","Download":"Télécharger","E-Mail Verification Settings":"Paramètres de vérification d'e-mail","E-mail:":"Adresse e-mail :","Edit":"Modifier","Email":"Adresse e-mail","Emails do not match. Please try again.":"Les adresses e-mails ne correspondent pas. Veuillez réessayer.","Enable":"Activer","Enter Phone Number:":"Numéro de téléphone :","Enter in the email and username associated with your account to reset your password.":"Saisissez l'adresse e-mail et le nom d'utilisateur associés à votre compte pour réinitialiser votre mot de passe.","Enter in the email associated with your account to receive a reminder email.":"Saisissez l'adresse e-mail associée à votre compte pour recevoir un e-mail de rappel.","Enter in the username and one time recovery code (when you setup your two factor authentication) to login.":"Saisissez le nom d'utilisateur et le code de récupération à usage unique (obtenu lors du paramétrage de l'authentification à deux facteurs) pour vous connecter.","Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.":"Saisissez votre nom d'utilisateur et votre mot de passe pour vous connecter. Votre code d'authentification à deux facteurs sera envoyé sur votre adresse e-mail de récupération.","Everytime":"À chaque fois","Finland":"Finlande","Forgot Your Password?":"Mot de passe oublié ?","Forgot Your Username?":"Nom d'utilisateur oublié ?","France":"France","Frequency:":"Fréquence :","Game":"Jeu","Game Invites":"Invitations","Games":"Jeux","Gdpr":"RGPD","Germany":"Allemagne","Gift":"Cadeau","I agree to receive Hi-Rez marketing communications, including event invitations, special offers, and newsletters.":"J'accepte de recevoir les communications marketing de Hi-Rez Studios, telles que des invitations à des événements, des offres spéciales et des actualités.","INACTIVE":"INACTIF","If the above options were not able to assist you:":"Si ce qui précède n'a pas permis de vous aider :","If you would like to relink to this service later to continue sharing data, simply sign in with the email address and click the connect button in the connected accounts section of the account dashboard.":"À l'avenir, si vous désirez utiliser à nouveau ce service de partage de données, connectez-vous avec l'adresse e-mail et cliquez sur le bouton 'Lier son compte' dans la section 'Comptes liés' sur la page de gestion de compte.","In-Game Rewards:":"Récompenses en jeu :","Information about referring a friend can go here.":"Informations sur le parrainage d'un ami.","Ireland":"Irlande","Korea":"Corée","Language":"Langue","Learn More.":"En savoir plus","Link A New Account":"Liaison d'un nouveau compte","Link Account":"Lier son compte","Link An Existing Account":"Liaison d'un compte existant","Link your Hi-Rez Account to other networks in order to receive in-game rewards! Questions? Check out our FAQ page.":"Liez votre compte Hi-Rez aux autres réseaux pour recevoir des récompenses en jeu ! Des questions ? Consultez notre FAQ !","Linked & Connected Accounts":"Comptes liés et connectés","Linked Accounts":"Comptes liés","Logging Into Your Account":"Connexion à votre compte","Login":"Connexion","Login With:":"Se connecter avec :","Login to change your two-factor settings":"Connectez-vous pour changer les paramètres de l'authentification à deux facteurs.","Logout":"Déconnexion","Method:":"Méthode :","Mexico":"Mexique","Netherlands":"Pays-Bas","New Email":"Nouvel e-mail","New Password":"Nouveau mot de passe","Next":"Suivant","None":"Aucun","Offline":"Hors ligne","Online":"En ligne","Only select countries can receive our SMS alerts. Normal SMS charges apply.":"Seuls certains pays peuvent recevoir des alertes par SMS. Les frais d'un SMS standard s'appliquent.","Order Number":"Numéro de commande","Other":"Autre","Other Settings":"Autres paramètres","Paladins":"Paladins","Password":"Mot de passe","Password:":"Mot de passe :","Passwords do not match. Please try again.":"Les mots de passe ne correspondent pas. Veuillez réessayer.","Periodic":"Périodique","Phone":"Téléphone","Phone Number Verification Settings":"Paramètres de vérification du numéro de téléphone","Phone Number:":"Numéro de téléphone :","Please check your recovery email and try again.":"Veuillez vérifier votre adresse e-mail de récupération et réessayer.","Please check your validation code and try again.":"Veuillez vérifier votre code de vérification et réessayer.","Please select how often you want to verify your account. Either every time you log in, every two weeks, or never.":"Veuillez sélectionner la fréquence à laquelle vous souhaitez vérifier votre compte. Ce peut être à chaque connexion, toutes les deux semaines ou jamais.","Please select your preferred method of receiving your two-factor security code. Note that not all countries are supported in our text message notification method.":"Veuillez sélectionner votre méthode préférée pour recevoir votre code d'authentification à deux facteurs. La méthode de notification par SMS n'est pas disponible dans tous les pays.","Please store this recovery code in a safe location.":"Veuillez conserver ce code récupération dans un endroit sûr.","Please try again.":"Veuillez réessayer.","Please verify your email address.":"Veuillez saisir votre adresse e-mail.","Please wait while we connect your Hi-Rez Studios Account to ${service}.":"Veuillez patienter pendant que nous connectons votre compte Hi-Rez Studios à ${service}.","Points Earned":"Points gagnés","Poland":"Pologne","Portugal":"Portugal","Preferred Notification Method":"Méthode de notification préférée","Program":"Programme","Purchases and earned game content will be reset on this account.":"Le contenu acheté et gagné sur ce compte sera supprimé.","Recent Rewards":"Récompenses récentes","Recent Transactions":"Transactions récentes","Recovery Code":"Code de récupération","Recovery E-Mail:":"Adresse e-mail de récupération :","Refer A Friend":"Parrainer un ami","Refer a Friend":"Parrainer un ami","Referral Email:":"E-mail de parrainage :","Referral Link:":"Lien de parrainage :","Referral sent to ${email}!":"Demande de parrainage envoyée à ${e-mail} !","Referring Player's Name":"Nom du parrain","Save":"Sauvegarder","Security":"Sécurité","Security - Confirm & Recovery Code":"Sécurité - Code récupération et confirmation","Security - Disable Two Factor Authentication":"Sécurité - Désactiver l'authentification à deux facteurs","Security - Two Factor Authentication":"Sécurité - Authentification à deux facteurs","Select A Game":"Sélectionner un jeu","Send me Hi-Rez Studios news.":"Je souhaite recevoir toute l'actualité de Hi-Rez Studios.","Shared game progression and history will be reset on this account.":"La progression partagée et l'historique seront supprimés de ce compte.","Shared profile data will be reset on this account.":"Les données de profil partagées seront supprimées de ce compte.","Sign Up Now! Join 25+ Million Players Today":"Je m'inscris ! Rejoignez plus de 25 millions de joueurs","Sign Up With:":"Connectez-vous avec :","Smite":"SMITE","Something went wrong. Please try again.":"Une erreur est survenue. Veuillez réessayer.","Spain":"Espagne","Status":"Statut","Status:":"Statut :","Submit":"Envoyer","Submit Support Ticket":"Envoyer un ticket d'assistance","Sweden":"Suède","Thank you, an email has been sent to the address on file.":"Merci, un e-mail a été envoyé à l'adresse renseignée.","The e-mail used to set up your Hi-Rez Account is automatically used for two-step verification codes.":"L'adresse e-mail utilisée pour paramétrer votre compte Hi-Rez est automatiquement utilisée pour envoyer les codes de vérification à deux facteurs.","There are no rewards to display":"Aucune récompense à afficher","There are no transactions to display":"Aucune transaction à afficher","There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.":"Il y a plusieurs raisons qui expliquent que vous ne puissiez pas vous connecter. Les options ci-après peuvent vous aider à récupérer votre compte.","This player has already been referred or has an existing Hi-Rez Studios account.":"Ce joueur a déjà été parrainé ou a déjà un compte Hi-Rez Studios.","Total Revenue":"Revenus au total","Two - Factor Sign In":"Connexion à deux facteurs","Two-Factor Sign In can be used to help protect your account from unauthorized access by requiring you to enter an additional code when you sign in.":"La connexion à deux facteurs sert à protéger votre compte contre toute tentative d'accès non-autorisé en vous invitant à saisir un code supplémentaire.","UTM Campaign":"Campagne UTM","UTM Content":"Contenu UTM","Unable to link or create Nintendo account. Please log into your Nintendo Switch, create a player, and retry.":"Impossible de lier ou de créer un Compte Nintendo. Veuillez vous connecter sur votre Nintendo Switch, créer un profil de joueur, puis réessayer.","United Kingdom":"Royaume-Uni","United States of America":"États-Unis","Unlink":"Détacher","Unlink Account":"Annuler la liaison","Unlink Facebook from this account":"Annuler la liaison Facebook","Unlink Google from this account":"Annuler la liaison Google","Unlink Mixer from this account":"Annuler la liaison Mixer","Unlink Nintendo from this account":"Annuler la liaison Nintendo","Unlink PSN from this account":"Annuler la liaison PSN","Unlink Steam from this account":"Annuler la liaison Steam","Unlink Twitch from this account":"Annuler la liaison Twitch","Unlink Xbox from this account":"Annuler la liaison Xbox","Unlink this platform from this account":"Détacher cette plateforme de ce compte","Unlinking this service will NOT unlock restricted platforms.":"Détacher ce service ne débloquera pas les plateformes interdites.","Use Backup Email to Login":"Utiliser l'e-mail de récupération pour vous connecter","Use One Time Recovery Code":"Utiliser le code de récupération à usage unique","Username":"Nom d'utilisateur","Username:":"Nom d'utilisateur :","VIP Chat":"Chat VIP","VIP Chat Support":"Assistance Chat VIP","Verification Code:":"Code de vérification :","Verification Frequency":"Fréquence de vérification","Verify":"Vérifier","View all rewards":"Voir toutes les récompenses","View all transactions":"Voir toutes les transactions","View more rewards":"Voir plus de récompenses","View more transactions":"Voir plus de transactions","Want to change your two factor settings? Click below.":"Voulez-vous changer les paramètres de l'authentification à deux facteurs ? Cliquez ci-après.","Want to send a link directly? Enter in your referral's email below and we'll send it to them directly!":"Vous préférez envoyer un lien directement ? Saisissez l'adresse e-mail de votre ami à parrainer ci-dessous et nous y enverrons un lien.","Warning: You will no longer be able to use this account to store your progression on Facebook":"Remarque : vous ne pourrez plus utiliser ce compte pour partager votre progression sur Facebook","Warning: You will no longer be able to use this account to store your progression on Google":"Remarque : vous ne pourrez plus utiliser ce compte pour partager votre progression sur Google","Warning: You will no longer be able to use this account to store your progression on Mixer":"Remarque : vous ne pourrez plus utiliser ce compte pour partager votre progression sur Mixer","Warning: You will no longer be able to use this account to store your progression on Nintendo":"Remarque : vous ne pourrez plus utiliser ce compte pour partager votre progression sur Nintendo","Warning: You will no longer be able to use this account to store your progression on PSN":"Remarque : vous ne pourrez plus utiliser ce compte pour partager votre progression sur PSN","Warning: You will no longer be able to use this account to store your progression on Steam":"Remarque : vous ne pourrez plus utiliser ce compte pour partager votre progression sur Steam","Warning: You will no longer be able to use this account to store your progression on Twitch":"Remarque : vous ne pourrez plus utiliser ce compte pour partager votre progression sur Twitch","Warning: You will no longer be able to use this account to store your progression on Xbox":"Remarque : vous ne pourrez plus utiliser ce compte pour partager votre progression sur Xbox","Warning: You will no longer be able to use this account to store your progression on this platform.":"Remarque : vous ne pourrez plus utiliser ce compte pour partager votre progression sur cette plateforme","We have agents available to speak with you! Please click below to enter our chat window in order to receive assistance with any questions you may have!":"Nos agents sont disponibles pour vous parler ! Veuillez cliquer ci-dessous pour accéder à notre fenêtre de chat et poser vos questions.","We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?":"Nous n'avons pas trouvé de compte Hi-Rez Studios lié. Voulez-vous lier ce compte ?","We've provided a backup code below to restore access to your account should you lose the ability to verify your Two Factor Authentication.":"Ci-dessous se trouve un code de récupération. Il vous permettra d'accéder à votre compte si vous ne parvenez plus à vous connecter via l'authentification à deux facteurs.","Wrong account? <a>Login to a different account.</a>":"Pas sur le bon compte ? <a>Connectez-vous à un autre compte.</a>","You must confirm your email.":"Vous devez confirmer votre adresse e-mail.","You must enter your current password.":"Vous devez saisir votre mot de passe actuel.","You must enter your new email.":"Vous devez saisir votre nouvelle adresse e-mail.","You must verify your email address before changing your password.":"Vous devez vérifier votre adresse e-mail avant de modifier votre mot de passe.","You will be logged in as:":"Vous serez connecté(e) en tant que :","You've successfully changed your email.":"Vous avez changé votre adresse e-mail.","You've successfully changed your password.":"Vous avez changé votre mot de passe.","You've successfully updated your Two Factor Authentication settings!":"Vous avez mis à jour vos paramètres pour l'authentification à deux facteurs.","You've successfully verified your backup email address.":"Vous avez vérifié votre adresse e-mail de récupération.","You've successfully verified your mobile phone number.":"Vous avez vérifié votre numéro de téléphone portable.","Your recovery email cannot be the same as your account email.":"Votre adresse e-mail de récupération ne peut pas être identique à l'adresse e-mail de votre compte.","or":"ou","to add a backup email address.":"pour ajouter une adresse e-mail de récupération.","to add a new phone number.":"pour ajouter un nouveau numéro de téléphone.","I am 13+ years old and I agree to the <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Terms of Service</a>.":"J'ai au moins 12 ans et j'accepte les <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=blank\\\">Conditions d'utilisation</a>\".","Link your Twitch account to receive content in SMITE with Twitch Prime. After linking, you will be returned to the Twitch Prime landing page for SMITE, or click <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >here</a> to return now.":"Liez votre compte Twitch pour recevoir du contenu sur SMITE avec Twitch Prime. Après la liaison de comptes, vous reviendrez à la page d'accueil SMITE de Twitch Prime. Cliquez <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >ici</a> pour y revenir maintenant.","To unlink your account, please submit a request to Customer Support <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >here</a>.":"Pour annuler la liaison de comptes, veuillez adresser une demande à notre service clients <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >ici</a>.","You must have a linked Twitch Prime account to receive these rewards in SMITE. You must also claim the offer <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">here</a>, and link your Hi-Rez account to your platform of choice <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >here</a>.":"Vous devez avoir un compte Twitch Prime lié pour recevoir ces récompenses sur SMITE. Vous devez aussi réclamer l'offre <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">ici</a> et lier votre compte Hi-Rez à la plateforme de votre choix <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >ici</a>."}

/***/ }),

/***/ "iEou":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("GC9o").default;

/***/ }),

/***/ "miSq":
/***/ (function(module, exports) {

module.exports = {"A country must be selected above.":"Kraj musi zostać wybrany.","A notification frequency is required to update two factor settings.":"Aby zaktualizować ustawienia weryfikacji dwuetapowej należy ustawić częstotliwość otrzymywania powiadomień.","A notification method is required to update two factor settings.":"Aby zaktualizować ustawienia weryfikacji dwuetapowej należy ustawić sposób otrzymywania powiadomień.","A phone number is required.":"Wymagane jest podanie numeru telefonu.","A phone number must be associated with your account to use the phone notification method.":"Aby wykorzystać powiadomienia telefoniczne, konto musi mieć powiązany numer telefonu.","A username is required to create an account.":"Aby stworzyć konto, niezbędne jest podanie nazwy użytkownika.","A valid email address is required.":"Wymagane jest podanie prawidłowego adresu e-mail.","A verification code is required.":"Wymagane jest podanie kodu weryfikacyjnego.","A verified email address with Facebook is required to create an account. You will use your Facebook login to play.":"Do stworzenia konta wymagane jest podanie adresu e-mail powiązanego z Facebookiem. Do logowania wykorzystywany będzie login Facebook.","A verified email address with Google is required to create an account. You will use your Google login to play.":"Do stworzenia konta wymagane jest podanie adresu e-mail powiązanego z Google. Do logowania wykorzystywany będzie login Google.","ACTIVE":"AKTYWNE","Account Id:":"ID konta:","Account Info":"Informacje o koncie","Account Overview":"Informacje ogólne","Accounts Created":"Stworzone konta","Add Referrer":"Dodaj osobę polecającą","Affiliate Rewards":"Nagrody","After verification, you can change your email address and password.":"Po weryfikacji możesz zmienić swój adres e-mail i hasło.","Already have a Hi-Rez Studios account? Login.":"Maz już konto Hi-Rez Studios? Zaloguj się.","An email address is required to send a referral.":"Do wysłania polecenia wymagane jest podanie adresu e-mail.","An email address is required.":"Wymagany jest adres e-mail.","Australia":"Australia","Authentication Code":"Kod weryfikacyjny","Back":"Wstecz","Belgium":"Belgia","Both":"Oba","Brazil":"Brazylia","CLICK HERE TO REQUEST AN ACCOUNT DELETION OR MAKE AN ACCOUNT DATA REQUEST":"KLIKNIJ TU, ABY ZGŁOSIĆ KONTO DO USUNIĘCIA LUB POPROSIĆ O DANE KONTA","Can only re-link to the previously linked account.":"Można połączyć się ponownie jedynie z poprzednio połączonym kontem.","Can't Login?":"Nie możesz się zalogować?","Canada":"Kanada","Cancel":"Anuluj","Change":"Zmień","Change Email Address":"Zmień adres e-mail","Change Your Password":"Zmień hasło","Chat VIP Support":"Czat obsługi klienta - VIP","Chile":"Chile","Choose Country":"Wybierz kraj","Choose Method":"Wybierz sposób","Click here":"Kliknij tutaj","Confirm":"Potwierdź","Confirm Email":"Potwierdź adres e-mail","Confirm New Password":"Potwierdź nowe hasło","Contact Customer Support":"Obsługa klienta","Continue":"Kontynuuj","Copy Link":"Skopiuj link","Create":"Stwórz","Create A Free Account":"Stwórz darmowe konto","Current Email":"Obecny e-mail","Current Password":"Obecne hasło","Currently using ${currentEmail} as your recovery e-mail.":"Obecnie używany adres e-mail: ${currentEmail}","Currently using ${currentPhone} as your phone number.":"Obecnie używany numer telefonu: ${currentPhone}","Date":"Data","Date of Purchase":"Data zakupu","Description":"Opis","Disable":"Wyłącz","Disable two factor authentication on this account?":"Czy chcesz wyłączyć weryfikację dwuetapową na tym koncie?","Download":"Pobierz","E-Mail Verification Settings":"Ustawienia weryfikacji adresu e-mail","E-mail:":"E-mail:","Edit":"Zmień","Email":"E-mail","Emails do not match. Please try again.":"Adresy nie są identyczne. Spróbuj ponownie.","Enable":"Włącz","Enter Phone Number:":"Wprowadź numer telefonu:","Enter in the email and username associated with your account to reset your password.":"Aby zresetować swoje hasło, wprowadź adres e-mail i nazwę użytkownika danego konta.","Enter in the email associated with your account to receive a reminder email.":"Aby otrzymać przypomnienie, wprowadź adres e-mail powiązany z twoim kontem.","Enter in the username and one time recovery code (when you setup your two factor authentication) to login.":"Aby się zalogować, wprowadź nazwę użytkownika i jednorazowy kod (po ustawieniu weryfikacji dwuetapowej).","Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.":"Aby się zalogować, wprowadź nazwę użytkownika i hasło. Twój kod weryfikacji dwuetapowej zostanie wysłany na twój zapasowy adres e-mail.","Everytime":"Za każdym razem","Finland":"Finlandia","Forgot Your Password?":"Nie pamiętasz hasła?","Forgot Your Username?":"Nie pamiętasz nazwy użytkownika?","France":"Francja","Frequency:":"Częstotliwość:","Game":"Gra","Game Invites":"Zaproszenia do gry","Games":"Gry","Gdpr":"Rodo","Germany":"Niemcy","Gift":"Prezent","I agree to receive Hi-Rez marketing communications, including event invitations, special offers, and newsletters.":"Wyrażam zgodę na otrzymywanie materiałów marketingowych, w tym informacji o wydarzeniach, specjalne oferty lub newslettery.","INACTIVE":"NIEAKTYWNE","If the above options were not able to assist you:":"Jeśli powyższe opcje nie są pomocne:","If you would like to relink to this service later to continue sharing data, simply sign in with the email address and click the connect button in the connected accounts section of the account dashboard.":"Jeśli chcesz połączyć tę usługę później, aby dzielić dane między kontami, zaloguj się za pomocą swojego adresu e-mail i kliknij przycisk łączenia kont w ustawieniach konta.","In-Game Rewards:":"Nagrody w grze:","Information about referring a friend can go here.":"Informacje o poleceniu znajomych mogą pojawić się tutaj.","Ireland":"Irlandia","Korea":"Korea Południowa","Language":"Język","Learn More.":"Dowiedz się więcej","Link A New Account":"Połącz nowe konto","Link Account":"Połącz konto","Link An Existing Account":"Połącz istniejące konto","Link your Hi-Rez Account to other networks in order to receive in-game rewards! Questions? Check out our FAQ page.":"Połącz swoje konto Hi-Rez z innymi stronami, aby otrzymać nagrody w grze! Masz pytania? Zapoznaj się z stroną FAQ.","Linked & Connected Accounts":"Połączone konta","Linked Accounts":"Połączone konta","Logging Into Your Account":"Trwa logowanie do konta","Login":"Zaloguj się","Login With:":"Zaloguj się za pomocą:","Login to change your two-factor settings":"Zaloguj się, aby zmienić swoje ustawienia weryfikacji dwuetapowej","Logout":"Wyloguj się","Method:":"Sposób:","Mexico":"Meksyk","Netherlands":"Holandia","New Email":"Nowy adres e-mail","New Password":"Nowe hasło","Next":"Dalej","None":"Brak","Offline":"Offline","Online":"Podłączeni","Only select countries can receive our SMS alerts. Normal SMS charges apply.":"Tylko niektóre kraje mogą otrzymywać nasze powiadomienia SMS. Obowiązują normalne opłaty za SMS-y.","Order Number":"Numer zamówienia","Other":"Inne","Other Settings":"Inne ustawienia","Paladins":"Paladins","Password":"Hasło","Password:":"Hasło:","Passwords do not match. Please try again.":"Hasła nie są identyczne. Spróbuj ponownie.","Periodic":"Co dwa tygodnie","Phone":"Telefon","Phone Number Verification Settings":"Ustawienia weryfikacji przez numer telefonu","Phone Number:":"Numer telefonu:","Please check your recovery email and try again.":"Sprawdź swój adres e-mail i spróbuj ponownie.","Please check your validation code and try again.":"Sprawdź swój kod weryfikacyjny i spróbuj ponownie.","Please select how often you want to verify your account. Either every time you log in, every two weeks, or never.":"Wybierz, jak często chcesz przeprowadzać weryfikację. Za każdym razem, co dwa tygodnie lub nigdy.","Please select your preferred method of receiving your two-factor security code. Note that not all countries are supported in our text message notification method.":"Wybierz swój preferowany sposób otrzymywania kodu weryfikacji dwuetapowej. Weryfikacja za pomocą telefonu nie jest dostępna we wszystkich krajach.","Please store this recovery code in a safe location.":"Upewnij się, że kod weryfikacyjny jest w bezpiecznym miejscu.","Please try again.":"Spróbuj ponownie.","Please verify your email address.":"Zweryfikuj swój adres e-mail.","Please wait while we connect your Hi-Rez Studios Account to ${service}.":"Prosimy o cierpliwość. Trwa łączenie twojego konta Hi-Rez Studios z usługą ${service}.","Points Earned":"Zdobyte punkty","Poland":"Polska","Portugal":"Portugalia","Preferred Notification Method":"Preferowany sposób wysyłania powiadomień","Program":"Program","Purchases and earned game content will be reset on this account.":"Zakupy i zdobyta zawartość zostaną zresetowane na danym koncie.","Recent Rewards":"Ostatnie nagrody","Recent Transactions":"Ostatnie transakcje","Recovery Code":"Kod odzyskiwania konta","Recovery E-Mail:":"Adres e-mail:","Refer A Friend":"Poleć znajomego","Refer a Friend":"Polecenie znajomego","Referral Email:":"E-mail polecenia:","Referral Link:":"Link polecenia:","Referral sent to ${email}!":"Polecenie wysłane do: ${email}!","Referring Player's Name":"Nazwa polecającego gracza","Save":"Zapisz","Security":"Bezpieczeństwo","Security - Confirm & Recovery Code":"Bezpieczeństwo - Weryfikacja i kod odzyskania konta","Security - Disable Two Factor Authentication":"Bezpieczeństwo - Wyłącz weryfikację dwuetapową","Security - Two Factor Authentication":"Bezpieczeństwo - Weryfikacja dwuetapowa","Select A Game":"Wybierz grę","Send me Hi-Rez Studios news.":"Wysyłaj mi wiadomości Hi-Rez Studios.","Shared game progression and history will be reset on this account.":"Dzielone postępy i historia zostaną zresetowane na danym koncie.","Shared profile data will be reset on this account.":"Dzielone dane profilu zostaną zresetowane na danym koncie.","Sign Up Now! Join 25+ Million Players Today":"Zarejestruj się teraz! Dołącz do ponad 25 milionów graczy","Sign Up With:":"Zarejestruj się za pomocą:","Smite":"SMITE","Something went wrong. Please try again.":"Coś poszło nie tak. Spróbuj ponownie.","Spain":"Hiszpania","Status":"Status","Status:":"Status:","Submit":"Wyślij","Submit Support Ticket":"Wyślij zgłoszenie","Sweden":"Szwecja","Thank you, an email has been sent to the address on file.":"Dziękujemy, wiadomość została wysłana na podany adres e-mail.","The e-mail used to set up your Hi-Rez Account is automatically used for two-step verification codes.":"Adres e-mail wykorzystany do założenia konta jest automatycznie wykorzystany do wysyłania kodów weryfikacji dwuetapowej.","There are no rewards to display":"Brak nagród.","There are no transactions to display":"Brak transakcji.","There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.":"Istnieje kilka powodów, które mogą uniemożliwiać logowanie. Poniższe opcje mogą być pomocne przy odzyskiwaniu konta.","This player has already been referred or has an existing Hi-Rez Studios account.":"Gracz już został polecony lub posiada już konto Hi-Rez.","Total Revenue":"Całkowite zarobki","Two - Factor Sign In":"Logowanie - Weryfikacja dwuetapowa","Two-Factor Sign In can be used to help protect your account from unauthorized access by requiring you to enter an additional code when you sign in.":"Logowanie z weryfikacją dwuetapową może być wykorzystane do chronienia twojego konta poprzez wymaganie wprowadzenia dodatkowego kodu podczas logowania.","UTM Campaign":"Akcja UTM","UTM Content":"Zawartość UTM","Unable to link or create Nintendo account. Please log into your Nintendo Switch, create a player, and retry.":"Nie możemy połączyć lub stworzyć konta Nintendo. Zaloguj się na Nintendo Switch, stwórz konto i spróbuj ponownie.","United Kingdom":"Wielka Brytania","United States of America":"Stany Zjednoczone","Unlink":"Odłącz","Unlink Account":"Rozłącz konto","Unlink Facebook from this account":"Odłącz Facebooka z tego konta","Unlink Google from this account":"Odłącz Google z tego konta","Unlink Mixer from this account":"Odłącz Mixera z tego konta","Unlink Nintendo from this account":"Odłącz Nintendo z tego konta","Unlink PSN from this account":"Odłącz PSN z tego konta","Unlink Steam from this account":"Odłącz Steam z tego konta","Unlink Twitch from this account":"Odłącz Twitch z tego konta.","Unlink Xbox from this account":"Odłącz Xbox One z tego konta.","Unlink this platform from this account":"Odłącz tę platformę z tego konta","Unlinking this service will NOT unlock restricted platforms.":"Odłączenie tej usługi NIE odblokuje platform, które nie wspierają tej funkcji.","Use Backup Email to Login":"Wykorzystaj zapasowy adres e-mail do zalogowania się","Use One Time Recovery Code":"Wykorzystaj jednorazowy kod odzyskania konta","Username":"Nazwa użytkownika","Username:":"Nazwa użytkownika:","VIP Chat":"Chat VIP","VIP Chat Support":"Czat obsługi klienta - VIP","Verification Code:":"Kod weryfikacyjny:","Verification Frequency":"Częstotliwość weryfikacji","Verify":"Zweryfikuj","View all rewards":"Zobacz wszystkie nagrody","View all transactions":"Zobacz wszystkie transakcje","View more rewards":"Zobacz więcej nagród","View more transactions":"Zobacz więcej transakcji","Want to change your two factor settings? Click below.":"Chcesz zmienić swoje ustawienia weryfikacji dwuetapowej? Kliknij poniżej.","Want to send a link directly? Enter in your referral's email below and we'll send it to them directly!":"Chcesz bezpośrednio wysłać link? Wprowadź adres e-mail osoby, którą polecasz, a wyślemy jej wiadomość!","Warning: You will no longer be able to use this account to store your progression on Facebook":"Uwaga: Nie będzie można korzystać z tego konta do dzielenia postępów na Facebooku","Warning: You will no longer be able to use this account to store your progression on Google":"Uwaga: Nie będzie można korzystać z tego konta do dzielenia postępów na Google","Warning: You will no longer be able to use this account to store your progression on Mixer":"Uwaga: Nie będzie można korzystać z tego konta do dzielenia postępów na Mixerze","Warning: You will no longer be able to use this account to store your progression on Nintendo":"Uwaga: Nie będzie można korzystać z tego konta do dzielenia postępów na Nintendo","Warning: You will no longer be able to use this account to store your progression on PSN":"Uwaga: Nie będzie można korzystać z tego konta do dzielenia postępów na PSN","Warning: You will no longer be able to use this account to store your progression on Steam":"Uwaga: Nie będzie można korzystać z tego konta do dzielenia postępów na Steam","Warning: You will no longer be able to use this account to store your progression on Twitch":"Uwaga: Nie będzie można korzystać z tego konta do dzielenia postępów na Twitch","Warning: You will no longer be able to use this account to store your progression on Xbox":"Uwaga: Nie będzie można korzystać z tego konta do dzielenia postępów na Xbox One","Warning: You will no longer be able to use this account to store your progression on this platform.":"Uwaga: Nie będzie można korzystać z tego konta do dzielenia postępów na tej platformie.","We have agents available to speak with you! Please click below to enter our chat window in order to receive assistance with any questions you may have!":"Czekają na ciebie specjaliści obsługi klienta! Kliknij poniżej, aby otworzyć okno czatu i otrzymać potrzebne wsparcie.","We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?":"Nie znaleźliśmy połączonego konta Hi-Rez Studios. Czy chcesz połączyć to konto?","We've provided a backup code below to restore access to your account should you lose the ability to verify your Two Factor Authentication.":"Poniżej znajdziesz zapasowy kod, który może być wykorzystany do odzyskania konta w wypadku utraty dostępu do wybranego sposobu weryfikacji dwuetapowej.","Wrong account? <a>Login to a different account.</a>":"Niewłaściwe konto? <a>Zaloguj się do właściwego konta.</a>","You must confirm your email.":"Musisz potwierdzić swój adres e-mail.","You must enter your current password.":"Musisz wpisać obecne hasło.","You must enter your new email.":"Musisz wprowadzić nowy adres e-mail.","You must verify your email address before changing your password.":"Musisz potwierdzić swój adres e-mail przed zmianą hasła.","You will be logged in as:":"Zalogujesz się jako:","You've successfully changed your email.":"Poprawnie zmieniono adres e-mail.","You've successfully changed your password.":"Poprawnie zmieniono hasło.","You've successfully updated your Two Factor Authentication settings!":"Poprawnie zaktualizowano ustawienia weryfikacji dwuetapowej.","You've successfully verified your backup email address.":"Poprawnie zweryfikowano zapasowy adres e-mail.","You've successfully verified your mobile phone number.":"Poprawnie zweryfikowano numer telefonu.","Your recovery email cannot be the same as your account email.":"Twój zapasowy adres e-mail nie może być identyczny jak obecny adres e-mail.","or":"lub","to add a backup email address.":"aby dodać zapasowy adres e-mail.","to add a new phone number.":"aby dodać nowy numer telefonu.","I am 13+ years old and I agree to the <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Terms of Service</a>.":"Mam co najmniej 13 lat i zgadzam się przestrzegać <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"blank\\\">Umowy użytkownika</a>.","Link your Twitch account to receive content in SMITE with Twitch Prime. After linking, you will be returned to the Twitch Prime landing page for SMITE, or click <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >here</a> to return now.":"Połącz swoje konto Twitch, aby otrzymać zawartość w SMITE dzięki Twitch Prime. Po połączeniu, trafisz na stronę Twitch Prime dla SMITE. Możesz też kliknąć <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >tutaj</a>, aby powrócić na tę stronę.","To unlink your account, please submit a request to Customer Support <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >here</a>.":"Aby odłączyć konto, wyślij zgłoszenie Obsłudze klienta <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >tutaj</a>.","You must have a linked Twitch Prime account to receive these rewards in SMITE. You must also claim the offer <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">here</a>, and link your Hi-Rez account to your platform of choice <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >here</a>.":"Musisz mieć połączone konto Twitch, aby otrzymać nagrody w SMITE. Musisz również odebrać ofertę <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">na tej stronie</a> oraz połączyć swoje konto Hi-Rez do wybranej platformy <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >tutaj</a>."}

/***/ }),

/***/ "oJ5z":
/***/ (function(module, exports) {

function attrString(attrs) {
    var buff = [];
    for (var key in attrs) {
        buff.push(key + '="' + attrs[key] + '"');
    }
    if (!buff.length) {
        return '';
    }
    return ' ' + buff.join(' ');
}

function stringify(buff, doc) {
    switch (doc.type) {
        case 'text':
            return buff + doc.content;
        case 'tag':
            buff += '<' + doc.name + (doc.attrs ? attrString(doc.attrs) : '') + (doc.voidElement ? '/>' : '>');
            if (doc.voidElement) {
                return buff;
            }
            return buff + doc.children.reduce(stringify, '') + '</' + doc.name + '>';
    }
}

module.exports = function (doc) {
    return doc.reduce(function (token, rootEl) {
        return token + stringify('', rootEl);
    }, '');
};

/***/ }),

/***/ "ohx6":
/***/ (function(module, exports) {

module.exports = {"A country must be selected above.":"必须在上面选择国家/地区。","A notification frequency is required to update two factor settings.":"需要使用通知频率来更新双重因素设置。","A notification method is required to update two factor settings.":"需要使用通知方法来更新双重因素设置。","A phone number is required.":"电话号码必填。","A phone number must be associated with your account to use the phone notification method.":"要使用电话通知方法，电话号码必须与您的账号关联。","A username is required to create an account.":"必须使用用户名创建账号。","A valid email address is required.":"需要有效的电子邮件地址。","A verification code is required.":"需要验证码。","A verified email address with Facebook is required to create an account. You will use your Facebook login to play.":"需要使用 Facebook 验证的电子邮件地址创建账号。 您将使用 Facebook 登录进行播放。","A verified email address with Google is required to create an account. You will use your Google login to play.":"需要使用 Google 验证的电子邮件地址创建账号。 您将使用 Google 登录进行播放。","ACTIVE":"生效","Account Id:":"账号 ID：","Account Info":"账号详情","Account Overview":"账号概述","Accounts Created":"账号已创建","Add Referrer":"添加推荐人","Affiliate Rewards":"会员奖励","After verification, you can change your email address and password.":"验证后，您可以更改您的电子邮件地址和密码。","Already have a Hi-Rez Studios account? Login.":"已经拥有Hi-Rez Studios帐号？ 登录。","An email address is required to send a referral.":"需要使用电子邮件发送推荐人。","An email address is required.":"需要电子邮件地址。","Australia":"澳大利亚","Authentication Code":"身份验证码","Back":"返回","Belgium":"比利时","Both":"两者","Brazil":"巴西","CLICK HERE TO REQUEST AN ACCOUNT DELETION OR MAKE AN ACCOUNT DATA REQUEST":"点击此处以提出一个删除账号或账号数据的请求","Can only re-link to the previously linked account.":"只能重新关联到过去关联过的账户。","Can't Login?":"无法登录？","Canada":"加拿大","Cancel":"取消","Change":"更改","Change Email Address":"更改电子邮件地址","Change Your Password":"更改您的密码","Chat VIP Support":"聊天贵宾支持","Chile":"智利","Choose Country":"选择国家/地区","Choose Method":"选择方法","Click here":"单击此处","Confirm":"确认","Confirm Email":"确认电子邮箱","Confirm New Password":"确认新密码","Contact Customer Support":"联系客户支持","Continue":"继续","Copy Link":"复制链接","Create":"创建","Create A Free Account":"创建免费账号","Current Email":"当前电子邮件","Current Password":"当前密码","Currently using ${currentEmail} as your recovery e-mail.":"目前正在使用 ${currentEmail} 作为您的恢复电子邮件。","Currently using ${currentPhone} as your phone number.":"目前正在使用 ${currentPhone} 作为您的电话号码。","Date":"日期","Date of Purchase":"购买日期","Description":"描述","Disable":"禁用","Disable two factor authentication on this account?":"对此账号禁用双重因素身份验证？","Download":"下载","E-Mail Verification Settings":"电子邮件验证设置","E-mail:":"电子邮件：","Edit":"编辑","Email":"电子邮件","Emails do not match. Please try again.":"电子邮件不匹配。 请稍后重试。","Enable":"启用","Enter Phone Number:":"输入电话号码：","Enter in the email and username associated with your account to reset your password.":"输入与您的账号相关联的电子邮件和用户名以重置密码。","Enter in the email associated with your account to receive a reminder email.":"输入与您的账号相关联的电子邮件，以接收提醒电子邮件。","Enter in the username and one time recovery code (when you setup your two factor authentication) to login.":"输入用户名和一次性恢复代码（当您设置双重因素身份验证时）登录。","Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.":"输入用户名和密码以便登录。 您的双重因素身份验证码将被发送到您的备份电子邮件中。","Everytime":"每次","Finland":"芬兰","Forgot Your Password?":"忘记密码？","Forgot Your Username?":"忘记用户名？","France":"法国","Frequency:":"频率：","Game":"游戏","Game Invites":"游戏邀请","Games":"游戏","Gdpr":"GDPR","Germany":"德国","Gift":"礼物","I agree to receive Hi-Rez marketing communications, including event invitations, special offers, and newsletters.":"我同意接收Hi-Rez营销通信，包括活动邀请、特价和新闻稿。","INACTIVE":"未生效","If the above options were not able to assist you:":"如果上述选项无法帮助您：","If you would like to relink to this service later to continue sharing data, simply sign in with the email address and click the connect button in the connected accounts section of the account dashboard.":"Verileri paylaşmak için daha sonra bu hizmete tekrar bağlanmak istersen e-posta adresi ile tekrar oturum açarak hesap tablosundaki bağlı hesaplar bölümündeki bağla butonuna basman yeterlidir.","In-Game Rewards:":"游戏中奖励：","Information about referring a friend can go here.":"有关如何推荐朋友的信息，请转至此处。","Ireland":"爱尔兰","Korea":"韩国","Language":"语言","Learn More.":"了解更多。","Link A New Account":"关联新帐号","Link Account":"账号关联","Link An Existing Account":"关联已有帐号","Link your Hi-Rez Account to other networks in order to receive in-game rewards! Questions? Check out our FAQ page.":"将您的 Hi-Rez 账号链接到其他网络，以便获得游戏中的奖励！ 遇到问题？ 请查看我们的常见问题解答页面。","Linked & Connected Accounts":"已关联和连接的账号","Linked Accounts":"已关联的账号","Logging Into Your Account":"正在登录你的账号","Login":"登录","Login With:":"登录方式：","Login to change your two-factor settings":"登录以更改您的双重因素设置","Logout":"注销","Method:":"方法：","Mexico":"墨西哥","Netherlands":"荷兰","New Email":"新电子邮件","New Password":"新密码","Next":"下一个","None":"无","Offline":"离线","Online":"在线","Only select countries can receive our SMS alerts. Normal SMS charges apply.":"只有选定的国家和地区可以收到我们的短信提醒。 正常短信费用适用。","Order Number":"订单号","Other":"其他","Other Settings":"其他设置","Paladins":"枪火游侠","Password":"密码","Password:":"密码：","Passwords do not match. Please try again.":"密码不一致。 请稍后重试。","Periodic":"定期","Phone":"电话","Phone Number Verification Settings":"电话号码验证设置","Phone Number:":"电话号码：","Please check your recovery email and try again.":"请检查您的恢复电子邮件，然后重试。","Please check your validation code and try again.":"请检查您的验证码，然后重试。","Please select how often you want to verify your account. Either every time you log in, every two weeks, or never.":"请选择验证您的账号的频率。 可以是您每次登录时验证，或者每两周验证一次，或者从不验证。","Please select your preferred method of receiving your two-factor security code. Note that not all countries are supported in our text message notification method.":"请选择接收双重因素安全码的首选方法。 请注意，并非所有国家和地区都支持我们的短信通知方法。","Please store this recovery code in a safe location.":"请将此恢复代码存储在安全的位置。","Please try again.":"请稍后重试。","Please verify your email address.":"请验证您的电子邮件地址。","Please wait while we connect your Hi-Rez Studios Account to ${service}.":"请等待我们将您的Hi-Rez Studios账号连接到 ${service}。","Points Earned":"赚取的点数","Poland":"波兰","Portugal":"葡萄牙","Preferred Notification Method":"首选通知方法","Program":"计划","Purchases and earned game content will be reset on this account.":"Satın alınan ve kazanılan oyun içerikleri bu hesapta sıfırlanacaktır.","Recent Rewards":"近期奖励","Recent Transactions":"近期交易","Recovery Code":"恢复代码","Recovery E-Mail:":"恢复电子邮件：","Refer A Friend":"呼朋唤友","Refer a Friend":"推荐给朋友","Referral Email:":"推荐电子邮件：","Referral Link:":"推荐链接：","Referral sent to ${email}!":"推荐发送给 ${email}！","Referring Player's Name":"发起邀请的玩家名","Save":"保存","Security":"安全","Security - Confirm & Recovery Code":"安全 - 确认和恢复代码","Security - Disable Two Factor Authentication":"安全 - 禁用双重因素身份验证","Security - Two Factor Authentication":"安全 - 双重因素身份验证","Select A Game":"选择一款游戏","Send me Hi-Rez Studios news.":"向我发送Hi-Rez Studios新闻。","Shared game progression and history will be reset on this account.":"Paylaşılan oyun ilerlemesi ve geçmişi bu hesapta sıfırlanacaktır.","Shared profile data will be reset on this account.":"Paylaşılan profil verileri bu hesapta sıfırlanacaktır.","Sign Up Now! Join 25+ Million Players Today":"立即注册！ 立刻加入2500多万名玩家的行列","Sign Up With:":"用以下方式注册：","Smite":"枪火游侠","Something went wrong. Please try again.":"出问题了。 请稍后重试。","Spain":"西班牙","Status":"状态","Status:":"状态：","Submit":"提交","Submit Support Ticket":"提交支持工单","Sweden":"瑞典","Thank you, an email has been sent to the address on file.":"谢谢，电子邮件已发送到文件上的地址。","The e-mail used to set up your Hi-Rez Account is automatically used for two-step verification codes.":"用于设置您的Hi-Rez账号的电子邮件将自动用于两步验证代码。","There are no rewards to display":"无可显示的奖励","There are no transactions to display":"无可显示的交易","There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.":"有几个原因可能导致您无法登录。 以下选项可能有助于您恢复账号。","This player has already been referred or has an existing Hi-Rez Studios account.":"该玩家已被推荐或拥有现有的Hi-Rez Studios账号。","Total Revenue":"总收入","Two - Factor Sign In":"双重因素登录","Two-Factor Sign In can be used to help protect your account from unauthorized access by requiring you to enter an additional code when you sign in.":"双重因素登录可以通过要求您在登录时输入附加代码来帮助保护您的账号免受未经授权的访问。","UTM Campaign":"UTM活动","UTM Content":"UTM内容","Unable to link or create Nintendo account. Please log into your Nintendo Switch, create a player, and retry.":"无法关联或创建Nintendo账号。 请登录你的Nintendo Switch，创建一名玩家并重试。","United Kingdom":"英国","United States of America":"美国","Unlink":"Bağlantıyı Kaldır","Unlink Account":"Hesap Bağlantısını Kaldır","Unlink Facebook from this account":"Bu hesaptan Facebook bağlantısını kaldır","Unlink Google from this account":"Bu hesaptan Google bağlantısını kaldır","Unlink Mixer from this account":"Bu hesaptan Mixer bağlantısını kaldır","Unlink Nintendo from this account":"Bu hesaptan Nintendo bağlantısını kaldır","Unlink PSN from this account":"Bu hesaptan PSN bağlantısını kaldır","Unlink Steam from this account":"Bu hesaptan Steam bağlantısını kaldır","Unlink Twitch from this account":"Bu hesaptan Twitch bağlantısını kaldır","Unlink Xbox from this account":"Bu hesaptan Xbox bağlantısını kaldır","Unlink this platform from this account":"Bu hesaptan bu platformun bağlantısını kaldır","Unlinking this service will NOT unlock restricted platforms.":"Bu hizmetin bağlantısını kaldırmak kısıtlanmış platformları AÇMAYACAKTIR.","Use Backup Email to Login":"使用备用电子邮件登录","Use One Time Recovery Code":"使用一次性恢复代码","Username":"用户名","Username:":"用户名：","VIP Chat":"贵宾聊天","VIP Chat Support":"贵宾聊天支持","Verification Code:":"验证码：","Verification Frequency":"验证频率","Verify":"验证","View all rewards":"查看所有奖励","View all transactions":"查看所有交易","View more rewards":"查看更多奖励","View more transactions":"查看更多交易","Want to change your two factor settings? Click below.":"想要更改您的双重因素设置？ 单击下方。","Want to send a link directly? Enter in your referral's email below and we'll send it to them directly!":"想要直接发送链接？ 在下面输入您的推荐人的电子邮件，我们会直接发送给他们！","Warning: You will no longer be able to use this account to store your progression on Facebook":"Uyarı: Facebook üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Google":"Uyarı: Google üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Mixer":"Uyarı: Mixer üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Nintendo":"Uyarı: Nintendo üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on PSN":"Uyarı: PSN üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Steam":"Uyarı: Steam üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Twitch":"Uyarı: Twitch üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on Xbox":"Uyarı: Xbox üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","Warning: You will no longer be able to use this account to store your progression on this platform.":"Uyarı: Bu platform üzerindeki ilerlemeni saklamak için artık bu hesabı kullanamayacaksın","We have agents available to speak with you! Please click below to enter our chat window in order to receive assistance with any questions you may have!":"我们有代理可以和您通话！ 请单击下面进入我们的聊天窗口，以便接受任何问题的帮助！","We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?":"我们无法找到关联的Hi-Rez Studios账号。 您是否希望关联该账号？","We've provided a backup code below to restore access to your account should you lose the ability to verify your Two Factor Authentication.":"我们在下面提供了备用代码，用于在您失去验证双重因素身份验证的能力时恢复对您账号的访问。","Wrong account? <a>Login to a different account.</a>":"账号错误？<a>试试换一个账号登录。</a>","You must confirm your email.":"您必须确认您的电子邮件。","You must enter your current password.":"您必须输入当前密码。","You must enter your new email.":"您必须输入新的电子邮件。","You must verify your email address before changing your password.":"更改密码之前必须验证你的电子邮件地址。","You will be logged in as:":"您将以以下身份登录：","You've successfully changed your email.":"您已成功更改电子邮件。","You've successfully changed your password.":"您已成功更改密码。","You've successfully updated your Two Factor Authentication settings!":"您已成功更新双重因素身份验证设置！","You've successfully verified your backup email address.":"您已成功验证备用电子邮件地址。","You've successfully verified your mobile phone number.":"您已成功验证手机号码。","Your recovery email cannot be the same as your account email.":"您的恢复电子邮件不能与您的账号电子邮件相同。","or":"或","to add a backup email address.":"添加备用电子邮件地址。","to add a new phone number.":"添加新电话号码。","I am 13+ years old and I agree to the <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Terms of Service</a>.":"我已经年满13岁，我同意 <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"blank\\\">服务条款</a>.","Link your Twitch account to receive content in SMITE with Twitch Prime. After linking, you will be returned to the Twitch Prime landing page for SMITE, or click <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >here</a> to return now.":"关联你的Twitch账号，凭Twitch Prime领取《神之浩劫》奖励。关联后，你将回到Twitch Prime的《神之浩劫》登陆页，也可点击<a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >here</a> 立刻返回。","To unlink your account, please submit a request to Customer Support <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >here</a>.":"解除账号关联步骤：点击<a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >此处</a>向客服提交请求。","You must have a linked Twitch Prime account to receive these rewards in SMITE. You must also claim the offer <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">here</a>, and link your Hi-Rez account to your platform of choice <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >here</a>.":"你必须拥有一个已关联的Twitch Prime账号才能获得这些《神之浩劫》奖励。你还需领取<a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">此处</a>的优惠，并点击<a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >此处</a>以将你的Hi-Rez账号与你所选的平台相关联。"}

/***/ }),

/***/ "pc+c":
/***/ (function(module, exports) {

module.exports = {"A country must be selected above.":"Länderauswahl ist erforderlich.","A notification frequency is required to update two factor settings.":"Für die Aktualisierung der Einstellungen deiner Zwei-Faktor-Authentifizierung ist eine Benachrichtigungshäufigkeit erforderlich.","A notification method is required to update two factor settings.":"Für die Aktualisierung der Einstellungen deiner Zwei-Faktor-Authentifizierung ist eine Benachrichtigungsmethode erforderlich.","A phone number is required.":"Telefonnummer ist erforderlich.","A phone number must be associated with your account to use the phone notification method.":"Für die Benachrichtigung per Telefon ist eine Telefonnummer erforderlich.","A username is required to create an account.":"Für die Kontoerstellung ist ein Benutzername erforderlich.","A valid email address is required.":"Gültige E-Mail-Adresse ist erforderlich.","A verification code is required.":"Bestätigungscode ist erforderlich.","A verified email address with Facebook is required to create an account. You will use your Facebook login to play.":"Für die Kontoerstellung ist eine mit Facebook verknüpfte E-Mail-Adresse erforderlich. Für den Login wird dein Facebook-Konto verwendet.","A verified email address with Google is required to create an account. You will use your Google login to play.":"Für die Kontoerstellung ist eine mit Google verknüpfte E-Mail-Adresse erforderlich. Für den Login wird dein Google-Konto verwendet.","ACTIVE":"AKTIV","Account Id:":"Konto-ID:","Account Info":"Konto-Informationen","Account Overview":"Konto-Übersicht","Accounts Created":"Erstellte Konten","Add Referrer":"Werber hinzufügen","Affiliate Rewards":"Partner-Belohnungen","After verification, you can change your email address and password.":"E-Mail-Adresse und Passwort können nach der Bestätigung geändert werden.","Already have a Hi-Rez Studios account? Login.":"Du hast bereits ein Hi-Rez-Konto? Logge dich ein.","An email address is required to send a referral.":"Für das Senden der Werbung ist eine E-Mail-Adresse erforderlich.","An email address is required.":"E-Mail-Adresse ist erforderlich.","Australia":"Australien","Authentication Code":"Authentifizierungs-Code","Back":"Zurück","Belgium":"Belgien","Both":"Beides","Brazil":"Brasilien","CLICK HERE TO REQUEST AN ACCOUNT DELETION OR MAKE AN ACCOUNT DATA REQUEST":"HIER KLICKEN, UM EINE LÖSCHUNG DES KONTOS ZU BEANTRAGEN ODER EINE ANFRAGE BEZÜGLICH DER ZU DIESEM KONTO GESPEICHERTEN DATEN EINZUREICHEN","Can only re-link to the previously linked account.":"Nur das zuvor verknüpfte Konto kann erneut verknüfpt werden.","Can't Login?":"Login nicht möglich?","Canada":"Kanada","Cancel":"Abbrechen","Change":"Ändern","Change Email Address":"E-Mail-Adresse ändern","Change Your Password":"Passwort ändern","Chat VIP Support":"VIP-Chat-Kundendienst","Chile":"Chile","Choose Country":"Land auswählen","Choose Method":"Methode auswählen","Click here":"Hier klicken","Confirm":"Bestätigen","Confirm Email":"E-Mail bestätigen","Confirm New Password":"Neues Passwort bestätigen","Contact Customer Support":"Kundendienst kontaktieren","Continue":"Weiter","Copy Link":"Link kopieren","Create":"Erstellen","Create A Free Account":"Kostenloses Konto erstellen","Current Email":"Aktuelle E-Mail-Adresse","Current Password":"Aktuelles Passwort","Currently using ${currentEmail} as your recovery e-mail.":"Für die Kontowiederherstellung wird derzeit ${currentEmail} verwendet.","Currently using ${currentPhone} as your phone number.":"Als Telefonnummer wird derzeit ${currentPhone} verwendet.","Date":"Datum","Date of Purchase":"Kaufdatum","Description":"Beschreibung","Disable":"Deaktivieren","Disable two factor authentication on this account?":"Zwei-Faktor-Authentifizierung für dieses Konto deaktivieren?","Download":"Herunterladen","E-Mail Verification Settings":"E-Mail-Bestätigungseinstellungen","E-mail:":"E-Mail-Adresse:","Edit":"Bearbeiten","Email":"E-Mail-Adresse","Emails do not match. Please try again.":"E-Mail-Adressen stimmen nicht überein. Bitte versuche es erneut.","Enable":"Aktivieren","Enter Phone Number:":"Telefonnummer eingeben:","Enter in the email and username associated with your account to reset your password.":"Gib die E-Mail-Adresse und den Benutzernamen für dieses Konto ein, um das Passwort zurückzusetzen.","Enter in the email associated with your account to receive a reminder email.":"Gib die E-Mail-Adresse deines Kontos ein, um eine Erinnerungs-E-Mail zu erhalten.","Enter in the username and one time recovery code (when you setup your two factor authentication) to login.":"Gib den Benutzernamen und den Einmal-Wiederherstellungscode (beim Einrichten deiner Zwei-Faktor-Authentifizierung erstellt) ein, um dich einzuloggen.","Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.":"Gib den Benutzernamen und das Passwort ein, um dich einzuloggen. Dein Code für die Zwei-Faktor-Authentifizierung wird an deine alternative E-Mail-Adresse gesendet.","Everytime":"Jedes Mal","Finland":"Finnland","Forgot Your Password?":"Passwort vergessen?","Forgot Your Username?":"Benutzernamen vergessen?","France":"Frankreich","Frequency:":"Häufigkeit:","Game":"Spiel","Game Invites":"Spieleinladungen","Games":"Spiele","Gdpr":"Gdpr","Germany":"Deutschland","Gift":"Geschenk","I agree to receive Hi-Rez marketing communications, including event invitations, special offers, and newsletters.":"Ich stimme der Zusendung von Marketing-Benachrichtigungen, wie z. B. Einladungen zu Events, besonderen Angeboten und Newslettern, durch Hi-Rez zu.","INACTIVE":"INAKTIV","If the above options were not able to assist you:":"Falls die obigen Optionen nicht weiterhelfen konnten:","If you would like to relink to this service later to continue sharing data, simply sign in with the email address and click the connect button in the connected accounts section of the account dashboard.":"Falls du dein Konto später wieder mit diesem Dienst verbinden möchtest, um weiterhin Daten mit diesem zu teilen, logge dich mit deiner E-Mail-Adresse ein und klicke im Menü „Verknüpfte Konten“ der Konto-Übersicht auf die Schaltfläche „Konto verknüpfen“.","In-Game Rewards:":"Belohnungen im Spiel:","Information about referring a friend can go here.":"Informationen zur Freundeswerbung","Ireland":"Irland","Korea":"Korea","Language":"Sprache","Learn More.":"Mehr erfahren","Link A New Account":"Neues Konto verknüpfen","Link Account":"Konto verknüpfen","Link An Existing Account":"Bestehendes Konto verknüpfen","Link your Hi-Rez Account to other networks in order to receive in-game rewards! Questions? Check out our FAQ page.":"Verknüpfe dein Hi-Rez-Konto mit anderen Netzwerken, um im Spiel Belohnungen zu erhalten! Fragen? Weitere Informationen gibt es in den FAQ.","Linked & Connected Accounts":"Verknüpfte und verbundene Konten","Linked Accounts":"Verknüpfte Konten","Logging Into Your Account":"Einloggen in dein Konto...","Login":"Einloggen","Login With:":"Login mit:","Login to change your two-factor settings":"Logge dich ein, um die Einstellungen der Zwei-Faktor-Authentifizierung zu ändern.","Logout":"Ausloggen","Method:":"Methode:","Mexico":"Mexiko","Netherlands":"Niederlande","New Email":"Neue E-Mail-Adresse","New Password":"Neues Passwort","Next":"Weiter","None":"Keine","Offline":"Offline","Online":"Online","Only select countries can receive our SMS alerts. Normal SMS charges apply.":"SMS-Benachrichtigungen sind nur in ausgewählten Ländern verfügbar. Standardgebühren für SMS können anfallen.","Order Number":"Bestellnummer","Other":"Sonstiges","Other Settings":"Weitere Einstellungen","Paladins":"Paladins","Password":"Passwort","Password:":"Passwort:","Passwords do not match. Please try again.":"Die Passwörter stimmen nicht überein. Bitte versuche es erneut.","Periodic":"Regelmäßig","Phone":"Telefon","Phone Number Verification Settings":"Telefonnummer-Bestätigungseinstellungen","Phone Number:":"Telefonnummer:","Please check your recovery email and try again.":"Überprüfe deine alternative E-Mail-Adresse und versuche es erneut.","Please check your validation code and try again.":"Überprüfe deinen Bestätigungscode und versuche es erneut.","Please select how often you want to verify your account. Either every time you log in, every two weeks, or never.":"Wähle aus, wie häufig du dein Konto verifizieren möchtest. Entweder bei jedem Login, alle zwei Wochen oder niemals.","Please select your preferred method of receiving your two-factor security code. Note that not all countries are supported in our text message notification method.":"Wähle aus, wie du deinen Bestätigungscode für die Zwei-Faktor-Authentifizierung erhalten möchtest. Beachte, dass die Benachrichtigung per SMS nicht in allen Ländern verfügbar ist.","Please store this recovery code in a safe location.":"Bewahre deinen Wiederherstellungscode gut auf.","Please try again.":"Bitte versuche es erneut.","Please verify your email address.":"Bitte bestätige deine E-Mail-Adresse.","Please wait while we connect your Hi-Rez Studios Account to ${service}.":"Gedulde dich ein wenig, während wir dein Hi-Rez-Konto mit ${service} verbinden.","Points Earned":"Verdiente Punkte","Poland":"Polen","Portugal":"Portugal","Preferred Notification Method":"Bevorzugte Benachrichtigungsmethode","Program":"Programm","Purchases and earned game content will be reset on this account.":"Käufe und verdiente Spielinhalte werden von diesem Konto entfernt.","Recent Rewards":"Letzte Belohnungen","Recent Transactions":"Letzte Transaktionen","Recovery Code":"Wiederherstellungscode","Recovery E-Mail:":"Alternative E-Mail-Adresse:","Refer A Friend":"Wirb-einen-Freund","Refer a Friend":"Freund werben","Referral Email:":"Werbe-E-Mail:","Referral Link:":"Werbe-Link:","Referral sent to ${email}!":"Werbung gesendet an ${email}!","Referring Player's Name":"Name des werbenden Spielers","Save":"Speichern","Security":"Sicherheit","Security - Confirm & Recovery Code":"Sicherheit – Bestätigung und Wiederherstellungscode","Security - Disable Two Factor Authentication":"Sicherheit – Zwei-Faktor-Authentifizierung deaktivieren","Security - Two Factor Authentication":"Sicherheit – Zwei-Faktor-Authentifizierung","Select A Game":"Wähle ein Spiel","Send me Hi-Rez Studios news.":"Ich möchte News zu Hi-Rez Studios erhalten.","Shared game progression and history will be reset on this account.":"Geteilte Spielfortschritte und Spielverläufe werden von diesem Konto entfernt.","Shared profile data will be reset on this account.":"Geteilte Profildaten werden von diesem Konto entfernt.","Sign Up Now! Join 25+ Million Players Today":"Jetzt anmelden! Spiele noch heute mit mehr als 25 Millionen anderen Spielern","Sign Up With:":"Anmelden mit:","Smite":"Smite","Something went wrong. Please try again.":"Etwas ist schiefgegangen. Bitte versuche es erneut.","Spain":"Spanien","Status":"Status","Status:":"Status:","Submit":"Absenden","Submit Support Ticket":"Support-Ticket einreichen","Sweden":"Schweden","Thank you, an email has been sent to the address on file.":"Danke. Wir haben eine E-Mail an die angegebene E-Mail-Adresse gesendet.","The e-mail used to set up your Hi-Rez Account is automatically used for two-step verification codes.":"Die mit deinem Hi-Rez-Konto verknüpfte E-Mail-Adresse wird automatisch für Bestätigungscodes der Zwei-Faktor-Authentifizierung verwendet.","There are no rewards to display":"Es gibt keine Belohnungen anzuzeigen.","There are no transactions to display":"Es gibt keine Transaktionen anzuzeigen.","There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.":"Es gibt verschiedene Gründe, aus denen du dich nicht einloggen kannst. Mithilfe dieser Optionen kannst du dein Konto wiederherstellen.","This player has already been referred or has an existing Hi-Rez Studios account.":"Dieser Spieler wurde entweder bereits geworben oder verfügt bereits über ein Hi-Rez-Konto.","Total Revenue":"Gesamteinnahmen","Two - Factor Sign In":"Login mit Zwei-Faktor-Authentifizierung","Two-Factor Sign In can be used to help protect your account from unauthorized access by requiring you to enter an additional code when you sign in.":"Die Zwei-Faktor-Authentifizierung erfordert beim Login die Eingabe eines zusätzlichen Codes und schützt so vor unbefugten Zugriffen auf dein Konto.","UTM Campaign":"UTM-Kampagne","UTM Content":"UTM-Inhalt","Unable to link or create Nintendo account. Please log into your Nintendo Switch, create a player, and retry.":"Nintendo-Account konnte nicht erstellt oder verknüpft werden. Bitte logge dich auf Nintendo Switch ein, erstelle ein Spielerprofil und versuche es erneut.","United Kingdom":"Vereinigtes Königreich","United States of America":"Vereinigte Staaten von Amerika","Unlink":"Verknüpfung trennen","Unlink Account":"Kontoverknüpfung trennen","Unlink Facebook from this account":"Verknüpfung mit Facebook trennen","Unlink Google from this account":"Verknüpfung mit Google trennen","Unlink Mixer from this account":"Verknüpfung mit Mixer trennen","Unlink Nintendo from this account":"Verknüpfung mit Nintendo trennen","Unlink PSN from this account":"Verknüpfung mit PSN trennen","Unlink Steam from this account":"Verknüpfung mit Steam trennen","Unlink Twitch from this account":"Verknüpfung mit Twitch trennen","Unlink Xbox from this account":"Verknüpfung mit Xbox trennen","Unlink this platform from this account":"Verknüpfung mit dieser Plattform trennen","Unlinking this service will NOT unlock restricted platforms.":"Bei Trennung der Verknüpfung werden gesperrte Plattformen NICHT freigeschaltet.","Use Backup Email to Login":"Mit alternativer E-Mail-Adresse einloggen","Use One Time Recovery Code":"Einmal-Wiederherstellungscode verwenden","Username":"Benutzername","Username:":"Benutzername:","VIP Chat":"VIP-Chat","VIP Chat Support":"VIP-Chat-Kundendienst","Verification Code:":"Bestätigungscode:","Verification Frequency":"Bestätigungshäufigkeit","Verify":"Bestätigen","View all rewards":"Alle Belohnungen anzeigen","View all transactions":"Alle Transaktionen anzeigen","View more rewards":"Mehr Belohnungen anzeigen","View more transactions":"Mehr Transaktionen anzeigen","Want to change your two factor settings? Click below.":"Möchtest du die Einstellungen der Zwei-Faktor-Authentifizierung ändern? Klicke hier.","Want to send a link directly? Enter in your referral's email below and we'll send it to them directly!":"Möchtest du den Link direkt senden? Gib die E-Mail-Adresse deines Freundes unten ein, um ihm den Link direkt zu schicken.","Warning: You will no longer be able to use this account to store your progression on Facebook":"WARNUNG: Mit diesem Konto wirst du geteilte Spielfortschritte und Inhalte nicht mehr auf Facebook nutzen können.","Warning: You will no longer be able to use this account to store your progression on Google":"WARNUNG: Mit diesem Konto wirst du geteilte Spielfortschritte und Inhalte nicht mehr auf Google nutzen können.","Warning: You will no longer be able to use this account to store your progression on Mixer":"WARNUNG: Mit diesem Konto wirst du geteilte Spielfortschritte und Inhalte nicht mehr auf Mixer nutzen können.","Warning: You will no longer be able to use this account to store your progression on Nintendo":"WARNUNG: Mit diesem Konto wirst du geteilte Spielfortschritte und Inhalte nicht mehr auf Nintendo Switch nutzen können.","Warning: You will no longer be able to use this account to store your progression on PSN":"WARNUNG: Mit diesem Konto wirst du geteilte Spielfortschritte und Inhalte nicht mehr auf PlayStation 4 nutzen können.","Warning: You will no longer be able to use this account to store your progression on Steam":"WARNUNG: Mit diesem Konto wirst du geteilte Spielfortschritte und Inhalte nicht mehr auf Steam nutzen können.","Warning: You will no longer be able to use this account to store your progression on Twitch":"WARNUNG: Mit diesem Konto wirst du geteilte Spielfortschritte und Inhalte nicht mehr auf Twitch nutzen können.","Warning: You will no longer be able to use this account to store your progression on Xbox":"WARNUNG: Mit diesem Konto wirst du geteilte Spielfortschritte und Inhalte nicht mehr auf Xbox One nutzen können.","Warning: You will no longer be able to use this account to store your progression on this platform.":"WARNUNG: Mit diesem Konto wirst du geteilte Spielfortschritte und Inhalte nicht mehr auf dieser Plattform nutzen können.","We have agents available to speak with you! Please click below to enter our chat window in order to receive assistance with any questions you may have!":"Ein Mitarbeiter vom Kundendienst ist verfügbar. Bitte klicke unten, um das Chat-Fenster zu öffnen und dich mit dem Kundendienst in Verbindung zu setzen.","We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?":"Wir konnten kein verknüpftes Hi-Rez-Konto finden. Möchtest du dieses Konto verknüpfen?","We've provided a backup code below to restore access to your account should you lose the ability to verify your Two Factor Authentication.":"Wir haben unten einen alternativen Code zur Verfügung gestellt, mit dem du auf dein Konto zugreifen kannst, wenn Zwei-Faktor-Authentifizierung nicht verfügbar ist.","Wrong account? <a>Login to a different account.</a>":"Falsches Konto? <a>Logge dich in ein anderes Konto ein.</a>","You must confirm your email.":"Bestätige deine E-Mail-Adresse.","You must enter your current password.":"Gib dein aktuelles Passwort ein.","You must enter your new email.":"Gib deine neue E-Mail-Adresse ein.","You must verify your email address before changing your password.":"Du musst deine E-Mail-Adresse verifizieren, bevor du dein Passwort ändern kannst.","You will be logged in as:":"Du wirst eingeloggt als:","You've successfully changed your email.":"Du hast deine E-Mail-Adresse geändert.","You've successfully changed your password.":"Du hast dein Passwort geändert.","You've successfully updated your Two Factor Authentication settings!":"Die Einstellungen deiner Zwei-Faktor-Authentifizierung wurden geändert!","You've successfully verified your backup email address.":"Deine alternative E-Mail-Adresse wurde verifiziert.","You've successfully verified your mobile phone number.":"Deine Telefonnummer wurde verifiziert.","Your recovery email cannot be the same as your account email.":"Deine alternative E-Mail-Adresse darf nicht mit deiner Konto-E-Mail-Adresse übereinstimmen.","or":"oder","to add a backup email address.":"zum Hinzufügen einer alternativen E-Mail-Adresse.","to add a new phone number.":"zum Hinzufügen einer neuen Telefonnummer.","I am 13+ years old and I agree to the <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Terms of Service</a>.":"Ich bin 12+ Jahre alt und stimme den <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"blank\\\">Nutzungsbedingungen von Hi-Rez Studios</a> zu.","Link your Twitch account to receive content in SMITE with Twitch Prime. After linking, you will be returned to the Twitch Prime landing page for SMITE, or click <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >here</a> to return now.":"Verknüpfe dein Twitch-Konto mit deinem Hi-Rez-Konto, um über Twitch Prime Inhalte für SMITE erhalten zu können. Nach der Kontoverknüpfung gelangst du wieder auf die Twitch-Prime-Startseite für SMITE. Wenn nicht, <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >klicke hier</a>, um jetzt zurückzukehren.","To unlink your account, please submit a request to Customer Support <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >here</a>.":"Wenn du die Verknüpfung deines Kontos trennen möchtest, wende dich an <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >unseren Kundendienst</a>.","You must have a linked Twitch Prime account to receive these rewards in SMITE. You must also claim the offer <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">here</a>, and link your Hi-Rez account to your platform of choice <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >here</a>.":"Du musst dein Twitch-Konto mit deinem Hi-Rez-Konto verknüpfen, um diese Belohnungen für SMITE erhalten zu können. Fordere das Angebot <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">hier</a> ein und verknüpfe dein Hi-Rez-Konto <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >hier</a> mit der Plattform deiner Wahl."}

/***/ }),

/***/ "pwNi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__("KM04");

if (false) {
	require('preact/devtools');
} else if (true && 'serviceWorker' in navigator && location.protocol === 'https:') {
	navigator.serviceWorker.register(__webpack_require__.p + 'sw.js');
}

var interopDefault = function interopDefault(m) {
	return m && m.default ? m.default : m;
};

var app = interopDefault(__webpack_require__("JkW7"));

if (typeof app === 'function') {
	var root = document.body.firstElementChild;

	var init = function init() {
		var app = interopDefault(__webpack_require__("JkW7"));
		root = (0, _preact.render)((0, _preact.h)(app), document.body, root);
	};

	if (false) module.hot.accept('preact-cli-entrypoint', init);

	init();
}

/***/ }),

/***/ "qAxq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'subdomain',

  lookup: function lookup(options) {
    var found = void 0;
    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/gi);
      if (language instanceof Array) {
        if (typeof options.lookupFromSubdomainIndex === 'number') {
          found = language[options.lookupFromSubdomainIndex].replace('http://', '').replace('https://', '').replace('.', '');
        } else {
          found = language[0].replace('http://', '').replace('https://', '').replace('.', '');
        }
      }
    }
    return found;
  }
};

/***/ }),

/***/ "qBBm":
/***/ (function(module, exports) {

module.exports = {"A country must be selected above.":"Debes seleccionar un país.","A notification frequency is required to update two factor settings.":"Se requiere una frecuencia de notificación para actualizar dos ajustes de factores.","A notification method is required to update two factor settings.":"Se requiere un método de notificación para actualizar dos ajustes de factores.","A phone number is required.":"Se requiere un número de teléfono.","A phone number must be associated with your account to use the phone notification method.":"Un número telefónico debe estar asociado con tu cuenta para utilizar el método de notificación telefónica.","A username is required to create an account.":"Se requiere un nombre de usuario para crear una cuenta.","A valid email address is required.":"Se requiere un correo electrónico.","A verification code is required.":"Se requiere un código de verificación.","A verified email address with Facebook is required to create an account. You will use your Facebook login to play.":"Se requiere una dirección de correo electrónico verificada con Facebook para crear una cuenta. Usarás tu nombre de usuario de Facebook para jugar.","A verified email address with Google is required to create an account. You will use your Google login to play.":"Se requiere una dirección de correo electrónico verificada con Google para crear una cuenta. Usarás tu nombre de usuario de Google para jugar.","ACTIVE":"ACTIVADO","Account Id:":"ID de la Cuenta:","Account Info":"Información de cuenta","Account Overview":"Resumen de cuenta","Accounts Created":"Cuentas creadas","Add Referrer":"Agregar recomendante","Affiliate Rewards":"Recompensas para afiliados","After verification, you can change your email address and password.":"Puedes cambiar tu dirección de correo electrónico y tu contraseña después verificar.","Already have a Hi-Rez Studios account? Login.":"¿Ya tienes una cuenta con Hi-Rez Studios? Inicia sesión.","An email address is required to send a referral.":"Se requiere un correo electrónico para enviar una referencia.","An email address is required.":"Se requiere un correo electrónico.","Australia":"Australia","Authentication Code":"Código de autenticación","Back":"Volver","Belgium":"Bélgica","Both":"Ambos","Brazil":"Brasil","CLICK HERE TO REQUEST AN ACCOUNT DELETION OR MAKE AN ACCOUNT DATA REQUEST":"HAZ CLIC AQUÍ PARA SOLICITAR BORRAR UNA CUENTA O HACER UNA SOLICITUD SOBRE LOS DATOS DE UNA CUENTA","Can only re-link to the previously linked account.":"Solo se puede volver a vincular con la cuenta anteriormente vinculada.","Can't Login?":"¿No puedes iniciar sesión?","Canada":"Canadá","Cancel":"Cancelar","Change":"Cambiar","Change Email Address":"Cambiar tu correo electrónico","Change Your Password":"Cambia tu contraseña","Chat VIP Support":"Soporte de Chat VIP","Chile":"Chile","Choose Country":"Elige tu país","Choose Method":"Elige tu método","Click here":"Haz clic aquí","Confirm":"Confirmar","Confirm Email":"Confirmar correo electrónico","Confirm New Password":"Confirmar nueva contraseña","Contact Customer Support":"Contactar soporte del cliente","Continue":"Continuar","Copy Link":"Copiar enlace","Create":"Crear","Create A Free Account":"Crea una cuenta gratis","Current Email":"Correo electrónico actual","Current Password":"Contraseña actual","Currently using ${currentEmail} as your recovery e-mail.":"${currentEmail} es tu correo electrónico de recuperación actual.","Currently using ${currentPhone} as your phone number.":"${currentPhone} es tu número telefónico actual.","Date":"Fecha","Date of Purchase":"Fecha de compra","Description":"Descripción","Disable":"Desactivar","Disable two factor authentication on this account?":"¿Deseas desactivar la autenticación de dos factores en esta cuenta?","Download":"Descargar","E-Mail Verification Settings":"Configuraciones de verificación de correo electrónico.","E-mail:":"Correo electrónico:","Edit":"Editar","Email":"Correo electrónico","Emails do not match. Please try again.":"Los correos electrónicos no coinciden. Inténtalo de nuevo.","Enable":"Activar","Enter Phone Number:":"Ingresa el número telefónico:","Enter in the email and username associated with your account to reset your password.":"Introduzca el correo electrónico y el nombre de usuario asociados a su cuenta para restablecer tu contraseña.","Enter in the email associated with your account to receive a reminder email.":"Ingresa el correo electrónico asociado a su cuenta para recibir un correo electrónico recordatorio.","Enter in the username and one time recovery code (when you setup your two factor authentication) to login.":"Introduzca el nombre de usuario y el código de recuperación (cuando configures tu autenticación de dos factores) para iniciar sesión.","Enter in the username and password to login. Your two factor authorization code will be sent to your backup email.":"Ingresa el nombre de usuario y la contraseña para iniciar sesión. Tu código de autorización de dos factores será enviado a tu correo electrónico de respaldo.","Everytime":"Cada vez","Finland":"Finlandia","Forgot Your Password?":"¿Olvidaste tu contraseña?","Forgot Your Username?":"¿Olvidaste tu nombre de usuario?","France":"Francia","Frequency:":"Frecuencia:","Game":"Juego","Game Invites":"Invitaciones de juego","Games":"Juegos","Gdpr":"RGPD","Germany":"Alemania","Gift":"Regalo","I agree to receive Hi-Rez marketing communications, including event invitations, special offers, and newsletters.":"Acepto recibir comunicaciones de mercadeo de Hi-Rez, incluyendo invitaciones a eventos, ofertas especiales y boletines informativos.","INACTIVE":"INACTIVO","If the above options were not able to assist you:":"Si las opciones anteriores no te pudieron ayudar:","If you would like to relink to this service later to continue sharing data, simply sign in with the email address and click the connect button in the connected accounts section of the account dashboard.":"Si deseas volver a vincular este servicio más tarde para seguir compartiendo datos, simplemente inicia sesión con la dirección de correo electrónico y da clic en botón de conectar en la sección de cuentas conectadas del tablero de cuentas.","In-Game Rewards:":"Recompensas dentro del juego:","Information about referring a friend can go here.":"La información sobre cómo referir a un amigo puede ir aquí.","Ireland":"Irlanda","Korea":"Corea","Language":"Idioma","Learn More.":"Aprende más.","Link A New Account":"Vincula una nueva cuenta","Link Account":"Vincula Cuenta","Link An Existing Account":"Vincula una cuenta existente","Link your Hi-Rez Account to other networks in order to receive in-game rewards! Questions? Check out our FAQ page.":"¡Vincula tu cuenta de Hi-Rez a otras redes para recibir recompensas en el juego! ¿Tienes preguntas? Mira nuestra página de preguntas frecuentes.","Linked & Connected Accounts":"Cuentas conectadas y vinculadas","Linked Accounts":"Cuentas vinculadas","Logging Into Your Account":"Iniciando sesión en tu cuenta","Login":"Ingresa","Login With:":"Inicia sesión:","Login to change your two-factor settings":"Inicia sesión para cambiar tu configuración de dos factores.","Logout":"Cerrar sesión","Method:":"Método:","Mexico":"México","Netherlands":"Holanda","New Email":"Nuevo correo electrónico","New Password":"Nueva contraseña","Next":"Siguiente","None":"Ninguno","Offline":"Desconectado","Online":"En línea","Only select countries can receive our SMS alerts. Normal SMS charges apply.":"Sólo algunos países pueden recibir nuestras alertas SMS. Se aplican los cargos normales por SMS.","Order Number":"Número de orden","Other":"Otro","Other Settings":"Otras configuraciones","Paladins":"Paladines","Password":"Contraseña","Password:":"Contraseña:","Passwords do not match. Please try again.":"Las contraseñas no coinciden. Inténtalo de nuevo.","Periodic":"Periódico","Phone":"Número de teléfono","Phone Number Verification Settings":"Configuraciones de verificación de número de teléfono.","Phone Number:":"Ingresa el número telefónico:","Please check your recovery email and try again.":"Comprueba tu correo electrónico de recuperación e inténtalo de nuevo.","Please check your validation code and try again.":"Compruebe tu código de validación e inténtalo de nuevo.","Please select how often you want to verify your account. Either every time you log in, every two weeks, or never.":"Selecciona la frecuencia en la cual deseas verificar tu cuenta. Cada vez que inicies sesión, cada dos semanas, o nunca.","Please select your preferred method of receiving your two-factor security code. Note that not all countries are supported in our text message notification method.":"Selecciona tu método preferido para recibir tu código de seguridad de dos factores. Tenga en cuenta que no todos los países son compatibles con nuestro método de notificación de mensajes de texto.","Please store this recovery code in a safe location.":"Guarda este código de recuperación en un lugar seguro.","Please try again.":"Inténtalo de nuevo.","Please verify your email address.":"Verifica tu dirección de correo electrónico.","Please wait while we connect your Hi-Rez Studios Account to ${service}.":"Espera mientras conectamos tu cuenta de Hi-Rez Studios a ${service}.","Points Earned":"Puntos obtenidos","Poland":"Polonia","Portugal":"Portugal","Preferred Notification Method":"Método de notificación preferido","Program":"Programa","Purchases and earned game content will be reset on this account.":"El contenido comprado y ganado del juego se reiniciará en esta cuenta.","Recent Rewards":"Recompensas recientes","Recent Transactions":"Transacciones recientes","Recovery Code":"Código de recuperación","Recovery E-Mail:":"Corre de recuperación:","Refer A Friend":"Recomienda a un amigo","Refer a Friend":"Recomienda a un amigo","Referral Email:":"Correo de referencia:","Referral Link:":"Enlace de referencia:","Referral sent to ${email}!":"¡Se envío el correo de referencia a ${email}!","Referring Player's Name":"Nombre del jugador referido","Save":"Guardar","Security":"Seguridad","Security - Confirm & Recovery Code":"Seguridad - Código de confirmación y recuperación.","Security - Disable Two Factor Authentication":"Seguridad - Desactiva la autenticación de dos factores.","Security - Two Factor Authentication":"Seguridad - Autenticación de dos factores.","Select A Game":"Selecciona un juego","Send me Hi-Rez Studios news.":"Envíame noticias de Hi-Rez.","Shared game progression and history will be reset on this account.":"La progresión e historia del juego compartida se reiniciarán en esta cuenta.","Shared profile data will be reset on this account.":"Los datos de perfil compartidos se reiniciarán en esta cuenta.","Sign Up Now! Join 25+ Million Players Today":"¡Regístrate ahora! Únete hoy a más de 25 millones de jugadores.","Sign Up With:":"Regístrate con:","Smite":"SMITE","Something went wrong. Please try again.":"Algo salió mal. Inténtalo de nuevo.","Spain":"España","Status":"Estado","Status:":"Estado:","Submit":"Enviar","Submit Support Ticket":"Envía un ticket de soporte","Sweden":"Suecia","Thank you, an email has been sent to the address on file.":"Gracias, se ha enviado un correo electrónico a la dirección en los archivos.","The e-mail used to set up your Hi-Rez Account is automatically used for two-step verification codes.":"El correo electrónico utilizado para configurar tu cuenta de Hi-Rez se utilizará automáticamente para códigos de verificación de dos pasos.","There are no rewards to display":"No hay recompensas para mostrar","There are no transactions to display":"No hay transacciones que mostrar","There are several reasons you might not be able to log in. The options below may be able to assist you in recovering your account.":"Hay varias razones por las que es posible que no puedes iniciar sesión. Las siguientes opciones pueden ayudarte a recuperar tu cuenta.","This player has already been referred or has an existing Hi-Rez Studios account.":"Este jugador ya ha sido referido o tiene una cuenta existente con Hi-Rez Studios.","Total Revenue":"Ingresos totales","Two - Factor Sign In":"Inicio de sesión de dos - factores","Two-Factor Sign In can be used to help protect your account from unauthorized access by requiring you to enter an additional code when you sign in.":"El inicio de sesión de dos factores se puede utilizar para ayudar a proteger tu cuenta contra el acceso no autorizado al solicitar que introduzcas un código adicional cuando inicies sesión.","UTM Campaign":"Campaña UTM","UTM Content":"Contenido UTM","Unable to link or create Nintendo account. Please log into your Nintendo Switch, create a player, and retry.":"No fue posible vincular o crear la cuenta Nintendo. Inicia sesión en tu Nintendo Switch, crea un jugador y vuelve a intentarlo.","United Kingdom":"Reino Unido","United States of America":"Estados Unidos de América","Unlink":"Desvincular","Unlink Account":"Desvincular Cuenta","Unlink Facebook from this account":"Desvincular Facebook de esta cuenta.","Unlink Google from this account":"Desvincular Google de esta cuenta.","Unlink Mixer from this account":"Desvincular Mixer de esta cuenta.","Unlink Nintendo from this account":"Desvincular Nintendo de esta cuenta.","Unlink PSN from this account":"Desvincular PSN de esta cuenta.","Unlink Steam from this account":"Desvincular Steam de esta cuenta.","Unlink Twitch from this account":"Desvincular Twitch de esta cuenta.","Unlink Xbox from this account":"Desvincular Xbox de esta cuenta.","Unlink this platform from this account":"Desvincular esta plataforma de esta cuenta.","Unlinking this service will NOT unlock restricted platforms.":"Desvincular este servicio NO desbloqueará las plataformas restringidas.","Use Backup Email to Login":"Usar el correo electrónico de copia para iniciar sesión.","Use One Time Recovery Code":"Usar el código de recuperación de un solo uso.","Username":"Nombre de usuario","Username:":"Nombre de usuario:","VIP Chat":"Chat VIP","VIP Chat Support":"Soporte de Chat VIP","Verification Code:":"Código de verificación:","Verification Frequency":"Frecuencia de verificación","Verify":"Verificar","View all rewards":"Ver todas las recompensas","View all transactions":"Ver todas las transacciones","View more rewards":"Ver más recompensas","View more transactions":"Ver más transacciones","Want to change your two factor settings? Click below.":"¿Deseas cambiar las configuraciones de dos factores? Haz clic abajo.","Want to send a link directly? Enter in your referral's email below and we'll send it to them directly!":"¿Deseas enviar un enlace directamente? ¡Ingresa el correo electrónico de tu referencia y se lo enviaremos directamente!","Warning: You will no longer be able to use this account to store your progression on Facebook":"Advertencia: Ya no podrás usar esta cuenta para guardar tu progreso en Facebook.","Warning: You will no longer be able to use this account to store your progression on Google":"Advertencia: Ya no podrás usar esta cuenta para guardar tu progreso en Google.","Warning: You will no longer be able to use this account to store your progression on Mixer":"Advertencia: Ya no podrás usar esta cuenta para guardar tu progreso en Mixer.","Warning: You will no longer be able to use this account to store your progression on Nintendo":"Advertencia: Ya no podrás usar esta cuenta para guardar tu progreso en Nintendo.","Warning: You will no longer be able to use this account to store your progression on PSN":"Advertencia: Ya no podrás usar esta cuenta para guardar tu progreso en PSN.","Warning: You will no longer be able to use this account to store your progression on Steam":"Advertencia: Ya no podrás usar esta cuenta para guardar tu progreso en Steam.","Warning: You will no longer be able to use this account to store your progression on Twitch":"Advertencia: Ya no podrás usar esta cuenta para guardar tu progreso en Twitch.","Warning: You will no longer be able to use this account to store your progression on Xbox":"Advertencia: Ya no podrás usar esta cuenta para guardar tu progreso en Xbox.","Warning: You will no longer be able to use this account to store your progression on this platform.":"Advertencia: Ya no podrás usar esta cuenta para guardar tu progreso en esta plataforma.","We have agents available to speak with you! Please click below to enter our chat window in order to receive assistance with any questions you may have!":"¡Tenemos agentes disponibles para hablar contigo! ¡Haz clic a continuación para entrar a nuestra ventana de chat para recibir asistencia sobre cualquier pregunta que tengas!","We were not able to find a linked Hi-Rez Studios account. Would you like to link this account?":"No pudimos encontrar una cuenta de Hi-Rez Studios vinculada. ¿Deseas vincular esta cuenta?","We've provided a backup code below to restore access to your account should you lose the ability to verify your Two Factor Authentication.":"Hemos proporcionado un código de respaldo a continuación para restaurar el acceso a tu cuenta en caso de que pierdas la capacidad de verificar tu autenticación de dos factores.","Wrong account? <a>Login to a different account.</a>":"¿Cuenta equivocada? <a>Inicia sesión con una cuenta diferente.</a>","You must confirm your email.":"Debes confirmar tu correo electrónico.","You must enter your current password.":"Debes introducir tu contraseña actual.","You must enter your new email.":"Debes introducir tu nuevo correo electrónico.","You must verify your email address before changing your password.":"Debes verifica tu dirección de correo electrónico antes de cambiar tu contraseña.","You will be logged in as:":"Se iniciará la sesión como:","You've successfully changed your email.":"Has cambiado con éxito tu correo electrónico.","You've successfully changed your password.":"Has cambiado con éxito tu contraseña.","You've successfully updated your Two Factor Authentication settings!":"¡Has actualizado con éxito las configuraciones de la autenticación de dos factores!","You've successfully verified your backup email address.":"Has verificado con éxito tu dirección de correo electrónico de seguridad.","You've successfully verified your mobile phone number.":"Has verificado con éxito tu número telefónico.","Your recovery email cannot be the same as your account email.":"El correo electrónico de recuperación no puede ser el mismo que el de la cuenta.","or":"o","to add a backup email address.":"para agregar una dirección de correo electrónica de respaldo.","to add a new phone number.":"para agregar un número telefónico.","I am 13+ years old and I agree to the <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" rel=\"noopener noreferrer\" target=\"_blank\">Terms of Service</a>.":"Soy mayor de 13 años y estoy de acuerdo con los <a href=\"https://webcdn.hirezstudios.com/hirez-studios/wp-content/uploads/2015/11/Hi-Rez-Studios-Online-Terms-of-Service-and-Use-Agreement-Last-updated-Aug.-24-2017.pdf\" target=\"_blank\">Términos de Servicio</a>. (Requerido)","Link your Twitch account to receive content in SMITE with Twitch Prime. After linking, you will be returned to the Twitch Prime landing page for SMITE, or click <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >here</a> to return now.":"Vincula tu cuenta Twitch para recibir contenido de SMITE con Twitch Prime. Tras vincular tu cuenta serás llevado a la página de SMITE en Twitch Prime, o haz clic <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\" >aquí</a> para regresar ahora.","To unlink your account, please submit a request to Customer Support <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >here</a>.":"Para desvincular tu cuenta envía una solicitud a Atención al Cliente <a href=\"https://www.hirezstudios.com/submit-support-ticket\" target=\"_blank\" >aquí</a>.","You must have a linked Twitch Prime account to receive these rewards in SMITE. You must also claim the offer <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">here</a>, and link your Hi-Rez account to your platform of choice <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\" >here</a>.":"Debes de tener una cuenta de Twitch Prime vinculada para poder recibir estas recompensas en SMITE. También debes reclamar la oferta <a target=\"_blank\" href=\"https://twitch.amazon.com/prime/loot/smite?ctx=account-link\">aquí</a> y vincular tu cuenta de Hi-Rez a la plataforma de tu elección <a target=\"_blank\" href=\"https://my.hirezstudios.com/linked-accounts\">aquí</a>."}

/***/ }),

/***/ "sw5u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link = exports.Match = undefined;

var _extends = Object.assign || function (target) {
	for (var i = 1; i < arguments.length; i++) {
		var source = arguments[i];for (var key in source) {
			if (Object.prototype.hasOwnProperty.call(source, key)) {
				target[key] = source[key];
			}
		}
	}return target;
};

var _preact = __webpack_require__("KM04");

var _preactRouter = __webpack_require__("/QC5");

function _objectWithoutProperties(obj, keys) {
	var target = {};for (var i in obj) {
		if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
	}return target;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError("Cannot call a class as a function");
	}
}

function _possibleConstructorReturn(self, call) {
	if (!self) {
		throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	}return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
	if (typeof superClass !== "function" && superClass !== null) {
		throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Match = exports.Match = function (_Component) {
	_inherits(Match, _Component);

	function Match() {
		var _temp, _this, _ret;

		_classCallCheck(this, Match);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.update = function (url) {
			_this.nextUrl = url;
			_this.setState({});
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	Match.prototype.componentDidMount = function componentDidMount() {
		_preactRouter.subscribers.push(this.update);
	};

	Match.prototype.componentWillUnmount = function componentWillUnmount() {
		_preactRouter.subscribers.splice(_preactRouter.subscribers.indexOf(this.update) >>> 0, 1);
	};

	Match.prototype.render = function render(props) {
		var url = this.nextUrl || (0, _preactRouter.getCurrentUrl)(),
		    path = url.replace(/\?.+$/, '');
		this.nextUrl = null;
		return props.children[0] && props.children[0]({
			url: url,
			path: path,
			matches: path === props.path
		});
	};

	return Match;
}(_preact.Component);

var Link = function Link(_ref) {
	var activeClassName = _ref.activeClassName,
	    path = _ref.path,
	    props = _objectWithoutProperties(_ref, ['activeClassName', 'path']);

	return (0, _preact.h)(Match, { path: path || props.href }, function (_ref2) {
		var matches = _ref2.matches;
		return (0, _preact.h)(_preactRouter.Link, _extends({}, props, { 'class': [props.class || props.className, matches && activeClassName].filter(Boolean).join(' ') }));
	});
};

exports.Link = Link;
exports.default = Match;

Match.Link = Link;

/***/ }),

/***/ "wRU+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "wVGV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("UQex");
var invariant = __webpack_require__("wRU+");
var ReactPropTypesSecret = __webpack_require__("Asjh");

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "x+I3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'querystring',

  lookup: function lookup(options) {
    var found = void 0;

    if (typeof window !== 'undefined') {
      var query = window.location.search.substring(1);
      var params = query.split('&');
      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');
        if (pos > 0) {
          var key = params[i].substring(0, pos);
          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }

    return found;
  }
};

/***/ }),

/***/ "xPfl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'navigator',

  lookup: function lookup(options) {
    var found = [];

    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (var i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }
      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }
      if (navigator.language) {
        found.push(navigator.language);
      }
    }

    return found.length > 0 ? found : undefined;
  }
};

/***/ }),

/***/ "xPr9":
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "keygen": true,
  "link": true,
  "menuitem": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};

/***/ }),

/***/ "ygIX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaults = defaults;
exports.extend = extend;
var arr = [];
var each = arr.forEach;
var slice = arr.slice;

function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

function extend(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

/***/ }),

/***/ "zsJU":
/***/ (function(module, exports, __webpack_require__) {

var attrRE = /([\w-]+)|=|(['"])([.\s\S]*?)\2/g;
var voidElements = __webpack_require__("xPr9");

module.exports = function (tag) {
    var i = 0;
    var key;
    var expectingValueAfterEquals = true;
    var res = {
        type: 'tag',
        name: '',
        voidElement: false,
        attrs: {},
        children: []
    };

    tag.replace(attrRE, function (match) {
        if (match === '=') {
            expectingValueAfterEquals = true;
            i++;
            return;
        }

        if (!expectingValueAfterEquals) {
            if (key) {
                res.attrs[key] = key; // boolean attribute
            }
            key = match;
        } else {
            if (i === 0) {
                if (voidElements[match] || tag.charAt(tag.length - 2) === '/') {
                    res.voidElement = true;
                }
                res.name = match;
            } else {
                res.attrs[key] = match.replace(/^['"]|['"]$/g, '');
                key = undefined;
            }
        }
        i++;
        expectingValueAfterEquals = false;
    });

    return res;
};

/***/ })

/******/ });


// WEBPACK FOOTER //
// bundle.a9326.js